// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: "Aptos", "Helvetica Neue", Arial, sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-red-900: oklch(39.6% 0.141 25.723);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-yellow-50: oklch(98.7% 0.026 102.212);
    --color-yellow-200: oklch(94.5% 0.129 101.54);
    --color-yellow-800: oklch(47.6% 0.114 61.907);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-zinc-200: oklch(92% 0.004 286.32);
    --color-zinc-950: oklch(14.1% 0.005 285.823);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-3xl: 48rem;
    --container-5xl: 64rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-tight: -0.025em;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-relaxed: 1.625;
    --radius-xl: calc(var(--radius) * 1.5);
    --radius-2xl: calc(var(--radius) * 2);
    --radius-3xl: calc(var(--radius) * 3);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-background: var(--background);
    --color-foreground: var(--foreground);
    --color-accent: var(--accent);
    --color-accent-foreground: var(--accent-foreground);
    --color-focus: var(--focus);
    --color-default: var(--default);
    --color-default-foreground: var(--default-foreground);
    --color-success: var(--success);
    --color-success-foreground: var(--success-foreground);
    --color-warning: var(--warning);
    --color-warning-foreground: var(--warning-foreground);
    --color-danger: var(--danger);
    --color-danger-foreground: var(--danger-foreground);
    --shadow-surface: var(--surface-shadow);
    --shadow-overlay: var(--overlay-shadow);
    --color-field-border: var(--field-border, var(--border));
    --border-width-field: var(--field-border-width, var(--border-width));
    --color-default-hover: var(--default);
    @supports (color: color-mix(in lab, red, red)) {
      --color-default-hover: color-mix(in oklab, var(--default) 96%, var(--default-foreground) 4%);
    }
    --color-accent-hover: var(--accent);
    @supports (color: color-mix(in lab, red, red)) {
      --color-accent-hover: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
    }
    --color-danger-hover: var(--danger);
    @supports (color: color-mix(in lab, red, red)) {
      --color-danger-hover: color-mix(in oklab, var(--danger) 90%, var(--danger-foreground) 10%);
    }
    --color-field-focus: var(--field-background, var(--default));
    --color-field-border-hover: var(--field-border, var(--border));
    @supports (color: color-mix(in lab, red, red)) {
      --color-field-border-hover: color-mix(
    in oklab,
    var(--field-border, var(--border)) 88%,
    var(--field-foreground, var(--foreground)) 10%
  );
    }
    --color-field-border-focus: var(--field-border, var(--border));
    @supports (color: color-mix(in lab, red, red)) {
      --color-field-border-focus: color-mix(
    in oklab,
    var(--field-border, var(--border)) 74%,
    var(--field-foreground, var(--foreground)) 22%
  );
    }
    --color-accent-soft: var(--accent-soft, var(--accent));
    @supports (color: color-mix(in lab, red, red)) {
      --color-accent-soft: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
    }
    --color-accent-soft-foreground: var(--accent-soft-foreground, var(--accent));
    --color-accent-soft-hover: var(
    --accent-soft-hover,
    var(--accent)
  );
    @supports (color: color-mix(in lab, red, red)) {
      --color-accent-soft-hover: var(
    --accent-soft-hover,
    color-mix(in oklab, var(--accent) 20%, transparent)
  );
    }
    --color-danger-soft: var(--danger-soft, var(--danger));
    @supports (color: color-mix(in lab, red, red)) {
      --color-danger-soft: var(--danger-soft, color-mix(in oklab, var(--danger) 15%, transparent));
    }
    --color-danger-soft-foreground: var(--danger-soft-foreground, var(--danger));
    --color-danger-soft-hover: var(
    --danger-soft-hover,
    var(--danger)
  );
    @supports (color: color-mix(in lab, red, red)) {
      --color-danger-soft-hover: var(
    --danger-soft-hover,
    color-mix(in oklab, var(--danger) 20%, transparent)
  );
    }
    --color-warning-soft: var(--warning-soft, var(--warning));
    @supports (color: color-mix(in lab, red, red)) {
      --color-warning-soft: var(--warning-soft, color-mix(in oklab, var(--warning) 15%, transparent));
    }
    --color-warning-soft-foreground: var(--warning-soft-foreground, var(--warning));
    --color-success-soft: var(--success-soft, var(--success));
    @supports (color: color-mix(in lab, red, red)) {
      --color-success-soft: var(--success-soft, color-mix(in oklab, var(--success) 15%, transparent));
    }
    --color-success-soft-foreground: var(--success-soft-foreground, var(--success));
    --ease-smooth: ease;
    --ease-out-quad: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    --ease-out-quart: cubic-bezier(0.165, 0.84, 0.44, 1);
    --ease-out-fluid: cubic-bezier(0.32, 0.72, 0, 1);
    --ease-linear: linear;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-y-0 {
    inset-block: calc(var(--spacing) * 0);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .isolate {
    isolation: isolate;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[10000\\] {
    z-index: 10000;
  }
  .float-left {
    float: left;
  }
  .float-right {
    float: right;
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .my-5 {
    margin-block: calc(var(--spacing) * 5);
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-5 {
    margin-left: calc(var(--spacing) * 5);
  }
  .\\!inline {
    display: inline !important;
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-\\[3px\\] {
    height: 3px;
  }
  .h-auto {
    height: auto;
  }
  .h-full {
    height: 100%;
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-12 {
    min-height: calc(var(--spacing) * 12);
  }
  .min-h-24 {
    min-height: calc(var(--spacing) * 24);
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-80 {
    width: calc(var(--spacing) * 80);
  }
  .w-\\[300px\\] {
    width: 300px;
  }
  .w-\\[320px\\] {
    width: 320px;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-\\[85vw\\] {
    max-width: 85vw;
  }
  .max-w-\\[480px\\] {
    max-width: 480px;
  }
  .max-w-\\[var\\(--tenant-max-width\\,1200px\\)\\] {
    max-width: var(--tenant-max-width,1200px);
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .flex-1 {
    flex: 1;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .-translate-x-full {
    --tw-translate-x: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .list-disc {
    list-style-type: disc;
  }
  .appearance-none {
    appearance: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .place-items-center {
    place-items: center;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .space-y-0\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-7 {
    column-gap: calc(var(--spacing) * 7);
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8);
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-\\[var\\(--owner-border\\)\\] {
    :where(& > :not(:last-child)) {
      border-color: var(--owner-border);
    }
  }
  .self-center {
    align-self: center;
  }
  .self-start {
    align-self: flex-start;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: calc(var(--radius) * 2);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: calc(var(--radius) * 1);
  }
  .rounded-md {
    border-radius: calc(var(--radius) * 0.75);
  }
  .rounded-xl {
    border-radius: calc(var(--radius) * 1.5);
  }
  .rounded-t-xl {
    border-top-left-radius: calc(var(--radius) * 1.5);
    border-top-right-radius: calc(var(--radius) * 1.5);
  }
  .rounded-b-2xl {
    border-bottom-right-radius: calc(var(--radius) * 2);
    border-bottom-left-radius: calc(var(--radius) * 2);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-0 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .border-\\[var\\(--owner-border\\)\\] {
    border-color: var(--owner-border);
  }
  .border-\\[var\\(--owner-border-strong\\)\\] {
    border-color: var(--owner-border-strong);
  }
  .border-\\[var\\(--owner-danger\\)\\] {
    border-color: var(--owner-danger);
  }
  .border-\\[var\\(--owner-info-border\\)\\] {
    border-color: var(--owner-info-border);
  }
  .border-\\[var\\(--owner-warning\\)\\] {
    border-color: var(--owner-warning);
  }
  .border-\\[var\\(--tenant-primary\\)\\] {
    border-color: var(--tenant-primary);
  }
  .border-green-200 {
    border-color: var(--color-green-200);
  }
  .border-green-300 {
    border-color: var(--color-green-300);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-red-300 {
    border-color: var(--color-red-300);
  }
  .border-red-500 {
    border-color: var(--color-red-500);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-yellow-200 {
    border-color: var(--color-yellow-200);
  }
  .border-zinc-200 {
    border-color: var(--color-zinc-200);
  }
  .border-t-\\[var\\(--tenant-primary\\)\\] {
    border-top-color: var(--tenant-primary);
  }
  .bg-\\[color-mix\\(in_srgb\\,\\#16a34a_15\\%\\,transparent\\)\\] {
    background-color: color-mix(in srgb,#16a34a 15%,transparent);
  }
  .bg-\\[color-mix\\(in_srgb\\,var\\(--owner-page-bg\\)_78\\%\\,transparent\\)\\] {
    background-color: var(--owner-page-bg);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in srgb,var(--owner-page-bg) 78%,transparent);
    }
  }
  .bg-\\[color-mix\\(in_srgb\\,var\\(--owner-warning\\)_12\\%\\,var\\(--owner-surface\\)\\)\\] {
    background-color: var(--owner-warning);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in srgb,var(--owner-warning) 12%,var(--owner-surface));
    }
  }
  .bg-\\[color-mix\\(in_srgb\\,var\\(--owner-warning\\)_20\\%\\,transparent\\)\\] {
    background-color: var(--owner-warning);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in srgb,var(--owner-warning) 20%,transparent);
    }
  }
  .bg-\\[color-mix\\(in_srgb\\,var\\(--tenant-primary\\)_14\\%\\,var\\(--owner-surface\\)\\)\\] {
    background-color: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in srgb,var(--tenant-primary) 14%,var(--owner-surface));
    }
  }
  .bg-\\[var\\(--owner-accent-subtle\\)\\] {
    background-color: var(--owner-accent-subtle);
  }
  .bg-\\[var\\(--owner-info-bg\\)\\] {
    background-color: var(--owner-info-bg);
  }
  .bg-\\[var\\(--owner-page-bg\\)\\] {
    background-color: var(--owner-page-bg);
  }
  .bg-\\[var\\(--owner-surface\\)\\] {
    background-color: var(--owner-surface);
  }
  .bg-\\[var\\(--owner-surface-muted\\)\\] {
    background-color: var(--owner-surface-muted);
  }
  .bg-\\[var\\(--tenant-primary\\)\\] {
    background-color: var(--tenant-primary);
  }
  .bg-black\\/30 {
    background-color: color-mix(in srgb, #000 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 30%, transparent);
    }
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-orange-500 {
    background-color: var(--color-orange-500);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-600 {
    background-color: var(--color-red-600);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-yellow-50 {
    background-color: var(--color-yellow-50);
  }
  .bg-zinc-950 {
    background-color: var(--color-zinc-950);
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pr-10 {
    padding-right: calc(var(--spacing) * 10);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-7 {
    padding-bottom: calc(var(--spacing) * 7);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .align-middle {
    vertical-align: middle;
  }
  .align-top {
    vertical-align: top;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[22px\\] {
    font-size: 22px;
  }
  .text-\\[28px\\] {
    font-size: 28px;
  }
  .text-\\[32px\\] {
    font-size: 32px;
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-7 {
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[0\\.04em\\] {
    --tw-tracking: 0.04em;
    letter-spacing: 0.04em;
  }
  .tracking-\\[0\\.24em\\] {
    --tw-tracking: 0.24em;
    letter-spacing: 0.24em;
  }
  .tracking-normal {
    --tw-tracking: var(--tracking-normal);
    letter-spacing: var(--tracking-normal);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .text-\\[var\\(--owner-accent-readable\\)\\] {
    color: var(--owner-accent-readable);
  }
  .text-\\[var\\(--owner-danger\\)\\] {
    color: var(--owner-danger);
  }
  .text-\\[var\\(--owner-info-text\\)\\] {
    color: var(--owner-info-text);
  }
  .text-\\[var\\(--owner-text\\)\\] {
    color: var(--owner-text);
  }
  .text-\\[var\\(--owner-text-muted\\)\\] {
    color: var(--owner-text-muted);
  }
  .text-\\[var\\(--owner-warning\\)\\] {
    color: var(--owner-warning);
  }
  .text-\\[var\\(--tenant-primary\\)\\] {
    color: var(--tenant-primary);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-orange-500 {
    color: var(--color-orange-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-800 {
    color: var(--color-red-800);
  }
  .text-red-900 {
    color: var(--color-red-900);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-yellow-800 {
    color: var(--color-yellow-800);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-2 {
    text-underline-offset: 2px;
  }
  .accent-\\[var\\(--tenant-primary\\)\\] {
    accent-color: var(--tenant-primary);
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[var\\(--owner-shadow\\)\\] {
    --tw-shadow: var(--owner-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[filter\\] {
    transition-property: filter;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .last\\:border-b-0 {
    &:last-child {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
  }
  .hover\\:border-\\[var\\(--owner-accent-border\\)\\] {
    &:hover {
      @media (hover: hover) {
        border-color: var(--owner-accent-border);
      }
    }
  }
  .hover\\:border-\\[var\\(--tenant-primary\\)\\] {
    &:hover {
      @media (hover: hover) {
        border-color: var(--tenant-primary);
      }
    }
  }
  .hover\\:bg-\\[color-mix\\(in_srgb\\,var\\(--tenant-primary\\)_8\\%\\,var\\(--owner-surface\\)\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--tenant-primary);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in srgb,var(--tenant-primary) 8%,var(--owner-surface));
        }
      }
    }
  }
  .hover\\:bg-\\[var\\(--owner-accent-subtle\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--owner-accent-subtle);
      }
    }
  }
  .hover\\:bg-\\[var\\(--owner-surface-muted\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--owner-surface-muted);
      }
    }
  }
  .hover\\:bg-black\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #000 10%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-red-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-50);
      }
    }
  }
  .hover\\:bg-white\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 10%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/\\[0\\.06\\] {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 6%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 6%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/\\[0\\.10\\] {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 10%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
        }
      }
    }
  }
  .hover\\:text-\\[var\\(--owner-accent-readable\\)\\] {
    &:hover {
      @media (hover: hover) {
        color: var(--owner-accent-readable);
      }
    }
  }
  .hover\\:text-\\[var\\(--owner-text\\)\\] {
    &:hover {
      @media (hover: hover) {
        color: var(--owner-text);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:brightness-95 {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(95%);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .hover\\:brightness-110 {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(110%);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .focus\\:border-\\[var\\(--tenant-primary\\)\\] {
    &:focus {
      border-color: var(--tenant-primary);
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-\\[var\\(--owner-focus-ring\\)\\] {
    &:focus {
      --tw-ring-color: var(--owner-focus-ring);
    }
  }
  .focus-visible\\:border-\\[var\\(--tenant-primary\\)\\] {
    &:focus-visible {
      border-color: var(--tenant-primary);
    }
  }
  .focus-visible\\:bg-white\\/10 {
    &:focus-visible {
      background-color: color-mix(in srgb, #fff 10%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
      }
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-\\[var\\(--owner-focus-ring\\)\\] {
    &:focus-visible {
      --tw-ring-color: var(--owner-focus-ring);
    }
  }
  .focus-visible\\:outline {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .focus-visible\\:outline-2 {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
  }
  .focus-visible\\:outline-offset-2 {
    &:focus-visible {
      outline-offset: 2px;
    }
  }
  .focus-visible\\:outline-\\[var\\(--tenant-primary\\)\\] {
    &:focus-visible {
      outline-color: var(--tenant-primary);
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .active\\:scale-\\[0\\.98\\] {
    &:active {
      scale: 0.98;
    }
  }
  .active\\:brightness-95 {
    &:active {
      --tw-brightness: brightness(95%);
      filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .sm\\:mb-10 {
    @media (width >= 40rem) {
      margin-bottom: calc(var(--spacing) * 10);
    }
  }
  .sm\\:w-\\[140px\\] {
    @media (width >= 40rem) {
      width: 140px;
    }
  }
  .sm\\:w-\\[160px\\] {
    @media (width >= 40rem) {
      width: 160px;
    }
  }
  .sm\\:w-auto {
    @media (width >= 40rem) {
      width: auto;
    }
  }
  .sm\\:max-w-\\[260px\\] {
    @media (width >= 40rem) {
      max-width: 260px;
    }
  }
  .sm\\:min-w-0 {
    @media (width >= 40rem) {
      min-width: calc(var(--spacing) * 0);
    }
  }
  .sm\\:min-w-\\[180px\\] {
    @media (width >= 40rem) {
      min-width: 180px;
    }
  }
  .sm\\:min-w-\\[200px\\] {
    @media (width >= 40rem) {
      min-width: 200px;
    }
  }
  .sm\\:flex-1 {
    @media (width >= 40rem) {
      flex: 1;
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:flex-wrap {
    @media (width >= 40rem) {
      flex-wrap: wrap;
    }
  }
  .sm\\:items-baseline {
    @media (width >= 40rem) {
      align-items: baseline;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center;
    }
  }
  .sm\\:items-end {
    @media (width >= 40rem) {
      align-items: flex-end;
    }
  }
  .sm\\:justify-between {
    @media (width >= 40rem) {
      justify-content: space-between;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .sm\\:gap-3 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 3);
    }
  }
  .sm\\:gap-4 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 4);
    }
  }
  .sm\\:gap-6 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-6 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-8 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 8);
    }
  }
  .sm\\:text-3xl {
    @media (width >= 40rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .md\\:col-span-2 {
    @media (width >= 48rem) {
      grid-column: span 2 / span 2;
    }
  }
  .md\\:flex {
    @media (width >= 48rem) {
      display: flex;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:items-center {
    @media (width >= 48rem) {
      align-items: center;
    }
  }
  .md\\:items-end {
    @media (width >= 48rem) {
      align-items: flex-end;
    }
  }
  .md\\:gap-4 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 4);
    }
  }
  .lg\\:col-start-2 {
    @media (width >= 64rem) {
      grid-column-start: 2;
    }
  }
  .lg\\:row-start-1 {
    @media (width >= 64rem) {
      grid-row-start: 1;
    }
  }
  .lg\\:block {
    @media (width >= 64rem) {
      display: block;
    }
  }
  .lg\\:flex {
    @media (width >= 64rem) {
      display: flex;
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-\\[minmax\\(0\\,1fr\\)_320px\\] {
    @media (width >= 64rem) {
      grid-template-columns: minmax(0,1fr) 320px;
    }
  }
  .lg\\:px-10 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 10);
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .\\[\\&\\>\\*\\]\\:w-full {
    &>* {
      width: 100%;
    }
  }
  .sm\\:\\[\\&\\>\\*\\]\\:w-auto {
    @media (width >= 40rem) {
      &>* {
        width: auto;
      }
    }
  }
}
@layer theme, base, components, utilities;
@layer theme, base, components, utilities;
@layer theme;
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities;
@property --tw-animation-delay {
  syntax: "*";
  inherits: false;
  initial-value: 0s;
}
@property --tw-animation-direction {
  syntax: "*";
  inherits: false;
  initial-value: normal;
}
@property --tw-animation-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-animation-fill-mode {
  syntax: "*";
  inherits: false;
  initial-value: none;
}
@property --tw-animation-iteration-count {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    border-color: var(--border, currentColor);
  }
  :root {
    view-transition-name: none;
  }
  ::view-transition {
    pointer-events: none;
  }
}
@layer components {
  .close-button {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    height: calc(var(--spacing) * 6);
    width: calc(var(--spacing) * 6);
    flex-shrink: 0;
    transform-origin: center;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 1.5);
    padding: calc(var(--spacing) * 1);
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    transition: transform 250ms var(--ease-out-quart), color 150ms var(--ease-out), background-color 100ms var(--ease-out), box-shadow 150ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-pending="true"] {
      pointer-events: none;
    }
    & svg {
      pointer-events: none;
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
      flex-shrink: 0;
      align-self: center;
      margin-inline: calc(var(--spacing) * -0.5);
      margin-block: calc(var(--spacing) * 0.5);
    }
  }
  .close-button--default {
    background-color: var(--default);
    color: var(--muted);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--default) 96%, var(--default-foreground) 4%);
        }
      }
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.93);
    }
  }
  .description {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    text-wrap: wrap;
    overflow-wrap: break-word;
    color: var(--muted);
  }
  .error-message {
    height: auto;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    overflow-wrap: break-word;
    color: var(--danger);
    transition: opacity 150ms var(--ease-out), height 350ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .field-error {
    height: calc(var(--spacing) * 0);
    padding-inline: calc(var(--spacing) * 1);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    overflow-wrap: break-word;
    color: var(--danger);
    opacity: 0%;
    &[data-visible="true"] {
      height: auto;
    }
    &[data-visible="true"] {
      opacity: 100%;
    }
    transition: opacity 150ms var(--ease-out), height 350ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .label {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .label--required, [data-required="true"]:not([role="group"]):not([role="radiogroup"]):not([role="checkboxgroup"]) > .label, [data-required="true"]:not([data-slot="radio"]):not([data-slot="checkbox"]) > .label {
    &::after {
      content: var(--tw-content);
      margin-left: calc(var(--spacing) * 0.5);
    }
    &::after {
      content: var(--tw-content);
      color: var(--danger);
    }
    &::after {
      --tw-content: '*';
      content: var(--tw-content);
    }
  }
  .label--disabled, [data-disabled="true"] .label {
    opacity: var(--disabled-opacity);
    cursor: var(--cursor-disabled);
    pointer-events: none;
  }
  .label--invalid, [data-invalid="true"] .label, [aria-invalid="true"] .label {
    color: var(--danger);
  }
  .accordion {
    width: 100%;
    contain: layout style;
  }
  .accordion__body {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .accordion__body-inner {
    padding-inline: calc(var(--spacing) * 4);
    padding-top: calc(var(--spacing) * 0);
    padding-bottom: calc(var(--spacing) * 4);
    color: var(--muted);
  }
  .accordion__heading {
    display: flex;
  }
  .accordion__indicator {
    margin-left: auto;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    color: var(--muted);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 250ms;
    transition-duration: 250ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-expanded="true"] {
      rotate: calc(180deg * -1);
    }
  }
  .accordion__item {
    position: relative;
    --tw-border-style: none;
    border-style: none;
  }
  .accordion__item::after {
    content: "";
    position: absolute;
    bottom: calc(var(--spacing) * 0);
    left: calc(var(--spacing) * 0);
    height: 1px;
    width: 100%;
    border-radius: calc(var(--radius) * 0.25);
    background-color: var(--separator);
  }
  .accordion__item:last-child::after {
    content: none;
  }
  .accordion__item[data-hide-separator="true"]::after {
    display: none;
  }
  .accordion__trigger {
    cursor: var(--cursor-interactive);
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 4);
    text-align: left;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    -webkit-tap-highlight-color: transparent;
    transition: opacity 150ms var(--ease-out), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not([aria-expanded="true"]), &[data-hovered="true"]:not([aria-expanded="true"]) {
        background-color: var(--color-foreground);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-foreground) 3%, transparent 90%);
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .accordion__panel {
    opacity: 0;
    height: var(--disclosure-panel-height);
    overflow: clip;
    transition: height 200ms var(--ease-out-quad), opacity 200ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-expanded="true"] {
      will-change: height, opacity;
      opacity: 1;
    }
  }
  .accordion--surface {
    background-color: var(--surface);
    border-radius: min(32px, var(--radius-3xl));
    .accordion__trigger {
      @media (hover: hover) {
        &:hover:not([aria-expanded="true"]), &[data-hovered="true"]:not([aria-expanded="true"]) {
          background-color: var(--default);
        }
      }
    }
    .accordion__item::after {
      background-color: var(--surface-foreground);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--surface-foreground) 6%, transparent);
      }
    }
  }
  .accordion--surface .accordion__item {
    &::after {
      left: 3%;
      width: 94%;
    }
    &:first-child [data-slot="accordion-trigger"] {
      border-top-left-radius: min(32px, var(--radius-3xl));
      border-top-right-radius: min(32px, var(--radius-3xl));
    }
    &:last-child:not(:has([data-slot="accordion-trigger"][aria-expanded="true"])) [data-slot="accordion-trigger"] {
      border-bottom-left-radius: min(32px, var(--radius-3xl));
      border-bottom-right-radius: min(32px, var(--radius-3xl));
    }
  }
  .breadcrumbs {
    display: flex;
    align-items: center;
    .breadcrumbs__link {
      position: relative;
      padding-inline: calc(var(--spacing) * 0.5);
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-leading: calc(var(--spacing) * 5);
      line-height: calc(var(--spacing) * 5);
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      color: var(--muted);
      text-decoration-line: none;
      opacity: 100%;
      &:hover, &[data-hovered="true"] {
        text-decoration-line: underline;
      }
      &[data-current="true"] {
        color: var(--link);
        opacity: 100%;
      }
    }
    .breadcrumbs__item {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      gap: calc(var(--spacing) * 0.5);
      padding-inline: calc(var(--spacing) * 0.5);
    }
    .breadcrumbs__separator {
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
      color: var(--muted);
      &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
        rotate: 180deg;
      }
    }
  }
  .disclosure-group {
    width: 100%;
    contain: layout style;
  }
  .disclosure {
    position: relative;
  }
  .accordion__heading {
    display: flex;
  }
  .disclosure__trigger {
    cursor: var(--cursor-interactive);
    display: inline-block;
    -webkit-tap-highlight-color: transparent;
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .disclosure__indicator {
    margin-left: auto;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    color: inherit;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 250ms;
    transition-duration: 250ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-expanded="true"] {
      rotate: calc(180deg * -1);
    }
  }
  .disclosure__content {
    opacity: 0;
    height: var(--disclosure-panel-height);
    overflow: clip;
    transition: height 200ms var(--ease-out-quad), opacity 200ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-expanded="true"] {
      will-change: height, opacity;
      opacity: 1;
    }
  }
  .disclosure__body {
    padding: calc(var(--spacing) * 2);
  }
  .link {
    position: relative;
    display: inline-flex;
    height: fit-content;
    width: fit-content;
    align-items: center;
    border-radius: calc(var(--radius) * 1.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--link);
    text-decoration-line: underline;
    text-decoration-color: var(--surface);
    @supports (color: color-mix(in lab, red, red)) {
      text-decoration-color: color-mix(
    in oklab,
    var(--surface) 81%,
    var(--surface-foreground) 19%
  );
    }
    text-decoration-thickness: 1.5px;
    text-underline-offset: 4px;
    -webkit-tap-highlight-color: transparent;
    transition: color 100ms var(--ease-smooth), text-decoration-color 100ms var(--ease-out), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out), opacity 100ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        text-decoration-color: var(--muted);
        .link__icon {
          opacity: 100%;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
      .link__icon {
        opacity: 100%;
      }
    }
    &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    .link__icon {
      pointer-events: none;
      display: inline-flex;
      width: calc(var(--spacing) * 2);
      height: calc(var(--spacing) * 2);
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      color: currentcolor;
      opacity: 60%;
      transition: opacity 150ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
      & svg {
        transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
      }
    }
    .link__icon[data-default-icon="true"] {
      margin-left: calc(var(--spacing) * 1);
      padding-bottom: calc(var(--spacing) * 1.5);
    }
    &.button {
      gap: calc(var(--spacing) * 0);
      text-decoration-line: none;
    }
  }
  .pagination {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: calc(var(--spacing) * 4);
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .pagination__summary {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
    align-self: flex-start;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--muted);
    @media (width >= 40rem) {
      align-self: center;
    }
  }
  .pagination__content {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 1);
    align-self: flex-start;
    @media (width >= 40rem) {
      align-self: center;
    }
  }
  .pagination__item {
    display: inline-flex;
  }
  .pagination__link {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
    transform-origin: center;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 3);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
    }
    cursor: var(--cursor-interactive);
    transition: transform 250ms var(--ease-smooth), background-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    --pagination-link-bg: transparent;
    --pagination-link-bg-hover: var(--color-default-hover);
    --pagination-link-bg-pressed: var(--color-default-hover);
    --pagination-link-fg: var(--color-default-foreground);
    background-color: var(--pagination-link-bg);
    color: var(--pagination-link-fg);
    &:focus-visible, &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--pagination-link-bg-hover);
      }
    }
    &:active, &[data-pressed="true"] {
      background-color: var(--pagination-link-bg-pressed);
      transform: scale(0.97);
    }
    &[data-active="true"] {
      --pagination-link-bg: var(--color-default);
      --pagination-link-bg-hover: var(--color-default-hover);
      --pagination-link-bg-pressed: var(--color-default-hover);
    }
  }
  .pagination__ellipsis {
    display: inline-flex;
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
    align-items: center;
    justify-content: center;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--muted);
    -webkit-user-select: none;
    user-select: none;
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
    }
  }
  .pagination__link--nav {
    width: auto;
    gap: calc(var(--spacing) * 1.5);
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .pagination--sm {
    .pagination__link {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
      @media (width >= 48rem) {
        width: calc(var(--spacing) * 7);
        height: calc(var(--spacing) * 7);
      }
      &:active, &[data-pressed="true"] {
        transform: scale(0.98);
      }
    }
    .pagination__link--nav {
      width: auto;
      padding-inline: calc(var(--spacing) * 2);
    }
    .pagination__ellipsis {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
      @media (width >= 48rem) {
        width: calc(var(--spacing) * 7);
        height: calc(var(--spacing) * 7);
      }
    }
    .pagination__summary {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
  }
  .pagination--lg {
    .pagination__link {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
      @media (width >= 48rem) {
        width: calc(var(--spacing) * 9);
        height: calc(var(--spacing) * 9);
      }
      &:active, &[data-pressed="true"] {
        transform: scale(0.96);
      }
    }
    .pagination__link--nav {
      width: auto;
      padding-inline: calc(var(--spacing) * 3);
    }
    .pagination__ellipsis {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
      @media (width >= 48rem) {
        width: calc(var(--spacing) * 9);
        height: calc(var(--spacing) * 9);
      }
    }
    .pagination__summary {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .tabs {
    display: flex;
    gap: calc(var(--spacing) * 2);
    &[data-orientation="horizontal"] {
      flex-direction: column;
    }
    &[data-orientation="vertical"] {
      flex-direction: row;
    }
  }
  .tabs__list-container {
    position: relative;
  }
  .tabs__list {
    display: inline-flex;
    background-color: var(--default);
    padding: calc(var(--spacing) * 1);
    border-radius: calc(var(--radius) * 2.5);
    &[data-orientation="horizontal"] {
      width: 100%;
      flex-direction: row;
    }
    &[data-orientation="vertical"] {
      flex-direction: column;
      gap: calc(var(--spacing) * 1);
      .tabs__tab {
        min-width: calc(var(--spacing) * 20);
      }
    }
  }
  .tabs__tab {
    position: relative;
    z-index: 1;
    cursor: var(--cursor-interactive);
    display: flex;
    height: calc(var(--spacing) * 8);
    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 3);
    padding-inline: calc(var(--spacing) * 4);
    text-align: center;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--muted);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    transition: color 150ms var(--ease-smooth), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out), opacity 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-selected="true"] {
      color: var(--segment-foreground);
    }
    &[data-selected="true"] .tabs__separator {
      opacity: 0;
    }
    &[data-selected="true"] + .tabs__tab .tabs__separator {
      opacity: 0;
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    @media (hover: hover) {
      &:not([data-selected="true"]):not([data-disabled="true"]):hover, &[data-hovered="true"]:not([data-selected="true"]):not([data-disabled="true"]) {
        opacity: 70%;
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
  }
  .tabs__separator {
    border-radius: calc(var(--radius) * 0.5);
    background-color: var(--muted);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 25%, transparent);
    }
    position: absolute;
    pointer-events: none;
    transition: opacity 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .tabs__list[data-orientation="horizontal"] & {
      left: 0;
      top: 25%;
      width: 1px;
      height: 50%;
    }
    .tabs__list[data-orientation="vertical"] & {
      top: 0;
      left: 5%;
      width: 90%;
      height: 1px;
    }
  }
  .tabs__panel {
    width: 100%;
    padding: calc(var(--spacing) * 2);
    --tw-outline-style: none;
    outline-style: none;
    &[data-exiting="true"] {
      position: absolute;
      top: calc(var(--spacing) * 0);
      left: calc(var(--spacing) * 0);
      width: 100%;
    }
    &[data-orientation="horizontal"] {
      margin-top: calc(var(--spacing) * 4);
    }
    &[data-orientation="vertical"] {
      margin-left: calc(var(--spacing) * 4);
    }
  }
  .tabs__indicator {
    box-shadow: var(--shadow-surface);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: var(--radius-3xl);
    width: 100%;
    height: 100%;
    background-color: var(--segment);
    transition-duration: 250ms;
    transition-property: translate, width, height;
    transition-timing-function: var(--ease-out-fluid);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .tabs--secondary {
    > .tabs__list-container > .tabs__list {
      background-color: transparent;
      padding: calc(var(--spacing) * 0);
      border-radius: 0;
      &[data-orientation="horizontal"] {
        border-bottom-style: var(--tw-border-style);
        border-bottom-width: 1px;
        border-color: var(--border);
        max-width: 100%;
        overflow-x: auto;
        overflow-y: clip;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      &[data-orientation="vertical"] {
        border-left-style: var(--tw-border-style);
        border-left-width: 1px;
        border-color: var(--border);
      }
    }
    > .tabs__list-container .tabs__tab {
      border-radius: 0;
      &[data-selected="true"] {
        color: var(--foreground);
      }
    }
    > .tabs__list-container .tabs__separator {
      display: none;
    }
    > .tabs__list-container .tabs__indicator {
      background-color: var(--accent);
      box-shadow: none;
      border-radius: 0;
    }
    &[data-orientation="horizontal"] > .tabs__list-container .tabs__indicator {
      top: auto;
      bottom: 0;
      height: 2px;
    }
    &[data-orientation="vertical"] > .tabs__list-container .tabs__indicator {
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
    }
  }
  .button {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    height: calc(var(--spacing) * 10);
    width: fit-content;
    transform-origin: center;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: calc(var(--radius) * 3);
    padding-inline: calc(var(--spacing) * 4);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 9);
    }
    transition: transform 250ms var(--ease-smooth), background-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    --button-bg: transparent;
    --button-bg-hover: var(--button-bg);
    --button-bg-pressed: var(--button-bg-hover);
    --button-fg: currentColor;
    background-color: var(--button-bg);
    color: var(--button-fg);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-pending="true"] {
      pointer-events: none;
    }
    &:active, &[data-pressed="true"] {
      background-color: var(--button-bg-pressed);
      transform: scale(0.97);
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--button-bg-hover);
      }
    }
    & svg:not([data-slot="spinner"] svg, [data-slot="link-icon"] svg) {
      pointer-events: none;
      margin-inline: calc(var(--spacing) * -0.5);
      margin-block: calc(var(--spacing) * 0.5);
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
      flex-shrink: 0;
      align-self: center;
      @media (width >= 40rem) {
        margin-block: calc(var(--spacing) * 1);
      }
      @media (width >= 40rem) {
        width: calc(var(--spacing) * 4);
        height: calc(var(--spacing) * 4);
      }
    }
  }
  .button--sm {
    height: calc(var(--spacing) * 9);
    padding-inline: calc(var(--spacing) * 3);
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 8);
    }
    & svg:not([data-slot="spinner"] svg, [data-slot="link-icon"] svg) {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.98);
    }
  }
  .button--lg {
    height: calc(var(--spacing) * 11);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 10);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.96);
    }
  }
  .button--primary {
    --button-bg: var(--color-accent);
    --button-bg-hover: var(--color-accent-hover);
    --button-bg-pressed: var(--color-accent-hover);
    --button-fg: var(--color-accent-foreground);
  }
  .button--secondary {
    --button-bg: var(--color-default);
    --button-bg-hover: var(--color-default-hover);
    --button-bg-pressed: var(--color-default-hover);
    --button-fg: var(--color-accent-soft-foreground);
  }
  .button--tertiary {
    --button-bg: var(--color-default);
    --button-bg-hover: var(--color-default-hover);
    --button-bg-pressed: var(--color-default-hover);
  }
  .button--ghost, .button--outline {
    --button-bg: transparent;
    --button-bg-hover: var(--color-default);
    --button-bg-pressed: var(--color-default);
    --button-fg: var(--color-default-foreground);
  }
  .button--outline {
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--border);
    --button-bg-hover: var(--color-default);
    @supports (color: color-mix(in lab, red, red)) {
      --button-bg-hover: color-mix(in srgb, var(--color-default) 60%, transparent);
    }
  }
  .button--danger {
    --button-bg: var(--color-danger);
    --button-bg-hover: var(--color-danger-hover);
    --button-bg-pressed: var(--color-danger-hover);
    --button-fg: var(--color-danger-foreground);
  }
  .button--danger-soft {
    --button-bg: var(--color-danger-soft);
    --button-bg-hover: var(--color-danger-soft-hover);
    --button-bg-pressed: var(--color-danger-soft-hover);
    --button-fg: var(--color-danger-soft-foreground);
  }
  .button--icon-only {
    width: calc(var(--spacing) * 10);
    padding: calc(var(--spacing) * 0);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 9);
    }
  }
  .button--icon-only.button--sm {
    width: calc(var(--spacing) * 9);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 8);
    }
  }
  .button--icon-only.button--lg {
    width: calc(var(--spacing) * 11);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 10);
    }
  }
  .button--full-width {
    width: 100%;
  }
  .button-group {
    display: inline-flex;
    height: auto;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 0);
  }
  .button-group--horizontal {
    flex-direction: row;
  }
  .button-group--vertical {
    flex-direction: column;
  }
  .button-group .button {
    border-radius: 0;
  }
  .button-group--horizontal .button:first-child {
    border-start-start-radius: calc(var(--radius) * 3);
    border-end-start-radius: calc(var(--radius) * 3);
  }
  .button-group--horizontal .button:last-child {
    border-start-end-radius: calc(var(--radius) * 3);
    border-end-end-radius: calc(var(--radius) * 3);
  }
  .button-group--horizontal .button:first-child:last-child {
    border-radius: calc(var(--radius) * 3);
  }
  .button-group--vertical .button:first-child {
    border-top-left-radius: calc(var(--radius) * 3);
    border-top-right-radius: calc(var(--radius) * 3);
  }
  .button-group--vertical .button:last-child {
    border-bottom-right-radius: calc(var(--radius) * 3);
    border-bottom-left-radius: calc(var(--radius) * 3);
  }
  .button-group--vertical .button:first-child:last-child {
    border-radius: calc(var(--radius) * 3);
  }
  .button-group .button:active, .button-group .button[data-pressed="true"] {
    transform: none;
  }
  .button-group .button:focus-visible:not(:focus), .button-group .button[data-focus-visible="true"] {
    --tw-ring-offset-width: 0px;
    --tw-ring-inset: inset;
  }
  .button-group__separator {
    border-radius: calc(var(--radius) * 0.5);
    background-color: currentcolor;
    opacity: 15%;
    position: absolute;
    pointer-events: none;
    transition: opacity 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .button-group--horizontal & {
      left: -1px;
      top: 25%;
      width: 1px;
      height: 50%;
    }
    .button-group--vertical & {
      left: 25%;
      top: -1px;
      width: 50%;
      height: 1px;
    }
  }
  .button-group--horizontal .button--outline:first-child {
    border-inline-end-style: var(--tw-border-style);
    border-inline-end-width: 0px;
  }
  .button-group--horizontal .button--outline:last-child {
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 0px;
  }
  .button-group--horizontal .button--outline:not(:first-child):not(:last-child) {
    border-inline-style: var(--tw-border-style);
    border-inline-width: 0px;
  }
  .button-group--vertical .button--outline:first-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .button-group--vertical .button--outline:last-child {
    border-top-style: var(--tw-border-style);
    border-top-width: 0px;
  }
  .button-group--vertical .button--outline:not(:first-child):not(:last-child) {
    border-block-style: var(--tw-border-style);
    border-block-width: 0px;
  }
  .button-group--full-width {
    width: 100%;
  }
  .toggle-button {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    height: calc(var(--spacing) * 10);
    width: fit-content;
    transform-origin: center;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: calc(var(--radius) * 3);
    padding-inline: calc(var(--spacing) * 4);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 9);
    }
    transition: transform 250ms var(--ease-smooth), background-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    --toggle-button-bg: var(--color-default);
    --toggle-button-bg-hover: var(--color-default-hover);
    --toggle-button-bg-pressed: var(--color-default-hover);
    --toggle-button-fg: currentColor;
    --toggle-button-bg-selected: var(--color-accent-soft);
    --toggle-button-bg-selected-hover: var(--color-accent-soft-hover);
    --toggle-button-bg-selected-pressed: var(--color-accent-soft-hover);
    --toggle-button-fg-selected: var(--color-accent-soft-foreground);
    background-color: var(--toggle-button-bg);
    color: var(--toggle-button-fg);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--toggle-button-bg-hover);
      }
    }
    &:active, &[data-pressed="true"] {
      background-color: var(--toggle-button-bg-pressed);
      transform: scale(0.97);
    }
    &[data-selected="true"] {
      background-color: var(--toggle-button-bg-selected);
      color: var(--toggle-button-fg-selected);
      @media (hover: hover) {
        &:hover, &[data-hovered="true"] {
          background-color: var(--toggle-button-bg-selected-hover);
        }
      }
      &:active, &[data-pressed="true"] {
        background-color: var(--toggle-button-bg-selected-pressed);
      }
    }
    & svg {
      pointer-events: none;
      margin-inline: calc(var(--spacing) * -0.5);
      margin-block: calc(var(--spacing) * 0.5);
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
      flex-shrink: 0;
      align-self: center;
      @media (width >= 40rem) {
        margin-block: calc(var(--spacing) * 1);
      }
      @media (width >= 40rem) {
        width: calc(var(--spacing) * 4);
        height: calc(var(--spacing) * 4);
      }
    }
  }
  .toggle-button--sm {
    height: calc(var(--spacing) * 9);
    padding-inline: calc(var(--spacing) * 3);
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 8);
    }
    & svg {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.98);
    }
  }
  .toggle-button--lg {
    height: calc(var(--spacing) * 11);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 10);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.96);
    }
  }
  .toggle-button--default {
    --toggle-button-bg: var(--color-default);
    --toggle-button-bg-hover: var(--color-default-hover);
    --toggle-button-bg-pressed: var(--color-default-hover);
  }
  .toggle-button--ghost {
    --toggle-button-bg: transparent;
    --toggle-button-bg-hover: var(--color-default);
    --toggle-button-bg-pressed: var(--color-default);
    --toggle-button-fg: var(--color-default-foreground);
  }
  .toggle-button--icon-only {
    width: calc(var(--spacing) * 10);
    padding: calc(var(--spacing) * 0);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 9);
    }
  }
  .toggle-button--icon-only.toggle-button--sm {
    width: calc(var(--spacing) * 9);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 8);
    }
  }
  .toggle-button--icon-only.toggle-button--lg {
    width: calc(var(--spacing) * 11);
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 10);
    }
  }
  .toggle-button-group {
    display: inline-flex;
    height: auto;
    width: fit-content;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 0);
  }
  .toggle-button-group--horizontal {
    flex-direction: row;
  }
  .toggle-button-group--vertical {
    flex-direction: column;
  }
  .toggle-button-group--full-width {
    width: 100%;
  }
  .toggle-button-group .toggle-button {
    border-radius: 0;
  }
  .toggle-button-group--horizontal .toggle-button:first-child {
    border-start-start-radius: calc(var(--radius) * 3);
    border-end-start-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--horizontal .toggle-button:last-child {
    border-start-end-radius: calc(var(--radius) * 3);
    border-end-end-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--horizontal .toggle-button:first-child:last-child {
    border-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--vertical .toggle-button:first-child {
    border-top-left-radius: calc(var(--radius) * 3);
    border-top-right-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--vertical .toggle-button:last-child {
    border-bottom-right-radius: calc(var(--radius) * 3);
    border-bottom-left-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--vertical .toggle-button:first-child:last-child {
    border-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group .toggle-button:active, .toggle-button-group .toggle-button[data-pressed="true"] {
    transform: none;
  }
  .toggle-button-group .toggle-button:focus-visible:not(:focus), .toggle-button-group .toggle-button[data-focus-visible="true"] {
    --tw-ring-offset-width: 0px;
    --tw-ring-inset: inset;
  }
  .toggle-button-group--full-width .toggle-button {
    flex: 1;
  }
  .toggle-button-group__separator {
    border-radius: calc(var(--radius) * 0.5);
    background-color: currentcolor;
    opacity: 15%;
    position: absolute;
    pointer-events: none;
    transition: opacity 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .toggle-button-group--horizontal & {
      left: -1px;
      top: 25%;
      width: 1px;
      height: 50%;
    }
    .toggle-button-group--vertical & {
      left: 25%;
      top: -1px;
      width: 50%;
      height: 1px;
    }
  }
  .toggle-button-group--detached {
    gap: calc(var(--spacing) * 1);
  }
  .toggle-button-group--detached .toggle-button {
    border-radius: calc(var(--radius) * 3);
  }
  .toggle-button-group--detached .toggle-button-group__separator {
    display: none;
  }
  .toolbar {
    display: grid;
    width: fit-content;
    grid-auto-flow: column;
    align-items: center;
    gap: calc(var(--spacing) * 2);
    .separator--vertical {
      height: calc(1 / 2 * 100%);
      align-self: center;
    }
    .separator--horizontal {
      width: calc(1 / 2 * 100%);
      justify-content: center;
      justify-self: center;
    }
  }
  .toolbar--vertical {
    grid-auto-flow: row;
    align-items: flex-start;
    justify-content: flex-start;
    .button-group {
      justify-content: flex-start;
    }
  }
  .toolbar--attached {
    border-radius: calc(var(--radius) * 3);
    background-color: var(--surface);
    padding: calc(var(--spacing) * 1);
    --tw-shadow: var(--overlay-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .dropdown {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
  }
  .dropdown__trigger {
    display: inline-block;
    --tw-outline-style: none;
    outline-style: none;
    transition: transform 250ms var(--ease-out-quart), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-pending="true"] {
      pointer-events: none;
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.97);
    }
  }
  .dropdown__popover {
    max-width: 48svw;
    transform-origin: var(--trigger-anchor-point);
    scroll-padding-block: calc(var(--spacing) * 1);
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 0);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    @media (width >= 48rem) {
      min-width: calc(var(--spacing) * 55);
    }
    border-radius: min(32px, var(--radius-3xl));
    box-shadow: var(--shadow-overlay);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(90*1%);
      --tw-enter-scale: .9;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="popover-overlay-arrow"] {
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="popover-overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="popover-overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="popover-overlay-arrow"] {
      rotate: 90deg;
    }
    [data-slot="dropdown-menu"] {
      padding: calc(var(--spacing) * 1.5);
      --tw-outline-style: none;
      outline-style: none;
    }
    [data-slot="menu-item"] {
      padding-inline: calc(var(--spacing) * 2.5);
    }
  }
  .dropdown__menu {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: calc(var(--spacing) * 0.5);
    overflow: clip;
    padding: calc(var(--spacing) * 1);
    [data-slot="separator"] {
      margin-left: 3%;
      width: 94%;
    }
  }
  .list-box-item {
    position: relative;
    display: flex;
    min-height: calc(var(--spacing) * 9);
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: calc(var(--spacing) * 3);
    border-radius: calc(var(--radius) * 2);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 1.5);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    transition: transform 250ms var(--ease-out-quart), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    [data-slot="label"] {
      pointer-events: none;
      width: fit-content;
      -webkit-user-select: none;
      user-select: none;
    }
    [data-slot="description"] {
      pointer-events: none;
      text-wrap: wrap;
      -webkit-user-select: none;
      user-select: none;
    }
    &:has(.list-box-item__indicator) {
      padding-right: calc(var(--spacing) * 7);
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.98);
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
      }
    }
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .list-box-item__indicator {
    position: absolute;
    top: calc(1 / 2 * 100%);
    right: calc(var(--spacing) * 2);
    display: flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    align-items: center;
    justify-content: center;
    color: var(--default-foreground);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 250ms;
    transition-duration: 250ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    [data-slot="list-box-item-indicator--checkmark"] {
      width: calc(var(--spacing) * 2.5);
      height: calc(var(--spacing) * 2.5);
      transition-property: all;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
      --tw-duration: 300ms;
      transition-duration: 300ms;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    .list-box-item[aria-selected="true"] [data-slot="list-box-item-indicator--checkmark"], .list-box-item[data-selected="true"] [data-slot="list-box-item-indicator--checkmark"] {
      transition: stroke-dashoffset 250ms linear;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
  }
  .list-box-item--danger {
    .list-box-item__indicator {
      color: var(--danger);
    }
    [data-slot="label"] {
      color: var(--danger);
    }
  }
  .list-box-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: calc(var(--spacing) * 0);
  }
  .list-box {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    overflow: clip;
    padding: calc(var(--spacing) * 1);
    [data-slot="separator"][data-orientation="horizontal"] {
      margin-left: 3%;
      width: 94%;
    }
  }
  .menu-item {
    position: relative;
    display: flex;
    min-height: calc(var(--spacing) * 9);
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: calc(var(--spacing) * 3);
    border-radius: calc(var(--radius) * 2);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 1.5);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    transition: transform 250ms var(--ease-out-quart), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    [data-slot="label"] {
      pointer-events: none;
      width: fit-content;
      -webkit-user-select: none;
      user-select: none;
    }
    [data-slot="description"] {
      pointer-events: none;
      text-wrap: wrap;
      -webkit-user-select: none;
      user-select: none;
    }
    [data-slot="submenu-indicator"] svg {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
    }
    &:has(.menu-item__indicator) {
      padding-left: calc(var(--spacing) * 7);
    }
    &[data-has-submenu="true"]:has(.menu-item__indicator) {
      padding-right: calc(var(--spacing) * 7);
      padding-left: calc(var(--spacing) * 2);
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.98);
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
      }
    }
    &[aria-checked="true"], &[aria-selected="true"], &[data-selected="true"] {
      [data-slot="menu-item-indicator--checkmark"] {
        transition: stroke-dashoffset 100ms linear;
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            transition-property: none;
            &::before, &::after {
              transition-property: none;
            }
          }
        }
      }
      [data-slot="menu-item-indicator--dot"] {
        --tw-scale-x: 100%;
        --tw-scale-y: 100%;
        --tw-scale-z: 100%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
        opacity: 100%;
      }
    }
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .menu-item__indicator {
    position: absolute;
    top: calc(1 / 2 * 100%);
    left: calc(var(--spacing) * 2);
    display: flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    align-items: center;
    justify-content: center;
    color: var(--muted);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 250ms;
    transition-duration: 250ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .menu-item[data-has-submenu="true"] & {
      right: calc(var(--spacing) * 2);
      left: auto;
    }
    [data-slot="menu-item-indicator--checkmark"] {
      width: calc(var(--spacing) * 2.5);
      height: calc(var(--spacing) * 2.5);
      .menu-item[data-selection-mode="multiple"] & {
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration));
        --tw-duration: 300ms;
        transition-duration: 300ms;
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            transition-property: none;
            &::before, &::after {
              transition-property: none;
            }
          }
        }
      }
    }
    [data-slot="menu-item-indicator--dot"] {
      width: calc(var(--spacing) * 2);
      height: calc(var(--spacing) * 2);
      .menu-item[data-selection-mode="multiple"] & {
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration));
        --tw-duration: 250ms;
        transition-duration: 250ms;
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            transition-property: none;
            &::before, &::after {
              transition-property: none;
            }
          }
        }
      }
      --tw-scale-x: 70%;
      --tw-scale-y: 70%;
      --tw-scale-z: 70%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
      opacity: 0%;
    }
  }
  .menu-item__indicator--submenu {
    color: var(--muted);
    svg {
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
    }
  }
  .menu-item--danger {
    .menu-item__indicator {
      color: var(--danger);
    }
    [data-slot="label"] {
      color: var(--danger);
    }
  }
  .menu-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: calc(var(--spacing) * 0);
  }
  .menu {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    overflow: clip;
    padding: calc(var(--spacing) * 1);
    [data-slot="separator"] {
      margin-left: 3%;
      width: 94%;
    }
  }
  .tag-group {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
  }
  .tag-group__list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--spacing) * 1.5);
  }
  .tag-group [slot="description"], .tag-group [data-slot="description"], .tag-group [slot="errorMessage"], .tag-group [data-slot="error-message"] {
    padding: calc(var(--spacing) * 1);
  }
  .tag {
    --optical-offset: 0.031em;
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing) * 1);
    border-radius: calc(var(--radius) * 1.5);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    transition: color 100ms var(--ease-smooth), scale 100ms var(--ease-smooth), opacity 100ms var(--ease-smooth), background-color 100ms var(--ease-smooth), box-shadow 100ms var(--ease-out);
    transform-origin: center;
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    & svg {
      pointer-events: none;
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
      flex-shrink: 0;
      align-self: center;
      color: currentcolor;
    }
  }
  .tag:is([data-disabled="true"], [aria-disabled="true"]) {
    opacity: var(--disabled-opacity);
    cursor: var(--cursor-disabled);
    pointer-events: none;
  }
  .tag:is(:focus-visible, [data-focus-visible]) {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-ring-color: var(--focus);
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-offset-color: var(--background);
    --tw-outline-style: none;
    outline-style: none;
    --tw-ring-offset-width: var(--ring-offset-width);
  }
  .tag:is([data-selected="true"], [aria-selected="true"]) {
    background-color: var(--accent-soft, var(--accent));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
    }
    color: var(--accent-soft-foreground, var(--accent));
    @media (hover: hover) {
      &:is(:hover, [data-hovered="true"]) {
        background-color: var(
    --accent-soft-hover,
    var(--accent)
  );
        @supports (color: color-mix(in lab, red, red)) {
          background-color: var(
    --accent-soft-hover,
    color-mix(in oklab, var(--accent) 20%, transparent)
  );
        }
      }
    }
  }
  .tag--sm {
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .tag--md {
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 1);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .tag--lg {
    border-radius: calc(var(--radius) * 2);
    padding-inline: calc(var(--spacing) * 2.5);
    padding-block: calc(var(--spacing) * 1.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .tag--default {
    background-color: var(--default);
    color: var(--default-foreground);
    @media (hover: hover) {
      &:is(:hover, [data-hovered="true"]):not([data-selected="true"]):not([data-disabled="true"]) {
        background-color: var(--default);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--default) 96%, var(--default-foreground) 4%);
        }
      }
    }
  }
  .tag--surface {
    background-color: var(--surface);
    color: var(--surface-foreground);
    @media (hover: hover) {
      &:is(:hover, [data-hovered="true"]):not([data-selected="true"]):not([data-disabled="true"]) {
        background-color: var(--surface);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--surface) 92%, var(--surface-foreground) 8%);
        }
      }
    }
  }
  .tag__remove-button {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
    color: inherit;
    & svg {
      width: inherit;
      height: inherit;
      flex-shrink: 0;
      align-self: center;
      color: currentcolor;
    }
  }
  .color-area {
    position: relative;
    width: 100%;
    max-width: calc(var(--spacing) * 56);
    flex-shrink: 0;
    border-radius: calc(var(--radius) * 2);
    -webkit-tap-highlight-color: transparent;
    aspect-ratio: 1 / 1;
    background: var(--color-area-background);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .color-area--show-dots {
    &::after {
      content: "";
      pointer-events: none;
      position: absolute;
      inset: calc(var(--spacing) * 0);
      border-radius: inherit;
      background-image: radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
      background-size: 8px 8px;
    }
  }
  .color-area__thumb {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    border-radius: calc(var(--radius) * 1.5);
    will-change: width,height;
    background-color: var(--color-area-thumb-color);
    border: 3px solid white;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    transition: width 150ms var(--ease-out), height 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &[data-dragging="true"] {
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
    }
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .color-picker {
    display: inline-flex;
  }
  .color-picker__trigger {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing) * 3);
    border-radius: calc(var(--radius) * 0.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    transition: background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    [data-slot="label"] {
      cursor: var(--cursor-interactive);
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .color-picker__popover {
    min-width: calc(var(--spacing) * 62);
    transform-origin: var(--trigger-anchor-point);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding-inline: calc(var(--spacing) * 2);
    padding-top: calc(var(--spacing) * 2);
    padding-bottom: calc(var(--spacing) * 3);
    box-shadow: var(--shadow-overlay);
    border-radius: min(32px, calc(var(--radius) * 2.5));
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement^="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement^="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement^="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement^="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
  }
  .color-slider {
    display: grid;
    width: 100%;
    gap: calc(var(--spacing) * 1);
    grid-template-areas: "label output" "track track";
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    &:not(:has([data-slot="label"])):not(:has(.color-slider__output)) {
      grid-template-areas: "track";
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      gap: 0;
    }
    &:has([data-slot="label"]):not(:has(.color-slider__output)) {
      grid-template-areas: "label" "track";
      grid-template-columns: 1fr;
    }
    &:not(:has([data-slot="label"])):has(.color-slider__output) {
      grid-template-areas: "output" "track";
      grid-template-columns: 1fr;
      .color-slider__output {
        justify-self: end;
      }
    }
    [data-slot="label"] {
      width: fit-content;
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      grid-area: label;
    }
    .color-slider__output {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      --tw-numeric-spacing: tabular-nums;
      font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
      grid-area: output;
    }
    .color-slider__track {
      position: relative;
      border-radius: calc(var(--radius) * 2);
      grid-area: track;
      &::before, &::after {
        content: "";
        position: absolute;
        z-index: 0;
        pointer-events: none;
      }
    }
    .color-slider__thumb {
      position: absolute;
      display: flex;
      cursor: grab;
      align-items: center;
      justify-content: center;
      border-radius: calc(var(--radius) * 2);
      -webkit-tap-highlight-color: transparent;
      border-style: var(--tw-border-style);
      border-width: 3px;
      border-color: var(--color-white);
      --tw-shadow: var(--overlay-shadow);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      z-index: 1;
      transition: transform 250ms var(--ease-out), box-shadow 150ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
      &[data-dragging="true"] {
        cursor: grabbing;
      }
      &[data-focus-visible="true"] {
        z-index: 10;
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--focus);
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-color: var(--background);
        --tw-outline-style: none;
        outline-style: none;
        --tw-ring-offset-width: var(--ring-offset-width);
      }
      &[data-disabled="true"] {
        cursor: default;
        background-color: var(--default);
      }
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      [data-slot="label"] {
        opacity: 100%;
      }
    }
    &[data-orientation="horizontal"] {
      flex-direction: column;
      .color-slider__track {
        height: calc(var(--spacing) * 5);
        justify-self: center;
        border-radius: 0;
        width: calc(100% - 1.25rem);
        box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
        &::before, &::after {
          top: calc(var(--spacing) * 0);
          height: 100%;
          width: 0.625rem;
        }
        &::before {
          border-top-left-radius: calc(var(--radius) * 2);
          border-bottom-left-radius: calc(var(--radius) * 2);
          left: -0.625rem;
          box-shadow: inset 1px 0 0 0 rgba(0, 0, 0, 0.1), inset 0 1px 0 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
          background: linear-gradient(var(--track-start-color, transparent)), repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;
        }
        &::after {
          border-top-right-radius: calc(var(--radius) * 2);
          border-bottom-right-radius: calc(var(--radius) * 2);
          right: -0.625rem;
          box-shadow: inset -1px 0 0 0 rgba(0, 0, 0, 0.1), inset 0 1px 0 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
          background-color: var(--track-end-color, transparent);
        }
      }
      .color-slider__thumb {
        top: calc(1 / 2 * 100%);
        width: calc(var(--spacing) * 4);
        height: calc(var(--spacing) * 4);
      }
    }
    &[data-orientation="vertical"] {
      height: 100%;
      gap: calc(var(--spacing) * 2);
      flex-direction: row;
      grid-template-areas: "output" "track" "label";
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;
      align-items: center;
      justify-items: center;
      &:not(:has([data-slot="label"])):not(:has(.color-slider__output)) {
        grid-template-areas: "track";
        grid-template-rows: 1fr;
        gap: 0;
      }
      &:has([data-slot="label"]):not(:has(.color-slider__output)) {
        grid-template-areas: "track" "label";
        grid-template-rows: 1fr auto;
      }
      &:not(:has([data-slot="label"])):has(.color-slider__output) {
        grid-template-areas: "output" "track";
        grid-template-rows: auto 1fr;
      }
      .color-slider__output {
        text-align: center;
      }
      [data-slot="label"] {
        text-align: center;
      }
      .color-slider__track {
        width: calc(var(--spacing) * 5);
        justify-self: center;
        border-radius: 0;
        height: calc(100% - 1.25rem);
        box-shadow: inset 1px 0 0 0 rgba(0, 0, 0, 0.1), inset -1px 0 0 0 rgba(0, 0, 0, 0.1);
        &::before, &::after {
          left: calc(var(--spacing) * 0);
          width: 100%;
          height: 0.625rem;
        }
        &::before {
          bottom: -0.625rem;
          border-bottom-left-radius: 999px;
          border-bottom-right-radius: 999px;
          box-shadow: inset 1px 0 0 0 rgba(0, 0, 0, 0.1), inset -1px 0 0 0 rgba(0, 0, 0, 0.1), inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
          background: linear-gradient(var(--track-start-color, transparent)), repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;
        }
        &::after {
          top: -0.625rem;
          border-top-left-radius: 999px;
          border-top-right-radius: 999px;
          box-shadow: inset 1px 0 0 0 rgba(0, 0, 0, 0.1), inset -1px 0 0 0 rgba(0, 0, 0, 0.1), inset 0 1px 0 0 rgba(0, 0, 0, 0.1);
          background-color: var(--track-end-color, transparent);
        }
      }
      .color-slider__thumb {
        left: calc(1 / 2 * 100%);
        width: calc(var(--spacing) * 4);
        height: calc(var(--spacing) * 4);
      }
    }
  }
  .color-swatch {
    position: relative;
    box-sizing: border-box;
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
    flex-shrink: 0;
    background: linear-gradient(var(--color-swatch-current), var(--color-swatch-current)), repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  }
  .color-swatch--circle {
    border-radius: calc(var(--radius) * 2);
  }
  .color-swatch--square {
    border-radius: calc(var(--radius) * 0.75);
  }
  .color-swatch--xs {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    &.color-swatch--circle {
      border-radius: calc(var(--radius) * 1);
    }
  }
  .color-swatch--sm {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
    &.color-swatch--circle {
      border-radius: calc(var(--radius) * 1.5);
    }
  }
  .color-swatch--lg {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
    &.color-swatch--circle {
      border-radius: calc(var(--radius) * 3);
    }
  }
  .color-swatch--xl {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
    &.color-swatch--circle {
      border-radius: calc(var(--radius) * 3);
    }
  }
  .color-swatch-picker {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: calc(var(--spacing) * 2);
  }
  .color-swatch-picker__item {
    position: relative;
    display: flex;
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 2);
    border-style: var(--tw-border-style);
    border-width: 2px;
    border-color: transparent;
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    transition: border-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible, &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-selected="true"] {
      border-color: var(--color-swatch-current);
      box-shadow: var(--field-shadow);
      .color-swatch-picker__swatch {
        transform: scale(0.77);
      }
    }
  }
  .color-swatch-picker__swatch {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    transition: transform 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  .color-swatch-picker__indicator {
    pointer-events: none;
    position: absolute;
    inset: calc(var(--spacing) * 0);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    & > * {
      width: calc(1 / 3 * 100%);
      height: calc(1 / 3 * 100%);
      color: var(--color-white);
      transform: scale(0) translateZ(0);
      transition: transform 150ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &[data-light-color="true"] & > * {
      color: var(--color-black);
    }
    .color-swatch-picker__item[data-selected="true"] & > * {
      transform: scale(1) translateZ(0);
    }
  }
  .color-swatch-picker--stack {
    flex-direction: column;
  }
  .color-swatch-picker--xs {
    .color-swatch-picker__item {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
      border-radius: calc(var(--radius) * 1);
      border-style: var(--tw-border-style);
      border-width: 1px;
    }
  }
  .color-swatch-picker--sm {
    .color-swatch-picker__item {
      width: calc(var(--spacing) * 6);
      height: calc(var(--spacing) * 6);
      border-radius: calc(var(--radius) * 1.5);
      border-style: var(--tw-border-style);
      border-width: 2px;
    }
  }
  .color-swatch-picker--lg {
    .color-swatch-picker__item {
      width: calc(var(--spacing) * 9);
      height: calc(var(--spacing) * 9);
      border-radius: calc(var(--radius) * 3);
      border-style: var(--tw-border-style);
      border-width: 3px;
    }
  }
  .color-swatch-picker--xl {
    .color-swatch-picker__item {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
      border-radius: calc(var(--radius) * 3);
      border-style: var(--tw-border-style);
      border-width: 3px;
    }
  }
  .color-swatch-picker--square {
    .color-swatch-picker__item {
      border-radius: calc(var(--radius) * 1.5);
      .color-swatch-picker__swatch {
        border-radius: calc(var(--radius) * 1);
      }
      &[data-selected="true"] {
        .color-swatch-picker__swatch {
          border-radius: calc(var(--radius) * 1);
        }
      }
    }
  }
  .color-swatch-picker--square.color-swatch-picker--xs {
    .color-swatch-picker__item {
      border-radius: calc(var(--radius) * 0.75);
      .color-swatch-picker__swatch {
        border-radius: calc(var(--radius) * 0.75);
      }
      &[data-selected="true"] {
        .color-swatch-picker__swatch {
          border-radius: calc(var(--radius) * 0.75);
        }
      }
    }
  }
  .color-swatch-picker--square.color-swatch-picker--sm {
    .color-swatch-picker__item {
      border-radius: calc(var(--radius) * 1);
      .color-swatch-picker__swatch {
        border-radius: calc(var(--radius) * 1);
      }
      &[data-selected="true"] {
        .color-swatch-picker__swatch {
          border-radius: calc(var(--radius) * 0.75);
        }
      }
    }
  }
  .color-swatch-picker--square.color-swatch-picker--lg {
    .color-swatch-picker__item {
      border-radius: calc(var(--radius) * 1.5);
      .color-swatch-picker__swatch {
        border-radius: calc(var(--radius) * 1);
      }
      &[data-selected="true"] {
        .color-swatch-picker__swatch {
          border-radius: calc(var(--radius) * 1);
        }
      }
    }
  }
  .color-swatch-picker--square.color-swatch-picker--xl {
    .color-swatch-picker__item {
      border-radius: calc(var(--radius) * 1.5);
      .color-swatch-picker__swatch {
        border-radius: calc(var(--radius) * 1);
      }
      &[data-selected="true"] {
        .color-swatch-picker__swatch {
          border-radius: calc(var(--radius) * 1);
        }
      }
    }
  }
  .color-input-group {
    display: inline-flex;
    height: calc(var(--spacing) * 9);
    align-items: center;
    overflow: hidden;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &[data-focus-within="true"], &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
      border-color: var(--color-field-border-invalid);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .color-input-group__input {
    display: flex;
    height: 100%;
    flex: 1;
    cursor: text;
    align-items: center;
    border-radius: 0;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    &::placeholder {
      color: var(--field-placeholder, var(--muted));
    }
    .color-input-group:has([data-slot="color-input-group-prefix"]) & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: calc(var(--spacing) * 2);
    }
    .color-input-group:has([data-slot="color-input-group-suffix"]) & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding-right: calc(var(--spacing) * 2);
    }
    &:focus, &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .color-input-group__prefix {
    flex-shrink: 0;
    color: var(--field-placeholder, var(--muted));
    margin-right: calc(var(--spacing) * 0);
    margin-left: calc(var(--spacing) * 3);
    display: flex;
    align-items: center;
  }
  .color-input-group__suffix {
    flex-shrink: 0;
    color: var(--field-placeholder, var(--muted));
    margin-right: calc(var(--spacing) * 3);
    display: flex;
    align-items: center;
  }
  .color-input-group--secondary {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--color-input-group-bg);
    --color-input-group-bg: var(--color-default);
    --color-input-group-bg-hover: var(--color-default-hover);
    --color-input-group-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--color-input-group-bg-hover);
      }
    }
    &:focus-within, &[data-focus-within="true"] {
      background-color: var(--color-input-group-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      border-color: var(--color-field-border-invalid);
      background-color: var(--color-input-group-bg-focus);
    }
    [data-slot="color-input-group-input"] {
      background-color: transparent;
    }
  }
  .color-input-group--full-width {
    width: 100%;
  }
  .color-field {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
  }
  .color-field--full-width {
    width: 100%;
  }
  .slider {
    display: grid;
    width: 100%;
    gap: calc(var(--spacing) * 1);
    grid-template-areas: "label output" "track track";
    grid-template-columns: 1fr auto;
    [data-slot="label"] {
      width: fit-content;
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      grid-area: label;
    }
    .slider__output {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      --tw-numeric-spacing: tabular-nums;
      font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
      grid-area: output;
    }
    .slider__track {
      position: relative;
      border-radius: calc(var(--radius) * 1.5);
      background-color: var(--default);
      grid-area: track;
    }
    .slider__fill {
      pointer-events: none;
      position: absolute;
      background-color: var(--accent);
    }
    .slider__thumb {
      position: absolute;
      display: flex;
      cursor: grab;
      align-items: center;
      justify-content: center;
      border-radius: calc(var(--radius) * 1.5);
      background-color: var(--accent);
      -webkit-tap-highlight-color: transparent;
      transition: background-color 250ms var(--ease-smooth), transform 250ms var(--ease-out), box-shadow 150ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
      &::after {
        position: relative;
        z-index: 10;
        border-radius: calc(var(--radius) * 1);
        background-color: var(--accent-foreground);
        color: var(--color-black);
        --tw-shadow: var(--field-shadow);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        content: "";
        transform-origin: center;
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration));
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            transition-property: none;
            &::before, &::after {
              transition-property: none;
            }
          }
        }
      }
      &[data-dragging="true"] {
        cursor: grabbing;
        &::after {
          scale: 0.9;
          &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
            --tw-scale-x: 100%;
            --tw-scale-y: 100%;
            --tw-scale-z: 100%;
            scale: var(--tw-scale-x) var(--tw-scale-y);
            &::before, &::after {
              --tw-scale-x: 100%;
              --tw-scale-y: 100%;
              --tw-scale-z: 100%;
              scale: var(--tw-scale-x) var(--tw-scale-y);
            }
          }
          @media (prefers-reduced-motion: reduce) {
            &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
              --tw-scale-x: 100%;
              --tw-scale-y: 100%;
              --tw-scale-z: 100%;
              scale: var(--tw-scale-x) var(--tw-scale-y);
              &::before, &::after {
                --tw-scale-x: 100%;
                --tw-scale-y: 100%;
                --tw-scale-z: 100%;
                scale: var(--tw-scale-x) var(--tw-scale-y);
              }
            }
          }
        }
      }
      &[data-focus-visible="true"] {
        z-index: 10;
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--focus);
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-color: var(--background);
        --tw-outline-style: none;
        outline-style: none;
        --tw-ring-offset-width: var(--ring-offset-width);
      }
      &[data-disabled="true"] {
        cursor: default;
      }
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      [data-slot="label"] {
        opacity: 100%;
      }
    }
    &[data-orientation="horizontal"] {
      flex-direction: column;
      .slider__track {
        height: calc(var(--spacing) * 5);
        width: 100%;
        border-inline-style: var(--tw-border-style);
        border-inline-width: 0.75rem;
        border-inline-color: transparent;
        &[data-fill-start="true"] {
          border-inline-start-color: var(--accent);
        }
        &[data-fill-end="true"] {
          border-inline-end-color: var(--accent);
        }
      }
      .slider__fill, .slider__thumb {
        height: 100%;
      }
      .slider__thumb {
        top: calc(1 / 2 * 100%);
        width: calc(1.5rem + 0.25rem);
        &::after {
          width: 1.5rem;
          height: 1rem;
        }
      }
    }
    &[data-orientation="vertical"] {
      height: 100%;
      gap: calc(var(--spacing) * 2);
      flex-direction: row;
      grid-template-areas: "output" "track" "label";
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;
      .slider__output {
        text-align: center;
      }
      [data-slot="label"] {
        text-align: center;
      }
      .slider__track {
        height: 100%;
        width: calc(var(--spacing) * 5);
        border-block-style: var(--tw-border-style);
        border-block-width: 0.75rem;
        border-block-color: transparent;
        justify-self: center;
        &[data-fill-start="true"] {
          border-bottom-color: var(--accent);
        }
        &[data-fill-end="true"] {
          border-top-color: var(--accent);
        }
      }
      .slider__fill, .slider__thumb {
        width: 100%;
      }
      .slider__thumb {
        left: calc(1 / 2 * 100%);
        height: calc(1.5rem + 0.25rem);
        &::after {
          width: 1rem;
          height: 1.5rem;
        }
      }
    }
  }
  .switch {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing) * 3);
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    --switch-control-bg: var(--color-default);
    --switch-control-bg-hover: var(--switch-control-bg);
    @supports (color: color-mix(in lab, red, red)) {
      --switch-control-bg-hover: color-mix(in oklab, var(--switch-control-bg), transparent 20%);
    }
    --switch-control-bg-pressed: var(--switch-control-bg-hover);
    --switch-control-bg-checked: var(--color-accent);
    --switch-control-bg-checked-hover: var(--color-accent-hover);
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      .switch__thumb {
        background-color: var(--default-foreground);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--default-foreground) 20%, transparent);
        }
      }
    }
    &:disabled[aria-checked="true"], &:disabled[data-selected="true"], &[data-disabled="true"][aria-checked="true"], &[data-disabled="true"][data-selected="true"], &[aria-disabled="true"][aria-checked="true"], &[aria-disabled="true"][data-selected="true"] {
      .switch__thumb {
        opacity: 0.4;
      }
    }
  }
  .switch__control {
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    overflow: hidden;
    border-radius: calc(var(--radius) * 1.5);
    height: 1.25rem;
    width: 2.5rem;
    background-color: var(--switch-control-bg);
    transition: background-color 250ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .switch:focus-visible &, .switch[data-focus-visible="true"] & {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    .switch:hover &, .switch[data-hovered="true"] & {
      background-color: var(--switch-control-bg-hover);
    }
    .switch:active &, .switch[data-pressed="true"] & {
      background-color: var(--switch-control-bg-pressed);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transform: none;
        &::before, &::after {
          transform: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transform: none;
          &::before, &::after {
            transform: none;
          }
        }
      }
    }
    .switch[aria-checked="true"] &, .switch[data-selected="true"] & {
      background-color: var(--switch-control-bg-checked);
    }
    .switch[aria-checked="true"]:hover &, .switch[data-selected="true"]:hover &, .switch[aria-checked="true"][data-hovered="true"] &, .switch[data-selected="true"][data-hovered="true"] & {
      background-color: var(--switch-control-bg-checked-hover);
    }
    .switch[aria-checked="true"]:active &, .switch[data-selected="true"]:active &, .switch[aria-checked="true"][data-pressed="true"] &, .switch[data-selected="true"][data-pressed="true"] & {
      background-color: var(--switch-control-bg-checked-hover);
    }
  }
  .switch--sm .switch__control {
    border-radius: calc(var(--radius) * 1);
    height: 1rem;
    width: 2rem;
  }
  .switch--lg .switch__control {
    height: 1.5rem;
    width: 3rem;
  }
  .switch__thumb {
    margin-inline-start: calc(var(--spacing) * 0.5);
    display: flex;
    transform-origin: center;
    border-radius: calc(var(--radius) * 1);
    background-color: var(--color-white);
    color: var(--color-black);
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    height: 1rem;
    width: 1.375rem;
    transition: margin 300ms var(--ease-out-fluid), background-color 200ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .switch[aria-checked="true"] &, .switch[data-selected="true"] & {
      margin-inline-start: calc(100% - 1.5rem);
      background-color: var(--accent-foreground);
      color: var(--accent);
      box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 0.02), 0px 2px 10px 0px rgb(0 0 0 / 0.06), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
    }
  }
  .switch--sm .switch__thumb {
    border-radius: calc(var(--radius) * 0.75);
    height: 0.75rem;
    width: 1.03125rem;
    .switch[aria-checked="true"] &, .switch[data-selected="true"] & {
      margin-inline-start: calc(100% - 1.15625rem);
    }
  }
  .switch--lg .switch__thumb {
    border-radius: calc(var(--radius) * 1.5);
    height: 1.25rem;
    width: 1.71875rem;
    .switch[aria-checked="true"] &, .switch[data-selected="true"] & {
      margin-inline-start: calc(100% - 1.84375rem);
    }
  }
  .switch__thumb > * {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .switch__label {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .switch__content {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 0);
  }
  .switch-group {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 6);
  }
  .switch-group__items {
    display: flex;
    gap: calc(var(--spacing) * 4);
  }
  .switch-group--horizontal .switch-group__items {
    flex-direction: row;
  }
  .switch-group--vertical .switch-group__items {
    flex-direction: column;
  }
  .badge {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 0.5);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    min-height: calc(var(--spacing) * 7);
    min-width: calc(var(--spacing) * 7);
    border-radius: calc(var(--radius) * 3);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: 1.34;
    line-height: 1.34;
    --badge-bg: var(--color-default);
    --badge-fg: var(--color-default-foreground);
    --badge-border: var(--color-background);
    background-color: var(--badge-bg);
    color: var(--badge-fg);
    border: 1px solid var(--badge-border);
  }
  .badge__label {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .badge-anchor {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
  }
  .badge--lg {
    min-height: calc(var(--spacing) * 8);
    min-width: calc(var(--spacing) * 8);
    border-radius: calc(var(--radius) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: 1.43;
    line-height: 1.43;
  }
  .badge--sm {
    min-height: calc(var(--spacing) * 4);
    min-width: calc(var(--spacing) * 4);
    border-radius: calc(var(--radius) * 1.5);
    font-size: 10px;
    --tw-leading: 1.34;
    line-height: 1.34;
  }
  .badge--accent {
    --badge-fg: var(--color-accent-soft-foreground);
  }
  .badge--default {
    --badge-fg: var(--color-default-foreground);
  }
  .badge--success {
    --badge-fg: var(--color-success);
  }
  .badge--warning {
    --badge-fg: var(--color-warning);
  }
  .badge--danger {
    --badge-fg: var(--color-danger);
  }
  .badge--top-right {
    position: absolute;
    top: calc(var(--spacing) * 0);
    right: calc(var(--spacing) * 0);
    transform: translate(25%, -25%);
  }
  .badge--top-left {
    position: absolute;
    top: calc(var(--spacing) * 0);
    left: calc(var(--spacing) * 0);
    transform: translate(-25%, -25%);
  }
  .badge--bottom-right {
    position: absolute;
    right: calc(var(--spacing) * 0);
    bottom: calc(var(--spacing) * 0);
    transform: translate(25%, 25%);
  }
  .badge--bottom-left {
    position: absolute;
    bottom: calc(var(--spacing) * 0);
    left: calc(var(--spacing) * 0);
    transform: translate(-25%, 25%);
  }
  .badge--primary.badge--accent {
    --badge-bg: var(--color-accent);
    --badge-fg: var(--color-accent-foreground);
  }
  .badge--primary.badge--default {
    --badge-bg: var(--color-default);
    --badge-fg: var(--color-default-foreground);
  }
  .badge--primary.badge--success {
    --badge-bg: var(--color-success);
    --badge-fg: var(--color-success-foreground);
  }
  .badge--primary.badge--warning {
    --badge-bg: var(--color-warning);
    --badge-fg: var(--color-warning-foreground);
  }
  .badge--primary.badge--danger {
    --badge-bg: var(--color-danger);
    --badge-fg: var(--color-danger-foreground);
  }
  .badge--soft.badge--accent {
    --badge-bg: var(--color-accent-soft);
    --badge-fg: var(--color-accent-soft-foreground);
  }
  .badge--soft.badge--default {
    --badge-bg: var(--color-default);
    --badge-fg: var(--color-default-foreground);
  }
  .badge--soft.badge--success {
    --badge-bg: var(--color-success-soft);
    --badge-fg: var(--color-success-soft-foreground);
  }
  .badge--soft.badge--warning {
    --badge-bg: var(--color-warning-soft);
    --badge-fg: var(--color-warning-soft-foreground);
  }
  .badge--soft.badge--danger {
    --badge-bg: var(--color-danger-soft);
    --badge-fg: var(--color-danger-soft-foreground);
  }
  .chip {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    gap: calc(var(--spacing) * 0.5);
    border-radius: calc(var(--radius) * 2);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    --chip-bg: var(--color-default);
    --chip-fg: currentColor;
    background-color: var(--chip-bg);
    color: var(--chip-fg);
  }
  .chip__label {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .chip--accent {
    --chip-fg: var(--color-accent-soft-foreground);
  }
  .chip--danger {
    --chip-fg: var(--color-danger);
  }
  .chip--default {
    --chip-fg: var(--color-default-foreground);
  }
  .chip--success {
    --chip-fg: var(--color-success);
  }
  .chip--warning {
    --chip-fg: var(--color-warning);
  }
  .chip--tertiary {
    --chip-bg: transparent;
  }
  .chip--sm {
    padding-inline: calc(var(--spacing) * 1);
    padding-block: calc(var(--spacing) * 0);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .chip--md {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .chip--lg {
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 1);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .chip--primary.chip--accent {
    --chip-bg: var(--color-accent);
    --chip-fg: var(--color-accent-foreground);
  }
  .chip--primary.chip--success {
    --chip-bg: var(--color-success);
    --chip-fg: var(--color-success-foreground);
  }
  .chip--primary.chip--warning {
    --chip-bg: var(--color-warning);
    --chip-fg: var(--color-warning-foreground);
  }
  .chip--primary.chip--danger {
    --chip-bg: var(--color-danger);
    --chip-fg: var(--color-danger-foreground);
  }
  .chip--accent.chip--soft {
    --chip-bg: var(--color-accent-soft);
    --chip-fg: var(--color-accent-soft-foreground);
  }
  .chip--success.chip--soft {
    --chip-bg: var(--color-success-soft);
    --chip-fg: var(--color-success-soft-foreground);
  }
  .chip--warning.chip--soft {
    --chip-bg: var(--color-warning-soft);
    --chip-fg: var(--color-warning-soft-foreground);
  }
  .chip--danger.chip--soft {
    --chip-bg: var(--color-danger-soft);
    --chip-fg: var(--color-danger-soft-foreground);
  }
  .table-root {
    position: relative;
    display: grid;
    width: 100%;
    overflow: clip;
    grid-template-columns: minmax(0, 1fr);
  }
  .table__scroll-container {
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: oklch(0% 0 0 / 0.15) transparent;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: oklch(0% 0 0 / 0.15);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: oklch(0% 0 0 / 0.25);
    }
    :is([data-theme="dark"], .dark) & {
      scrollbar-color: oklch(100% 0 0 / 0.15) transparent;
      &::-webkit-scrollbar-thumb {
        background: oklch(100% 0 0 / 0.15);
      }
      &::-webkit-scrollbar-thumb:hover {
        background: oklch(100% 0 0 / 0.25);
      }
    }
  }
  .table-root--primary {
    background-color: var(--surface-secondary);
    padding-inline: calc(var(--spacing) * 1);
    padding-bottom: calc(var(--spacing) * 1);
    border-radius: min(32px, calc(var(--radius) * 2.5));
  }
  .table-root--secondary .table__header {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
    background-color: transparent;
  }
  .table-root--secondary .table__column {
    background-color: var(--surface-secondary);
  }
  .table-root--secondary .table__column:first-child {
    border-top-left-radius: min(32px, var(--radius-2xl));
    border-bottom-left-radius: min(32px, var(--radius-2xl));
  }
  .table-root--secondary .table__column:last-child {
    border-top-right-radius: min(32px, var(--radius-2xl));
    border-bottom-right-radius: min(32px, var(--radius-2xl));
  }
  .table-root--secondary .table__body {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    & tr:first-child td:first-child, & tr:first-child td:last-child, & tr:last-child td:first-child, & tr:last-child td:last-child {
      border-radius: 0;
    }
    &:not(tbody) {
      overflow: visible;
      border-radius: 0;
    }
  }
  .table-root--secondary .table__row {
    .table__cell {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
      border-color: var(--surface);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, color-mix(
    in oklab,
    var(--surface) 81%,
    var(--surface-foreground) 19%
  ) 50%, transparent);
      }
      background-color: transparent;
    }
    @media (hover: hover) {
      &:hover .table__cell, &[data-hovered="true"] .table__cell {
        background-color: var(--default);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--default) 50%, transparent);
        }
      }
    }
  }
  .table__content {
    width: 100%;
    border-collapse: separate;
    --tw-border-spacing-x: calc(var(--spacing) * 0);
    --tw-border-spacing-y: calc(var(--spacing) * 0);
    border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .table-root--primary .table__content {
    overflow: clip;
  }
  .table__header {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--separator);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--separator) 50%, transparent);
    }
    background-color: var(--surface-secondary);
  }
  .table__column {
    position: relative;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2.5);
    text-align: left;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--muted);
    &::after {
      content: "";
      pointer-events: none;
      position: absolute;
      top: calc(1 / 2 * 100%);
      right: calc(var(--spacing) * 0);
      height: calc(var(--spacing) * 4);
      width: 1px;
      --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
      border-radius: calc(var(--radius) * 0.5);
      background-color: var(--separator);
    }
    &:last-child:not(:only-child)::after {
      content: none;
    }
    &[data-allows-sorting="true"] {
      cursor: var(--cursor-interactive);
    }
    @media (hover: hover) {
      &[data-allows-sorting="true"]:hover, &[data-allows-sorting="true"][data-hovered="true"] {
        color: var(--foreground);
      }
    }
    &:focus-visible, &[data-focus-visible="true"] {
      border-radius: calc(var(--radius) * 1);
      --tw-outline-style: none;
      outline-style: none;
      box-shadow: inset 0 0 0 2px var(--color-focus);
    }
  }
  .table__body {
    & tr:first-child td:first-child {
      border-top-left-radius: min(32px, var(--radius-2xl));
    }
    & tr:first-child td:last-child {
      border-top-right-radius: min(32px, var(--radius-2xl));
    }
    & tr:last-child td:first-child {
      border-bottom-left-radius: min(32px, var(--radius-2xl));
    }
    & tr:last-child td:last-child {
      border-bottom-right-radius: min(32px, var(--radius-2xl));
    }
    &:not(tbody) {
      position: relative;
      height: 100%;
      overflow: clip;
      border-radius: min(32px, var(--radius-2xl));
    }
  }
  .table__row {
    position: relative;
    height: 100%;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--separator);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--separator) 50%, transparent);
    }
    &:last-child {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
    @media (hover: hover) {
      &:hover .table__cell, &[data-hovered="true"] .table__cell {
        background-color: var(--surface);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--surface) 40%, transparent);
        }
      }
    }
    &[data-selected="true"] .table__cell {
      background-color: var(--surface);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--surface) 10%, transparent);
      }
    }
    &[aria-disabled="true"], &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:focus-visible, &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-dragging="true"] {
      opacity: 50%;
    }
    &[data-drop-target="true"] .table__cell {
      background-color: var(--accent-soft, var(--accent));
      @supports (color: color-mix(in lab, red, red)) {
        background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
      }
    }
  }
  .table__cell {
    height: 100%;
    background-color: var(--surface);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    vertical-align: middle;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--foreground);
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--surface);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, color-mix(
    in oklab,
    var(--surface) 81%,
    var(--surface-foreground) 19%
  ) 50%, transparent);
    }
    &:focus-visible, &[data-focus-visible="true"] {
      border-radius: calc(var(--radius) * 1);
      --tw-outline-style: none;
      outline-style: none;
      box-shadow: inset 0 0 0 2px var(--color-focus);
    }
  }
  .table__row:is(:focus-visible, [data-focus-visible="true"]) :is(.table__cell, .table__column) {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .table__row:is(:focus-visible, [data-focus-visible="true"]) > :is(.table__cell, .table__column):only-child, .table__row:is(:focus-visible, [data-focus-visible="true"]) > *:only-child :is(.table__cell, .table__column) {
    border-radius: calc(var(--radius) * 1);
    --tw-shadow: inset 0 0 0 2px var(--tw-shadow-color, var(--color-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
  }
  .table__row:is(:focus-visible, [data-focus-visible="true"]) > :is(.table__cell, .table__column):first-child:not(:only-child), .table__row:is(:focus-visible, [data-focus-visible="true"]) > *:first-child:not(:only-child) :is(.table__cell, .table__column) {
    border-top-left-radius: calc(var(--radius) * 1);
    border-bottom-left-radius: calc(var(--radius) * 1);
    --tw-shadow: inset 2px 0 0 0 var(--tw-shadow-color, var(--color-focus)), inset 0 2px 0 0 var(--tw-shadow-color, var(--color-focus)), inset 0 -2px 0 0 var(--tw-shadow-color, var(--color-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
  }
  .table__row:is(:focus-visible, [data-focus-visible="true"]) > :is(.table__cell, .table__column):last-child:not(:only-child), .table__row:is(:focus-visible, [data-focus-visible="true"]) > *:last-child:not(:only-child) :is(.table__cell, .table__column) {
    border-top-right-radius: calc(var(--radius) * 1);
    border-bottom-right-radius: calc(var(--radius) * 1);
    --tw-shadow: inset -2px 0 0 0 var(--tw-shadow-color, var(--color-focus)), inset 0 2px 0 0 var(--tw-shadow-color, var(--color-focus)), inset 0 -2px 0 0 var(--tw-shadow-color, var(--color-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
  }
  .table__row:is(:focus-visible, [data-focus-visible="true"]) > :is(.table__cell, .table__column):not(:first-child):not(:last-child):not(:only-child), .table__row:is(:focus-visible, [data-focus-visible="true"]) > *:not(:first-child):not(:last-child):not(:only-child) :is(.table__cell, .table__column) {
    --tw-shadow: inset 0 2px 0 0 var(--tw-shadow-color, var(--color-focus)), inset 0 -2px 0 0 var(--tw-shadow-color, var(--color-focus));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
  }
  .table__cell[data-tree-column] {
    padding-inline-start: calc(1rem * var(--table-row-level, 1));
  }
  .table__footer {
    display: flex;
    align-items: center;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2.5);
  }
  .table__resizable-container {
    position: relative;
    overflow: auto;
  }
  .table__column-resizer {
    position: absolute;
    top: calc(1 / 2 * 100%);
    right: calc(var(--spacing) * 0);
    height: calc(var(--spacing) * 4);
    width: 1px;
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    border-radius: calc(var(--radius) * 0.5);
    background-color: var(--separator);
    box-sizing: content-box;
    --tw-translate-x: calc(1 / 2 * 100%);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    cursor: col-resize;
    touch-action: none;
    padding-inline: calc(var(--spacing) * 2);
    --tw-border-style: none;
    border-style: none;
    background-clip: content-box;
    --tw-outline-style: none;
    outline-style: none;
    &[data-hovered="true"], &:hover {
      height: 100%;
      width: calc(var(--spacing) * 0.5);
      background-color: var(--accent);
    }
    &[data-resizing="true"] {
      height: 100%;
      width: calc(var(--spacing) * 0.5);
      background-color: var(--accent);
    }
    &[data-focus-visible="true"], &:focus-visible {
      height: 100%;
      width: calc(var(--spacing) * 0.5);
      background-color: var(--focus);
    }
  }
  .table__column:has(.table__column-resizer)::after {
    content: none;
  }
  .table__load-more {
    & td, & [role="rowheader"] {
      padding-block: calc(var(--spacing) * 3);
      text-align: center;
      & > * {
        margin-inline: auto;
      }
    }
  }
  .table__load-more-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 2);
  }
  .alert {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: calc(var(--spacing) * 4);
    background-color: var(--surface);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    --tw-shadow: var(--surface-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    border-radius: min(32px, var(--radius-3xl));
  }
  .alert__content {
    display: flex;
    height: 100%;
    flex-grow: 1;
    flex-direction: column;
    align-items: flex-start;
  }
  .alert__indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: calc(var(--spacing) * 1);
    -webkit-user-select: none;
    user-select: none;
    [data-slot="alert-default-icon"] {
      box-sizing: content-box;
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .alert__title {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .alert__description {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--muted);
  }
  .alert--default .alert__indicator {
    color: var(--foreground);
  }
  .alert--default .alert__title {
    color: var(--foreground);
  }
  .alert--accent .alert__indicator {
    color: var(--accent);
  }
  .alert--accent .alert__title {
    color: var(--accent);
  }
  .alert--success .alert__indicator {
    color: var(--success);
  }
  .alert--success .alert__title {
    color: var(--success);
  }
  .alert--warning .alert__indicator {
    color: var(--warning);
  }
  .alert--warning .alert__title {
    color: var(--warning);
  }
  .alert--danger .alert__indicator {
    color: var(--danger);
  }
  .alert--danger .alert__title {
    color: var(--danger);
  }
  .empty-state {
    padding: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--muted);
  }
  .skeleton {
    pointer-events: none;
    position: relative;
    overflow: hidden;
    border-radius: calc(var(--radius) * 0.5);
    background-color: var(--surface-tertiary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--surface-tertiary) 70%, transparent);
    }
  }
  .skeleton--shimmer {
    &::after {
      position: absolute;
      inset: calc(var(--spacing) * 0);
      --tw-translate-x: -100%;
      translate: var(--tw-translate-x) var(--tw-translate-y);
      animation: skeleton 2s linear infinite;
      --tw-gradient-position: to right;
      @supports (background-image: linear-gradient(in lab, red, red)) {
        --tw-gradient-position: to right in oklab;
      }
      background-image: linear-gradient(var(--tw-gradient-stops));
      --tw-gradient-from: transparent;
      --tw-gradient-via: var(--surface-tertiary);
      --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
      --tw-gradient-stops: var(--tw-gradient-via-stops);
      --tw-gradient-to: transparent;
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
      --tw-content: '';
      content: var(--tw-content);
    }
    &:has(.skeleton) {
      &::after {
        content: none;
      }
      &::before {
        position: absolute;
        inset: calc(var(--spacing) * 0);
        --tw-translate-x: -100%;
        translate: var(--tw-translate-x) var(--tw-translate-y);
        animation: skeleton 2s linear infinite;
        --tw-content: '';
        content: var(--tw-content);
        background: linear-gradient( 90deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100% );
        z-index: 10;
        pointer-events: none;
        mix-blend-mode: overlay;
      }
      & .skeleton {
        &::after {
          content: none;
        }
      }
    }
  }
  .skeleton--pulse {
    animation: var(--animate-pulse);
  }
  .meter {
    display: grid;
    width: 100%;
    gap: calc(var(--spacing) * 1);
    grid-template-areas: "label output" "track track";
    grid-template-columns: 1fr auto;
    --meter-fill: var(--color-accent);
    [data-slot="label"] {
      width: fit-content;
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      grid-area: label;
    }
    .meter__output {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      --tw-numeric-spacing: tabular-nums;
      font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
      grid-area: output;
    }
    .meter__track {
      position: relative;
      overflow: hidden;
      border-radius: calc(var(--radius) * 0.5);
      background-color: var(--default);
      grid-area: track;
      height: calc(var(--spacing) * 2);
    }
    .meter__fill {
      position: absolute;
      top: calc(var(--spacing) * 0);
      left: calc(var(--spacing) * 0);
      height: 100%;
      border-radius: calc(var(--radius) * 0.5);
      background-color: var(--meter-fill);
      transition: width 300ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      [data-slot="label"] {
        opacity: 100%;
      }
    }
  }
  .meter--sm {
    .meter__track {
      height: calc(var(--spacing) * 1);
      border-radius: calc(var(--radius) * 0.25);
    }
    .meter__fill {
      border-radius: calc(var(--radius) * 0.25);
    }
  }
  .meter--lg {
    .meter__track {
      height: calc(var(--spacing) * 3);
      border-radius: calc(var(--radius) * 0.75);
    }
    .meter__fill {
      border-radius: calc(var(--radius) * 0.75);
    }
  }
  .meter--default {
    --meter-fill: var(--color-default-foreground);
  }
  .meter--accent {
    --meter-fill: var(--color-accent);
  }
  .meter--success {
    --meter-fill: var(--color-success);
  }
  .meter--warning {
    --meter-fill: var(--color-warning);
  }
  .meter--danger {
    --meter-fill: var(--color-danger);
  }
  .progress-bar {
    display: grid;
    width: 100%;
    gap: calc(var(--spacing) * 1);
    grid-template-areas: "label output" "track track";
    grid-template-columns: 1fr auto;
    --progress-bar-fill: var(--color-accent);
    [data-slot="label"] {
      width: fit-content;
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      grid-area: label;
    }
    .progress-bar__output {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      --tw-numeric-spacing: tabular-nums;
      font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
      grid-area: output;
    }
    .progress-bar__track {
      position: relative;
      overflow: hidden;
      border-radius: calc(var(--radius) * 0.5);
      background-color: var(--default);
      grid-area: track;
      height: calc(var(--spacing) * 2);
    }
    .progress-bar__fill {
      position: absolute;
      top: calc(var(--spacing) * 0);
      left: calc(var(--spacing) * 0);
      height: 100%;
      border-radius: calc(var(--radius) * 0.5);
      background-color: var(--progress-bar-fill);
      transition: width 300ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &:not([aria-valuenow]) {
      .progress-bar__fill {
        width: calc(2 / 5 * 100%);
        animation: progress-bar-indeterminate 1.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            animation: none;
            &::before, &::after {
              animation: none;
            }
          }
        }
      }
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      [data-slot="label"] {
        opacity: 100%;
      }
    }
  }
  @keyframes progress-bar-indeterminate {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(350%);
    }
  }
  .progress-bar--sm {
    .progress-bar__track {
      height: calc(var(--spacing) * 1);
      border-radius: calc(var(--radius) * 0.25);
    }
    .progress-bar__fill {
      border-radius: calc(var(--radius) * 0.25);
    }
  }
  .progress-bar--lg {
    .progress-bar__track {
      height: calc(var(--spacing) * 3);
      border-radius: calc(var(--radius) * 0.75);
    }
    .progress-bar__fill {
      border-radius: calc(var(--radius) * 0.75);
    }
  }
  .progress-bar--default {
    --progress-bar-fill: var(--color-default-foreground);
  }
  .progress-bar--accent {
    --progress-bar-fill: var(--color-accent);
  }
  .progress-bar--success {
    --progress-bar-fill: var(--color-success);
  }
  .progress-bar--warning {
    --progress-bar-fill: var(--color-warning);
  }
  .progress-bar--danger {
    --progress-bar-fill: var(--color-danger);
  }
  .progress-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    --progress-circle-stroke: var(--color-accent);
    --progress-circle-track-stroke: var(--color-default);
    .progress-circle__track {
      width: calc(var(--spacing) * 7);
      height: calc(var(--spacing) * 7);
    }
    .progress-circle__track-circle {
      stroke: var(--progress-circle-track-stroke);
    }
    .progress-circle__fill-circle {
      stroke: var(--progress-circle-stroke);
      transition: stroke-dashoffset 300ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &:not([aria-valuenow]) {
      .progress-circle__track {
        animation: progress-circle-spin 1s linear infinite;
        &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
            animation: none;
            &::before, &::after {
              animation: none;
            }
          }
        }
      }
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  @keyframes progress-circle-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .progress-circle--sm {
    .progress-circle__track {
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
    }
  }
  .progress-circle--lg {
    .progress-circle__track {
      width: calc(var(--spacing) * 9);
      height: calc(var(--spacing) * 9);
    }
  }
  .progress-circle--default {
    --progress-circle-stroke: var(--color-default-foreground);
  }
  .progress-circle--accent {
    --progress-circle-stroke: var(--color-accent);
  }
  .progress-circle--success {
    --progress-circle-stroke: var(--color-success);
  }
  .progress-circle--warning {
    --progress-circle-stroke: var(--color-warning);
  }
  .progress-circle--danger {
    --progress-circle-stroke: var(--color-danger);
  }
  .spinner {
    pointer-events: none;
    position: relative;
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
    transform-origin: center;
    animation: spin 0.75s linear infinite;
  }
  .spinner--sm {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .spinner--lg {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .spinner--xl {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
  }
  .spinner--current {
    color: inherit;
  }
  .spinner--accent {
    color: var(--accent);
  }
  .spinner--danger {
    color: var(--danger);
  }
  .spinner--success {
    color: var(--success);
  }
  .spinner--warning {
    color: var(--warning);
  }
  .toast-region {
    pointer-events: none;
    position: fixed;
    z-index: 50;
    --tw-outline-style: none;
    outline-style: none;
    width: calc(100vw - 2rem);
    @media (width >= 40rem) {
      width: auto;
    }
    @media (width >= 40rem) {
      min-width: var(--toast-width);
    }
    display: block;
  }
  .toast-region--bottom {
    bottom: calc(var(--spacing) * 4);
    left: calc(1 / 2 * 100%);
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .toast-region--bottom-start {
    bottom: calc(var(--spacing) * 4);
    left: calc(var(--spacing) * 4);
  }
  .toast-region--bottom-end {
    right: calc(var(--spacing) * 4);
    bottom: calc(var(--spacing) * 4);
  }
  .toast-region--top {
    top: calc(var(--spacing) * 4);
    left: calc(1 / 2 * 100%);
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .toast-region--top-start {
    top: calc(var(--spacing) * 4);
    left: calc(var(--spacing) * 4);
  }
  .toast-region--top-end {
    top: calc(var(--spacing) * 4);
    right: calc(var(--spacing) * 4);
  }
  .toast-region:focus-visible {
    outline-style: var(--tw-outline-style);
    outline-width: 2px;
    outline-offset: 2px;
    outline-color: var(--focus);
  }
  .toast {
    position: absolute;
    left: 0;
    right: 0;
    pointer-events: auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: calc(var(--spacing) * 1.5);
    background-color: var(--surface);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    --tw-shadow: var(--overlay-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    border-radius: min(32px, var(--radius-3xl));
  }
  .toast--bottom, .toast--bottom-start, .toast--bottom-end {
    bottom: 0;
  }
  .toast--top, .toast--top-start, .toast--top-end {
    top: 0;
  }
  .toast:not([data-frontmost="true"]) {
    pointer-events: none;
    height: var(--front-height);
    overflow: hidden;
    .toast__close-button {
      pointer-events: none;
      opacity: 0%;
      outline: none;
    }
  }
  .toast[data-hidden="true"] {
    pointer-events: none;
    display: flex;
    opacity: 0%;
  }
  .toast:focus-visible {
    outline-style: var(--tw-outline-style);
    outline-width: 2px;
    outline-offset: 2px;
    outline-color: var(--focus);
  }
  .toast--bottom, .toast--bottom-start, .toast--bottom-end {
    view-transition-class: toast-bottom;
  }
  .toast--top, .toast--top-start, .toast--top-end {
    view-transition-class: toast-top;
  }
  .toast__content {
    display: flex;
    height: 100%;
    flex-grow: 1;
    flex-direction: column;
    align-items: flex-start;
    align-self: center;
  }
  .toast__indicator {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: calc(var(--spacing) * 1);
    color: var(--overlay-foreground);
    -webkit-user-select: none;
    user-select: none;
    [data-slot="toast-default-icon"] {
      box-sizing: content-box;
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    [data-slot="spinner"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    [data-slot="spinner-icon"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .toast__title {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--overlay-foreground);
  }
  .toast__description {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--muted);
  }
  .toast__close-button {
    position: absolute;
    top: calc(var(--spacing) * 2.5);
    right: calc(var(--spacing) * 2.5);
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
    border-color: var(--border);
    background-color: var(--default);
    opacity: 100%;
    @media (width >= 40rem) {
      pointer-events: none;
    }
    @media (width >= 40rem) {
      top: calc(var(--spacing) * -1);
    }
    @media (width >= 40rem) {
      right: calc(var(--spacing) * -1);
    }
    @media (width >= 40rem) {
      border-style: var(--tw-border-style);
      border-width: 1px;
    }
    @media (width >= 40rem) {
      background-color: var(--overlay);
    }
    @media (width >= 40rem) {
      opacity: 0%;
    }
    transition: opacity 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    [data-slot="close-button-icon"] {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
      @media (width >= 40rem) {
        width: calc(var(--spacing) * 3);
        height: calc(var(--spacing) * 3);
      }
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
      }
    }
  }
  .toast[data-frontmost="true"]:hover .toast__close-button {
    pointer-events: auto;
    opacity: 100%;
  }
  .toast__action {
    margin-top: calc(var(--spacing) * 2);
    @media (width >= 40rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .toast--accent .toast__title {
    color: var(--accent);
  }
  .toast--success .toast__title {
    color: var(--success);
  }
  .toast--success .toast__indicator {
    color: var(--success);
  }
  .toast--warning .toast__title {
    color: var(--warning);
  }
  .toast--warning .toast__indicator {
    color: var(--warning);
  }
  .toast--danger .toast__title {
    color: var(--danger);
  }
  .toast--danger .toast__indicator {
    color: var(--danger);
  }
  ::view-transition-old(*), ::view-transition-new(*) {
    will-change: translate, opacity;
  }
  ::view-transition-new(.toast-bottom):only-child {
    animation: toast-slide-bottom-in 350ms;
  }
  ::view-transition-old(.toast-bottom):only-child {
    animation: toast-slide-bottom-out 350ms;
    animation-fill-mode: forwards;
  }
  ::view-transition-new(.toast-top):only-child {
    animation: toast-slide-top-in 350ms;
  }
  ::view-transition-old(.toast-top):only-child {
    animation: toast-slide-top-out 350ms;
    animation-fill-mode: forwards;
  }
  @keyframes toast-slide-bottom-in {
    from {
      translate: 0 100%;
      opacity: 0;
    }
  }
  @keyframes toast-slide-bottom-out {
    to {
      translate: 0 100%;
      opacity: 0;
    }
  }
  @keyframes toast-slide-top-in {
    from {
      translate: 0 -100%;
      opacity: 0;
    }
  }
  @keyframes toast-slide-top-out {
    to {
      translate: 0 -100%;
      opacity: 0;
    }
  }
  .checkbox-group {
    display: flex;
    flex-direction: column;
    [data-slot="checkbox"] {
      margin-top: calc(var(--spacing) * 4);
    }
  }
  .checkbox {
    display: flex;
    gap: calc(var(--spacing) * 3);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    &:not(:has([data-slot="description"])) {
      align-items: center;
    }
    &:has([data-slot="description"]) {
      align-items: flex-start;
    }
    [data-slot="label"] {
      -webkit-user-select: none;
      user-select: none;
    }
    [data-slot="description"] {
      text-wrap: wrap;
      -webkit-user-select: none;
      user-select: none;
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-selected="true"], &[data-indeterminate="true"] {
      .checkbox__indicator {
        border-color: var(--accent-foreground);
      }
    }
    [data-slot="checkbox-default-indicator--checkmark"] {
      width: calc(var(--spacing) * 2.5);
      height: calc(var(--spacing) * 2.5);
      stroke-width: 2.5px;
      color: var(--accent-foreground);
      transition-property: all;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
      --tw-duration: 200ms;
      transition-duration: 200ms;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &[data-selected="true"] [data-slot="checkbox-default-indicator--checkmark"] {
      transition: stroke-dashoffset 150ms linear 15ms;
    }
    &[data-invalid="true"][data-selected="true"] [data-slot="checkbox-default-indicator--checkmark"], &[data-invalid="true"][aria-checked="true"] [data-slot="checkbox-default-indicator--checkmark"], &[aria-invalid="true"][data-selected="true"] [data-slot="checkbox-default-indicator--checkmark"], &[aria-invalid="true"][aria-checked="true"] [data-slot="checkbox-default-indicator--checkmark"] {
      color: var(--danger-foreground);
    }
    &[data-indeterminate="true"] {
      [data-slot="checkbox-default-indicator--indeterminate"] {
        width: calc(var(--spacing) * 3);
        height: calc(var(--spacing) * 3);
      }
    }
    &[data-indeterminate="true"][data-invalid="true"] [data-slot="checkbox-default-indicator--indeterminate"], &[data-indeterminate="true"][aria-invalid="true"] [data-slot="checkbox-default-indicator--indeterminate"] {
      color: var(--danger-foreground);
    }
  }
  .checkbox__control {
    position: relative;
    display: inline-flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: calc(var(--radius) * 0.75);
    background-color: var(--field-background, var(--default));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 200ms var(--ease-out), transform 100ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    .checkbox:has([data-slot="description"]) & {
      margin-top: calc(var(--spacing) * 0.5);
    }
    &::before {
      pointer-events: none;
      position: absolute;
      inset: calc(var(--spacing) * 0);
      z-index: 0;
      transform-origin: center;
      --tw-scale-x: 70%;
      --tw-scale-y: 70%;
      --tw-scale-z: 70%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
      border-radius: calc(var(--radius) * 0.75);
      background-color: var(--accent);
      opacity: 0%;
      --tw-content: '';
      content: var(--tw-content);
      transition: scale 100ms var(--ease-linear), opacity 200ms var(--ease-linear), background-color 200ms var(--ease-out);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    .checkbox:focus-visible &, .checkbox[data-focus-visible="true"] & {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    .checkbox:hover &, .checkbox[data-hovered="true"] & {
      border-color: var(--field-border, var(--border));
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(
    in oklab,
    var(--field-border, var(--border)) 88%,
    var(--field-foreground, var(--foreground)) 10%
  );
      }
      &::before {
        background-color: var(--accent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
        }
      }
    }
    .checkbox[aria-checked="true"] &, .checkbox[data-selected="true"] & {
      border-color: transparent;
      color: var(--accent-foreground);
      &::before {
        --tw-scale-x: 100%;
        --tw-scale-y: 100%;
        --tw-scale-z: 100%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
        opacity: 100%;
      }
    }
    .checkbox[data-indeterminate="true"] & {
      background-color: var(--accent);
      color: var(--accent-foreground);
    }
    .checkbox:active[data-indeterminate="true"] &, .checkbox[data-pressed="true"][data-indeterminate="true"] & {
      background-color: var(--accent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
      }
    }
    .checkbox[data-invalid="true"]:not([aria-checked="true"]):not([data-selected="true"]):not( [data-indeterminate="true"] ) &, .checkbox[aria-invalid="true"]:not([aria-checked="true"]):not([data-selected="true"]):not( [data-indeterminate="true"] ) & {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
    }
    .checkbox[data-invalid="true"][aria-checked="true"] &, .checkbox[data-invalid="true"][data-selected="true"] &, .checkbox[aria-invalid="true"][aria-checked="true"] &, .checkbox[aria-invalid="true"][data-selected="true"] & {
      border-color: transparent;
      background-color: var(--danger);
      color: var(--danger-foreground);
      &::before {
        --tw-scale-x: 100%;
        --tw-scale-y: 100%;
        --tw-scale-z: 100%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
        background-color: var(--danger);
        opacity: 100%;
      }
    }
    .checkbox[data-indeterminate="true"][aria-invalid="true"] &, .checkbox[data-indeterminate="true"][data-invalid="true"] & {
      background-color: var(--danger);
      color: var(--danger-foreground);
    }
  }
  .checkbox__indicator {
    position: relative;
    z-index: 10;
    display: flex;
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
    align-items: center;
    justify-content: center;
    & svg {
      transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    }
  }
  .checkbox__content {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 0);
  }
  .checkbox--disabled {
    opacity: var(--disabled-opacity);
    cursor: var(--cursor-disabled);
    pointer-events: none;
  }
  .checkbox--secondary .checkbox__control {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--checkbox-control-bg);
    --checkbox-control-bg: var(--color-default);
    .checkbox:hover &, .checkbox[data-hovered="true"] & {
      border-color: var(--field-border, var(--border));
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(
    in oklab,
    var(--field-border, var(--border)) 88%,
    var(--field-foreground, var(--foreground)) 10%
  );
      }
    }
  }
  .checkbox--secondary:not([aria-checked="true"]):not([data-selected="true"]):not( [data-indeterminate="true"] ) .checkbox__control {
    background-color: var(--checkbox-control-bg);
  }
  .checkbox--secondary[aria-checked="true"] .checkbox__control, .checkbox--secondary[data-selected="true"] .checkbox__control {
    &::before {
      background-color: var(--accent);
    }
  }
  .checkbox--secondary[data-indeterminate="true"] .checkbox__control {
    background-color: var(--accent);
    &::before {
      background-color: var(--accent);
    }
  }
  .fieldset {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 6);
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: calc(var(--spacing) * 0);
  }
  .fieldset__legend {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .fieldset__field_group {
    width: 100%;
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .fieldset__actions {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
    padding-top: calc(var(--spacing) * 1);
  }
  .input-otp {
    position: relative;
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
    &[data-disabled="true"] {
      cursor: not-allowed;
      opacity: 50%;
    }
  }
  .input-otp__group {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
  }
  .input-otp__slot {
    position: relative;
    display: flex;
    height: calc(var(--spacing) * 10);
    width: calc(var(--spacing) * 9.5);
    flex: 1;
    align-items: center;
    justify-content: center;
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &[data-active="true"] {
      z-index: 10;
      background-color: var(--field-background, var(--default));
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
    }
    &[data-filled="true"] {
      background-color: var(--field-background, var(--default));
    }
    &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
    }
  }
  .input-otp__slot-value {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
    --tw-tracking: -0.27px;
    letter-spacing: -0.27px;
    animation: slot-value-in 250ms var(--ease-smooth) both;
    transform-origin: bottom center;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      animation: none;
      &::before, &::after {
        animation: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        animation: none;
        &::before, &::after {
          animation: none;
        }
      }
    }
  }
  .input-otp__caret {
    position: absolute;
    height: calc(var(--spacing) * 4);
    width: 2px;
    animation: caret-blink 1.2s ease-out infinite;
    border-radius: calc(var(--radius) * 0.5);
    background-color: var(--field-placeholder, var(--muted));
  }
  .input-otp__separator {
    height: 2px;
    width: 6px;
    flex-shrink: 0;
    border-radius: calc(var(--radius) * 0.5);
    background-color: var(--separator);
  }
  .input-otp--secondary .input-otp__slot {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--input-otp-slot-bg);
    --input-otp-slot-bg: var(--color-default);
    --input-otp-slot-bg-hover: var(--color-default-hover);
    --input-otp-slot-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--input-otp-slot-bg-hover);
      }
    }
    &[data-active="true"], &[data-filled="true"] {
      background-color: var(--input-otp-slot-bg-focus);
    }
  }
  @keyframes slot-value-in {
    0% {
      opacity: 0;
      transform: translateY(8px) scale(0.8);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  .input {
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    &::placeholder {
      color: var(--field-placeholder, var(--muted));
    }
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus):not(:focus-visible), &[data-hovered="true"]:not([data-focused="true"]):not([data-focus-visible="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &:focus, &[data-focused="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .input--secondary {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--input-bg);
    --input-bg: var(--color-default);
    --input-bg-hover: var(--color-default-hover);
    --input-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus):not(:focus-visible), &[data-hovered="true"]:not([data-focus-visible="true"]):not([data-focused="true"]) {
        background-color: var(--input-bg-hover);
      }
    }
    &:focus, &[data-focused="true"] {
      background-color: var(--input-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--input-bg-focus);
    }
  }
  .input--full-width {
    width: 100%;
  }
  .input-group {
    display: inline-flex;
    min-height: calc(var(--spacing) * 9);
    align-items: center;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    &:has([data-slot="input-group-textarea"]) {
      align-items: flex-start;
      height: auto;
    }
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &:has([data-slot="input-group-input"]:focus), &:has([data-slot="input-group-textarea"]:focus) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
      border-color: var(--color-field-border-invalid);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .input-group__input {
    flex: 1;
    border-radius: 0;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    &::placeholder {
      color: var(--field-placeholder, var(--muted));
    }
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .input-group:has([data-slot="input-group-prefix"]) & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: calc(var(--spacing) * 0);
    }
    .input-group:has([data-slot="input-group-suffix"]) & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding-right: calc(var(--spacing) * 0);
    }
    &:focus, &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .input-group__input[data-slot="input-group-textarea"] {
    min-height: 38px;
    resize: vertical;
  }
  .input-group__prefix {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-top-left-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-bottom-left-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    color: var(--field-placeholder, var(--muted));
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    border-style: solid;
    border-right-color: var(--color-field-border);
    border-left: none;
    border-top: none;
    border-bottom: none;
    .input-group:has([data-slot="input-group-textarea"]) & {
      align-items: flex-start;
      padding-top: 0.5rem;
    }
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .input-group__suffix {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-bottom-right-radius: var(--field-radius, calc(var(--radius) * 1.5));
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    color: var(--field-placeholder, var(--muted));
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    border-style: solid;
    border-left-color: var(--color-field-border);
    border-right: none;
    border-top: none;
    border-bottom: none;
    .input-group:has([data-slot="input-group-textarea"]) & {
      align-items: flex-start;
      padding-top: 0.5rem;
    }
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .input-group--secondary {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--input-group-bg);
    --input-group-bg: var(--color-default);
    --input-group-bg-hover: var(--color-default-hover);
    --input-group-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--input-group-bg-hover);
      }
    }
    &:has([data-slot="input-group-input"]:focus), &:has([data-slot="input-group-textarea"]:focus) {
      background-color: var(--input-group-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      border-color: var(--color-field-border-invalid);
      background-color: var(--input-group-bg-focus);
    }
    [data-slot="input-group-input"], [data-slot="input-group-textarea"] {
      background-color: transparent;
    }
  }
  .input-group--full-width {
    width: 100%;
  }
  .number-field {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
  }
  .number-field__group {
    display: grid;
    height: calc(var(--spacing) * 9);
    align-items: center;
    overflow: hidden;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    grid-template-columns: 40px 1fr 40px;
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &[data-focus-within="true"], &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
      border-color: var(--color-field-border-invalid);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .number-field__input {
    min-width: calc(var(--spacing) * 0);
    border-radius: 0;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .number-field__group:has([slot="decrement"]) & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .number-field__group:has([slot="increment"]) & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:focus, &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .number-field__increment-button, .number-field__decrement-button {
    display: flex;
    height: 100%;
    width: calc(var(--spacing) * 10);
    align-items: center;
    justify-content: center;
    border-radius: 0;
    background-color: transparent;
    color: var(--field-foreground, var(--foreground));
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    border-style: solid;
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    &:active, &[data-pressed="true"] {
      background-color: var(--field-foreground, var(--foreground));
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--field-foreground, var(--foreground)) 10%, transparent);
      }
      transform: scale(0.97);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    [data-slot="number-field-increment-button-icon"], [data-slot="number-field-decrement-button-icon"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .number-field__increment-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-bottom-right-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
    border-color: var(--field-placeholder, var(--muted));
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--field-placeholder, var(--muted)) 15%, transparent);
    }
  }
  .number-field__decrement-button {
    border-top-left-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-bottom-left-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
    border-color: var(--field-placeholder, var(--muted));
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--field-placeholder, var(--muted)) 15%, transparent);
    }
  }
  .number-field--secondary .number-field__group {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--number-field-group-bg);
    --number-field-group-bg: var(--color-default);
    --number-field-group-bg-hover: var(--color-default-hover);
    --number-field-group-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--number-field-group-bg-hover);
      }
    }
    &:focus-within, &[data-focus-within="true"] {
      background-color: var(--number-field-group-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      border-color: var(--color-field-border-invalid);
      background-color: var(--number-field-group-bg-focus);
    }
    [data-slot="number-field-input"] {
      background-color: transparent;
    }
  }
  .number-field--full-width {
    width: 100%;
  }
  .number-field__group--full-width {
    width: 100%;
  }
  .radio-group {
    display: flex;
    flex-direction: column;
    &[data-orientation="vertical"] {
      [data-slot="radio"] {
        margin-top: calc(var(--spacing) * 4);
      }
    }
    &[data-orientation="horizontal"] {
      flex-direction: row;
      flex-wrap: wrap;
      gap: calc(var(--spacing) * 4);
    }
  }
  .radio-group--secondary .radio__control {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--radio-control-bg);
    --radio-control-bg: var(--color-default);
    --radio-control-bg-hover: var(--color-default-hover);
    .radio:hover &, .radio[data-hovered="true"] & {
      border-color: var(--field-border, var(--border));
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(
    in oklab,
    var(--field-border, var(--border)) 88%,
    var(--field-foreground, var(--foreground)) 10%
  );
      }
    }
    .radio:not([aria-checked="true"]):not([data-selected="true"]) & .radio__indicator:empty::before {
      background-color: var(--radio-control-bg);
    }
    .radio:hover:not([aria-checked="true"]):not([data-selected="true"]) &, .radio[data-hovered="true"]:not([aria-checked="true"]):not([data-selected="true"]) & {
      .radio__indicator:empty::before {
        background-color: var(--radio-control-bg-hover);
      }
    }
  }
  .radio {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: calc(var(--spacing) * 3);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    [data-slot="label"] {
      -webkit-user-select: none;
      user-select: none;
    }
    [data-slot="description"] {
      text-wrap: wrap;
      -webkit-user-select: none;
      user-select: none;
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .radio__control {
    position: relative;
    margin-top: 3px;
    display: inline-flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 1);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-width: var(--border-width-field);
    background-color: var(--field-background, var(--default));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 200ms var(--ease-out), border-color 200ms var(--ease-out), transform 100ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    .radio:focus-visible &, .radio[data-focus-visible="true"] & {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    .radio:hover &, .radio[data-hovered="true"] & {
      border-color: var(--field-border, var(--border));
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(
    in oklab,
    var(--field-border, var(--border)) 88%,
    var(--field-foreground, var(--foreground)) 10%
  );
      }
    }
    .radio:hover:not([aria-checked="true"]):not([data-selected="true"]) &, .radio[data-hovered="true"]:not([aria-checked="true"]):not([data-selected="true"]) & {
      .radio__indicator:empty::before {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
      }
    }
    .radio:active &, .radio[data-pressed="true"] & {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
    .radio[aria-checked="true"] &, .radio[data-selected="true"] & {
      border-color: transparent;
      background-color: var(--accent);
    }
    .radio:active[data-selected="true"] &, .radio[data-pressed="true"][data-selected="true"] & {
      background-color: var(--accent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
      }
    }
    .radio[data-invalid="true"] &, .radio[aria-invalid="true"] & {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
    }
    .radio[data-invalid="true"][aria-checked="true"] &, .radio[data-invalid="true"][data-selected="true"] &, .radio[aria-invalid="true"][aria-checked="true"] &, .radio[aria-invalid="true"][data-selected="true"] & {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
    }
  }
  .radio__indicator {
    position: absolute;
    inset: calc(var(--spacing) * 0);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .radio__indicator:empty::before {
    content: "";
    border-radius: calc(var(--radius) * 1);
    background-color: var(--field-background, var(--default));
    width: 100%;
    height: 100%;
    scale: 1;
    transition: scale 200ms var(--ease-out), background-color 200ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .radio[aria-checked="true"] .radio__indicator:empty::before, .radio[data-selected="true"] .radio__indicator:empty::before {
    background-color: var(--accent-foreground);
    scale: 0.4286;
  }
  .radio[data-selected="true"][data-pressed="true"] .radio__indicator:empty::before {
    scale: 0.5714;
  }
  .radio__content {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 0);
  }
  .radio--disabled {
    opacity: var(--disabled-opacity);
    cursor: var(--cursor-disabled);
    pointer-events: none;
  }
  .textfield {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
  }
  .textfield--full-width {
    width: 100%;
    [data-slot="input"], [data-slot="textarea"] {
      width: 100%;
    }
  }
  .search-field {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
    &[data-empty="true"] {
      [data-slot="search-field-clear-button"] {
        pointer-events: none;
        opacity: 0%;
      }
    }
  }
  .search-field__group {
    position: relative;
    display: inline-flex;
    height: calc(var(--spacing) * 9);
    align-items: center;
    overflow: hidden;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &[data-focus-within="true"], &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
      border-color: var(--color-field-border-invalid);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .search-field__input {
    flex: 1;
    border-radius: 0;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    &::-webkit-search-cancel-button, &::-webkit-search-decoration {
      -webkit-appearance: none;
      appearance: none;
    }
    .search-field__group:has([data-slot="search-field-search-icon"]) & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: calc(var(--spacing) * 2);
    }
    .search-field__group:has([slot="clear"]) & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding-right: calc(var(--spacing) * 2);
    }
    &:focus, &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .search-field__search-icon {
    pointer-events: none;
    flex-shrink: 0;
    color: var(--field-placeholder, var(--muted));
    margin-right: calc(var(--spacing) * 0);
    margin-left: calc(var(--spacing) * 3);
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .search-field__clear-button {
    margin-right: calc(var(--spacing) * 2);
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
    flex-shrink: 0;
    [data-slot="close-button-icon"] {
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
    }
  }
  .search-field--secondary .search-field__group {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--search-field-group-bg);
    --search-field-group-bg: var(--color-default);
    --search-field-group-bg-hover: var(--color-default-hover);
    --search-field-group-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--search-field-group-bg-hover);
      }
    }
    &:focus-within, &[data-focus-within="true"] {
      background-color: var(--search-field-group-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      border-color: var(--color-field-border-invalid);
      background-color: var(--search-field-group-bg-focus);
    }
    [data-slot="search-field-input"] {
      background-color: transparent;
    }
  }
  .search-field--full-width {
    width: 100%;
  }
  .search-field__group--full-width {
    width: 100%;
  }
  .textarea {
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    &::placeholder {
      color: var(--field-placeholder, var(--muted));
    }
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    min-height: 38px;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus):not(:focus-visible), &[data-hovered="true"]:not([data-focused="true"]):not([data-focus-visible="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &:focus, &[data-focused="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .textarea--secondary {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--textarea-bg);
    --textarea-bg: var(--color-default);
    --textarea-bg-hover: var(--color-default-hover);
    --textarea-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus):not(:focus-visible), &[data-hovered="true"]:not([data-focused="true"]):not([data-focus-visible="true"]) {
        background-color: var(--textarea-bg-hover);
      }
    }
    &:focus, &[data-focused="true"] {
      background-color: var(--textarea-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--textarea-bg-focus);
    }
  }
  .textarea--full-width {
    width: 100%;
  }
  .calendar {
    width: calc(var(--spacing) * 63);
    max-width: 100%;
    container-type: inline-size;
  }
  .calendar__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: calc(var(--spacing) * 0.5);
    padding-bottom: calc(var(--spacing) * 4);
    &:has(.calendar-year-picker__trigger[data-open="true"]) {
      .calendar__nav-button {
        pointer-events: none;
        opacity: 0%;
      }
    }
  }
  .calendar__heading {
    flex: 1;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .calendar__nav-button {
    display: flex;
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 2);
    color: var(--accent);
    will-change: scale;
    transition: transform 250ms var(--ease-out), background-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out), opacity 150ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
        color: var(--accent);
      }
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.95);
    }
    &:focus-visible, &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .calendar__nav-button-icon {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .calendar__grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    width: 100%;
    &[aria-readonly="true"] {
      .calendar__cell {
        pointer-events: none;
      }
    }
  }
  .calendar__grid-header {
    display: contents;
    & > tr {
      display: contents;
    }
  }
  .calendar__grid-body {
    display: contents;
    & > tr {
      display: contents;
    }
    & > tr:first-child > td {
      margin-top: calc(var(--spacing) * 1);
    }
  }
  .calendar__grid-row {
    display: contents;
  }
  .calendar__header-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: calc(var(--spacing) * 2);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--muted);
  }
  .calendar__cell {
    position: relative;
    display: flex;
    aspect-ratio: 1 / 1;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 3);
    text-align: center;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-tap-highlight-color: transparent;
    will-change: scale;
    transition: transform 250ms var(--ease-out), box-shadow 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &[data-today="true"] {
      color: var(--accent);
    }
    &[data-selected="true"] {
      background-color: var(--accent);
      color: var(--accent-foreground);
    }
    &:active, &[data-pressed="true"] {
      background-color: var(--default);
      transform: scale(0.95);
      &[data-selected="true"] {
        background-color: var(--accent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
        }
      }
    }
    @media (hover: hover) {
      &:hover:not([data-selected="true"]), &[data-hovered="true"]:not([data-selected="true"]) {
        background-color: var(--default);
      }
    }
    &[data-outside-month="true"] {
      color: var(--muted);
      opacity: 50%;
    }
    &[data-selected="true"][data-outside-month="true"] {
      background-color: var(--default);
    }
    &[data-unavailable="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:disabled:not([data-outside-month="true"]), &[data-disabled="true"]:not([data-outside-month="true"]) {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      text-decoration: line-through;
    }
  }
  .calendar__cell-indicator {
    position: absolute;
    bottom: calc(var(--spacing) * 1);
    left: calc(1 / 2 * 100%);
    width: 3px;
    height: 3px;
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    border-radius: calc(var(--radius) * 0.25);
    background-color: var(--muted);
    [data-selected="true"] > & {
      background-color: var(--accent-foreground);
    }
  }
  .range-calendar {
    width: calc(var(--spacing) * 63);
    max-width: 100%;
    container-type: inline-size;
  }
  .range-calendar__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: calc(var(--spacing) * 0.5);
    padding-bottom: calc(var(--spacing) * 4);
    &:has(.calendar-year-picker__trigger[data-open="true"]) {
      .range-calendar__nav-button {
        pointer-events: none;
        opacity: 0%;
      }
    }
  }
  .range-calendar__heading {
    flex: 1;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .range-calendar__nav-button {
    display: flex;
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 1.5);
    color: var(--accent);
    will-change: scale;
    transition: transform 250ms var(--ease-out), background-color 100ms var(--ease-out), box-shadow 100ms var(--ease-out), opacity 150ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
        color: var(--accent);
      }
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.95);
    }
    &:focus-visible, &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[data-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .range-calendar__nav-button-icon {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .range-calendar__grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    width: 100%;
    &[aria-readonly="true"] {
      .range-calendar__cell {
        pointer-events: none;
      }
    }
  }
  .range-calendar__grid-header {
    display: contents;
    & > tr {
      display: contents;
    }
  }
  .range-calendar__grid-body {
    display: contents;
    & > tr {
      display: contents;
    }
    & > tr:first-child > td {
      margin-top: calc(var(--spacing) * 1);
    }
  }
  .range-calendar__grid-row {
    display: contents;
  }
  .range-calendar__header-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: calc(var(--spacing) * 2);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--muted);
  }
  .range-calendar__cell {
    position: relative;
    z-index: 1;
    margin-inline: calc(var(--spacing) * 0);
    margin-block: 2px;
    border-radius: calc(var(--radius) * 3);
    padding: calc(var(--spacing) * 0);
    --tw-outline-style: none;
    outline-style: none;
    cursor: var(--cursor-interactive);
    will-change: background-color, border-color;
    transition: box-shadow 100ms var(--ease-out), border-color 100ms var(--ease-out);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    .range-calendar__cell-button {
      display: flex;
      aspect-ratio: 1 / 1;
      width: 100%;
      align-items: center;
      justify-content: center;
      border-radius: calc(var(--radius) * 3);
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
      color: var(--foreground);
      -webkit-tap-highlight-color: transparent;
      will-change: scale;
      transition: scale 200ms var(--ease-out);
      transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      z-index: 2;
      .range-calendar__cell-button {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--focus);
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-color: var(--background);
        --tw-outline-style: none;
        outline-style: none;
        --tw-ring-offset-width: var(--ring-offset-width);
      }
    }
    &[data-today="true"] {
      .range-calendar__cell-button {
        color: var(--accent);
      }
    }
    &[data-selected="true"]:not([data-outside-month="true"]) {
      border-radius: 0;
      background-color: var(--accent-soft, var(--accent));
      @supports (color: color-mix(in lab, red, red)) {
        background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
      }
    }
    &[data-selected="true"]:is(td:first-child > *, [aria-disabled] + td > *) {
      border-start-start-radius: calc(var(--radius) * 1);
      border-end-start-radius: calc(var(--radius) * 1);
      &[data-selection-start="true"] {
        border-start-start-radius: calc(var(--radius) * 3);
        border-end-start-radius: calc(var(--radius) * 3);
      }
    }
    &[data-selected="true"]:is(td:last-child > *, td:has(+ [aria-disabled]) > *) {
      border-start-end-radius: calc(var(--radius) * 1);
      border-end-end-radius: calc(var(--radius) * 1);
      &[data-selection-end="true"] {
        border-start-end-radius: calc(var(--radius) * 3);
        border-end-end-radius: calc(var(--radius) * 3);
      }
    }
    &[data-selection-start="true"]:not([data-outside-month="true"]), &[data-selection-end="true"]:not([data-outside-month="true"]) {
      z-index: 2;
      .range-calendar__cell-button {
        background-color: var(--accent);
        color: var(--accent-foreground);
      }
    }
    &[data-selection-start="true"]:not([data-outside-month="true"]) {
      border-top-left-radius: calc(var(--radius) * 3);
      border-bottom-left-radius: calc(var(--radius) * 3);
    }
    &[data-selection-end="true"]:not([data-outside-month="true"]) {
      border-top-right-radius: calc(var(--radius) * 3);
      border-bottom-right-radius: calc(var(--radius) * 3);
    }
    &:active, &[data-pressed="true"] {
      .range-calendar__cell-button {
        scale: 0.9;
      }
      &[data-selection-start="true"], &[data-selection-end="true"] {
        .range-calendar__cell-button {
          background-color: var(--accent);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
          }
        }
      }
    }
    @media (hover: hover) {
      &:hover:not([data-selected="true"]), &[data-hovered="true"]:not([data-selected="true"]) {
        .range-calendar__cell-button {
          background-color: var(--default);
        }
      }
    }
    &[data-outside-month="true"] {
      color: var(--muted);
      opacity: 50%;
    }
    &[data-selected="true"][data-outside-month="true"]:not( [data-selection-start="true"], [data-selection-end="true"] ) {
      background-color: var(--default);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--default) 20%, transparent);
      }
    }
    &[data-unavailable="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:disabled:not([data-outside-month="true"]), &[data-disabled="true"]:not([data-outside-month="true"]) {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
      text-decoration: line-through;
    }
  }
  .range-calendar__grid-body td:has(> .range-calendar__cell[data-outside-month="true"]) + td > .range-calendar__cell[data-selected="true"] {
    border-start-start-radius: calc(var(--radius) * 1);
    border-end-start-radius: calc(var(--radius) * 1);
    &[data-outside-month="true"], &[data-selection-start="true"] {
      border-start-start-radius: calc(var(--radius) * 3);
      border-end-start-radius: calc(var(--radius) * 3);
    }
  }
  .range-calendar__grid-body td:has(> .range-calendar__cell[data-selected="true"]):has( + td > .range-calendar__cell[data-outside-month="true"] ) > .range-calendar__cell[data-selected="true"] {
    border-start-end-radius: calc(var(--radius) * 1);
    border-end-end-radius: calc(var(--radius) * 1);
    &[data-outside-month="true"], &[data-selection-end="true"] {
      border-start-end-radius: calc(var(--radius) * 3);
      border-end-end-radius: calc(var(--radius) * 3);
    }
  }
  .range-calendar__cell-indicator {
    position: absolute;
    bottom: calc(var(--spacing) * 1);
    left: calc(1 / 2 * 100%);
    width: 3px;
    height: 3px;
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    border-radius: calc(var(--radius) * 0.25);
    background-color: var(--muted);
    [data-selected="true"] > & {
      background-color: var(--accent-foreground);
    }
  }
  .calendar:has(.calendar-year-picker__year-grid), .range-calendar:has(.calendar-year-picker__year-grid) {
    position: relative;
  }
  .calendar:has(.calendar-year-picker__year-grid) > [data-slot="calendar-grid"], .range-calendar:has(.calendar-year-picker__year-grid) > [data-slot="range-calendar-grid"] {
    will-change: opacity;
    transition: opacity 150ms var(--ease-out), visibility 0ms linear;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .calendar:has(.calendar-year-picker__year-grid[data-open="true"]) > [data-slot="calendar-grid"], .range-calendar:has(.calendar-year-picker__year-grid[data-open="true"]) > [data-slot="range-calendar-grid"] {
    pointer-events: none;
    opacity: 0%;
    visibility: hidden;
    transition: opacity 150ms var(--ease-out), visibility 0ms linear 150ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .calendar-year-picker__trigger {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    gap: calc(var(--spacing) * 1);
    border-radius: calc(var(--radius) * 1);
    --tw-outline-style: none;
    outline-style: none;
    cursor: var(--cursor-interactive);
    touch-action: manipulation;
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
  }
  .calendar-year-picker__trigger-heading {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    transition: color 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .calendar-year-picker__trigger-indicator {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--accent);
    transition: transform 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .calendar-year-picker__trigger[data-open="true"] .calendar-year-picker__trigger-indicator {
    transform: rotate(90deg);
  }
  .calendar-year-picker__trigger[data-open="true"] .calendar-year-picker__trigger-heading {
    color: var(--accent);
  }
  .calendar-year-picker__year-grid {
    pointer-events: none;
    position: absolute;
    right: calc(var(--spacing) * 0);
    left: calc(var(--spacing) * 0);
    display: grid;
    align-content: flex-start;
    gap: calc(var(--spacing) * 1);
    overflow-y: auto;
    padding: calc(var(--spacing) * 1);
    opacity: 0%;
    grid-template-columns: repeat(3, 1fr);
    will-change: opacity;
    scrollbar-width: thin;
    scrollbar-color: oklch(0% 0 0 / 0.15) transparent;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: oklch(0% 0 0 / 0.15);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: oklch(0% 0 0 / 0.25);
    }
    :is([data-theme="dark"], .dark) & {
      scrollbar-color: oklch(100% 0 0 / 0.15) transparent;
      &::-webkit-scrollbar-thumb {
        background: oklch(100% 0 0 / 0.15);
      }
      &::-webkit-scrollbar-thumb:hover {
        background: oklch(100% 0 0 / 0.25);
      }
    }
  }
  .calendar-year-picker__year-grid[data-open="true"] {
    pointer-events: auto;
    opacity: 100%;
    transition: opacity 200ms var(--ease-out) 50ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .calendar-year-picker__year-cell {
    position: relative;
    display: inline-flex;
    height: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 3);
    padding-inline: calc(var(--spacing) * 2.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    transition: color 100ms var(--ease-smooth), scale 100ms var(--ease-smooth), opacity 100ms var(--ease-smooth), background-color 100ms var(--ease-smooth), box-shadow 100ms var(--ease-out);
    transform-origin: center;
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    @media (hover: hover) and (pointer: fine) {
      &:is(:hover, [data-hovered="true"]):not([data-selected="true"]) {
        background-color: var(--default);
        color: var(--default-foreground);
      }
    }
    &[data-selected="true"], &[aria-selected="true"] {
      background-color: var(--accent);
      color: var(--accent-foreground);
      @media (hover: hover) and (pointer: fine) {
        &:is(:hover, [data-hovered="true"]) {
          background-color: var(--accent);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);
          }
        }
      }
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
  }
  .date-field {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
  }
  .date-field--full-width {
    width: 100%;
  }
  .time-field {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
  }
  .time-field--full-width {
    width: 100%;
  }
  .date-input-group {
    display: inline-flex;
    height: calc(var(--spacing) * 9);
    align-items: center;
    overflow: hidden;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &[data-focus-within="true"]:not( :has( [data-slot="date-picker-trigger"]:focus, [data-slot="date-picker-trigger"][data-focused="true"], [data-slot="date-range-picker-trigger"]:focus, [data-slot="date-range-picker-trigger"][data-focused="true"] ) ), &:focus-within:not( :has( [data-slot="date-picker-trigger"]:focus, [data-slot="date-picker-trigger"][data-focused="true"], [data-slot="date-range-picker-trigger"]:focus, [data-slot="date-range-picker-trigger"][data-focused="true"] ) ) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: 0px;
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
      border-color: var(--color-field-border-invalid);
    }
    &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .date-input-group__input {
    display: flex;
    flex: 1;
    cursor: text;
    align-items: center;
    gap: 1px;
    border-radius: 0;
    border-style: var(--tw-border-style);
    border-width: 0px;
    background-color: transparent;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .date-input-group:has([data-slot="date-input-group-prefix"]) & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: calc(var(--spacing) * 2);
    }
    .date-input-group:has([data-slot="date-input-group-suffix"]) & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding-right: calc(var(--spacing) * 2);
    }
    .date-input-group:has(.date-range-picker__range-separator) & {
      &[slot="start"] {
        flex: none;
        padding-right: calc(var(--spacing) * 0);
      }
      &[slot="end"] {
        padding-left: calc(var(--spacing) * 0);
      }
    }
    &:focus, &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .date-input-group__input-container {
    display: flex;
    flex: 1;
    align-items: center;
    width: fit-content;
    overflow-x: auto;
    overflow-y: clip;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .date-input-group__segment {
    display: inline-block;
    border-radius: calc(var(--radius) * 0.75);
    padding-inline: calc(var(--spacing) * 0.5);
    text-align: end;
    text-wrap: nowrap;
    --tw-outline-style: none;
    outline-style: none;
    &[data-type="literal"] {
      padding: calc(var(--spacing) * 0);
      color: var(--muted);
    }
    &[data-placeholder="true"] {
      color: var(--field-placeholder, var(--muted));
    }
    &:focus, &[data-focused="true"] {
      background-color: var(--accent-soft, var(--accent));
      @supports (color: color-mix(in lab, red, red)) {
        background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
      }
      color: var(--accent-soft-foreground, var(--accent));
    }
    &[data-disabled="true"] {
      opacity: 50%;
    }
    &[data-invalid="true"] {
      color: var(--danger);
      &:focus, &[data-focused="true"] {
        background-color: var(--danger-soft, var(--danger));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: var(--danger-soft, color-mix(in oklab, var(--danger) 15%, transparent));
        }
        color: var(--danger-soft-foreground, var(--danger));
      }
    }
  }
  .date-input-group__prefix {
    pointer-events: none;
    flex-shrink: 0;
    color: var(--field-placeholder, var(--muted));
    margin-right: calc(var(--spacing) * 0);
    margin-left: calc(var(--spacing) * 3);
    display: flex;
    align-items: center;
  }
  .date-input-group__suffix {
    pointer-events: none;
    flex-shrink: 0;
    color: var(--field-placeholder, var(--muted));
    margin-right: calc(var(--spacing) * 3);
    display: flex;
    align-items: center;
  }
  .date-input-group--secondary {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--date-input-group-bg);
    --date-input-group-bg: var(--color-default);
    --date-input-group-bg-hover: var(--color-default-hover);
    --date-input-group-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:focus-within), &[data-hovered="true"]:not([data-focus-within="true"]) {
        background-color: var(--date-input-group-bg-hover);
      }
    }
    &:focus-within, &[data-focus-within="true"] {
      background-color: var(--date-input-group-bg-focus);
    }
    &[data-invalid="true"] {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      border-color: var(--color-field-border-invalid);
      background-color: var(--date-input-group-bg-focus);
    }
    [data-slot="date-input-group-input"] {
      background-color: transparent;
    }
  }
  .date-input-group--full-width {
    width: 100%;
  }
  .date-picker {
    display: inline-flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    .date-input-group__suffix, .date-input-group__prefix {
      pointer-events: auto;
    }
  }
  .date-picker__trigger {
    display: inline-flex;
    width: 100%;
    align-items: center;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    padding: calc(var(--spacing) * 1);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    transition: box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .date-picker__trigger-indicator {
    display: inline-flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    align-items: center;
    justify-content: center;
    color: var(--field-placeholder, var(--muted));
  }
  .date-picker__popover {
    max-width: var(--trigger-width);
    transform-origin: var(--trigger-anchor-point);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 3);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    box-shadow: var(--shadow-overlay);
    border-radius: min(32px, calc(var(--radius) * 2.5));
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement^="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement^="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement^="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement^="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
  }
  .date-range-picker {
    display: inline-flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    .date-input-group__suffix, .date-input-group__prefix {
      pointer-events: auto;
    }
  }
  .date-range-picker__trigger {
    display: inline-flex;
    width: 100%;
    align-items: center;
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    padding: calc(var(--spacing) * 1);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    -webkit-tap-highlight-color: transparent;
    cursor: var(--cursor-interactive);
    transition: box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .date-range-picker__trigger-indicator {
    display: inline-flex;
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    align-items: center;
    justify-content: center;
    color: var(--field-placeholder, var(--muted));
  }
  .date-range-picker__range-separator {
    padding-inline: calc(var(--spacing) * 1);
    color: var(--field-placeholder, var(--muted));
    -webkit-user-select: none;
    user-select: none;
  }
  .date-range-picker__popover {
    max-width: var(--trigger-width);
    transform-origin: var(--trigger-anchor-point);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 3);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    box-shadow: var(--shadow-overlay);
    border-radius: min(32px, calc(var(--radius) * 2.5));
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement^="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement^="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement^="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement^="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
  }
  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    overflow: hidden;
    padding: calc(var(--spacing) * 4);
    --tw-shadow: var(--surface-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    border-radius: min(32px, var(--radius-3xl));
  }
  .card__header {
    display: flex;
    flex-direction: column;
  }
  .card__title {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .card__description {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
    color: var(--muted);
  }
  .card__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
  }
  .card__footer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .card--transparent {
    --tw-border-style: none;
    border-style: none;
    background-color: transparent;
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .card--default {
    background-color: var(--surface);
  }
  .card--secondary {
    background-color: var(--surface-secondary);
  }
  .card--tertiary {
    background-color: var(--surface-tertiary);
  }
  .header {
    width: 100%;
    padding-inline: calc(var(--spacing) * 2);
    padding-top: calc(var(--spacing) * 1.5);
    padding-bottom: calc(var(--spacing) * 1);
    text-align: left;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--muted);
  }
  .separator {
    flex-shrink: 0;
    border-radius: calc(var(--radius) * 0.5);
    border-top-style: var(--tw-border-style);
    border-top-width: 0px;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
    background-color: var(--separator);
    height: 1px;
    width: 100%;
  }
  .separator--horizontal {
    height: 1px;
    width: 100%;
  }
  .separator--vertical {
    height: auto;
    min-height: calc(var(--spacing) * 2);
    width: 1px;
    align-self: stretch;
  }
  .separator--default {
    background-color: var(--separator);
  }
  .separator--secondary {
    background-color: var(--surface);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(
    in oklab,
    var(--surface) 85%,
    var(--surface-foreground) 15%
  );
    }
  }
  .separator--tertiary {
    background-color: var(--surface);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(
    in oklab,
    var(--surface) 81%,
    var(--surface-foreground) 19%
  );
    }
  }
  .separator__container {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 3);
  }
  .separator__container--horizontal {
    width: 100%;
    flex-direction: row;
  }
  .separator__container--vertical {
    height: 100%;
    flex-direction: column;
    justify-content: center;
  }
  .separator__line {
    flex-shrink: 0;
    flex-grow: 1;
  }
  .separator__content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    color: var(--muted);
  }
  .separator__content--horizontal {
    text-align: center;
  }
  .separator__content--vertical {
    text-align: center;
  }
  .surface {
    position: relative;
    color: var(--foreground);
  }
  .surface--transparent {
    background-color: transparent;
  }
  .surface--default {
    background-color: var(--surface);
    color: var(--surface-foreground);
  }
  .surface--secondary {
    background-color: var(--surface-secondary);
    color: var(--surface-secondary-foreground);
  }
  .surface--tertiary {
    background-color: var(--surface-tertiary);
    color: var(--surface-tertiary-foreground);
  }
  .avatar {
    position: relative;
    display: flex;
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: calc(var(--radius) * 3);
    background-color: var(--default);
  }
  .avatar__fallback {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-color: var(--default);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .avatar__image {
    position: absolute;
    inset: calc(var(--spacing) * 0);
    aspect-ratio: 1 / 1;
    width: 100%;
    height: 100%;
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 250ms;
    transition-duration: 250ms;
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
  }
  .avatar--sm {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
    border-radius: calc(var(--radius) * 2);
  }
  .avatar--lg {
    width: calc(var(--spacing) * 12);
    height: calc(var(--spacing) * 12);
    border-radius: calc(var(--radius) * 3);
    .avatar__fallback {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .avatar__fallback--accent {
    color: var(--accent);
  }
  .avatar__fallback--default {
    color: var(--default-foreground);
  }
  .avatar__fallback--success {
    color: var(--success);
  }
  .avatar__fallback--warning {
    color: var(--warning);
  }
  .avatar__fallback--danger {
    color: var(--danger);
  }
  .avatar--soft {
    background-color: transparent;
  }
  .avatar--soft .avatar__fallback--accent {
    background-color: var(--accent-soft, var(--accent));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
    }
    color: var(--accent-soft-foreground, var(--accent));
  }
  .avatar--soft .avatar__fallback--success {
    background-color: var(--success-soft, var(--success));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--success-soft, color-mix(in oklab, var(--success) 15%, transparent));
    }
    color: var(--success-soft-foreground, var(--success));
  }
  .avatar--soft .avatar__fallback--warning {
    background-color: var(--warning-soft, var(--warning));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--warning-soft, color-mix(in oklab, var(--warning) 15%, transparent));
    }
    color: var(--warning-soft-foreground, var(--warning));
  }
  .avatar--soft .avatar__fallback--danger {
    background-color: var(--danger-soft, var(--danger));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--danger-soft, color-mix(in oklab, var(--danger) 15%, transparent));
    }
    color: var(--danger-soft-foreground, var(--danger));
  }
  .alert-dialog__trigger {
    display: inline-block;
    cursor: var(--cursor-interactive);
    transition: transform 250ms var(--ease-out-quart), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.97);
    }
  }
  .alert-dialog__backdrop {
    position: fixed;
    inset: calc(var(--spacing) * 0);
    z-index: 50;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: var(--visual-viewport-height);
    width: 100%;
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: var(--ease-out);
      transition-timing-function: var(--ease-out);
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: var(--ease-out);
      transition-timing-function: var(--ease-out);
      --tw-exit-opacity: calc(0/100);
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        animation: none;
        &::before, &::after {
          animation: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
      }
    }
  }
  .alert-dialog__backdrop--transparent {
    background-color: transparent;
  }
  .alert-dialog__backdrop--opaque {
    background-color: var(--backdrop);
  }
  .alert-dialog__backdrop--blur {
    background-color: var(--backdrop);
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .alert-dialog__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: var(--visual-viewport-height);
    width: 100%;
    min-width: calc(var(--spacing) * 0);
    flex: 1;
    padding: calc(var(--spacing) * 4);
    @media (width >= 40rem) {
      width: fit-content;
    }
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 10);
    }
    pointer-events: none;
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 250ms;
      transition-duration: 250ms;
      --tw-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(105*1%);
      &[data-placement="auto"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
        @media (width >= 40rem) {
          --tw-enter-translate-y: calc(0*var(--spacing));
          --tw-enter-translate-y: calc(0*100%);
        }
      }
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="center"] {
        --tw-enter-translate-y: calc(0*var(--spacing)*-1);
        --tw-enter-translate-y: calc(0*-100%);
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      --tw-exit-opacity: calc(0/100);
      --tw-exit-opacity: 0;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        animation: none;
        &::before, &::after {
          animation: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
      }
    }
  }
  .alert-dialog__dialog {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: var(--overlay);
    --tw-shadow: var(--overlay-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-radius: min(32px, var(--radius-3xl));
    padding: calc(var(--spacing) * 6);
    overflow: hidden;
    pointer-events: auto;
    &[data-placement="auto"] {
      margin-top: auto;
      @media (width >= 40rem) {
        margin-block: auto;
      }
    }
    &[data-placement="center"] {
      margin-block: auto;
    }
    &[data-placement="bottom"] {
      margin-top: auto;
    }
    &[data-placement="top"] {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .alert-dialog__dialog--xs {
    max-width: var(--container-xs);
  }
  .alert-dialog__dialog--sm {
    max-width: var(--container-sm);
  }
  .alert-dialog__dialog--md {
    max-width: var(--container-md);
  }
  .alert-dialog__dialog--lg {
    max-width: var(--container-lg);
  }
  .alert-dialog__dialog--cover {
    height: 100%;
    min-height: 100%;
    width: 100%;
  }
  .alert-dialog__header {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    margin-bottom: calc(var(--spacing) * 0);
    & > .modal__icon {
      margin-bottom: calc(var(--spacing) * 0);
    }
  }
  .alert-dialog__heading {
    vertical-align: middle;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .alert-dialog__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
    flex-shrink: 0;
    border-radius: calc(var(--radius) * 3);
    -webkit-user-select: none;
    user-select: none;
    [data-slot="alert-dialog-default-icon"] {
      box-sizing: content-box;
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
    }
  }
  .alert-dialog__icon--default {
    background-color: var(--default);
    color: var(--foreground);
  }
  .alert-dialog__icon--accent {
    background-color: var(--accent-soft, var(--accent));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));
    }
    color: var(--accent-soft-foreground, var(--accent));
  }
  .alert-dialog__icon--success {
    background-color: var(--success-soft, var(--success));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--success-soft, color-mix(in oklab, var(--success) 15%, transparent));
    }
    color: var(--success-soft-foreground, var(--success));
  }
  .alert-dialog__icon--warning {
    background-color: var(--warning-soft, var(--warning));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--warning-soft, color-mix(in oklab, var(--warning) 15%, transparent));
    }
    color: var(--warning-soft-foreground, var(--warning));
  }
  .alert-dialog__icon--danger {
    background-color: var(--danger-soft, var(--danger));
    @supports (color: color-mix(in lab, red, red)) {
      background-color: var(--danger-soft, color-mix(in oklab, var(--danger) 15%, transparent));
    }
    color: var(--danger-soft-foreground, var(--danger));
  }
  .alert-dialog__body {
    min-height: calc(var(--spacing) * 0);
    flex: 1;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: 1.43;
    line-height: 1.43;
    color: var(--muted);
    margin-block: calc(var(--spacing) * 0);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .alert-dialog__footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: calc(var(--spacing) * 2);
    margin-top: calc(var(--spacing) * 0);
  }
  .alert-dialog__close-trigger {
    position: absolute;
    top: calc(var(--spacing) * 4);
    right: calc(var(--spacing) * 4);
  }
  .alert-dialog__header + .alert-dialog__body {
    margin-top: calc(var(--spacing) * 2);
  }
  .alert-dialog__header + .alert-dialog__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .alert-dialog__body + .alert-dialog__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .drawer__trigger {
    display: inline-block;
    cursor: var(--cursor-interactive);
    transition: transform 250ms var(--ease-out-quart), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.97);
    }
  }
  .drawer__backdrop {
    position: fixed;
    inset: calc(var(--spacing) * 0);
    z-index: 50;
    height: var(--visual-viewport-height);
    width: 100%;
    opacity: 1;
    transition: opacity 250ms cubic-bezier(0.32, 0.72, 0, 1);
    &[data-entering="true"] {
      opacity: 0;
    }
    &[data-exiting="true"] {
      opacity: 0;
      transition-duration: 200ms;
      transition-timing-function: cubic-bezier(0.32, 0.72, 0, 1);
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity;
    }
    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
  .drawer__backdrop--transparent {
    background-color: transparent;
  }
  .drawer__backdrop--opaque {
    background-color: var(--backdrop);
  }
  .drawer__backdrop--blur {
    background-color: var(--backdrop);
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .drawer__content {
    pointer-events: none;
    position: fixed;
    inset: calc(var(--spacing) * 0);
    z-index: 50;
    display: flex;
    height: var(--visual-viewport-height);
    width: 100%;
    min-width: calc(var(--spacing) * 0);
  }
  .drawer__content--bottom {
    align-items: flex-end;
  }
  .drawer__content--top {
    align-items: flex-start;
  }
  .drawer__content--left {
    justify-content: flex-start;
  }
  .drawer__content--right {
    justify-content: flex-end;
  }
  .drawer__dialog {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: var(--overlay);
    --tw-shadow: var(--overlay-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    padding: calc(var(--spacing) * 6);
    pointer-events: auto;
    --drawer-enter-duration: 250ms;
    --drawer-exit-duration: 200ms;
    --drawer-enter-ease: cubic-bezier(0.32, 0.72, 0, 1);
    --drawer-exit-ease: cubic-bezier(0.32, 0.72, 0, 1);
    will-change: translate;
    transition: translate var(--drawer-enter-duration) var(--drawer-enter-ease);
    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
    &[data-placement="bottom"] {
      width: 100%;
      max-height: 85vh;
      border-top-left-radius: min(32px, var(--radius-2xl));
      border-top-right-radius: min(32px, var(--radius-2xl));
    }
    &[data-placement="top"] {
      width: 100%;
      max-height: 85vh;
      border-bottom-left-radius: min(32px, var(--radius-2xl));
      border-bottom-right-radius: min(32px, var(--radius-2xl));
    }
    &[data-placement="left"] {
      height: 100%;
      border-radius: 0;
      width: calc(var(--spacing) * 80);
      max-width: 85vw;
      @media (width >= 40rem) {
        width: calc(var(--spacing) * 96);
      }
    }
    &[data-placement="right"] {
      height: 100%;
      border-radius: 0;
      width: calc(var(--spacing) * 80);
      max-width: 85vw;
      @media (width >= 40rem) {
        width: calc(var(--spacing) * 96);
      }
    }
  }
  [data-exiting="true"] .drawer__dialog {
    transition-duration: var(--drawer-exit-duration);
    transition-timing-function: var(--drawer-exit-ease);
  }
  .drawer__content--left .drawer__dialog, .drawer__content--right .drawer__dialog, .drawer__content--top .drawer__dialog, .drawer__content--bottom .drawer__dialog {
    translate: 0 0;
  }
  .drawer__content--left[data-entering="true"] .drawer__dialog, .drawer__content--left[data-exiting="true"] .drawer__dialog {
    translate: -100% 0;
  }
  .drawer__content--right[data-entering="true"] .drawer__dialog, .drawer__content--right[data-exiting="true"] .drawer__dialog {
    translate: 100% 0;
  }
  .drawer__content--top[data-entering="true"] .drawer__dialog, .drawer__content--top[data-exiting="true"] .drawer__dialog {
    translate: 0 -100%;
  }
  .drawer__content--bottom[data-entering="true"] .drawer__dialog, .drawer__content--bottom[data-exiting="true"] .drawer__dialog {
    translate: 0 100%;
  }
  .drawer__dialog--top {
    padding-bottom: calc(var(--spacing) * 2);
    .drawer__handle {
      padding-bottom: calc(var(--spacing) * 0);
    }
  }
  .drawer__header {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    margin-bottom: calc(var(--spacing) * 0);
  }
  .drawer__heading {
    vertical-align: middle;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .drawer__body {
    min-height: calc(var(--spacing) * 0);
    flex: 1;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: 1.43;
    line-height: 1.43;
    color: var(--muted);
    margin: calc(3px * -1);
    margin-block: calc(var(--spacing) * 0);
    padding: 3px;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
  .drawer__footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: calc(var(--spacing) * 2);
    margin-top: calc(var(--spacing) * 0);
  }
  .drawer__handle {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: calc(var(--spacing) * 2);
    & > [data-slot="drawer-handle-bar"] {
      height: calc(var(--spacing) * 1);
      width: calc(var(--spacing) * 9);
      border-radius: calc(var(--radius) * 0.25);
      background-color: var(--separator);
    }
  }
  .drawer__close-trigger {
    position: absolute;
    top: calc(var(--spacing) * 4);
    right: calc(var(--spacing) * 4);
  }
  .drawer__header + .drawer__body {
    margin-top: calc(var(--spacing) * 2);
  }
  .drawer__header + .drawer__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .drawer__body + .drawer__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .drawer__handle + .drawer__header {
    margin-top: calc(var(--spacing) * 0);
  }
  .drawer__handle + .drawer__body {
    margin-top: calc(var(--spacing) * 0);
  }
  .modal__trigger {
    display: inline-block;
    cursor: var(--cursor-interactive);
    transition: transform 250ms var(--ease-out-quart), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.97);
    }
  }
  .modal__backdrop {
    position: fixed;
    inset: calc(var(--spacing) * 0);
    z-index: 50;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: var(--visual-viewport-height);
    width: 100%;
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: var(--ease-out);
      transition-timing-function: var(--ease-out);
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: var(--ease-out);
      transition-timing-function: var(--ease-out);
      --tw-exit-opacity: calc(0/100);
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        animation: none;
        &::before, &::after {
          animation: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
      }
    }
  }
  .modal__backdrop--transparent {
    background-color: transparent;
  }
  .modal__backdrop--opaque {
    background-color: var(--backdrop);
  }
  .modal__backdrop--blur {
    background-color: var(--backdrop);
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .modal__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: var(--visual-viewport-height);
    width: 100%;
    min-width: calc(var(--spacing) * 0);
    flex: 1;
    padding: calc(var(--spacing) * 4);
    @media (width >= 40rem) {
      width: fit-content;
    }
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 10);
    }
    pointer-events: none;
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 250ms;
      transition-duration: 250ms;
      --tw-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(105*1%);
      &[data-placement="auto"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
        @media (width >= 40rem) {
          --tw-enter-translate-y: calc(0*var(--spacing));
          --tw-enter-translate-y: calc(0*100%);
        }
      }
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="center"] {
        --tw-enter-translate-y: calc(0*var(--spacing)*-1);
        --tw-enter-translate-y: calc(0*-100%);
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      --tw-exit-opacity: calc(0/100);
      --tw-exit-opacity: 0;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        animation: none;
        &::before, &::after {
          animation: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          animation: none;
          &::before, &::after {
            animation: none;
          }
        }
      }
    }
  }
  .modal__container--scroll-outside {
    overflow-y: auto;
    pointer-events: auto;
    -webkit-overflow-scrolling: touch;
  }
  .modal__container--full {
    padding: calc(var(--spacing) * 0);
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 0);
    }
    &[data-entering="true"] {
      --tw-enter-translate-y: calc(0*var(--spacing));
      --tw-enter-translate-y: calc(0*100%);
      --tw-enter-scale: calc(100*1%);
      --tw-enter-scale: 1;
      @media (width >= 40rem) {
        --tw-enter-translate-y: calc(0*var(--spacing));
        --tw-enter-translate-y: calc(0*100%);
      }
    }
    &[data-exiting="true"] {
      --tw-exit-scale: calc(100*1%);
      --tw-exit-scale: 1;
    }
  }
  .modal__dialog {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: var(--overlay);
    --tw-shadow: var(--overlay-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    border-radius: min(32px, var(--radius-3xl));
    padding: calc(var(--spacing) * 6);
    pointer-events: auto;
    &[data-placement="auto"] {
      margin-top: auto;
      @media (width >= 40rem) {
        margin-block: auto;
      }
    }
    &[data-placement="center"] {
      margin-block: auto;
    }
    &[data-placement="bottom"] {
      margin-top: auto;
    }
    &[data-placement="top"] {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .modal__dialog--scroll-inside {
    overflow: hidden;
  }
  .modal__dialog--scroll-outside {
    height: auto;
    min-height: calc(var(--spacing) * 0);
    flex-shrink: 0;
  }
  .modal__dialog--xs {
    max-width: var(--container-xs);
  }
  .modal__dialog--sm {
    max-width: var(--container-sm);
  }
  .modal__dialog--md {
    max-width: var(--container-md);
  }
  .modal__dialog--lg {
    max-width: var(--container-lg);
  }
  .modal__dialog--cover {
    height: 100%;
    min-height: 100%;
    width: 100%;
  }
  .modal__dialog--full {
    height: 100%;
    min-height: 100%;
    width: 100%;
    border-radius: 0;
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .modal__header {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    margin-bottom: calc(var(--spacing) * 0);
    & > .modal__icon {
      margin-bottom: calc(var(--spacing) * 0);
    }
  }
  .modal__heading {
    vertical-align: middle;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--foreground);
  }
  .modal__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
    flex-shrink: 0;
    border-radius: calc(var(--radius) * 3);
    -webkit-user-select: none;
    user-select: none;
  }
  .modal__body {
    min-height: calc(var(--spacing) * 0);
    flex: 1;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: 1.43;
    line-height: 1.43;
    color: var(--muted);
    margin-block: calc(var(--spacing) * 0);
  }
  .modal__body--scroll-inside {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .modal__body--scroll-outside {
    overflow-y: visible;
  }
  .modal__footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: calc(var(--spacing) * 2);
    margin-top: calc(var(--spacing) * 0);
  }
  .modal__close-trigger {
    position: absolute;
    top: calc(var(--spacing) * 4);
    right: calc(var(--spacing) * 4);
  }
  .modal__header + .modal__body {
    margin-top: calc(var(--spacing) * 2);
  }
  .modal__header + .modal__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .modal__body + .modal__footer {
    margin-top: calc(var(--spacing) * 5);
  }
  .popover {
    transform-origin: var(--trigger-anchor-point);
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 0);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    border-radius: min(32px, var(--radius-3xl));
    box-shadow: var(--shadow-overlay);
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(90*1%);
      --tw-enter-scale: .9;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="popover-overlay-arrow"] {
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="popover-overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="popover-overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="popover-overlay-arrow"] {
      rotate: 90deg;
    }
  }
  .popover__dialog {
    padding: calc(var(--spacing) * 4);
    --tw-outline-style: none;
    outline-style: none;
  }
  .popover__heading {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .popover__trigger {
    display: inline-block;
    transition: color 150ms var(--ease-smooth), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
    &:disabled, &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .tooltip {
    max-width: var(--container-xs);
    transform-origin: var(--trigger-anchor-point);
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 2);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    word-break: break-all;
    border-radius: min(32px, var(--radius-xl));
    box-shadow: var(--shadow-overlay);
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(90*1%);
      --tw-enter-scale: .9;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="overlay-arrow"] {
      stroke: var(--border);
      @supports (color: color-mix(in lab, red, red)) {
        stroke: color-mix(in oklab, var(--border) 40%, transparent);
      }
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="overlay-arrow"] {
      rotate: 90deg;
    }
  }
  .tooltip__trigger {
    display: inline-block;
    transition: color 150ms var(--ease-smooth), background-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
    }
  }
  .combo-box {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
    [data-slot="input"] {
      min-width: calc(var(--spacing) * 0);
      flex: 1;
      &:has(+ .combo-box__trigger) {
        padding-right: calc(var(--spacing) * 7);
      }
      &:focus, &[data-focus] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--focus);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-outline-style: none;
        outline-style: none;
        --tw-ring-offset-width: 0px;
        border-color: var(--color-field-border-focus);
        background-color: var(--color-field-focus);
      }
      &:disabled, &[data-disabled], &[aria-disabled="true"] {
        opacity: var(--disabled-opacity);
        cursor: var(--cursor-disabled);
        pointer-events: none;
      }
    }
  }
  .combo-box__input-group {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    align-items: center;
  }
  .combo-box__trigger {
    position: absolute;
    top: calc(1 / 2 * 100%);
    right: calc(var(--spacing) * 0);
    display: flex;
    height: 100%;
    flex-shrink: 0;
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    cursor: pointer;
    align-items: center;
    justify-content: center;
    padding-right: calc(var(--spacing) * 2);
    color: var(--field-placeholder, var(--muted));
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    -webkit-tap-highlight-color: transparent;
    --tw-border-style: none;
    border-style: none;
    background-color: transparent;
    --tw-outline-style: none;
    outline-style: none;
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        color: var(--field-foreground, var(--foreground));
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      border-radius: 0.25rem;
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-pressed="true"] {
      opacity: 70%;
    }
    &:disabled, &[data-disabled], &[aria-disabled="true"] {
      cursor: not-allowed;
      opacity: 50%;
    }
    [data-slot="combo-box-trigger-default-icon"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
      transition-property: transform, translate, scale, rotate;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
      --tw-duration: 150ms;
      transition-duration: 150ms;
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &[data-open="true"] [data-slot="combo-box-trigger-default-icon"] {
      rotate: 180deg;
    }
  }
  .combo-box__popover {
    min-width: var(--trigger-width);
    transform-origin: var(--trigger-anchor-point);
    scroll-padding-block: calc(var(--spacing) * 1);
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 0);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    border-radius: min(32px, var(--radius-3xl));
    box-shadow: var(--shadow-overlay);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="popover-overlay-arrow"] {
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="popover-overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="popover-overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="popover-overlay-arrow"] {
      rotate: 90deg;
    }
    [data-slot="list-box"] {
      padding: calc(var(--spacing) * 1.5);
      --tw-outline-style: none;
      outline-style: none;
    }
    [data-slot="list-box-item"] {
      padding-inline: calc(var(--spacing) * 2.5);
      [data-slot="list-box-item-indicator--checkmark"] {
        transition-property: none;
      }
    }
  }
  .combo-box--full-width {
    width: 100%;
  }
  .combo-box__input-group--full-width {
    width: 100%;
  }
  .select {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
    &[data-invalid="true"], &[aria-invalid="true"] {
      [data-slot="description"] {
        display: none;
      }
    }
    [data-slot="label"] {
      width: fit-content;
    }
  }
  .select__trigger {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    min-height: calc(var(--spacing) * 9);
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    &:has(.select__indicator) {
      padding-right: calc(var(--spacing) * 7);
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    .select[data-invalid="true"] &, .select[aria-invalid="true"] & {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .select--secondary .select__trigger {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--select-trigger-bg);
    --select-trigger-bg: var(--color-default);
    --select-trigger-bg-hover: var(--color-default-hover);
    --select-trigger-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--select-trigger-bg-hover);
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      background-color: var(--select-trigger-bg-focus);
    }
  }
  .select__value {
    flex: 1;
    text-align: left;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    overflow-wrap: break-word;
    color: currentcolor;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    &[data-placeholder="true"] {
      color: var(--field-placeholder, var(--muted));
    }
    [data-slot="list-box-item-indicator"] {
      display: none;
    }
  }
  .select__indicator {
    position: absolute;
    inset-block: calc(var(--spacing) * 0);
    right: calc(var(--spacing) * 2);
    margin-block: auto;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    color: var(--field-placeholder, var(--muted));
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    &[data-open="true"] {
      rotate: 180deg;
    }
    &[data-slot="select-default-indicator"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .select__popover {
    min-width: var(--trigger-width);
    transform-origin: var(--trigger-anchor-point);
    scroll-padding-block: calc(var(--spacing) * 1);
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 0);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    border-radius: min(32px, var(--radius-3xl));
    box-shadow: var(--shadow-overlay);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 150ms;
      transition-duration: 150ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: ease;
      transition-timing-function: ease;
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="popover-overlay-arrow"] {
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="popover-overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="popover-overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="popover-overlay-arrow"] {
      rotate: 90deg;
    }
    [data-slot="list-box"] {
      padding: calc(var(--spacing) * 1.5);
      --tw-outline-style: none;
      outline-style: none;
    }
    [data-slot="list-box-item"] {
      padding-inline: calc(var(--spacing) * 2.5);
    }
    [data-slot="list-box"]:not([aria-multiselectable="true"]) [data-slot="list-box-item-indicator"], [data-slot="list-box"]:not([aria-multiselectable="true"]) [data-slot="list-box-item-indicator"] [data-slot="list-box-item-indicator--checkmark"] {
      transition-property: none;
    }
  }
  .select--full-width {
    width: 100%;
  }
  .select__trigger--full-width {
    width: 100%;
  }
  .autocomplete {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 1);
  }
  .autocomplete__trigger {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    min-height: calc(var(--spacing) * 9);
    border-radius: var(--field-radius, calc(var(--radius) * 1.5));
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--field-background, var(--default));
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--field-foreground, var(--foreground));
    --tw-shadow: var(--field-shadow);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-outline-style: none;
    outline-style: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 150ms var(--ease-smooth), border-color 150ms var(--ease-smooth), box-shadow 150ms var(--ease-out);
    &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
      transition-property: none;
      &::before, &::after {
        transition-property: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
    }
    cursor: var(--cursor-interactive);
    border-width: var(--border-width-field);
    border-color: var(--color-field-border);
    &:has(.autocomplete__indicator) {
      padding-right: calc(var(--spacing) * 7);
    }
    @media (hover: hover) {
      &:hover:not(:has(.autocomplete__clear-button:hover)), &[data-hovered="true"]:not(:has(.autocomplete__clear-button:hover)) {
        background-color: var(--field-background, var(--default));
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(
    in oklab,
    var(--field-background, var(--default)) 90%,
    var(--field-foreground, var(--foreground)) 2%
  );
        }
        border-color: var(--color-field-border-hover);
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      --tw-ring-color: var(--focus);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-offset-color: var(--background);
      --tw-outline-style: none;
      outline-style: none;
      --tw-ring-offset-width: var(--ring-offset-width);
      border-color: var(--color-field-border-focus);
      background-color: var(--color-field-focus);
    }
    .autocomplete[data-invalid="true"] &, .autocomplete[aria-invalid="true"] & {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
      outline-color: var(--danger);
      --tw-outline-style: solid;
      outline-style: solid;
      --tw-ring-offset-width: 3px;
      &:focus, &:focus-visible, &[data-focused="true"], &[data-focus-visible="true"], &:focus-within, &[data-focus-within="true"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: var(--danger);
        --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-offset-width: 0px;
      }
      background-color: var(--color-field-focus);
    }
    &:disabled, &[data-disabled="true"], &[aria-disabled="true"] {
      opacity: var(--disabled-opacity);
      cursor: var(--cursor-disabled);
      pointer-events: none;
    }
  }
  .autocomplete--secondary .autocomplete__trigger {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background-color: var(--autocomplete-trigger-bg);
    --autocomplete-trigger-bg: var(--color-default);
    --autocomplete-trigger-bg-hover: var(--color-default-hover);
    --autocomplete-trigger-bg-focus: var(--color-default);
    @media (hover: hover) {
      &:hover:not(:has(.autocomplete__clear-button:hover)), &[data-hovered="true"]:not(:has(.autocomplete__clear-button:hover)) {
        background-color: var(--autocomplete-trigger-bg-hover);
      }
    }
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      background-color: var(--autocomplete-trigger-bg-focus);
    }
  }
  .autocomplete__value {
    flex: 1;
    text-align: left;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    overflow-wrap: break-word;
    color: currentcolor;
    @media (width >= 40rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    &[data-placeholder="true"] {
      color: var(--field-placeholder, var(--muted));
    }
    [data-slot="list-box-item-indicator"] {
      display: none;
    }
  }
  .autocomplete__indicator {
    position: absolute;
    inset-block: calc(var(--spacing) * 0);
    right: calc(var(--spacing) * 2);
    margin-block: auto;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    color: var(--field-placeholder, var(--muted));
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    cursor: var(--cursor-interactive);
    &[data-open="true"] {
      rotate: 180deg;
    }
    &[data-slot="autocomplete-default-indicator"] {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
  }
  .autocomplete__popover {
    min-width: var(--trigger-width);
    transform-origin: var(--trigger-anchor-point);
    scroll-padding-block: calc(var(--spacing) * 1);
    overflow-y: auto;
    overscroll-behavior: contain;
    background-color: var(--overlay);
    padding: calc(var(--spacing) * 0);
    padding-top: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    border-radius: min(32px, var(--radius-3xl));
    box-shadow: var(--shadow-overlay);
    &:focus-visible:not(:focus), &[data-focus-visible="true"] {
      --tw-outline-style: none;
      outline-style: none;
    }
    &[data-entering="true"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 250ms;
      transition-duration: 250ms;
      --tw-ease: cubic-bezier(0.32, 0.72, 0, 1);
      transition-timing-function: cubic-bezier(0.32, 0.72, 0, 1);
      --tw-enter-opacity: calc(0/100);
      --tw-enter-opacity: 0;
      --tw-enter-scale: calc(95*1%);
      --tw-enter-scale: .95;
      &[data-placement="top"] {
        --tw-enter-translate-y: calc(1*var(--spacing));
      }
      &[data-placement="bottom"] {
        --tw-enter-translate-y: calc(1*var(--spacing)*-1);
      }
      &[data-placement="left"] {
        --tw-enter-translate-x: calc(1*var(--spacing));
      }
      &[data-placement="right"] {
        --tw-enter-translate-x: calc(1*var(--spacing)*-1);
      }
    }
    &[data-exiting="true"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none);
      --tw-duration: 100ms;
      transition-duration: 100ms;
      --tw-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
      --tw-exit-scale: calc(95*1%);
      --tw-exit-scale: .95;
      --tw-exit-opacity: 0;
    }
    &[data-exiting="true"], &[data-entering="true"] {
      will-change: opacity,transform;
    }
    & [data-slot="popover-overlay-arrow"] {
      fill: var(--overlay);
    }
    &[data-placement="bottom"] [data-slot="popover-overlay-arrow"] {
      rotate: 180deg;
    }
    &[data-placement="left"] [data-slot="popover-overlay-arrow"] {
      rotate: -90deg;
    }
    &[data-placement="right"] [data-slot="popover-overlay-arrow"] {
      rotate: 90deg;
    }
    [data-slot="list-box"] {
      padding: calc(var(--spacing) * 1.5);
      --tw-outline-style: none;
      outline-style: none;
    }
    [data-slot="list-box-item"] {
      padding-inline: calc(var(--spacing) * 2.5);
    }
    [data-slot="list-box"]:not([aria-multiselectable="true"]) [data-slot="list-box-item-indicator"], [data-slot="list-box"]:not([aria-multiselectable="true"]) [data-slot="list-box-item-indicator"] [data-slot="list-box-item-indicator--checkmark"] {
      transition-property: none;
    }
    [data-slot="search-field"] {
      padding-inline: calc(var(--spacing) * 3);
      padding-block: calc(var(--spacing) * 1);
      --tw-outline-style: none;
      outline-style: none;
    }
    [data-slot="empty-state"] {
      text-align: center;
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
      color: var(--overlay-foreground);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--overlay-foreground) 60%, transparent);
      }
    }
  }
  .autocomplete--full-width {
    width: 100%;
  }
  .autocomplete__trigger--full-width {
    width: 100%;
  }
  .autocomplete__clear-button {
    position: relative;
    isolation: isolate;
    display: inline-flex;
    height: calc(var(--spacing) * 6);
    width: calc(var(--spacing) * 6);
    transform-origin: center;
    align-items: center;
    justify-content: center;
    border-radius: calc(var(--radius) * 1.5);
    padding: calc(var(--spacing) * 1);
    color: var(--muted);
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    margin-right: calc(var(--spacing) * 0);
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
    flex-shrink: 0;
    align-self: center;
    background-color: transparent;
    cursor: var(--cursor-interactive);
    transform: translateZ(0) var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
    &:not([data-empty="true"]) {
      transition: opacity 150ms var(--ease-smooth);
      &:is([data-reduce-motion="true"], [data-reduce-motion="true"] *) {
        transition-property: none;
        &::before, &::after {
          transition-property: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        &:not(:is([data-reduce-motion="true"], [data-reduce-motion="true"] *)) {
          transition-property: none;
          &::before, &::after {
            transition-property: none;
          }
        }
      }
    }
    &[data-empty="true"] {
      pointer-events: none;
      opacity: 0%;
    }
    [data-slot="autocomplete-clear-button-icon"] {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
    }
    @media (hover: hover) {
      &:hover, &[data-hovered="true"] {
        background-color: var(--default);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--default) 96%, var(--default-foreground) 4%);
        }
      }
    }
    &:active, &[data-pressed="true"] {
      transform: scale(0.93);
    }
  }
  .kbd {
    display: inline-flex;
    height: calc(var(--spacing) * 6);
    align-items: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: calc(var(--radius) * 1);
    background-color: var(--default);
    padding-inline: calc(var(--spacing) * 2);
    text-align: center;
    font-family: var(--font-sans);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
    color: var(--muted);
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 1;
      }
    }
    word-spacing: -0.25rem;
  }
  .kbd__abbr {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
  .kbd__content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .kbd--light {
    background-color: transparent;
  }
  .text {
    color: var(--foreground);
  }
  .text-prose {
    color: var(--foreground);
  }
  .text-prose h1 {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose h2 {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose h3 {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose h4 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose h5 {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose h6 {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text-prose p {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .text-prose code {
    border-radius: calc(var(--radius) * 0.75);
    background-color: var(--default);
    padding-inline: calc(var(--spacing) * 1.5);
    padding-block: calc(var(--spacing) * 0.5);
    font-family: var(--font-mono);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--foreground);
  }
  .text-prose a {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--link);
    text-decoration-line: underline;
    text-underline-offset: 4px;
  }
  .text-prose blockquote {
    margin-top: calc(var(--spacing) * 4);
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
    border-color: var(--border);
    padding-left: calc(var(--spacing) * 4);
    color: var(--muted);
    font-style: italic;
  }
  .text-prose ul {
    margin-block: calc(var(--spacing) * 4);
    list-style-type: disc;
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
    padding-left: calc(var(--spacing) * 6);
  }
  .text-prose ol {
    margin-block: calc(var(--spacing) * 4);
    list-style-type: decimal;
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
    padding-left: calc(var(--spacing) * 6);
  }
  .text-prose li {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .text-prose hr {
    margin-block: calc(var(--spacing) * 8);
    border-color: var(--separator);
  }
  .text-prose pre {
    margin-block: calc(var(--spacing) * 4);
    overflow-x: auto;
    border-radius: calc(var(--radius) * 1.5);
    background-color: var(--default);
    padding: calc(var(--spacing) * 4);
    font-family: var(--font-mono);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .text-prose strong {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--foreground);
  }
  .text-prose em {
    font-style: italic;
  }
  .text-prose img {
    margin-block: calc(var(--spacing) * 4);
    border-radius: calc(var(--radius) * 1.5);
  }
  .text--h1 {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--h2 {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--h3 {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--h4 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--h5 {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--h6 {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .text--body {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .text--body-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .text--body-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .text--code {
    border-radius: calc(var(--radius) * 0.75);
    background-color: var(--default);
    padding-inline: calc(var(--spacing) * 1.5);
    padding-block: calc(var(--spacing) * 0.5);
    font-family: var(--font-mono);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--foreground);
  }
  .text--align-start {
    text-align: left;
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      text-align: right;
    }
  }
  .text--align-center {
    text-align: center;
  }
  .text--align-end {
    text-align: right;
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      text-align: left;
    }
  }
  .text--align-justify {
    text-align: justify;
  }
  .text--color-default {
    color: var(--foreground);
  }
  .text--color-muted {
    color: var(--muted);
  }
  .text--truncate {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text--weight-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .text--weight-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .text--weight-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .text--weight-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .scroll-shadow {
    position: relative;
    --scroll-shadow-size: 40px;
  }
  .scroll-shadow--vertical {
    overflow-y: auto;
  }
  .scroll-shadow--horizontal {
    overflow-x: auto;
  }
  .scroll-shadow--fade.scroll-shadow--vertical {
    &[data-top-scroll="true"] {
      --scroll-linear-gradient: 0deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
    &[data-bottom-scroll="true"] {
      --scroll-linear-gradient: 180deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
    &[data-top-bottom-scroll="true"] {
      --scroll-linear-gradient: #000, #000, transparent 0, #000 var(--scroll-shadow-size),
      #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
  }
  .scroll-shadow--fade.scroll-shadow--horizontal {
    &[data-left-scroll="true"] {
      --scroll-linear-gradient: 270deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
    &[data-right-scroll="true"] {
      --scroll-linear-gradient: 90deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
    &[data-left-right-scroll="true"] {
      --scroll-linear-gradient: to right, #000, #000, transparent 0, #000 var(--scroll-shadow-size),
      #000 calc(100% - var(--scroll-shadow-size)), transparent;
      mask-image: linear-gradient(var(--scroll-linear-gradient));
      -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));
    }
  }
  .scroll-shadow--hide-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
@layer theme {
  @layer theme {
    @layer base {
      :root, .light, .default, [data-theme="light"], [data-theme="default"] {
        color-scheme: light;
        --white: oklch(100% 0 0);
        --black: oklch(0% 0 0);
        --snow: oklch(0.9911 0 0);
        --eclipse: oklch(0.2103 0.0059 285.89);
        --spacing: 0.25rem;
        --border-width: 1px;
        --field-border-width: 0px;
        --disabled-opacity: 0.5;
        --ring-offset-width: 2px;
        --cursor-interactive: pointer;
        --cursor-disabled: not-allowed;
        --radius: 0.5rem;
        --field-radius: calc(var(--radius) * 1.5);
        --background: oklch(0.9702 0 0);
        --foreground: var(--eclipse);
        --surface: var(--white);
        --surface-foreground: var(--foreground);
        --surface-secondary: oklch(0.9524 0.0013 286.37);
        --surface-secondary-foreground: var(--foreground);
        --surface-tertiary: oklch(0.9373 0.0013 286.37);
        --surface-tertiary-foreground: var(--foreground);
        --overlay: var(--white);
        --overlay-foreground: var(--foreground);
        --muted: oklch(0.5517 0.0138 285.94);
        --scrollbar: oklch(87.1% 0.006 286.286);
        --default: oklch(94% 0.001 286.375);
        --default-foreground: var(--eclipse);
        --accent: oklch(0.6204 0.195 253.83);
        --accent-foreground: var(--snow);
        --field-background: var(--white);
        --field-foreground: oklch(0.2103 0.0059 285.89);
        --field-placeholder: var(--muted);
        --field-border: transparent;
        --success: oklch(0.7329 0.1935 150.81);
        --success-foreground: var(--eclipse);
        --warning: oklch(0.7819 0.1585 72.33);
        --warning-foreground: var(--eclipse);
        --danger: oklch(0.6532 0.2328 25.74);
        --danger-foreground: var(--snow);
        --segment: var(--white);
        --segment-foreground: var(--eclipse);
        --border: oklch(90% 0.004 286.32);
        --separator: oklch(92% 0.004 286.32);
        --focus: var(--accent);
        --link: var(--foreground);
        --backdrop: rgba(0, 0, 0, 0.5);
        --surface-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.06),
      0 0 1px 0 rgba(0, 0, 0, 0.06);
        --overlay-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06), 0 -6px 12px 0 rgba(0, 0, 0, 0.03),
      0 14px 28px 0 rgba(0, 0, 0, 0.08);
        --field-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.06),
      0 0 1px 0 rgba(0, 0, 0, 0.06);
        --skeleton-animation: shimmer;
      }
      .dark, [data-theme="dark"] {
        color-scheme: dark;
        --background: oklch(12% 0.005 285.823);
        --foreground: var(--snow);
        --surface: oklch(0.2103 0.0059 285.89);
        --surface-foreground: var(--foreground);
        --surface-secondary: oklch(0.257 0.0037 286.14);
        --surface-tertiary: oklch(0.2721 0.0024 247.91);
        --overlay: oklch(0.2103 0.0059 285.89);
        --overlay-foreground: var(--foreground);
        --muted: oklch(70.5% 0.015 286.067);
        --scrollbar: oklch(70.5% 0.015 286.067);
        --default: oklch(27.4% 0.006 286.033);
        --default-foreground: var(--snow);
        --field-background: oklch(0.2103 0.0059 285.89);
        --field-foreground: var(--foreground);
        --warning: oklch(0.8203 0.1388 76.34);
        --warning-foreground: var(--eclipse);
        --danger: oklch(0.594 0.1967 24.63);
        --danger-foreground: var(--snow);
        --segment: oklch(0.3964 0.01 285.93);
        --segment-foreground: var(--foreground);
        --border: oklch(28% 0.006 286.033);
        --separator: oklch(25% 0.006 286.033);
        --focus: var(--accent);
        --link: var(--foreground);
        --backdrop: rgba(0, 0, 0, 0.6);
        --surface-shadow: 0 0 0 0 transparent inset;
        --overlay-shadow: 0 0 1px 0 rgba(255, 255, 255, 0.3) inset;
        --field-shadow: 0 0 0 0 transparent inset;
      }
    }
  }
  @layer components;
}
@layer base {
  :root {
    --tenant-primary: #463634;
    --tenant-secondary: #ece9e2;
    --tenant-surface: #ffffff;
    --tenant-foreground: #18181b;
    --tenant-max-width: 1200px;
    color-scheme: light;
    --owner-page-bg: #fafafa;
    --owner-surface: #ffffff;
    --owner-surface-raised: #ffffff;
    --owner-surface-muted: #f4f4f5;
    --owner-text: #18181b;
    --owner-text-muted: #52525b;
    --owner-border: #e4e4e7;
    --owner-border-strong: #d4d4d8;
    --owner-header-bg: var(--tenant-secondary);
    --owner-nav-bg: #17191b;
    --owner-nav-active-bg: rgba(255, 255, 255, 0.09);
    --owner-subnav-bg: var(--tenant-primary);
    --owner-accent-readable: var(--tenant-primary);
    --owner-accent-subtle: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 9%, var(--owner-surface));
    }
    --owner-accent-border: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 34%, var(--owner-border));
    }
    --owner-focus-ring: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 22%, transparent);
    }
    --owner-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
    --owner-shadow-strong: 0 24px 60px rgba(15, 23, 42, 0.16);
    --owner-info-bg: #eff6ff;
    --owner-info-text: #1e40af;
    --owner-info-border: #bfdbfe;
    --owner-danger: #dc2626;
    --owner-success: #16a34a;
    --owner-warning: #ea580c;
    --accent: var(--tenant-primary);
    --accent-foreground: #fff;
    --danger: var(--owner-danger);
    --danger-foreground: #fff;
    --default: var(--owner-surface-muted);
    --default-foreground: var(--owner-text);
  }
  :root.dark,
  :root[data-theme="dark"] {
    color-scheme: dark;
    --owner-page-bg: #111113;
    --owner-surface: #18181b;
    --owner-surface-raised: #202024;
    --owner-surface-muted: #27272a;
    --owner-text: #f4f4f5;
    --owner-text-muted: #a1a1aa;
    --owner-border: #3f3f46;
    --owner-border-strong: #52525b;
    --owner-header-bg: #1b1817;
    --owner-nav-bg: #09090b;
    --owner-nav-active-bg: rgba(255, 255, 255, 0.13);
    --owner-subnav-bg: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-subnav-bg: color-mix(in srgb, var(--tenant-primary) 70%, #09090b 30%);
    }
    --owner-accent-readable: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-accent-readable: color-mix(in srgb, var(--tenant-primary) 42%, #ffffff 58%);
    }
    --owner-accent-subtle: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 14%, var(--owner-surface));
    }
    --owner-accent-border: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 44%, var(--owner-border));
    }
    --owner-focus-ring: var(--tenant-primary);
    @supports (color: color-mix(in lab, red, red)) {
      --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 42%, transparent);
    }
    --owner-shadow: 0 16px 40px rgba(0, 0, 0, 0.34);
    --owner-shadow-strong: 0 28px 70px rgba(0, 0, 0, 0.48);
    --owner-info-bg: #172033;
    --owner-info-text: #bfdbfe;
    --owner-info-border: #31527e;
    --owner-danger: #f87171;
    --owner-success: #4ade80;
    --owner-warning: #fb923c;
  }
  @media (prefers-color-scheme: dark) {
    :root:not(.light):not([data-theme="light"]) {
      color-scheme: dark;
      --owner-page-bg: #111113;
      --owner-surface: #18181b;
      --owner-surface-raised: #202024;
      --owner-surface-muted: #27272a;
      --owner-text: #f4f4f5;
      --owner-text-muted: #a1a1aa;
      --owner-border: #3f3f46;
      --owner-border-strong: #52525b;
      --owner-header-bg: #1b1817;
      --owner-nav-bg: #09090b;
      --owner-nav-active-bg: rgba(255, 255, 255, 0.13);
      --owner-subnav-bg: var(--tenant-primary);
      @supports (color: color-mix(in lab, red, red)) {
        --owner-subnav-bg: color-mix(in srgb, var(--tenant-primary) 70%, #09090b 30%);
      }
      --owner-accent-readable: var(--tenant-primary);
      @supports (color: color-mix(in lab, red, red)) {
        --owner-accent-readable: color-mix(in srgb, var(--tenant-primary) 42%, #ffffff 58%);
      }
      --owner-accent-subtle: var(--tenant-primary);
      @supports (color: color-mix(in lab, red, red)) {
        --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 14%, var(--owner-surface));
      }
      --owner-accent-border: var(--tenant-primary);
      @supports (color: color-mix(in lab, red, red)) {
        --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 44%, var(--owner-border));
      }
      --owner-focus-ring: var(--tenant-primary);
      @supports (color: color-mix(in lab, red, red)) {
        --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 42%, transparent);
      }
      --owner-shadow: 0 16px 40px rgba(0, 0, 0, 0.34);
      --owner-shadow-strong: 0 28px 70px rgba(0, 0, 0, 0.48);
      --owner-info-bg: #172033;
      --owner-info-text: #bfdbfe;
      --owner-info-border: #31527e;
      --owner-danger: #f87171;
      --owner-success: #4ade80;
      --owner-warning: #fb923c;
    }
  }
  html {
    font-family: var(--font-sans);
    font-size: 16px;
    line-height: 1.5;
  }
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--owner-page-bg);
    color: var(--owner-text);
    font-family: var(--font-sans);
  }
  button,
  input,
  select,
  textarea {
    font: inherit;
  }
  a {
    color: var(--tenant-primary);
  }
}
@layer components {
  .owner-page {
    margin-inline: auto;
    width: 100%;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 8);
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
    max-width: var(--tenant-max-width);
  }
  .owner-card {
    border-radius: calc(var(--radius) * 2);
    border-style: var(--tw-border-style);
    border-width: 1px;
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    background: var(--owner-surface);
    border-color: var(--owner-border);
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-border-spacing-x {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-spacing-y {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity,1);
    transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0));
    filter: blur(var(--tw-enter-blur,0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity,1);
    transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0));
    filter: blur(var(--tw-exit-blur,0));
  }
}
@keyframes caret-blink {
  0%,70%,100% {
    opacity: 1;
  }
  20%,50% {
    opacity: 0;
  }
}
@keyframes skeleton {
  100% {
    transform: translateX(200%);
  }
}
@keyframes caret-blink {
  0%, 70%, 100% {
    opacity: 1;
  }
  20%, 50% {
    opacity: 0;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-animation-delay: 0s;
      --tw-animation-direction: normal;
      --tw-animation-duration: initial;
      --tw-animation-fill-mode: none;
      --tw-animation-iteration-count: 1;
      --tw-enter-blur: 0;
      --tw-enter-opacity: 1;
      --tw-enter-rotate: 0;
      --tw-enter-scale: 1;
      --tw-enter-translate-x: 0;
      --tw-enter-translate-y: 0;
      --tw-exit-blur: 0;
      --tw-exit-opacity: 1;
      --tw-exit-rotate: 0;
      --tw-exit-scale: 1;
      --tw-exit-translate-x: 0;
      --tw-exit-translate-y: 0;
      --tw-content: "";
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-border-spacing-x: 0;
      --tw-border-spacing-y: 0;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-space-x-reverse: 0;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/styles/heroui.css","webpack://./node_modules/@heroui/styles/dist/themes/shared/theme.css","webpack://./node_modules/@heroui/styles/dist/index.css","webpack://./node_modules/tw-animate-css/dist/tw-animate.css","webpack://./node_modules/@heroui/styles/dist/base/base.css","webpack://./node_modules/@heroui/styles/dist/components/close-button.css","webpack://./node_modules/@heroui/styles/dist/components/description.css","webpack://./node_modules/@heroui/styles/dist/components/error-message.css","webpack://./node_modules/@heroui/styles/dist/components/field-error.css","webpack://./node_modules/@heroui/styles/dist/components/label.css","webpack://./node_modules/@heroui/styles/dist/components/accordion.css","webpack://./node_modules/@heroui/styles/dist/components/breadcrumbs.css","webpack://./node_modules/@heroui/styles/dist/components/disclosure-group.css","webpack://./node_modules/@heroui/styles/dist/components/disclosure.css","webpack://./node_modules/@heroui/styles/dist/components/link.css","webpack://./node_modules/@heroui/styles/dist/components/pagination.css","webpack://./node_modules/@heroui/styles/dist/components/tabs.css","webpack://./node_modules/@heroui/styles/dist/components/button.css","webpack://./node_modules/@heroui/styles/dist/components/button-group.css","webpack://./node_modules/@heroui/styles/dist/components/toggle-button.css","webpack://./node_modules/@heroui/styles/dist/components/toggle-button-group.css","webpack://./node_modules/@heroui/styles/dist/components/toolbar.css","webpack://./node_modules/@heroui/styles/dist/components/dropdown.css","webpack://./node_modules/@heroui/styles/dist/components/list-box-item.css","webpack://./node_modules/@heroui/styles/dist/components/list-box-section.css","webpack://./node_modules/@heroui/styles/dist/components/list-box.css","webpack://./node_modules/@heroui/styles/dist/components/menu-item.css","webpack://./node_modules/@heroui/styles/dist/components/menu-section.css","webpack://./node_modules/@heroui/styles/dist/components/menu.css","webpack://./node_modules/@heroui/styles/dist/components/tag-group.css","webpack://./node_modules/@heroui/styles/dist/components/tag.css","webpack://./node_modules/@heroui/styles/dist/components/color-area.css","webpack://./node_modules/@heroui/styles/dist/components/color-picker.css","webpack://./node_modules/@heroui/styles/dist/components/color-slider.css","webpack://./node_modules/@heroui/styles/dist/components/color-swatch.css","webpack://./node_modules/@heroui/styles/dist/components/color-swatch-picker.css","webpack://./node_modules/@heroui/styles/dist/components/color-input-group.css","webpack://./node_modules/@heroui/styles/dist/components/color-field.css","webpack://./node_modules/@heroui/styles/dist/components/slider.css","webpack://./node_modules/@heroui/styles/dist/components/switch.css","webpack://./node_modules/@heroui/styles/dist/components/switch-group.css","webpack://./node_modules/@heroui/styles/dist/components/badge.css","webpack://./node_modules/@heroui/styles/dist/components/chip.css","webpack://./node_modules/@heroui/styles/dist/components/table.css","webpack://./node_modules/@heroui/styles/dist/components/alert.css","webpack://./node_modules/@heroui/styles/dist/components/empty-state.css","webpack://./node_modules/@heroui/styles/dist/components/skeleton.css","webpack://./node_modules/@heroui/styles/dist/components/meter.css","webpack://./node_modules/@heroui/styles/dist/components/progress-bar.css","webpack://./node_modules/@heroui/styles/dist/components/progress-circle.css","webpack://./node_modules/@heroui/styles/dist/components/spinner.css","webpack://./node_modules/@heroui/styles/dist/components/toast.css","webpack://./node_modules/@heroui/styles/dist/components/checkbox-group.css","webpack://./node_modules/@heroui/styles/dist/components/checkbox.css","webpack://./node_modules/@heroui/styles/dist/components/fieldset.css","webpack://./node_modules/@heroui/styles/dist/components/input-otp.css","webpack://./node_modules/@heroui/styles/dist/components/input.css","webpack://./node_modules/@heroui/styles/dist/components/input-group.css","webpack://./node_modules/@heroui/styles/dist/components/number-field.css","webpack://./node_modules/@heroui/styles/dist/components/radio-group.css","webpack://./node_modules/@heroui/styles/dist/components/radio.css","webpack://./node_modules/@heroui/styles/dist/components/textfield.css","webpack://./node_modules/@heroui/styles/dist/components/search-field.css","webpack://./node_modules/@heroui/styles/dist/components/textarea.css","webpack://./node_modules/@heroui/styles/dist/components/calendar.css","webpack://./node_modules/@heroui/styles/dist/components/range-calendar.css","webpack://./node_modules/@heroui/styles/dist/components/calendar-year-picker.css","webpack://./node_modules/@heroui/styles/dist/components/date-field.css","webpack://./node_modules/@heroui/styles/dist/components/time-field.css","webpack://./node_modules/@heroui/styles/dist/components/date-input-group.css","webpack://./node_modules/@heroui/styles/dist/components/date-picker.css","webpack://./node_modules/@heroui/styles/dist/components/date-range-picker.css","webpack://./node_modules/@heroui/styles/dist/components/card.css","webpack://./node_modules/@heroui/styles/dist/components/header.css","webpack://./node_modules/@heroui/styles/dist/components/separator.css","webpack://./node_modules/@heroui/styles/dist/components/surface.css","webpack://./node_modules/@heroui/styles/dist/components/avatar.css","webpack://./node_modules/@heroui/styles/dist/components/alert-dialog.css","webpack://./node_modules/@heroui/styles/dist/components/drawer.css","webpack://./node_modules/@heroui/styles/dist/components/modal.css","webpack://./node_modules/@heroui/styles/dist/components/popover.css","webpack://./node_modules/@heroui/styles/dist/components/tooltip.css","webpack://./node_modules/@heroui/styles/dist/components/combo-box.css","webpack://./node_modules/@heroui/styles/dist/components/select.css","webpack://./node_modules/@heroui/styles/dist/components/autocomplete.css","webpack://./node_modules/@heroui/styles/dist/components/kbd.css","webpack://./node_modules/@heroui/styles/dist/components/text.css","webpack://./node_modules/@heroui/styles/dist/components/scroll-shadow.css","webpack://./node_modules/@heroui/styles/dist/themes/default/index.css","webpack://./node_modules/@heroui/styles/dist/themes/default/variables.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;ICGA,yDAA0D;IDExD;8BAE0B;IAE1B,wCAAwC;IAExC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAQ1C,6CAA6C;IAmB7C,6CAA6C;IAE7C,6CAA6C;IAM7C,6CAA6C;IAgB7C,4CAA4C;IAE5C,6CAA6C;IAC7C,4CAA4C;IAG5C,6CAA6C;IAE7C,6CAA6C;IA0D7C,4CAA4C;IAwG5C,yCAAyC;IAQzC,4CAA4C;IA0E5C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IAErB,sBAAsB;IAEtB,sBAAsB;IAEtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IAezC,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAKvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IAIxB,qBAAqB;IACrB,qBAAqB;IAErB,wBAAwB;IE1P1B,sCAAsC;IACtC,qCAAqC;IACrC,qCAAqC;IFuSnC,sCAAsC;IAGtC,uCAAuC;IAEvC,+DAA+D;IAqC/D,cAAc;IACd,eAAe;IAcf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IE9f3D,qCAAqC;IACrC,qCAAqC;IAiBrC,6BAA6B;IAC7B,mDAAmD;IAOnD,2BAA2B;IAG3B,+BAA+B;IAC/B,qDAAqD;IAErD,+BAA+B;IAC/B,qDAAqD;IAErD,+BAA+B;IAC/B,qDAAqD;IAErD,6BAA6B;IAC7B,mDAAmD;IAInD,uCAAuC;IACvC,uCAAuC;IAYvC,wDAAwD;IAExD,oEAAoE;IAYpE,qCAA4F;IAA5F;MAAA,4FAA4F;IAAA;IAC5F,mCAA0F;IAA1F;MAAA,0FAA0F;IAAA;IAG1F,mCAA0F;IAA1F;MAAA,0FAA0F;IAAA;IAQ1F,4DAA4D;IAC5D,8DAIC;IAJD;MAAA;;;;GAIC;IAAA;IACD,8DAIC;IAJD;MAAA;;;;GAIC;IAAA;IAGD,sDAA4F;IAA5F;MAAA,4FAA4F;IAAA;IAC5F,4EAA4E;IAC5E;;;GAGC;IAHD;MAAA;;;GAGC;IAAA;IAED,sDAA4F;IAA5F;MAAA,4FAA4F;IAAA;IAC5F,4EAA4E;IAC5E;;;GAGC;IAHD;MAAA;;;GAGC;IAAA;IAED,yDAA+F;IAA/F;MAAA,+FAA+F;IAAA;IAC/F,+EAA+E;IAM/E,yDAA+F;IAA/F;MAAA,+FAA+F;IAAA;IAC/F,+EAA+E;IAkC/E,mBAAmB;IAWnB,qDAAqD;IAErD,oDAAoD;IAKpD,gDAAgD;IAUhD,qBAAqB;EFjLN;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB,kDAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,kFAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,mFAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;QAAnB;UAAA,kFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,0LAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,OAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,WAAmB;MAAA;IAAA;EAAA;AADJ;AG76BjB,yCAAyC;AHAzC,yCAAyC;AAEzC,YAAa;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ,gBAAiB;AI76BjB;EAA+B,WAAU;EAAC,eAAc;EAAC,iBAAgB;AAA3C;AAA4C;EAAmC,WAAU;EAAC,eAAc;EAAC,qBAAoB;AAA/C;AAAgD;EAAkC,WAAU;EAAC,eAAc;AAA1B;AAA2B;EAAmC,WAAU;EAAC,eAAc;EAAC,mBAAkB;AAA7C;AAA8C;EAAyC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA0B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA6B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAyB,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA0B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;ADSlqC;EEMA;IAKE,yCAAyC;EADpB;EAKvB;IACE,0BAA0B;EADtB;EAIN;IACE,oBAAoB;EADJ;AFnBmB;AAGrC;EGTA;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,gCAAG;IAAC,+BAAG;IAAC,cAAQ;IAAC,wBAAa;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAU;IAAC,iCAAG;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAGtI,iCAAiC;IAMjC,wJAIkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACS,oBAAc;IADA;IAKvB;MACS,oBAAmB;MACnB,+BAAM;MAAN,gCAAM;MAAC,cAAQ;MAAC,kBAAW;MAC3B,0CAAO;MAAC,wCAAM;IAHjB;EAnCM;EA2Cd;IACS,gCAAU;IAAC,mBAAU;IAM5B;MACE;QAES,gCAAgB;QAAhB;UAAA,uFAAgB;QAAA;MADF;IAFH;IAOtB;MAEE,sBAAsB;IADD;EAfF;EC7CvB;IACS,yBAAO;IAAP,2DAAO;IAAC,eAAS;IAAC,yBAAe;IAAC,mBAAU;EADxC;ECAb;IACS,YAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,yBAAe;IAAC,oBAAW;IAMjD,0EAEiC;IAC1B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAVvB;ECAf;IACS,gCAAG;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,yBAAe;IAAC,oBAAW;IAAC,WAAS;IAAC;MAAA,YAA0B;IAAA;IAAC;MAAA,aAA+B;IAAA;IAMxH,0EAEiC;IAC1B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAVzB;ECAb;IAES,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAFrC;EAUP;IAIS;MAAA,0BAAY;MAAZ,uCAAY;IAAA;IAAC;MAAA,0BAAiB;MAAjB,oBAAiB;IAAA;IAAC;MAAA,iBAAmB;MAAnB,0BAAmB;IAAA;EAD0B;EAIrF;IAES,gCAAe;IAAf,8BAAe;IAAf,oBAAe;EADM;EAI9B;IAGS,oBAAW;EADS;ECxB7B;IACS,WAAM;IAGb,qBAAqB;EAJZ;EAQX;IACS,yBAAO;IAAP,2DAAO;EADC;EAIjB;IACS,wCAAI;IAAC,qCAAI;IAAC,wCAAI;IAAC,mBAAU;EADX;EAIvB;IACS,aAAI;EADO;EAIpB;IACS,iBAAO;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,mBAAU;IAKlC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAG5D;MACS,yBAAW;IADI;EATJ;EAetB;IACS,kBAAQ;IAAC,uBAAW;IAAX,kBAAW;EADZ;EAIjB;IACE,WAAW;IACJ,kBAAQ;IAAC,gCAAQ;IAAC,8BAAM;IAAC,WAAI;IAAC,WAAM;IAAC,yCAAU;IAAC,kCAAY;EAF7C;EAKxB;IACE,aAAa;EADoB;EAKnC;IACE,aAAa;EADqC;EAKpD;IACE,iCAAiC;IAG1B,aAAI;IAAC,OAAM;IAAC,mBAAY;IAAC,8BAAe;IAAC,wCAAI;IAAC,uCAAI;IAAC,gBAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,wCAAY;IAMpG,2EAEkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAEE,yCAAkF;QAAlF;UAAA,kFAAkF;QAAA;MADjC;IAF/B;IAYtB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAnCN;EAwCpB;IACE,UAAU;IACV,sCAAsC;IACtC,cAAc;IAMd,4EAE+B;IACxB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACE,4BAA4B;MAC5B,UAAU;IAFY;EAdR;EAqBlB;IACS,gCAAU;IACjB,2CAA2C;IAE3C;MACE;QACE;UAES,gCAAU;QADgC;MAF/B;IADJ;IASpB;MACS,2CAAuB;MAAvB;QAAA,gFAAuB;MAAA;IADR;EAbN;EAkBpB;IAEE;MACS,QAAS;MAAC,UAAO;IADjB;IAKT;MACE,oDAAoD;MACpD,qDAAqD;IAFT;IAK9C;MAEE,uDAAuD;MACvD,wDAAwD;IAFxB;EAbC;ECrIrC;IACS,aAAI;IAAC,mBAAY;IAGxB;MACS,kBAAQ;MAAC,0CAAM;MAAC,yBAAO;MAAP,2DAAO;MAAC,sCAAS;MAAT,qCAAS;MAAC,2CAAW;MAAX,sCAAW;MAAC,mBAAU;MAAC,0BAAY;MAAC,aAAW;MAExF;QAES,+BAAS;MADK;MAIvB;QACS,kBAAS;QAAC,aAAW;MADP;IARN;IAcnB;MACS,aAAI;MAAC,cAAQ;MAAC,mBAAY;MAAC,uBAAc;MAAC,+BAAO;MAAC,0CAAM;IAD9C;IAKnB;MACS,+BAAM;MAAN,gCAAM;MAAC,mBAAU;MAAC;QAAA,cAAc;MAAA;IADjB;EAvBb;ECAb;IACS,WAAM;IAGb,qBAAqB;EAJL;ECAlB;IACS,kBAAQ;EADL;EAIZ;IACS,aAAI;EADO;EAIpB;IACE,iCAAiC;IAC1B,qBAAY;IAAC,wCAAY;IAGhC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAZL;EAiBrB;IACS,iBAAO;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,cAAY;IAKpC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAG5D;MACS,yBAAW;IADI;EATH;EAcvB;IACE,UAAU;IACV,sCAAsC;IACtC,cAAc;IAMd,4EAE+B;IACxB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACE,4BAA4B;MAC5B,UAAU;IAFY;EAdL;EAoBrB;IACS,iCAAG;EADM;EC3DlB;IACS,kBAAQ;IAAC,oBAAW;IAAC,mBAAK;IAAC,kBAAK;IAAC,mBAAY;IAAC,wCAAU;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,kBAAS;IAAC,+BAAS;IAAC,qCAA6B;IAA7B;MAAA;;;;GAA6B;IAAA;IAAC,gCAAkB;IAAC,0BAAkB;IAAC,wCAAY;IAMxL,mMAK+B;IACxB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAGjC;MACE;QAES,mCAAgB;QAEvB;UACS,aAAW;QADR;MAHS;IAFH;IAYtB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;MAErB;QACS,aAAW;MADR;IAHe;IAS7B;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAIxB;MACS,oBAAmB;MAAC,oBAAW;MAAC,+BAAM;MAAN,gCAAM;MAAC,cAAQ;MAAC,mBAAY;MAAC,uBAAc;MAAC,mBAAY;MAAC,YAAU;MAM1G,yCAAyC;MAClC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;MAEpC;QACS,wHAAa;MADhB;IAVI;IAeZ;MACS,qCAAI;MAAC,0CAAM;IADkB;IAKtC;MACS,6BAAK;MAAC,0BAAY;IADlB;EAjEL;ECIN;IACS,aAAI;IAAC,WAAM;IAAC,sBAAQ;IAAC,mBAAY;IAAC,8BAAe;IAAC,6BAAK;IAAC;MAAA,mBAAW;IAAA;EADhE;EAKZ;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;IAAC,sBAAU;IAAC,yBAAO;IAAP,2DAAO;IAAC,mBAAU;IAAC;MAAA,kBAAc;IAAA;EADxD;EAKrB;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;IAAC,sBAAU;IAAC;MAAA,kBAAc;IAAA;EADrC;EAKrB;IACS,oBAAW;EADF;EAKlB;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,wBAAa;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAiB;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAAC;MAAA,+BAAS;MAAT,gCAAS;IAAA;IAEtL,iCAAiC;IAMjC,wHAGkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD,iCAAiC;IACjC,sDAAsD;IACtD,wDAAwD;IACxD,qDAAqD;IAErD,2CAA2C;IAC3C,gCAAgC;IAGhC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACE;QAEE,iDAAiD;MAD5B;IAFH;IAQtB;MAEE,mDAAmD;MACnD,sBAAsB;IAFD;IAMvB;MACE,0CAA0C;MAC1C,sDAAsD;MACtD,wDAAwD;IAHpC;EApDN;EA4DlB;IACS,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,yBAAO;IAAP,2DAAO;IAAC,mBAAU;IAAC,yBAAW;IAAX,iBAAW;IAAC;MAAA,+BAAS;MAAT,gCAAS;IAAA;EAD1E;EAKtB;IACS,WAAM;IAAC,+BAAO;IAAC,0CAAM;EADP;EAQvB;IACE;MACS,+BAAM;MAAN,gCAAM;MAAC,yBAAO;MAAP,2DAAO;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;MAE/B;QAEE,sBAAsB;MADD;IAJP;IASlB;MACS,WAAM;MAAC,wCAAI;IADG;IAIvB;MACS,+BAAM;MAAN,gCAAM;MAAC,yBAAO;MAAP,2DAAO;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;IADX;IAItB;MACS,yBAAO;MAAP,2DAAO;IADK;EAlBP;EA2BhB;IACE;MACS,gCAAO;MAAP,iCAAO;MAAC,2BAAS;MAAT,6DAAS;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;MAElC;QAEE,sBAAsB;MADD;IAJP;IASlB;MACS,WAAM;MAAC,wCAAI;IADG;IAIvB;MACS,gCAAO;MAAP,iCAAO;MAAC,2BAAS;MAAT,6DAAS;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;IADd;IAItB;MACS,2BAAS;MAAT,6DAAS;IADG;EAlBP;EC5HhB;IACS,aAAI;IAAC,6BAAK;IAGjB;MACS,sBAAQ;IADgB;IAIjC;MACS,mBAAQ;IADc;EAR3B;EAcN;IACS,kBAAQ;EADK;EAKtB;IACS,oBAAW;IAAC,gCAAU;IAAC,iCAAG;IAEjC,wCAAwC;IAGxC;MACS,WAAM;MAAC,mBAAQ;IADS;IAKjC;MACS,sBAAQ;MAAC,6BAAK;MAErB;QACS,oCAAQ;MADN;IAHkB;EAXrB;EAqBZ;IACE,kBAAkB;IAClB,UAAU;IACV,iCAAiC;IAE1B,aAAI;IAAC,gCAAG;IAAC,WAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,wCAAI;IAAC,kBAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAU;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAMxI,yJAIkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACS,gCAAuB;IADR;IAKxB;MACE,UAAU;IAD6B;IAKzC;MACE,UAAU;IAD0C;IAKtD;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACE;QAES,YAAU;MAD4D;IAF3D;IAQtB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;EAlDpB;EAwDX;IACS,wCAAU;IAAC,8BAAW;IAAX;MAAA,oEAAW;IAAA;IAC7B,kBAAkB;IAClB,oBAAoB;IAMpB,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE,OAAO;MACP,QAAQ;MACR,UAAU;MACV,WAAW;IAJgC;IAQ7C;MACE,MAAM;MACN,QAAQ;MACR,UAAU;MACV,WAAW;IAJ8B;EArB5B;EA8BjB;IACS,WAAM;IAAC,iCAAG;IAAC,wBAAY;IAAZ,mBAAY;IAO9B;MACS,kBAAQ;MAAC,6BAAK;MAAC,8BAAM;MAAC,WAAM;IADd;IAKvB;MACS,oCAAI;IADoB;IAIjC;MACS,qCAAI;IADkB;EAjBpB;EAuBb;IACE,iCAAiC;IACjC,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,gCAAgC;IAChC,WAAW;IACX,YAAY;IAEL,gCAAU;IAMjB,0BAA0B;IAC1B,6CAA6C;IAC7C,iDAAiD;IAC1C;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAnBrB;EA0BjB;IAEE;MACS,6BAAc;MAAC,iCAAG;MAEzB,gBAAgB;MAGhB;QACS,2CAAQ;QAAR,wBAAQ;QAAC,2BAAa;QAE7B,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QAErB;UACE,aAAa;QADM;MARU;MAcjC;QACS,yCAAQ;QAAR,sBAAQ;QAAC,2BAAa;MADA;IApBK;IA0BtC;MACS,gBAAY;MAGnB;QACS,wBAAe;MADA;IAJS;IAUnC;MACE,aAAa;IAD0B;IAKzC;MACS,+BAAS;MAEhB,gBAAgB;MAChB,gBAAgB;IAJuB;IAQzC;MACE,SAAS;MACT,SAAS;MACT,WAAW;IAH6D;IAO1E;MACE,OAAO;MACP,MAAM;MACN,UAAU;MACV,YAAY;IAJ0D;EA1DzD;EC7KjB;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,iCAAI;IAAC,kBAAK;IAAC,wBAAa;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,sCAAW;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAiB;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAAC;MAAA,gCAAM;IAAA;IAMlM,wHAGkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD,iCAAiC;IAGjC,wBAAwB;IACxB,mCAAmC;IACnC,2CAA2C;IAC3C,yBAAyB;IAEzB,kCAAkC;IAClC,uBAAuB;IAGvB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACS,oBAAc;IADA;IAKvB;MAEE,0CAA0C;MAC1C,sBAAsB;IAFD;IAMvB;MACE;QAEE,wCAAwC;MADnB;IAFH;IAQtB;MACS,oBAAmB;MAAC,0CAAO;MAAC,wCAAM;MAAC,+BAAM;MAAN,gCAAM;MAAC,cAAQ;MAAC,kBAAW;MAAC;QAAA,sCAAO;MAAA;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;IADvB;EA1D5D;EAgER;IACS,gCAAG;IAAC,wCAAI;IAAC;MAAA,gCAAM;IAAA;IAEtB;MACS,+BAAM;MAAN,gCAAM;IADmD;IAIlE;MAEE,sBAAsB;IADD;EARb;EAiBZ;IACS,iCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC;MAAA,iCAAO;IAAA;IAE7B;MAEE,sBAAsB;IADD;EAJb;EAUZ;IACE,gCAAgC;IAChC,4CAA4C;IAC5C,8CAA8C;IAC9C,2CAA2C;EAJ5B;EAOjB;IACE,iCAAiC;IACjC,6CAA6C;IAC7C,+CAA+C;IAC/C,gDAAgD;EAJ/B;EAOnB;IACE,iCAAiC;IACjC,6CAA6C;IAC7C,+CAA+C;EAH/B;EAMlB;IAEE,wBAAwB;IACxB,uCAAuC;IACvC,yCAAyC;IACzC,4CAA4C;EAJ7B;EAOjB;IACS,oCAAM;IAAN,iBAAM;IAAC,2BAAa;IAC3B,uCAA4E;IAA5E;MAAA,4EAA4E;IAAA;EAF7D;EAKjB;IACE,gCAAgC;IAChC,4CAA4C;IAC5C,8CAA8C;IAC9C,2CAA2C;EAJ7B;EAOhB;IACE,qCAAqC;IACrC,iDAAiD;IACjD,mDAAmD;IACnD,gDAAgD;EAJ7B;EAQrB;IACS,gCAAI;IAAC,iCAAG;IAAC;MAAA,+BAAM;IAAA;EADL;EAInB;IACS,+BAAG;IAAC;MAAA,+BAAM;IAAA;EADW;EAI9B;IACS,gCAAI;IAAC;MAAA,gCAAO;IAAA;EADS;EAK9B;IACS,WAAM;EADK;ECtJpB;IACS,oBAAW;IAAC,YAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;EAD/C;EAQd;IACS,mBAAQ;EADS;EAI1B;IACS,sBAAQ;EADO;EAKxB;IACS,gBAAY;EADC;EAKtB;IACS,kDAAa;IAAb,gDAAa;EADwB;EAK9C;IACS,gDAAa;IAAb,8CAAa;EADuB;EAK7C;IACS,sCAAW;EADqC;EAKzD;IACS,+CAAa;IAAb,gDAAa;EADsB;EAK5C;IACS,mDAAa;IAAb,kDAAa;EADqB;EAK3C;IACS,sCAAW;EADmC;EAKvD;IAEE,eAAe;EAD0B;EAK3C;IAEE,2BAA2B;IACpB,sBAAU;EAF8B;EASjD;IACS,wCAAU;IAAC,8BAAU;IAAC,YAAU;IACvC,kBAAkB;IAClB,oBAAoB;IAMpB,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE,UAAU;MACV,QAAQ;MACR,UAAU;MACV,WAAW;IAJe;IAQ5B;MACE,SAAS;MACT,SAAS;MACT,UAAU;MACV,WAAW;IAJa;EArBH;EAmCzB;IACS,+CAAU;IAAV,4BAAU;EADoC;EAKvD;IACS,iDAAU;IAAV,8BAAU;EADmC;EAKtD;IACS,2CAAU;IAAV,wBAAU;EAD2D;EAM9E;IACS,2CAAU;IAAV,wBAAU;EADkC;EAKrD;IACS,wCAAU;IAAV,qBAAU;EADiC;EAKpD;IACS,0CAAU;IAAV,uBAAU;EADyD;EAQ5E;IACS,WAAM;EADW;ECzI1B;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,iCAAI;IAAC,kBAAK;IAAC,wBAAa;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,sCAAW;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAiB;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAAC;MAAA,gCAAM;IAAA;IAMlM,wHAGkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD,iCAAiC;IAGjC,wCAAwC;IACxC,oDAAoD;IACpD,sDAAsD;IACtD,gCAAgC;IAGhC,qDAAqD;IACrD,iEAAiE;IACjE,mEAAmE;IACnE,gEAAgE;IAEhE,yCAAyC;IACzC,8BAA8B;IAG9B;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACE;QAEE,+CAA+C;MAD1B;IAFH;IAQtB;MAEE,iDAAiD;MACjD,sBAAsB;IAFD;IAMvB;MACE,kDAAkD;MAClD,uCAAuC;MAEvC;QACE;UAEE,wDAAwD;QADnC;MAFH;MAOtB;QAEE,0DAA0D;MADrC;IAZD;IAkBxB;MACS,oBAAmB;MAAC,0CAAO;MAAC,wCAAM;MAAC,+BAAM;MAAN,gCAAM;MAAC,cAAQ;MAAC,kBAAW;MAAC;QAAA,sCAAO;MAAA;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;IADnF;EA7EO;EAsFf;IACS,gCAAG;IAAC,wCAAI;IAAC;MAAA,gCAAM;IAAA;IAEtB;MACS,+BAAM;MAAN,gCAAM;IADT;IAIN;MAEE,sBAAsB;IADD;EARN;EAiBnB;IACS,iCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC;MAAA,iCAAO;IAAA;IAE7B;MAEE,sBAAsB;IADD;EAJN;EAanB;IACE,wCAAwC;IACxC,oDAAoD;IACpD,sDAAsD;EAHhC;EAMxB;IACE,+BAA+B;IAC/B,8CAA8C;IAC9C,gDAAgD;IAChD,mDAAmD;EAJ/B;EAWtB;IACS,gCAAI;IAAC,iCAAG;IAAC;MAAA,+BAAM;IAAA;EADE;EAI1B;IACS,+BAAG;IAAC;MAAA,+BAAM;IAAA;EADyB;EAI5C;IACS,gCAAI;IAAC;MAAA,gCAAO;IAAA;EADuB;EC7I5C;IACS,oBAAW;IAAC,YAAM;IAAC,kBAAK;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;EAD9C;EAQrB;IACS,mBAAQ;EADgB;EAIjC;IACS,sBAAQ;EADc;EAQ/B;IACS,WAAM;EADkB;EASjC;IACS,gBAAY;EADe;EAKpC;IACS,kDAAa;IAAb,gDAAa;EADsC;EAK5D;IACS,gDAAa;IAAb,8CAAa;EADqC;EAK3D;IACS,sCAAW;EADmD;EAKvE;IACS,+CAAa;IAAb,gDAAa;EADoC;EAK1D;IACS,mDAAa;IAAb,kDAAa;EADmC;EAKzD;IACS,sCAAW;EADiD;EAKrE;IAEE,eAAe;EADwC;EAKzD;IAEE,2BAA2B;IACpB,sBAAU;EAF4C;EAM/D;IACS,OAAM;EADiC;EAQhD;IACS,wCAAU;IAAC,8BAAU;IAAC,YAAU;IACvC,kBAAkB;IAClB,oBAAoB;IAMpB,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE,UAAU;MACV,QAAQ;MACR,UAAU;MACV,WAAW;IAJsB;IAQnC;MACE,SAAS;MACT,SAAS;MACT,UAAU;MACV,WAAW;IAJoB;EArBH;EAiChC;IACS,6BAAK;EADiB;EAK/B;IACS,sCAAW;EAD0B;EAK9C;IACE,aAAa;EADgD;EChI/D;IACS,aAAI;IAAC,kBAAK;IAAC,sBAAa;IAAC,mBAAY;IAAC,6BAAK;IAElD;MACS,0BAAK;MAAC,kBAAW;IADL;IAIrB;MACS,yBAAK;MAAC,uBAAc;MAAC,oBAAmB;IAD1B;EAPhB;EAgBT;IACS,mBAAa;IAAC,uBAAW;IAAC,2BAAa;IAC9C;MACS,2BAAa;IADR;EAFG;EAQnB;IACS,sCAAW;IAAC,gCAAU;IAAC,iCAAG;IAAC,kCAAc;IAAd,sIAAc;EAD/B;ECzBnB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADlB;EAIV;IACS,qBAAY;IAEZ,wBAAY;IAAZ,mBAAY;IAKnB,8HAGkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD,iCAAiC;IAGjC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACS,oBAAc;IADA;IAKvB;MAEE,sBAAsB;IADD;EApCN;EA0CnB;IACS,gBAAa;IAAC,6CAA+B;IAAC,8CAAW;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC;MAAA,oCAAW;IAAA;IACtI,2CAA2C;IAC3C,iCAAiC;IAGjC;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,oBAAU;MAG/D;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACE,oBAAoB;IADgB;IAKtC;MACE,cAAc;IAD+C;IAI/D;MACE,cAAc;IAD6C;IAI7D;MACE,aAAa;IAD+C;IAK9D;MACS,mCAAK;MAAC,wBAAY;MAAZ,mBAAY;IADC;IAI5B;MACS,0CAAM;IADS;EAlEP;EAuEnB;IACS,kBAAQ;IAAC,aAAI;IAAC,WAAM;IAAC,sBAAQ;IAAC,+BAAO;IAAC,cAAa;IAAC,iCAAG;IAG9D;MACS,eAAO;MAAC,UAAO;IADA;EAJV;ECrHhB;IACS,kBAAQ;IAAC,aAAI;IAAC,oCAAO;IAAC,WAAM;IAAC,mBAAY;IAAC,2BAAa;IAAC,6BAAK;IAAC,sCAAW;IAAC,wCAAI;IAAC,yCAAM;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAMtH,mFAEkC;IAE3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAEjC;MACS,oBAAmB;MAAC,kBAAK;MAAC,yBAAW;MAAX,iBAAW;IAD1B;IAIpB;MACS,oBAAmB;MAAC,eAAS;MAAC,yBAAW;MAAX,iBAAW;IADxB;IAK1B;MACS,uCAAI;IADoB;IAKjC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAU7B;MAEE,sBAAsB;IADD;IAKvB;MACE;QAES,gCAAU;MADI;IAFH;IAatB;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA5DX;EAqEf;IACS,kBAAQ;IAAC,uBAAO;IAAC,+BAAO;IAAC,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,mBAAY;IAAC,uBAAc;IAAC,gCAAuB;IAKlH,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAG5D;MACS,iCAAQ;MAAR,kCAAQ;MAKR,wBAAc;MAAd,qFAAc;MAAd,2EAAc;MAAC,oBAAY;MAAZ,0BAAY;MAAC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IANjB;IASjD;MAME,0CAA0C;MACnC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IANgD;EAnB9D;EAkC1B;IACE;MACS,oBAAW;IADM;IAI1B;MACS,oBAAW;IADA;EALC;ECvGvB;IACS,aAAI;IAAC,sBAAQ;IAAC,uBAAW;IAAC,6BAAK;EADtB;ECAlB;IACS,kBAAQ;IAAC,aAAI;IAAC,WAAM;IAAC,sBAAQ;IAAC,6BAAK;IAAC,cAAa;IAAC,iCAAG;IAG5D;MACS,eAAO;MAAC,UAAO;IAD+B;EAJ/C;ECAV;IACS,kBAAQ;IAAC,aAAI;IAAC,oCAAO;IAAC,WAAM;IAAC,mBAAY;IAAC,2BAAa;IAAC,6BAAK;IAAC,sCAAW;IAAC,wCAAI;IAAC,yCAAM;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAMtH,mFAEkC;IAE3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAEjC;MACS,oBAAmB;MAAC,kBAAK;MAAC,yBAAW;MAAX,iBAAW;IAD1B;IAIpB;MACS,oBAAmB;MAAC,eAAS;MAAC,yBAAW;MAAX,iBAAW;IADxB;IAI1B;MACS,iCAAQ;MAAR,kCAAQ;IADmB;IAKpC;MACS,sCAAI;IADgB;IAK7B;MACS,uCAAI;MAAC,sCAAI;IADoC;IAKtD;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAU7B;MAEE,sBAAsB;IADD;IAKvB;MACE;QAES,gCAAU;MADI;IAFH;IAQtB;MAGE;QAKE,0CAA0C;QACnC;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;QAA7B;UAAA;YAAA,yBAA6B;YAA7B;cAAA,yBAA6B;YAAA;UAAA;QAAA;MANO;MAS7C;QAIS,kBAAS;QAAT,kBAAS;QAAT,kBAAS;QAAT,0CAAS;QAAC,aAAW;MAJS;IAVjB;IAmBxB;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EArFf;EA8FX;IACS,kBAAQ;IAAC,uBAAO;IAAC,8BAAM;IAAC,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,mBAAY;IAAC,uBAAc;IAAC,mBAAU;IAKpG,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAG5D;MACS,+BAAO;MAAC,UAAS;IADY;IAKtC;MACS,iCAAQ;MAAR,kCAAQ;MAEf;QAIS,wBAAc;QAAd,qFAAc;QAAd,2EAAc;QAAC,oBAAY;QAAZ,0BAAY;QAAC;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;QAA7B;UAAA;YAAA,yBAA6B;YAA7B;cAAA,yBAA6B;YAAA;UAAA;QAAA;MAJrB;IAHF;IAY7C;MACS,+BAAM;MAAN,gCAAM;MAEb;QAIS,wBAAc;QAAd,qFAAc;QAAd,2EAAc;QAAC,oBAAY;QAAZ,0BAAY;QAAC;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;QAA7B;UAAA;YAAA,yBAA6B;YAA7B;cAAA,yBAA6B;YAAA;UAAA;QAAA;MAJrB;MAStC,iBAAQ;MAAR,iBAAQ;MAAR,iBAAQ;MAAR,0CAAQ;MAAC,WAAS;IAZY;EA1BnB;EA2CtB;IACS,mBAAU;IAEjB;MACS,+BAAM;MAAN,gCAAM;IADX;EAHyB;EAa/B;IACE;MACS,oBAAW;IADE;IAItB;MACS,oBAAW;IADA;EALH;ECtJnB;IACS,aAAI;IAAC,sBAAQ;IAAC,uBAAW;IAAC,6BAAK;EAD1B;ECAd;IACS,kBAAQ;IAAC,aAAI;IAAC,WAAM;IAAC,sBAAQ;IAAC,6BAAK;IAAC,cAAa;IAAC,iCAAG;IAG5D;MACS,eAAO;MAAC,UAAO;IADA;EAJpB;ECHN;IACS,kBAAQ;IAAC,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EAD1B;EAIX;IACS,kBAAQ;IAAC,aAAI;IAAC,eAAS;IAAC,+BAAO;EADvB;EAIjB;IAIS,iCAAG;EAD2B;ECXvC;IACE,yBAAyB;IAElB,kBAAQ;IAAC,oBAAW;IAAC,mBAAY;IAAC,6BAAK;IAAC,wCAAU;IAAC,2CAAW;IAAX,sCAAW;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAM9F,yLAKkC;IAC3B,wBAAa;IAAC,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGhE,iCAAiC;IAGjC;MACS,oBAAmB;MAAC,+BAAM;MAAN,gCAAM;MAAC,cAAQ;MAAC,kBAAW;MAAC,mBAAY;IAD/D;EArBH;EA2BL;IACS,gCAAe;IAAf,8BAAe;IAAf,oBAAe;EADgC;EAKxD;IACS,wHAAc;IAAd,sIAAc;IAAd,6BAAc;IAAd,2BAAc;IAAd,4GAAc;IAAd,yCAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,gDAAc;EADuB;EAS9C;IACS,mDAAc;IAAd;MAAA,yFAAc;IAAA;IAAC,mDAA2B;IAGjD;MACE;QACS;;;GAAoB;QAApB;UAAA;;;GAAoB;QAAA;MADO;IADhB;EAJgC;EAYxD;IACS,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;EADnB;EAIT;IACS,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;EADjB;EAIT;IACS,sCAAW;IAAC,0CAAM;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;EADjC;EAKT;IACS,gCAAU;IAAC,gCAAuB;IAGzC;MACE;QACS,gCAAgB;QAAhB;UAAA,uFAAgB;QAAA;MADmE;IADxE;EAJV;EAWd;IACS,gCAAU;IAAC,gCAAuB;IAGzC;MACE;QACS,gCAAgB;QAAhB;UAAA,uFAAgB;QAAA;MADmE;IADxE;EAJV;EAYd;IACS,+BAAM;IAAN,gCAAM;IAAC,cAAY;IAG1B;MACS,cAAc;MAAd,eAAc;MAAC,cAAQ;MAAC,kBAAW;MAAC,mBAAY;IADnD;EAJY;ECrFpB;IACS,kBAAQ;IAAC,WAAM;IAAC,oCAAQ;IAAC,cAAQ;IAAC,sCAAW;IAAC,wCAAY;IAGjE,mBAAmB;IAGnB,wCAAwC;IAGxC,8CAA8C;IAG9C;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAbd;EAsBZ;IAEE;MACE,WAAW;MACJ,oBAAmB;MAAC,kBAAQ;MAAC,+BAAO;MAAC,sBAAiB;MAE7D,wFAAwF;MACxF,wBAAwB;IALjB;EAFY;EAevB;IACS,+BAAM;IAAN,gCAAM;IAAC,wCAAU;IAAC,yBAA0B;IAGnD,+CAA+C;IAG/C,uBAAuB;IAGvB,4EAEoC;IAMpC,qEAE8B;IACvB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACS,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MACS,+BAAM;MAAN,gCAAM;IADS;IAKxB;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAlCP;ECrCnB;IACS,oBAAW;EADN;EAQd;IACS,oBAAW;IAAC,mBAAY;IAAC,6BAAK;IAAC,wCAAU;IAAC,yBAAO;IAAP,2DAAO;IAAC,wCAAY;IAGrE,iCAAiC;IAMjC,uFAEkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACE,iCAAiC;IADf;IAKpB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA5BH;EAqCvB;IACS,oCAAQ;IAAC,6CAA+B;IAAC,kBAAiB;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,wCAAI;IAAC,qCAAI;IAAC,wCAAI;IAC9H,iCAAiC;IACjC,mDAAmD;IAE5C,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAG1B;MACE,aAAa;IADM;IAIrB,wBAAwB;IAExB,qBAAqB;IAGrB;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAG/D;QACS,8CAAsB;MADN;MAIzB;QACS,iDAAmB;MADA;MAI5B;QACS,8CAAqB;MADJ;MAI1B;QACS,iDAAoB;MADF;IAhBL;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;EAlDH;EC7CvB;IACS,aAAI;IAAC,WAAM;IAAC,6BAAK;IAExB,iDAEe;IACf,+BAA+B;IAC/B,6BAA6B;IAG7B;MACE,4BAA4B;MAC5B,0BAA0B;MAC1B,wBAAwB;MACxB,MAAM;IAJ0D;IAQlE;MACE,oCAES;MACT,0BAA0B;IAJgC;IAQ5D;MACE,qCAES;MACT,0BAA0B;MAE1B;QACE,iBAAiB;MADG;IANoC;IAW5D;MACS,kBAAK;MAAC,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAEhC,gBAAgB;IAHE;IAMpB;MACS,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAAC,kCAAY;MAAZ,iJAAY;MAEvC,iBAAiB;IAHG;IAMtB;MACS,kBAAQ;MAAC,sCAAW;MAE3B,gBAAgB;MAEhB;QAEE,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,oBAAoB;MAJb;IANU;IAcrB;MAES,kBAAQ;MAAC,aAAI;MAAC,YAAW;MAAC,mBAAY;MAAC,uBAAc;MAAC,sCAAW;MAAC,wCAAY;MAG9E,oCAAQ;MAAR,iBAAQ;MAAC,gCAAY;MAAC,kCAAc;MAAd,sIAAc;MAG3C,UAAU;MAMV,6EAEkC;MAC3B;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;MAGpC;QACS,gBAAe;MADA;MAKxB;QACS,WAAI;QAAC,wHAAc;QAAd,sIAAc;QAAd,6BAAc;QAAd,2BAAc;QAAd,4GAAc;QAAd,yCAAc;QAAd,wBAAc;QAAd,mBAAc;QAAd,gDAAc;MADC;MAK7B;QACS,eAAc;QAAC,gCAAU;MADV;IA9BL;IAoCrB;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB;QACS,aAAW;MADA;IAHE;IASxB;MACE,sBAAsB;MAEtB;QACS,gCAAG;QAAC,oBAAmB;QAAC,gBAAY;QAC3C,2BAA2B;QAG3B,mFAEqC;QAGrC;UAES,6BAAK;UAAC,YAAM;UACnB,eAAe;QAFR;QAKT;UACS,+CAAc;UAAC,kDAAc;UACpC,eAAe;UACf,uHAGqC;UACrC,4IAE0E;QATlE;QAYV;UACS,gDAAc;UAAC,mDAAc;UACpC,gBAAgB;UAChB,wHAGqC;UACrC,qDAAqD;QAP9C;MA5BU;MAuCrB;QACS,uBAAO;QAAC,+BAAM;QAAN,gCAAM;MADF;IA1CU;IAgDjC;MACS,YAAM;MAAC,6BAAK;MAEnB,mBAAmB;MACnB,6CAGS;MACT,iCAAiC;MACjC,0BAA0B;MAC1B,mBAAmB;MACnB,qBAAqB;MAGrB;QACE,4BAA4B;QAC5B,uBAAuB;QACvB,MAAM;MAH0D;MAOlE;QACE,oCAES;QACT,4BAA4B;MAJ8B;MAQ5D;QACE,qCAES;QACT,4BAA4B;MAJ8B;MAO5D;QACE,kBAAkB;MADE;MAItB;QACE,kBAAkB;MADA;MAIpB;QACS,+BAAG;QAAC,oBAAmB;QAAC,gBAAY;QAC3C,4BAA4B;QAG5B,mFAEqC;QAGrC;UAES,8BAAM;UAAC,WAAM;UACpB,gBAAgB;QAFT;QAKT;UACE,iBAAiB;UACjB,gCAAgC;UAChC,iCAAiC;UAEjC,wHAGqC;UACrC,4IAE0E;QAXlE;QAcV;UACE,cAAc;UACd,6BAA6B;UAC7B,8BAA8B;UAE9B,uHAGoC;UACpC,qDAAqD;QAT9C;MA9BU;MA2CrB;QACS,wBAAQ;QAAC,+BAAM;QAAN,gCAAM;MADH;IAvFQ;EA9JnB;ECJd;IACS,kBAAQ;IAAC,sBAAU;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAG1C,+JAE0E;IAG1E,8CAA8C;EATlC;EAad;IACS,sCAAW;EADE;EAItB;IACS,yCAAU;EADG;EAKtB;IACS,+BAAM;IAAN,gCAAM;IAEb;MACS,sCAAU;IADI;EAHP;EAQlB;IACS,+BAAM;IAAN,gCAAM;IAEb;MACS,wCAAU;IADI;EAHP;EAYlB;IACS,+BAAM;IAAN,gCAAM;IAEb;MACS,sCAAW;IADG;EAHP;EAQlB;IACS,gCAAO;IAAP,iCAAO;IAEd;MACS,sCAAW;IADG;EAHP;EC9ClB;IACS,aAAI;IAAC,eAAS;IAAC,mBAAY;IAAC,6BAAK;EADrB;EAQrB;IACS,kBAAQ;IAAC,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,yBAAkB;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAGzH,iCAAiC;IAMjC,gFAEkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACE,yCAAyC;MACzC,+BAA+B;MAE/B;QACE,sBAAsB;MADK;IAJP;EA3BC;EAyC3B;IACS,cAAK;IAAC,WAAS;IAAT,YAAS;IAGtB,sBAAsB;IAKtB,2CAA2C;IACpC,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAElD;MACE;QACE,qBAAqB;MADf;IADY;EAZK;EAuB7B;IACS,oBAAmB;IAAC,kBAAQ;IAAC,+BAAO;IAAC,WAAI;IAAC,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAGjF;MACS,yBAAQ;MAAR,0BAAQ;MAAC,yBAAU;MAG1B,iCAAiC;MAKjC,2CAA2C;MACpC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IAVhC;IAcN;MACS,yBAAU;IADc;IAKjC;MACE,iCAAiC;IADoB;EAvBzB;EAoChC;IACS,sBAAQ;EADW;EAQ5B;IACE;MACS,+BAAM;MAAN,gCAAM;MAAC,sCAAU;MAAC,oCAAM;MAAN,iBAAM;IADN;EADJ;EAMzB;IACE;MACS,+BAAM;MAAN,gCAAM;MAAC,wCAAU;MAAC,oCAAQ;MAAR,iBAAQ;IADR;EADJ;EAYzB;IACE;MACS,+BAAM;MAAN,gCAAM;MAAC,sCAAW;MAAC,oCAAQ;MAAR,iBAAQ;IADT;EADJ;EAMzB;IACE;MACS,gCAAO;MAAP,iCAAO;MAAC,sCAAW;MAAC,oCAAQ;MAAR,iBAAQ;IADV;EADJ;EAgBzB;IACE;MACS,wCAAU;MACjB;QACS,sCAAU;MADU;MAG7B;QACE;UACS,sCAAU;QADU;MADP;IALC;EADA;EAe7B;IACE;MACS,yCAAU;MACjB;QACS,yCAAU;MADU;MAG7B;QACE;UACS,yCAAU;QADU;MADP;IALC;EADwB;EAerD;IACE;MACS,sCAAU;MACjB;QACS,sCAAU;MADU;MAG7B;QACE;UACS,yCAAU;QADU;MADP;IALC;EADwB;EAoBrD;IACE;MACS,wCAAU;MACjB;QACS,sCAAU;MADU;MAG7B;QACE;UACS,sCAAU;QADU;MADP;IALC;EADwB;EAerD;IACE;MACS,wCAAU;MACjB;QACS,sCAAU;MADU;MAG7B;QACE;UACS,sCAAU;QADU;MADP;IALC;EADwB;EC7NrD;IACS,oBAAW;IAAC,gCAAG;IAAC,mBAAY;IAAC,gBAAe;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IACzI,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFQ;IAFnC;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;IADd;IAKf;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;MAC1C,+CAA+C;IAH1B;IAOvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAvCP;EAgDnB;IACS,aAAI;IAAC,YAAM;IAAC,OAAM;IAAC,YAAW;IAAC,mBAAY;IAAC,gBAAY;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,6BAAc;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,sBAAW;IAAX,sIAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAG/I;MACS,6CAAsB;IADhB;IAKf;MACS,yBAAc;MAAd,4BAAc;MAAC,sCAAI;IADqC;IAKjE;MACS,0BAAc;MAAd,6BAAc;MAAC,uCAAI;IADqC;IAKjE;MAES,wBAAY;MAAZ,mBAAY;IADL;EApBQ;EAyB1B;IACS,cAAQ;IAAC,6CAAsB;IAC/B,sCAAI;IAAC,qCAAI;IAAC,aAAI;IAAC,mBAAY;EAFT;EAK3B;IACS,cAAQ;IAAC,6CAAsB;IAC/B,sCAAI;IAAC,aAAI;IAAC,mBAAY;EAFJ;EAa3B;IACS,sBAAW;IAAX,sIAAW;IAClB,6CAA6C;IAE7C,4CAA4C;IAC5C,wDAAwD;IACxD,kDAAkD;IAElD;MACE;QAEE,mDAAmD;MADE;IAFnC;IAOtB;MAEE,mDAAmD;IADzB;IAK5B;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,+CAA+C;MAC/C,mDAAmD;IAH9B;IAMvB;MACS,6BAAc;IADe;EA3BV;EAoC9B;IACS,WAAM;EADgB;EC/H/B;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;EAVT;EAgBb;IACS,WAAM;EADU;ECnBzB;IACS,aAAI;IAAC,WAAM;IAAC,6BAAK;IAExB,iDAEe;IACf,+BAA+B;IAE/B;MACS,kBAAK;MAAC,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAEhC,gBAAgB;IAHE;IAMpB;MACS,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAAC,kCAAY;MAAZ,iJAAY;MAEvC,iBAAiB;IAHH;IAMhB;MACS,kBAAQ;MAAC,wCAAU;MAAC,gCAAU;MAErC,gBAAgB;IAHH;IAMf;MACS,oBAAmB;MAAC,kBAAQ;MAAC,+BAAS;IADjC;IAId;MAES,kBAAQ;MAAC,aAAI;MAAC,YAAW;MAAC,mBAAY;MAAC,uBAAc;MAAC,wCAAU;MAAC,+BAAS;MAAC,wCAAY;MAM9F,wHAGkC;MAC3B;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;MAGpC;QACS,kBAAQ;QAAC,WAAI;QAAC,sCAAU;QAAC,0CAAoB;QAAC,yBAAU;QAAC,gCAAY;QAAZ,sIAAY;QAC5E,WAAW;QAKJ,wBAAa;QAAC,wBAAc;QAAd,qFAAc;QAAd,2EAAc;QAAC;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;QAA7B;UAAA;YAAA,yBAA6B;YAA7B;cAAA,yBAA6B;YAAA;UAAA;QAAA;MAP1D;MAWT;QACS,gBAAe;QAEtB;UACS,UAAW;UAAC;YAAA,kBAAuB;YAAvB,kBAAuB;YAAvB,kBAAuB;YAAvB,0CAAuB;YAAvB;cAAA,kBAAuB;cAAvB,kBAAuB;cAAvB,kBAAuB;cAAvB,0CAAuB;YAAA;UAAA;UAAvB;YAAA;cAAA,kBAAuB;cAAvB,kBAAuB;cAAvB,kBAAuB;cAAvB,0CAAuB;cAAvB;gBAAA,kBAAuB;gBAAvB,kBAAuB;gBAAvB,kBAAuB;gBAAvB,0CAAuB;cAAA;YAAA;UAAA;QADnC;MAHa;MASxB;QACS,WAAI;QAAC,wHAAc;QAAd,sIAAc;QAAd,6BAAc;QAAd,2BAAc;QAAd,4GAAc;QAAd,yCAAc;QAAd,wBAAc;QAAd,mBAAc;QAAd,gDAAc;MADC;MAK7B;QACS,eAAc;MADC;IAxCX;IA8Cf;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB;QACS,aAAW;MADA;IAHE;IASxB;MACE,sBAAsB;MAEtB;QACS,gCAAG;QAAC,WAAM;QAGV,2CAAkB;QAAlB,4BAAkB;QAAC,gCAAoB;QAE9C;UACS,wCAAe;QADE;QAI1B;UACS,sCAAe;QADA;MAVX;MAef;QAES,YAAM;MADA;MAIf;QACS,uBAAO;QAGd,6BAA6B;QAE7B;UACE,aAAa;UACb,YAAY;QAFL;MANI;IAvBgB;IAqCjC;MACS,YAAM;MAAC,6BAAK;MAEnB,mBAAmB;MACnB,6CAGS;MACT,iCAAiC;MACjC,0BAA0B;MAE1B;QACE,kBAAkB;MADJ;MAIhB;QACE,kBAAkB;MADA;MAIpB;QACS,YAAM;QAAC,+BAAG;QAGV,0CAAkB;QAAlB,2BAAkB;QAAC,+BAAoB;QAC9C,oBAAoB;QAEpB;UACS,kCAAe;QADE;QAI1B;UACS,+BAAe;QADA;MAXX;MAgBf;QAES,WAAM;MADA;MAIf;QACS,wBAAQ;QAGf,8BAA8B;QAE9B;UACE,WAAW;UACX,cAAc;QAFP;MANI;IAxCc;EA5HzB;ECDR;IACS,oBAAW;IAAC,mBAAY;IAAC,6BAAK;IAAC,wCAAY;IAGlD,iCAAiC;IAGjC,yCAAyC;IACzC,mDAAyF;IAAzF;MAAA,yFAAyF;IAAA;IACzF,2DAA2D;IAC3D,gDAAgD;IAChD,4DAA4D;IAG5D;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB;QACS,2CAAwB;QAAxB;UAAA,iFAAwB;QAAA;MADlB;IAHO;IASxB;MAME;QACE,YAAY;MADC;IAD6B;EA9BxC;EAmDR;IAES,kBAAQ;IAAC,aAAI;IAAC,cAAQ;IAAC,mBAAY;IAAC,gBAAe;IAAC,wCAAU;IACrE,eAAe;IACf,aAAa;IAEb,0CAA0C;IAM1C,uFAEkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADc;IAKrC;MAEE,gDAAgD;IADnB;IAK/B;MAEE,kDAAkD;MAC3C;QAAA,eAA4B;QAA5B;UAAA,eAA4B;QAAA;MAAA;MAA5B;QAAA;UAAA,eAA4B;UAA5B;YAAA,eAA4B;UAAA;QAAA;MAAA;IAFN;IAM/B;MAEE,kDAAkD;IADpB;IAKhC;MAIE,wDAAwD;IADL;IAKrD;MAIE,wDAAwD;IADL;EAtDtC;EA4DjB;IACS,sCAAU;IACjB,YAAY;IACZ,WAAW;EAHgB;EAU7B;IACE,cAAc;IACd,WAAW;EAFgB;EAM7B;IAES,+CAAM;IAAC,aAAI;IAAC,wBAAa;IAAC,sCAAU;IAAC,oCAAQ;IAAC,yBAAU;IAAC,gCAAY;IAAZ,sIAAY;IAC5E,YAAY;IACZ,eAAe;IAMf,sFAEwC;IACjC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MAES,wCAAsB;MAAC,0CAAoB;MAAC,oBAAW;MAC9D,mHAGkC;IALJ;EAjBnB;EA+Bf;IACS,yCAAU;IACjB,eAAe;IACf,iBAAiB;IAGjB;MAES,4CAA0B;IADH;EAPP;EAY3B;IACS,wCAAU;IACjB,eAAe;IACf,iBAAiB;IAGjB;MAES,4CAA0B;IADH;EAPP;EAa3B;IACS,aAAI;IAAC,WAAS;IAAT,YAAS;IAAC,mBAAY;IAAC,uBAAc;EADhC;EAKnB;IACS,2BAAS;IAAT,6DAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAD/B;EAKf;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADX;ECjMjB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADd;EAId;IACS,aAAI;IAAC,6BAAK;EADE;EAKrB;IACS,mBAAQ;EAD8B;EAI/C;IACS,sBAAQ;EAD4B;ECT7C;IACS,oBAAW;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAO;IAAC,2CAAW;IAAX,sCAAW;IAGpE,oCAAO;IAAC,mCAAO;IAAC,sCAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,kBAAc;IAAd,iBAAc;IAGzD,gCAAgC;IAChC,2CAA2C;IAC3C,uCAAuC;IAEvC,iCAAiC;IACjC,sBAAsB;IACtB,qCAAqC;EAbhC;EAgBP;IACS,0CAAM;EADD;EAId;IACS,kBAAQ;IAAC,oBAAW;IAAC,cAAQ;EADxB;EAQd;IACS,oCAAO;IAAC,mCAAO;IAAC,sCAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,kBAAc;IAAd,iBAAc;EADhD;EAQX;IACS,oCAAO;IAAC,mCAAO;IAAC,wCAAU;IAAC,eAAW;IAAC,kBAAc;IAAd,iBAAc;EADnD;EAQX;IACE,+CAA+C;EADlC;EAIf;IACE,2CAA2C;EAD7B;EAIhB;IACE,gCAAgC;EADlB;EAIhB;IACE,gCAAgC;EADlB;EAIhB;IACE,+BAA+B;EADlB;EAwBf;IACS,kBAAQ;IAAC,6BAAK;IAAC,+BAAO;IAC7B,+BAA+B;EAFf;EAKlB;IACS,kBAAQ;IAAC,6BAAK;IAAC,8BAAM;IAC5B,gCAAgC;EAFjB;EAKjB;IACS,kBAAQ;IAAC,+BAAO;IAAC,gCAAQ;IAChC,8BAA8B;EAFX;EAKrB;IACS,kBAAQ;IAAC,gCAAQ;IAAC,8BAAM;IAC/B,+BAA+B;EAFb;EASpB;IACE,+BAA+B;IAC/B,0CAA0C;EAFd;EAK9B;IACE,gCAAgC;IAChC,2CAA2C;EAFd;EAK/B;IACE,gCAAgC;IAChC,2CAA2C;EAFd;EAK/B;IACE,gCAAgC;IAChC,2CAA2C;EAFd;EAK/B;IACE,+BAA+B;IAC/B,0CAA0C;EAFd;EAS9B;IACE,oCAAoC;IACpC,+CAA+C;EAFtB;EAK3B;IACE,gCAAgC;IAChC,2CAA2C;EAFjB;EAK5B;IACE,qCAAqC;IACrC,gDAAgD;EAFtB;EAK5B;IACE,qCAAqC;IACrC,gDAAgD;EAFtB;EAK5B;IACE,oCAAoC;IACpC,+CAA+C;EAFtB;ECjK3B;IACS,oBAAW;IAAC,cAAQ;IAAC,mBAAY;IAAC,+BAAO;IAAC,sCAAW;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,2CAAW;IAAX,sCAAW;IAGtG,+BAA+B;IAC/B,uBAAuB;IAEvB,gCAAgC;IAChC,qBAAqB;EARjB;EAWN;IACS,0CAAM;EADF;EAKb;IACE,8CAA8C;EADlC;EAId;IACE,8BAA8B;EADlB;EAId;IACE,0CAA0C;EAD7B;EAIf;IACE,+BAA+B;EADlB;EAIf;IACE,+BAA+B;EADlB;EAYf;IACE,sBAAsB;EADR;EAKhB;IACS,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;EADhB;EAIV;IACS,yBAAO;IAAP,2DAAO;EADN;EAIV;IACS,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;EAD5B;EASV;IACE,8BAA8B;IAC9B,yCAAyC;EAFf;EAK5B;IACE,+BAA+B;IAC/B,0CAA0C;EAFf;EAK7B;IACE,+BAA+B;IAC/B,0CAA0C;EAFf;EAK7B;IACE,8BAA8B;IAC9B,yCAAyC;EAFf;EAM5B;IACE,mCAAmC;IACnC,8CAA8C;EAFvB;EAKzB;IACE,oCAAoC;IACpC,+CAA+C;EAFvB;EAK1B;IACE,oCAAoC;IACpC,+CAA+C;EAFvB;EAK1B;IACE,mCAAmC;IACnC,8CAA8C;EAFvB;EC/FzB;IACS,kBAAQ;IAAC,aAAI;IAAC,WAAM;IAAC,cAAa;IACzC,qCAAqC;EAF3B;EAWZ;IACS,gBAAe;IAEtB,qBAAqB;IACrB,iDAAiD;IAEjD;MACE,UAAU;IADS;IAIrB;MACE,uBAAuB;IADE;IAI3B;MACE,gCAAgC;MAChC,kBAAkB;IAFO;IAK3B;MACE,gCAAgC;IADD;IAKjC;MACE,mDAAmD;MAEnD;QACE,kCAAkC;MADT;MAI3B;QACE,kCAAkC;MADH;IAPD;EAxBX;EAqCzB;IACS,0CAAoB;IAAC,wCAAI;IAAC,wCAAI;IACrC,mDAAmD;EAFhC;EAWrB;IACS,2CAAU;IAAV,wBAAU;IAAC,6BAAc;EADI;EAItC;IACS,0CAAoB;EADS;EAItC;IACE,oDAAoD;IACpD,uDAAuD;EAFP;EAKlD;IACE,qDAAqD;IACrD,wDAAwD;EAFT;EAMjD;IACS,sBAAW;IAAX,sIAAW;IAGlB;MAIS,gBAAY;IADS;IAK9B;MACS,iBAAgB;MAAC,gBAAY;IADzB;EAZqB;EAkBpC;IACE;MACS,2CAAQ;MAAR,wBAAQ;MAAC,4BAA4B;MAA5B;QAAA;;;;qBAA4B;MAAA;MAAC,6BAAc;IADhD;IAIb;MACE;QAES,gCAAa;QAAb;UAAA,sEAAa;QAAA;MADc;IAFhB;EALW;EAgBnC;IACS,WAAM;IAAC,yBAAe;IAAC,+CAAgB;IAAhB,+CAAgB;IAAhB,qEAAgB;IAAC,yBAAO;IAAP,2DAAO;EADxC;EAKhB;IACS,cAAa;EADe;EAOrC;IACS,2CAAQ;IAAR,wBAAQ;IAAC,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;IAAC,0CAAoB;EAD3C;EAOf;IACS,kBAAQ;IAAC,wCAAI;IAAC,yCAAM;IAAC,gBAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAU;IAGpE;MACE,WAAW;MACJ,oBAAmB;MAAC,kBAAQ;MAAC,uBAAO;MAAC,+BAAO;MAAC,gCAAG;MAAC,UAAI;MAAC,+CAAgB;MAAhB,sDAAgB;MAAC,wCAAU;MAAC,kCAAY;IAF9F;IAKT;MACE,aAAa;IADsB;IAKrC;MACE,iCAAiC;IADL;IAI9B;MACE;QAES,wBAAe;MAD2B;IAF/B;IAQtB;MAES,sCAAU;MAAC,wBAAY;MAAZ,mBAAY;MAC9B,8CAA8C;IAFnB;EA3BhB;EAoCf;IAGE;MACE,oDAAoD;IADtB;IAGhC;MACE,qDAAqD;IADxB;IAG/B;MACE,uDAAuD;IAD1B;IAG/B;MACE,wDAAwD;IAD5B;IAO9B;MACS,kBAAQ;MAAC,YAAM;MAAC,cAAa;MACpC,2CAA2C;IAFhC;EAnBF;EA4Bb;IACS,kBAAQ;IAAC,YAAM;IAGf,2CAAQ;IAAR,wBAAQ;IAAC,8BAAmB;IAAnB;MAAA,oEAAmB;IAAA;IAGnC;MACS,2CAAU;MAAV,wBAAU;IADN;IAKb;MACE;QAES,gCAAa;QAAb;UAAA,sEAAa;QAAA;MADc;IAFhB;IAQtB;MACS,gCAAa;MAAb;QAAA,sEAAa;MAAA;IADe;IAKrC;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,YAAU;IADK;IAKxB;MACS,mDAAc;MAAd;QAAA,yFAAc;MAAA;IADiB;EA1C9B;EAkDZ;IACS,YAAM;IAAC,gCAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,sBAAY;IAAC,yBAAO;IAAP,2DAAO;IAAC,wBAAe;IAEhE,2CAAQ;IAAR,wBAAQ;IAAC,4BAA4B;IAA5B;MAAA;;;;qBAA4B;IAAA;IAG5C;MAES,sCAAU;MAAC,wBAAY;MAAZ,mBAAY;MAC9B,8CAA8C;IAFnB;EAPlB;EAmBb;IACS,sBAAW;IAAX,sIAAW;EAD0E;EAI9F;IAKS,sCAAU;IAAC,uEAA2C;IAA3C,sIAA2C;IAAC,wBAAY;IAAZ,mBAAY;EADxC;EAIpC;IAKS,+CAAY;IAAZ,kDAAY;IAAC,gMAAkH;IAAlH,sIAAkH;IAAC,wBAAY;IAAZ,mBAAY;EADjH;EAIpC;IAKS,gDAAY;IAAZ,mDAAY;IAAC,iMAAmH;IAAnH,sIAAmH;IAAC,wBAAY;IAAZ,mBAAY;EADlH;EAIpC;IAKS,oIAA+E;IAA/E,sIAA+E;IAAC,wBAAY;IAAZ,mBAAY;EADjE;EAUpC;IACE,4DAA4D;EAD/B;EAO/B;IACS,aAAI;IAAC,mBAAY;IAAC,wCAAI;IAAC,yCAAM;EADvB;EAOf;IACS,kBAAQ;IAAC,cAAa;EADH;EAQ5B;IAES,kBAAQ;IAAC,uBAAO;IAAC,+BAAO;IAAC,gCAAG;IAAC,UAAI;IAAC,+CAAgB;IAAC,wCAAU;IAAC,kCAAY;IAE1E,uBAAW;IAAC,oCAAe;IAAf,sDAAe;IAAC,kBAAiB;IAAC,kBAAU;IAAC,wCAAI;IAE7D,uBAAW;IAAX,kBAAW;IAAC,4BAAe;IAAC,wBAAY;IAAZ,mBAAY;IAE/C;MAES,YAAM;MAAC,iCAAK;MAAC,+BAAS;IADvB;IAIR;MACS,YAAM;MAAC,iCAAK;MAAC,+BAAS;IADP;IAIxB;MAES,YAAM;MAAC,iCAAK;MAAC,8BAAQ;IADd;EAlBK;EAwBvB;IACE,aAAa;EADmC;EASlD;IACE;MAES,uCAAI;MAAC,kBAAW;MACvB;QACS,mBAAO;MADV;IAFa;EAFL;EAclB;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,uCAAI;EAD1B;EC5X1B;IACS,aAAI;IAAC,WAAM;IAAC,mBAAQ;IAAC,uBAAW;IAAC,2BAAa;IAAC,6BAAK;IAAC,gCAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,kCAAc;IAAd,sIAAc;IAC/F,2CAA2C;EAFtC;EAMP;IACS,aAAI;IAAC,YAAM;IAAC,YAAI;IAAC,sBAAQ;IAAC,uBAAW;EAD9B;EAIhB;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,iCAAG;IAAC,yBAAW;IAAX,iBAAW;IAEvD;MACS,uBAAW;MAAC,+BAAM;MAAN,gCAAM;IADM;EAHjB;EAQlB;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,2CAAW;IAAX,sCAAW;EADxB;EAId;IACS,yBAAO;IAAP,2DAAO;IAAC,mBAAU;EADP;EAKpB;IACS,wBAAe;EADU;EAIlC;IACS,wBAAe;EADM;EAI9B;IACS,oBAAW;EADa;EAIjC;IACS,oBAAW;EADS;EAI7B;IACS,qBAAY;EADa;EAIlC;IACS,qBAAY;EADS;EAI9B;IACS,qBAAY;EADa;EAIlC;IACS,qBAAY;EADS;EAI9B;IACS,oBAAW;EADa;EAIjC;IACS,oBAAW;EADS;ECjE7B;IACS,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC,mBAAU;EADlB;ECDb;IACS,oBAAmB;IAAC,kBAAQ;IAAC,gBAAe;IAAC,wCAAU;IAAC,yCAAsB;IAAtB;MAAA,+EAAsB;IAAA;EAD7E;EAOV;IACE;MACS,kBAAQ;MAAC,+BAAO;MAAC,uBAAiB;MAAjB,sDAAiB;MAAC,sCAAgB;MAAC,gCAAc;MAAd;QAAA,yCAAc;MAAA;MAAd,2DAAc;MAAC,+BAAgB;MAAC,0CAAoB;MAApB,4NAAoB;MAApB,iDAAoB;MAAC,6BAAc;MAAd,8LAAc;MAAC,gBAAY;MAAZ,0BAAY;IADpI;IAKT;MACE;QACE,aAAa;MADN;MAKT;QACS,kBAAQ;QAAC,+BAAO;QAAC,uBAAiB;QAAjB,sDAAiB;QAAC,sCAAgB;QAAC,gBAAY;QAAZ,0BAAY;QACvE,oGAKC;QACD,WAAW;QACX,oBAAoB;QAEpB,uBAAuB;MAXf;MAeV;QACE;UACE,aAAa;QADN;MADC;IArBG;EANA;EAmCnB;IACS,+BAAa;EADL;ECrCjB;IACS,aAAI;IAAC,WAAM;IAAC,6BAAK;IACxB,iDAEe;IACf,+BAA+B;IAG/B,iCAAiC;IAEjC;MACS,kBAAK;MAAC,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAEhC,gBAAgB;IAHE;IAMpB;MACS,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAAC,kCAAY;MAAZ,iJAAY;MAEvC,iBAAiB;IAHJ;IAMf;MACS,kBAAQ;MAAC,gBAAe;MAAC,wCAAU;MAAC,gCAAU;MAErD,gBAAgB;MAGT,gCAAG;IANE;IASd;MACS,kBAAQ;MAAC,6BAAK;MAAC,8BAAM;MAAC,YAAM;MAAC,wCAAU;MAE9C,mCAAmC;MAMnC,uCAAuC;MAChC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IAVzB;IAcb;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB;QACS,aAAW;MADA;IAHE;EA/CnB;EA4DP;IACE;MACS,gCAAG;MAAC,yCAAU;IADT;IAId;MACS,yCAAU;IADN;EALJ;EAcX;IACE;MACS,gCAAG;MAAC,yCAAU;IADT;IAId;MACS,yCAAU;IADN;EALJ;EAcX;IACE,6CAA6C;EAD/B;EAIhB;IACE,iCAAiC;EADpB;EAIf;IACE,kCAAkC;EADpB;EAIhB;IACE,kCAAkC;EADpB;EAIhB;IACE,iCAAiC;EADpB;ECxGf;IACS,aAAI;IAAC,WAAM;IAAC,6BAAK;IACxB,iDAEe;IACf,+BAA+B;IAG/B,wCAAwC;IAExC;MACS,kBAAK;MAAC,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAEhC,gBAAgB;IAHE;IAMpB;MACS,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAAC,kCAAY;MAAZ,iJAAY;MAEvC,iBAAiB;IAHG;IAMtB;MACS,kBAAQ;MAAC,gBAAe;MAAC,wCAAU;MAAC,gCAAU;MAErD,gBAAgB;MAGT,gCAAG;IANS;IASrB;MACS,kBAAQ;MAAC,6BAAK;MAAC,8BAAM;MAAC,YAAM;MAAC,wCAAU;MAE9C,0CAA0C;MAM1C,uCAAuC;MAChC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IAVlB;IAcpB;MACE;QACS,yBAAK;QAEZ,kFAAkF;QAE3E;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;QAA1B;UAAA;YAAA,eAA0B;YAA1B;cAAA,eAA0B;YAAA;UAAA;QAAA;MALf;IADC;IAWvB;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB;QACS,aAAW;MADA;IAHE;EA1DZ;EAuEd;IACE;MACE,4BAA4B;IAD3B;IAGH;MACE,2BAA2B;IADxB;EAJ+B;EAatC;IACE;MACS,gCAAG;MAAC,yCAAU;IADF;IAIrB;MACS,yCAAU;IADC;EALJ;EAclB;IACE;MACS,gCAAG;MAAC,yCAAU;IADF;IAIrB;MACS,yCAAU;IADC;EALJ;EAclB;IACE,oDAAoD;EAD/B;EAIvB;IACE,wCAAwC;EADpB;EAItB;IACE,yCAAyC;EADpB;EAIvB;IACE,yCAAyC;EADpB;EAIvB;IACE,wCAAwC;EADpB;EChItB;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAG9C,6CAA6C;IAC7C,oDAAoD;IAEpD;MAES,+BAAM;MAAN,gCAAM;IAFS;IAKxB;MACE,2CAA2C;IADd;IAI/B;MACE,qCAAqC;MAMrC,mDAAmD;MAC5C;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IARR;IAY9B;MACE;QACE,kDAAkD;QAE3C;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;QAA1B;UAAA;YAAA,eAA0B;YAA1B;cAAA,eAA0B;YAAA;UAAA;QAAA;MAHX;IADH;IASvB;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAvCT;EAgDjB;IACE;MACE,uBAAuB;IADpB;IAGL;MACE,yBAAyB;IADxB;EAJ2B;EAahC;IACE;MACS,+BAAM;MAAN,gCAAM;IADS;EADL;EAUrB;IACE;MACS,+BAAM;MAAN,gCAAM;IADS;EADL;EAUrB;IACE,yDAAyD;EADjC;EAI1B;IACE,6CAA6C;EADtB;EAIzB;IACE,8CAA8C;EADtB;EAI1B;IACE,8CAA8C;EADtB;EAI1B;IACE,6CAA6C;EADtB;ECrGzB;IACS,oBAAmB;IAAC,kBAAQ;IAAC,+BAAM;IAAN,gCAAM;IAAC,wBAAa;IAAC,qCAAiB;EADnE;EAKT;IACS,+BAAM;IAAN,gCAAM;EADF;EAQb;IACS,+BAAM;IAAN,gCAAM;EADF;EAIb;IACS,gCAAO;IAAP,iCAAO;EADH;EAKb;IACE,cAAc;EADE;EAIlB;IACE,oBAAoB;EADL;EAIjB;IACE,oBAAoB;EADL;EAIjB;IACE,qBAAqB;EADL;EAIlB;IACE,qBAAqB;EADL;ECpClB;IACS,oBAAmB;IAAC,eAAK;IAAC,WAAI;IAAC,wBAAY;IAAZ,mBAAY;IAC3C,yBAAoB;IAAC;MAAA,WAAS;IAAA;IAAC;MAAA,6BAAwB;IAAA;IAE9D,cAAc;EAJF;EAQd;IACS,gCAAQ;IAAC,wBAAQ;IAAC,+CAAgB;IAAhB,sDAAgB;EADrB;EAItB;IACS,gCAAQ;IAAC,8BAAM;EADI;EAI5B;IACS,+BAAO;IAAC,gCAAQ;EADC;EAK1B;IACS,6BAAK;IAAC,wBAAQ;IAAC,+CAAgB;IAAhB,sDAAgB;EADrB;EAInB;IACS,6BAAK;IAAC,8BAAM;EADI;EAIzB;IACS,6BAAK;IAAC,+BAAO;EADC;EAIvB;IACS,sCAAS;IAAT,kBAAS;IAAC,mBAAgB;IAAC,2BAAa;EADrB;EAK5B;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IAED,oBAAmB;IAAC,aAAI;IAAC,mBAAQ;IAAC,uBAAW;IAAC,2BAAa;IAAC,+BAAO;IAAC,gCAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,kCAAc;IAAd,sIAAc;IAC9G,2CAA2C;EANtC;EASP;IAGE,SAAS;EADQ;EAInB;IAGE,MAAM;EADQ;EAIhB;IACS,oBAAmB;IAE1B,2BAA2B;IAC3B,gBAAgB;IAEhB;MACS,oBAAmB;MAAC,WAAS;MACpC,aAAa;IAFM;EANa;EAYpC;IACS,oBAAmB;IAAC,aAAI;IAAC,WAAS;EADhB;EAI3B;IACS,sCAAS;IAAT,kBAAS;IAAC,mBAAgB;IAAC,2BAAa;EAD5B;EAKrB;IAGE,mCAAmC;EADlB;EAInB;IAGE,gCAAgC;EADlB;EAKhB;IACS,aAAI;IAAC,YAAM;IAAC,YAAI;IAAC,sBAAQ;IAAC,uBAAW;IAAC,kBAAW;EAD1C;EAKhB;IACS,aAAI;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,iCAAG;IAAC,gCAAuB;IAAC,yBAAW;IAAX,iBAAW;IAExF;MACS,uBAAW;MAAC,+BAAM;MAAN,gCAAM;IADM;IAKjC;MACS,+BAAM;MAAN,gCAAM;IADO;IAItB;MACS,+BAAM;MAAN,gCAAM;IADY;EAZX;EAkBlB;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,gCAAuB;EADhD;EAKd;IACS,yBAAO;IAAP,2DAAO;IAAC,mBAAU;EADP;EAKpB;IACS,kBAAQ;IAAC,+BAAO;IAAC,iCAAS;IAAC,+BAAM;IAAN,gCAAM;IAAC,2BAAa;IAAC,gCAAU;IAAC,aAAW;IAAC;MAAA,oBAAsB;IAAA;IAAC;MAAA,8BAAS;IAAA;IAAC;MAAA,gCAAW;IAAA;IAAC;MAAA,oCAAS;MAAT,iBAAS;IAAA;IAAC;MAAA,gCAAa;IAAA;IAAC;MAAA,WAAY;IAAA;IAE/J,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACS,iCAAQ;MAAR,kCAAQ;MAAC;QAAA,+BAAS;QAAT,gCAAS;MAAA;IADK;IAKhC;MACE;QAES,gCAAU;MADI;IAFH;EAXH;EAoBrB;IACS,oBAAmB;IAAC,aAAW;EADiB;EAKzD;IACS,oCAAI;IAAC;MAAA,oCAAO;IAAA;EADN;EAKf;IACS,oBAAW;EADS;EAI7B;IACS,qBAAY;EADS;EAI9B;IACS,qBAAY;EADa;EAIlC;IACS,qBAAY;EADS;EAI9B;IACS,qBAAY;EADa;EAIlC;IACS,oBAAW;EADS;EAI7B;IACS,oBAAW;EADa;EASjC;IAEE,+BAA+B;EADR;EAKzB;IACE,sCAAsC;EADQ;EAIhD;IACE,uCAAuC;IACvC,6BAA6B;EAFiB;EAMhD;IACE,mCAAmC;EADQ;EAI7C;IACE,oCAAoC;IACpC,6BAA6B;EAFc;EAQ7C;IACE;MACE,iBAAiB;MACjB,UAAU;IAFP;EAD0B;EAOjC;IACE;MACE,iBAAiB;MACjB,UAAU;IAFT;EAD6B;EAQlC;IACE;MACE,kBAAkB;MAClB,UAAU;IAFP;EADuB;EAO9B;IACE;MACE,kBAAkB;MAClB,UAAU;IAFT;EAD0B;EClP/B;IACS,aAAI;IAAC,sBAAQ;IAEpB;MACS,oCAAI;IADU;EAHT;ECIhB;IACS,aAAI;IAAC,6BAAK;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAE3C,iCAAiC;IAGjC;MACS,mBAAY;IADkB;IAKvC;MACS,uBAAW;IADa;IAIjC;MACS,yBAAW;MAAX,iBAAW;IADA;IAIpB;MACS,eAAS;MAAC,yBAAW;MAAX,iBAAW;IADJ;IAK1B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAEE;QACE,sCAAsC;MADnB;IADM;IAO7B;MACS,iCAAQ;MAAR,kCAAQ;MAAC,mBAAc;MAAC,+BAAsB;MAK9C,wBAAc;MAAd,qFAAc;MAAd,2EAAc;MAAC,oBAAY;MAAZ,0BAAY;MAAC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IANd;IASpD;MACE,+CAA+C;IAD2B;IAK5E;MAIS,+BAAsB;IADiE;IAKhG;MACE;QACS,+BAAM;QAAN,gCAAM;MADyC;IAD7B;IAO7B;MAIS,+BAAsB;IAD2B;EAvElD;EAgFV;IACS,kBAAQ;IAAC,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,gBAAe;IAAC,yCAAU;IAAC,yDAAQ;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAMlJ,mFAEiC;IAC1B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC,iCAAiC;IAGjC;MACS,sCAAM;IAD4B;IAK3C;MACS,oBAAmB;MAAC,kBAAQ;MAAC,+BAAO;MAAC,UAAG;MAAC,wBAAa;MAAC,iBAAQ;MAAR,iBAAQ;MAAR,iBAAQ;MAAR,0CAAQ;MAAC,yCAAU;MAAC,+BAAS;MAAC,WAAS;MAAC,gBAAY;MAAZ,0BAAY;MAMlH,oHAGwC;MACjC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IAX5B;IAgBV;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADgB;IAKvC;MAES,gDAAyB;MAAzB;QAAA;;;;GAAyB;MAAA;MAEhC;QACS,+BAAe;QAAf;UAAA,sFAAe;QAAA;MADd;IAHqB;IAejC;MAES,yBAAkB;MAAC,+BAAsB;MAEhD;QACS,kBAAS;QAAT,kBAAS;QAAT,kBAAS;QAAT,0CAAS;QAAC,aAAW;MADpB;IAHsB;IASlC;MACS,+BAAS;MAAC,+BAAsB;IADF;IAKvC;MAES,+BAAe;MAAf;QAAA,sFAAe;MAAA;IADoC;IAM5D;MAQS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;IADzB;IAKJ;MAIS,yBAAkB;MAAC,+BAAS;MAAC,+BAAsB;MAE1D;QACS,kBAAS;QAAT,kBAAS;QAAT,kBAAS;QAAT,0CAAS;QAAC,+BAAS;QAAC,aAAW;MAD9B;IAH2C;IASvD;MAES,+BAAS;MAAC,+BAAsB;IADmB;EAzG3C;EAkHnB;IACS,kBAAQ;IAAC,WAAI;IAAC,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAE5D;MACS,wHAAa;IADhB;EAHa;EAYrB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADT;EAQnB;IACS,gCAAe;IAAf,8BAAe;IAAf,oBAAe;EADJ;EAYpB;IACS,sBAAW;IAAX,sIAAW;IAClB,4CAA4C;IAE5C,2CAA2C;IAG3C;MAES,gDAAyB;MAAzB;QAAA;;;;GAAyB;MAAA;IADD;EARK;EAcxC;IAIE,4CAA4C;EADzB;EAKrB;IAEE;MACS,+BAAS;IADR;EADkD;EAO9D;IACS,+BAAS;IAEhB;MACS,+BAAS;IADR;EAHuD;ECnQnE;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAEnB,cAAM;IAAC,YAAI;IAAC,oCAAO;EAHlB;EAMV;IACS,2BAAS;IAAT,6DAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAD5B;EAIlB;IACS,WAAM;IAAC;MAAA,uBAAS;MAAT,8EAAS;MAAT,sFAAS;IAAA;EADF;EAIvB;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;IAAC,qCAAI;EADlB;ECdnB;IACS,kBAAQ;IAAC,aAAI;IAAC,mBAAY;IAAC,6BAAK;IAEvC;MACS,mBAAkB;MAAC,YAAU;IADd;EAHf;EASX;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;EADd;EAKlB;IACS,kBAAQ;IAAC,aAAI;IAAC,iCAAI;IAAC,iCAAK;IAAC,OAAM;IAAC,mBAAY;IAAC,uBAAc;IAC3D,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAClD,6DAAa;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,wBAAY;IAAZ,mBAAY;IAEvD,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFxB;IAFH;IAStB;MACS,WAAI;MAAC,yDAAc;MAAC,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;IAD3B;IAKtB;MACS,yDAAc;IADD;IAKtB;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFrB;EA3CR;EAkDjB;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,sBAAkB;IAAlB,uBAAkB;IAM3C,sDAAsD;IACtD,+BAA+B;IACxB;MAAA,eAA0B;MAA1B;QAAA,eAA0B;MAAA;IAAA;IAA1B;MAAA;QAAA,eAA0B;QAA1B;UAAA,eAA0B;QAAA;MAAA;IAAA;EATZ;EAavB;IACS,kBAAQ;IAAC,gCAAG;IAAC,UAAO;IAAC,6CAAmB;IAAC,wCAAU;IAAC,wDAAoB;EAD/D;EAKlB;IACS,WAAO;IAAC,UAAO;IAAC,cAAQ;IAAC,wCAAU;IAAC,kCAAY;EADnC;EAStB;IACS,sBAAW;IAAX,sIAAW;IAClB,0CAA0C;IAE1C,yCAAyC;IACzC,qDAAqD;IACrD,+CAA+C;IAE/C;MACE;QAEE,gDAAgD;MAD3B;IAFH;IAOtB;MAEE,gDAAgD;IAD5B;EAhBe;EAsBvC;IACE;MACE,UAAU;MACV,qCAAqC;IAFpC;IAIH;MACE,UAAU;MACV,iCAAiC;IAF9B;EALkB;EClHzB;IACS,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,6CAAkC;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAEtJ,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFoC;IAF/D;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;MAC3B,6CAA6C;MAC7C,0CAA0C;IAHrB;IAYvB;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFrB;IAMvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA7CnB;EAuDP;IACS,sBAAW;IAAX,sIAAW;IAClB,iCAAiC;IAEjC,gCAAgC;IAChC,4CAA4C;IAC5C,sCAAsC;IAEtC;MACE;QAEE,uCAAuC;MAD0C;IAF/D;IAOtB;MAEE,uCAAuC;IADlB;IAUvB;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,uCAAuC;IAFlB;EA1BP;EAiClB;IACS,WAAM;EADI;ECvFnB;IACS,oBAAW;IAAC,oCAAO;IAAC,mBAAY;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAC7H,uCAAuC;IACvC,uCAAuC;IAGvC;MACS,uBAAW;MAClB,YAAY;IAF4B;IAS1C,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFQ;IAFnC;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;MAC3B,6CAA6C;MAC7C,0CAA0C;IAHI;IAOhD;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;MAC1C,+CAA+C;IAH1B;IAOvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA/Cb;EAoDb;IACS,OAAM;IAAC,gBAAY;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,6BAAc;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,sBAAW;IAAX,sIAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,6CAAkC;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAG7I;MACS,yBAAc;MAAd,4BAAc;MAAC,sCAAI;IADyB;IAKrD;MACS,0BAAc;MAAd,6BAAc;MAAC,uCAAI;IADyB;IAKrD;MAES,wBAAY;MAAZ,mBAAY;IADL;EAfE;EAqBpB;IACE,gBAAgB;IAChB,gBAAgB;EAFoC;EAKtD;IACS,aAAI;IAAC,YAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,sEAAe;IAAf,yEAAe;IAAC,0BAAc;IAAd,6BAAc;IAAC,6BAAc;IAAC,wCAAI;IAAC,6CAAsB;IACxH,uCAAuC;IACvC,uCAAuC;IACvC,mBAAmB;IACnB,6CAA6C;IAC7C,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IAGnB;MACS,uBAAW;MAClB,mBAAmB;IAFkC;IASvD,4FAEuC;IAChC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAvBjB;EA0BrB;IACS,aAAI;IAAC,YAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,yBAAc;IAAd,4BAAc;IAAC,uEAAe;IAAf,0EAAe;IAAC,6BAAc;IAAC,wCAAI;IAAC,6CAAsB;IACxH,uCAAuC;IACvC,uCAAuC;IACvC,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IAGnB;MACS,uBAAW;MAClB,mBAAmB;IAFkC;IASvD,4FAEuC;IAChC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAvBjB;EA+BrB;IACS,sBAAW;IAAX,sIAAW;IAClB,uCAAuC;IAEvC,sCAAsC;IACtC,kDAAkD;IAClD,4CAA4C;IAE5C;MACE;QAEE,6CAA6C;MADQ;IAFnC;IAOtB;MAEE,6CAA6C;IADC;IAKhD;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,+CAA+C;MAC/C,6CAA6C;IAHxB;IAMvB;MAES,6BAAc;IADY;EA5Bb;EAkCxB;IACS,WAAM;EADU;ECzKzB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;EAVR;EAed;IACS,aAAI;IAAC,gCAAG;IAAC,mBAAY;IAAC,gBAAe;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAClI,uCAAuC;IACvC,uCAAuC;IACvC,oCAAoC;IAMpC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFQ;IAFnC;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;MAC3B,6CAA6C;MAC7C,0CAA0C;IAH7B;IAOf;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;MAC1C,+CAA+C;IAH1B;IAOvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA1CL;EA+CrB;IACS,mCAAO;IAAC,gBAAY;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,6BAAc;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,kCAAY;IAAZ,iJAAY;IAAC,sBAAW;IAAX,sIAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAGxH;MACS,yBAAc;MAAd,4BAAc;IADwB;IAK/C;MACS,0BAAc;MAAd,6BAAc;IADwB;IAK/C;MAES,wBAAY;MAAZ,mBAAY;IADL;EAfG;EAoBrB;IAES,aAAI;IAAC,YAAM;IAAC,gCAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,gBAAY;IAAC,6BAAc;IAAC,iDAAqB;IAAC,wBAAY;IAAZ,mBAAY;IAClH,uCAAuC;IACvC,uCAAuC;IACvC,mBAAmB;IAMnB,4FAEuC;IAChC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAajC;MAES,4DAAsB;MAAtB;QAAA,kGAAsB;MAAA;MAC7B,sBAAsB;IAFD;IAMvB;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAES,+BAAM;MAAN,gCAAM;IADkC;EA5CnB;EAiDhC;IACS,yBAAc;IAAd,4BAAc;IAAC,uEAAe;IAAf,0EAAe;IAAC,yCAAQ;IAAR,sBAAQ;IAAC,oDAA2B;IAA3B;MAAA,0FAA2B;IAAA;EAD5C;EAIhC;IACS,sEAAe;IAAf,yEAAe;IAAC,0BAAc;IAAd,6BAAc;IAAC,0CAAQ;IAAR,uBAAQ;IAAC,oDAA2B;IAA3B;MAAA,0FAA2B;IAAA;EAD5C;EAShC;IACS,sBAAW;IAAX,sIAAW;IAClB,8CAA8C;IAE9C,6CAA6C;IAC7C,yDAAyD;IACzD,mDAAmD;IAEnD;MACE;QAEE,oDAAoD;MADC;IAFnC;IAOtB;MAEE,oDAAoD;IAD1B;IAK5B;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,+CAA+C;MAC/C,oDAAoD;IAH/B;IAMvB;MACS,6BAAc;IADU;EA3BW;EAiC9C;IACS,WAAM;EADW;EAI1B;IACS,WAAM;EADkB;ECtLjC;IACS,aAAI;IAAC,sBAAQ;IAGpB;MACE;QACS,oCAAI;MADO;IADS;IAM/B;MACS,mBAAQ;MAAC,eAAS;MAAC,6BAAK;IADA;EAVtB;EAoBb;IACS,sBAAW;IAAX,sIAAW;IAClB,yCAAyC;IAEzC,wCAAwC;IACxC,oDAAoD;IAGpD;MAES,gDAAyB;MAAzB;QAAA;;;;GAAyB;MAAA;IADJ;IAK9B;MACE,yCAAyC;IADqD;IAKhG;MAEE;QACE,+CAA+C;MADjB;IADmD;EApB/C;ECjBxC;IACS,kBAAQ;IAAC,aAAI;IAAC,uBAAW;IAAC,6BAAK;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAEhE,iCAAiC;IAEjC;MACS,yBAAW;MAAX,iBAAW;IADA;IAIpB;MACS,eAAS;MAAC,yBAAW;MAAX,iBAAW;IADJ;IAK1B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAhBnB;EAyBP;IACS,kBAAQ;IAAC,eAAQ;IAAC,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,uCAAwC;IAAC,yDAAQ;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAM3L,uHAGiC;IAC1B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC,iCAAiC;IAIjC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADa;IAKpC;MAES,gDAAyB;MAAzB;QAAA;;;;GAAyB;MAAA;IADJ;IAK9B;MAEE;QACS,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;MADS;IADmD;IAOrF;MAES,iBAAQ;MAAR,iBAAQ;MAAR,iBAAQ;MAAR,0CAAQ;IADa;IAM9B;MAES,yBAAkB;MAAC,+BAAS;IADN;IAK/B;MAES,+BAAe;MAAf;QAAA,sFAAe;MAAA;IAD4B;IAMpD;MAES,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;IADC;IAK9B;MAIS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;IADuB;EAlEtC;EA2EhB;IACS,kBAAQ;IAAC,+BAAO;IAAC,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAExD,oBAAoB;EAHJ;EAQlB;IACE,WAAW;IACJ,sCAAU;IAAC,yDAAQ;IAE1B,WAAW;IACX,YAAY;IACZ,QAAQ;IAMR,+EAEwC;IACjC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAfN;EAmBhC;IAES,0CAAoB;IAC3B,aAAa;EAF8C;EAM7D;IACE,aAAa;EADmE;EAQlF;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADZ;EAQhB;IACS,gCAAe;IAAf,8BAAe;IAAf,oBAAe;EADP;ECxJjB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;EAJd;EAYX;IACS,WAAM;IAGb;MAES,WAAM;IADQ;EALF;ECbvB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;IAIpB;MACE;QACS,oBAAmB;QAAC,WAAS;MADE;IADrB;EAdT;EAqBd;IACS,kBAAQ;IAAC,oBAAW;IAAC,gCAAG;IAAC,mBAAY;IAAC,gBAAe;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAClJ,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFQ;IAFnC;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;IADd;IAKf;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;MAC1C,+CAA+C;IAH1B;IAOvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAvCL;EA4CrB;IACS,OAAM;IAAC,gBAAY;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,6BAAc;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,sBAAW;IAAX,sIAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAG1G;MAEE,wBAAwB;MACxB,gBAAgB;IAFW;IAM7B;MACS,yBAAc;MAAd,4BAAc;MAAC,sCAAI;IADuC;IAKnE;MACS,0BAAc;MAAd,6BAAc;MAAC,uCAAI;IADe;IAK3C;MAES,wBAAY;MAAZ,mBAAY;IADL;EAtBG;EA2BrB;IACS,oBAAmB;IAAC,cAAQ;IAAC,6CAAsB;IACnD,sCAAI;IAAC,qCAAI;IAAC,+BAAM;IAAN,gCAAM;EAFE;EAK3B;IACS,sCAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAG3B;MACS,+BAAM;MAAN,gCAAM;IADiB;EAJN;EAc5B;IACS,sBAAW;IAAX,sIAAW;IAClB,8CAA8C;IAE9C,6CAA6C;IAC7C,yDAAyD;IACzD,mDAAmD;IAEnD;MACE;QAEE,oDAAoD;MADC;IAFnC;IAOtB;MAEE,oDAAoD;IAD1B;IAK5B;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,+CAA+C;MAC/C,oDAAoD;IAH/B;IAMvB;MACS,6BAAc;IADU;EA3BW;EAiC9C;IACS,WAAM;EADW;EAI1B;IACS,WAAM;EADkB;ECpJjC;IACS,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,6CAAkC;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAEtJ,gBAAgB;IAEhB,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFoC;IAF/D;IAStB;MAES,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;MAC3B,6CAA6C;MAC7C,0CAA0C;IAHrB;IAWvB;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFrB;IAMvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EA9ChB;EAwDV;IACS,sBAAW;IAAX,sIAAW;IAClB,oCAAoC;IAEpC,mCAAmC;IACnC,+CAA+C;IAC/C,yCAAyC;IAEzC;MACE;QAEE,0CAA0C;MADuC;IAF/D;IAOtB;MAEE,0CAA0C;IADrB;IAUvB;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFrB;EA1BJ;EAiCrB;IACS,WAAM;EADO;EChFtB;IACS,gCAAI;IAAC,eAAU;IAEtB,2BAA2B;EAHnB;EASV;IACS,aAAI;IAAC,mBAAY;IAAC,8BAAe;IAAC,0CAAM;IAAC,wCAAI;IAEpD;MACE;QACS,oBAAmB;QAAC,WAAS;MADhB;IADgC;EAHxC;EAUlB;IACS,OAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;EADhB;EAInB;IACS,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,oBAAW;IAEtE,kBAAkB;IAMlB,oJAI+B;IACxB,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAElD,iCAAiC;IAGjC;MACE;QAES,gCAAU;QAAC,oBAAW;MADR;IAFH;IAQtB;MAEE,sBAAsB;IADD;IAKvB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAxCJ;EA6CtB;IACS,+BAAM;IAAN,gCAAM;EADY;EAO3B;IAEE,aAAa;IACb,qCAAqC;IAC9B,WAAM;IAEb;MACE;QACS,oBAAmB;MADZ;IADM;EANV;EAahB;IAEE,iBAAiB;IAEjB;MACE,iBAAiB;IADZ;EAJc;EASvB;IAEE,iBAAiB;IAEjB;MACE,iBAAiB;IADZ;IAKP;MACS,oCAAI;IADW;EATL;EAcrB;IAGE,iBAAiB;EAHC;EAMpB;IAES,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAU;EAFtD;EAQvB;IAES,kBAAQ;IAAC,aAAI;IAAC,mBAAa;IAAC,WAAS;IAAT,YAAS;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,kBAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC,wCAAY;IAE9I,kBAAkB;IAKlB,6EAEkC;IAC3B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAElD,iCAAiC;IAGjC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MACS,oBAAW;IADC;IAKrB;MACS,+BAAS;MAAC,+BAAsB;IADjB;IAKxB;MAES,gCAAU;MACjB,sBAAsB;MAEtB;QACS,+BAAe;QAAf;UAAA,sFAAe;QAAA;MADA;IAJH;IAUvB;MACE;QAES,gCAAU;MADgC;IAF/B;IAQtB;MACS,mBAAU;MAAC,YAAU;IADD;IAI7B;MACS,gCAAU;IADgC;IAKnD;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADG;IAK3B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB,6BAA6B;IAH0B;EAnE3C;EA2EhB;IACS,kBAAQ;IAAC,gCAAQ;IAAC,wBAAQ;IAAC,UAAU;IAAV,WAAU;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,yCAAU;IAAC,8BAAQ;IAGjF;MACS,0CAAoB;IADF;EAJH;ECxM1B;IACS,gCAAI;IAAC,eAAU;IAEtB,2BAA2B;EAHb;EAShB;IACS,aAAI;IAAC,mBAAY;IAAC,8BAAe;IAAC,0CAAM;IAAC,wCAAI;IAEpD;MACE;QACS,oBAAmB;QAAC,WAAS;MADV;IAD0B;EAHlC;EAUxB;IACS,OAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;EADV;EAIzB;IACS,aAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAU;IAAC,oBAAW;IAErE,kBAAkB;IAMlB,oJAI+B;IACxB,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAElD,iCAAiC;IAGjC;MACE;QAES,gCAAU;QAAC,oBAAW;MADR;IAFH;IAQtB;MAEE,sBAAsB;IADD;IAKvB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAxCE;EA6C5B;IACS,+BAAM;IAAN,gCAAM;EADkB;EAOjC;IAEE,aAAa;IACb,qCAAqC;IAC9B,WAAM;IAEb;MACE;QACS,oBAAmB;MADN;IADA;EANJ;EAatB;IAEE,iBAAiB;IAEjB;MACE,iBAAiB;IADZ;EAJoB;EAS7B;IAEE,iBAAiB;IAEjB;MACE,iBAAiB;IADZ;IAKP;MACS,oCAAI;IADW;EATC;EAc3B;IAGE,iBAAiB;EAHO;EAM1B;IAES,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAU;EAFhD;EAQ7B;IACS,kBAAQ;IAAC,UAAG;IAAC,uCAAI;IAAC,iBAAQ;IAAC,sCAAW;IAAC,iCAAG;IAAC,wBAAY;IAAZ,mBAAY;IAC9D,iCAAiC;IAEjC,2CAA2C;IAK3C,gFAEoC;IAC7B,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGlD;MACS,aAAI;MAAC,mBAAa;MAAC,WAAM;MAAC,mBAAY;MAAC,uBAAc;MAAC,sCAAW;MAAC,yBAAO;MAAP,2DAAO;MAAC,2CAAW;MAAX,sCAAW;MAAC,wBAAe;MAAC,wCAAY;MAEzH,kBAAkB;MAClB,uCAAuC;MAChC,wHAAa;MAAC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IALvB;IAS7B;MAES,UAAG;MAEV;QACS,wHAAc;QAAd,sIAAc;QAAd,6BAAc;QAAd,2BAAc;QAAd,4GAAc;QAAd,yCAAc;QAAd,wBAAc;QAAd,mBAAc;QAAd,gDAAc;MADM;IAHF;IAS7B;MACE;QACS,oBAAW;MADS;IADV;IAOrB;MACS,gBAAY;MAAC,mDAAc;MAAd;QAAA,yFAAc;MAAA;IADqB;IAKzD;MACS,kDAAa;MAAC,gDAAa;MAClC;QACS,kDAAc;QAAC,gDAAc;MADP;IAFwC;IAOzE;MACS,gDAAa;MAAC,8CAAa;MAClC;QACS,gDAAc;QAAC,8CAAc;MADT;IAF8C;IAQ7E;MAES,UAAG;MAEV;QACS,+BAAS;QAAC,+BAAsB;MADZ;IAH+B;IAY9D;MACS,+CAAc;MAAC,kDAAc;IAD0B;IAIhE;MACS,gDAAc;MAAC,mDAAc;IADwB;IAK9D;MAEE;QACE,UAAU;MADiB;MAI7B;QAEE;UACS,+BAAe;UAAf;YAAA,sFAAe;UAAA;QADK;MADF;IANR;IAcvB;MACE;QAEE;UACS,gCAAU;QADU;MADoB;IAF/B;IAUtB;MACS,mBAAU;MAAC,YAAU;IADD;IAI7B;MAIS,gCAAa;MAAb;QAAA,sEAAa;MAAA;IADlB;IAKJ;MACS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADG;IAK3B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;MAEtB,6BAA6B;IAH0B;EA9HrC;EAsItB;IAIS,kDAAa;IAAC,gDAAa;IAElC;MAES,kDAAc;MAAC,gDAAc;IADP;EAJe;EAUhD;IAKS,gDAAa;IAAC,8CAAa;IAElC;MAES,gDAAc;MAAC,8CAAc;IADT;EAJiB;EAUhD;IACS,kBAAQ;IAAC,gCAAQ;IAAC,wBAAQ;IAAC,UAAU;IAAV,WAAU;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,yCAAU;IAAC,8BAAQ;IAGjF;MACS,0CAAoB;IADF;EAJG;ECvRhC;IAEE,kBAAkB;EADkC;EAetD;IAEE,oBAAoB;IACpB,gEAEuB;IAChB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EALoD;EAS1F;IAGS,oBAAmB;IAAC,WAAS;IACpC,kBAAkB;IAClB,sEAE6B;IACtB;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EANA;EAYtC;IACS,aAAI;IAAC,OAAM;IAAC,mBAAY;IAAC,2BAAa;IAAC,6BAAK;IAAC,sCAAU;IAAC,wBAAY;IAAZ,mBAAY;IAE3E,iCAAiC;IACjC,0BAA0B;IAG1B;MACS,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADP;EAPa;EAY/B;IACS,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAE1B,uCAAuC;IAChC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAJC;EAOvC;IACS,yBAAO;IAAP,2DAAO;IAAC,oBAAW;IAE1B,2CAA2C;IACpC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EAJG;EAQzC;IACE,wBAAwB;EADgE;EAI1F;IACS,oBAAW;EADoE;EAUxF;IACS,oBAAmB;IAAC,kBAAQ;IAAC,+BAAO;IAAC,8BAAM;IAAC,aAAI;IAAC,yBAAa;IAAC,6BAAK;IAAC,gBAAe;IAAC,iCAAG;IAAC,WAAS;IACzG,qCAAqC;IAGrC,oBAAoB;IAGpB,qBAAqB;IACrB,iDAAiD;IAEjD;MACE,UAAU;IADS;IAIrB;MACE,uBAAuB;IADE;IAI3B;MACE,gCAAgC;MAChC,kBAAkB;IAFO;IAK3B;MACE,gCAAgC;IADD;IAKjC;MACE,mDAAmD;MAEnD;QACE,kCAAkC;MADT;MAI3B;QACE,kCAAkC;MADH;IAPD;EA7BH;EA0CjC;IACS,oBAAmB;IAAC,aAAW;IAGtC,8CAA8C;IACvC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EALa;EAWnD;IACS,kBAAQ;IAAC,oBAAW;IAAC,gCAAG;IAAC,mBAAY;IAAC,uBAAc;IAAC,sCAAW;IAAC,0CAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IACxI,0BAA0B;IAM1B,yLAKkC;IAC3B,wBAAa;IAAC,wHAAa;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEhE,iCAAiC;IAGjC;MACE;QACS,gCAAU;QAAC,gCAAuB;MADqB;IADxB;IAO1C;MAES,+BAAS;MAAC,+BAAsB;MAEvC;QACE;UACS,+BAAe;UAAf;YAAA,sFAAe;UAAA;QADY;MADI;IAHpB;IAWxB;MACS,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADP;EAtCe;ECtJjC;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;EAVV;EAgBZ;IACS,WAAM;EADS;EChBxB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;EAVV;EAgBZ;IACS,WAAM;EADS;EChBxB;IACS,oBAAW;IAAC,gCAAG;IAAC,mBAAY;IAAC,gBAAe;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IACzI,uCAAuC;IACvC,uCAAuC;IAMvC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFQ;IAFnC;IAStB;MAgBS,wHAAoB;MAApB,sIAAoB;MAApB,6BAAoB;MAApB,4GAAoB;MAApB,wBAAoB;MAApB,mBAAoB;MAApB,2BAAoB;IADzB;IAKJ;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;MAC1C,+CAA+C;IAH1B;IAOvB;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EArDR;EA0DlB;IACS,aAAI;IAAC,OAAM;IAAC,YAAW;IAAC,mBAAY;IAAC,QAAM;IAAC,gBAAY;IAAC,oCAAQ;IAAR,iBAAQ;IAAC,6BAAc;IAAC,wCAAI;IAAC,uCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC,sBAAW;IAAX,sIAAW;IAAC,wBAAY;IAAZ,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAG/I;MACS,yBAAc;MAAd,4BAAc;MAAC,sCAAI;IADmC;IAK/D;MACS,0BAAc;MAAd,6BAAc;MAAC,uCAAI;IADmC;IAI/D;MACE;QACS,UAAS;QAAC,uCAAI;MADP;MAGhB;QACS,sCAAI;MADC;IAJ6C;IAU7D;MAES,wBAAY;MAAZ,mBAAY;IADL;EAxBO;EA6BzB;IACS,aAAI;IAAC,OAAM;IAAC,mBAAY;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IAErB;MACE,aAAa;IADM;EAPY;EAYnC;IACS,qBAAY;IAAC,yCAAU;IAAC,0CAAM;IAAC,eAAQ;IAAC,iBAAW;IAAC,wBAAY;IAAZ,mBAAY;IAGvE;MACS,iCAAG;MAAC,mBAAU;IADA;IAKvB;MACS,6CAAsB;IADJ;IAK3B;MAES,mDAAc;MAAd;QAAA,yFAAc;MAAA;MAAC,mDAA2B;IAD5B;IAKvB;MACS,YAAU;IADK;IAKxB;MACS,oBAAW;MAGlB;QAES,mDAAc;QAAd;UAAA,yFAAc;QAAA;QAAC,mDAA2B;MAD5B;IALF;EAzBE;EAoC3B;IACS,oBAAmB;IAAC,cAAQ;IAAC,6CAAsB;IACnD,sCAAI;IAAC,qCAAI;IAAC,aAAI;IAAC,mBAAY;EAFV;EAK1B;IACS,oBAAmB;IAAC,cAAQ;IAAC,6CAAsB;IACnD,sCAAI;IAAC,aAAI;IAAC,mBAAY;EAFL;EAU1B;IACS,sBAAW;IAAX,sIAAW;IAClB,4CAA4C;IAE5C,2CAA2C;IAC3C,uDAAuD;IACvD,iDAAiD;IAEjD;MACE;QAEE,kDAAkD;MADG;IAFnC;IAOtB;MAEE,kDAAkD;IADxB;IAK5B;MACS,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,+CAA+C;MAC/C,kDAAkD;IAH7B;IAMvB;MACS,6BAAc;IADc;EA3BV;EAiC7B;IACS,WAAM;EADe;ECpL9B;IACS,oBAAW;IAAC,sBAAQ;IAAC,6BAAK;IAEjC;MAES,oBAAmB;IADF;EAJf;EASb;IACS,oBAAW;IAAC,WAAM;IAAC,mBAAY;IAAC,6DAAa;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC,wCAAY;IAE7E,iCAAiC;IAMjC,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAI7B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAnBJ;EAwBtB;IACS,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,6CAAsB;EAD9C;EAIhC;IACS,+BAAuB;IAAC,6CAA+B;IAAC,kBAAiB;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAC3H;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC,iCAAiC;IACjC,mDAAmD;IAEnD;MACE,aAAa;IADM;IAIrB,wBAAwB;IACxB,qBAAqB;IAErB;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAI7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAE/D;QACS,8CAAsB;MADN;MAIzB;QACS,iDAAmB;MADA;MAI5B;QACS,8CAAqB;MADJ;MAI1B;QACS,iDAAoB;MADF;IAfL;IAoBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;EA5CJ;ECrCtB;IACS,oBAAW;IAAC,sBAAQ;IAAC,6BAAK;IAEjC;MAES,oBAAmB;IADF;EAJT;EASnB;IACS,oBAAW;IAAC,WAAM;IAAC,mBAAY;IAAC,6DAAa;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC,wCAAY;IAE7E,iCAAiC;IAMjC,4CAA4C;IACrC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAI7B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAnBE;EAwB5B;IACS,oBAAW;IAAC,+BAAM;IAAN,gCAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,6CAAsB;EADxC;EAItC;IACS,wCAAI;IAAC,6CAAsB;IAAC,yBAAW;IAAX,iBAAW;EADZ;EAIpC;IACS,+BAAuB;IAAC,6CAA+B;IAAC,kBAAiB;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAC3H;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC,iCAAiC;IACjC,mDAAmD;IAEnD;MACE,aAAa;IADM;IAIrB,wBAAwB;IACxB,qBAAqB;IAErB;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAI7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAE/D;QACS,8CAAsB;MADN;MAIzB;QACS,iDAAmB;MADA;MAI5B;QACS,8CAAqB;MADJ;MAI1B;QACS,iDAAoB;MADF;IAfL;IAoBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;EA5CE;EC1C5B;IACS,kBAAQ;IAAC,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAAC,gBAAe;IAAC,iCAAG;IAChD,kCAAc;IAAd,sIAAc;IACrB,2CAA2C;EAHvC;EAON;IACS,aAAI;IAAC,sBAAQ;EADR;EAKd;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EADzC;EAKb;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;IAAC,mBAAU;EADlB;EAKnB;IACS,aAAI;IAAC,OAAM;IAAC,sBAAQ;IAAC,6BAAK;EADpB;EAKf;IACS,aAAI;IAAC,mBAAQ;IAAC,mBAAY;EADrB;EAMd;IACS,uBAAW;IAAX,kBAAW;IAAC,6BAAc;IAAC,sBAAW;IAAX,sIAAW;EAD5B;EAInB;IACS,gCAAU;EADJ;EAIf;IACS,0CAAoB;EADZ;EAIjB;IACS,yCAAmB;EADZ;EC5ChB;IACS,WAAM;IAAC,wCAAI;IAAC,uCAAM;IAAC,wCAAI;IAAC,gBAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAU;EADjE;ECDR;IACS,cAAQ;IAAC,wCAAU;IAAC,wCAAU;IAAV,qBAAU;IAAC,2CAAU;IAAV,wBAAU;IAAC,kCAAY;IAGtD,WAAI;IAAC,WAAM;EAJT;EAQX;IACS,WAAI;IAAC,WAAM;EADG;EAIvB;IACS,YAAM;IAAC,oCAAO;IAAC,UAAI;IAAC,mBAAY;EADpB;EAKrB;IACS,kCAAY;EADD;EAIpB;IACS,gCAAsB;IAAtB;MAAA;;;;GAAsB;IAAA;EADT;EAItB;IACS,gCAAqB;IAArB;MAAA;;;;GAAqB;IAAA;EADT;EAIrB;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;EADV;EAItB;IACS,WAAM;IAAC,mBAAQ;EADU;EAIlC;IACS,YAAM;IAAC,sBAAQ;IAAC,uBAAc;EADP;EAIhC;IACS,cAAQ;IAAC,YAAI;EADL;EAIjB;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,kBAAW;IAAC,mBAAiB;IAAC,mBAAU;EADrE;EAIpB;IACS,kBAAW;EADY;EAIhC;IACS,kBAAW;EADU;ECrD9B;IACS,kBAAQ;IAAC,wBAAe;EADxB;EAKT;IACS,6BAAc;EADD;EAItB;IACS,gCAAU;IAAC,gCAAuB;EADzB;EAIlB;IACS,0CAAoB;IAAC,0CAAiC;EAD3C;EAIpB;IACS,yCAAmB;IAAC,yCAAgC;EAD1C;ECnBnB;IACS,kBAAQ;IAAC,aAAI;IAAC,gCAAO;IAAP,iCAAO;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,gBAAe;IAAC,sCAAW;IAAC,gCAAU;EADlG;EAKR;IACS,aAAI;IAAC,WAAS;IAAT,YAAS;IAAC,mBAAY;IAAC,uBAAc;IAAC,gCAAU;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;EADhE;EAKlB;IACS,kBAAQ;IAAC,+BAAO;IAAC,mBAAa;IAAC,WAAS;IAAT,YAAS;IAKxC,4BAAkB;IAAlB,qFAAkB;IAAlB,2EAAkB;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;EANvD;EAUf;IACS,+BAAM;IAAN,gCAAM;IAAC,sCAAW;EADf;EAQZ;IACS,gCAAO;IAAP,iCAAO;IAAC,sCAAW;IAE1B;MACS,2BAAS;MAAT,6DAAS;IADA;EAHR;EASZ;IACS,oBAAW;EADM;EAI1B;IACS,gCAAuB;EADL;EAI3B;IACS,qBAAY;EADM;EAI3B;IACS,qBAAY;EADM;EAI3B;IACS,oBAAW;EADM;EAK1B;IACS,6BAAc;EADT;EAId;IACS,mDAAc;IAAd;MAAA,yFAAc;IAAA;IAAC,mDAA2B;EADX;EAIxC;IACS,qDAAe;IAAf;MAAA,2FAAe;IAAA;IAAC,qDAA4B;EADZ;EAIzC;IACS,qDAAe;IAAf;MAAA,2FAAe;IAAA;IAAC,qDAA4B;EADZ;EAIzC;IACS,mDAAc;IAAd;MAAA,yFAAc;IAAA;IAAC,mDAA2B;EADX;ECnExC;IACS,qBAAY;IACZ,iCAA6B;IAMpC,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAEE,sBAAsB;IADD;EA5BF;EAoCvB;IACS,eAAK;IAAC,+BAAO;IAAC,WAAI;IAClB,aAAI;IAAC,mBAAQ;IAAC,mBAAY;IAAC,uBAAc;IACzC,qCAA4B;IAAC,WAAM;IAG1C;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,0BAAQ;MAAR,2CAAQ;MAAC,+BAAS;MAAT,qBAAS;IAD3B;IAKxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,0BAAQ;MAAR,2CAAQ;MAAC,8BAAU;MAAV,oBAAU;IAD9B;IAQvB;MAES,oBAAqB;MACrB;QAAA,eAA0B;QAA1B;UAAA,eAA0B;QAAA;MAAA;MAA1B;QAAA;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;MAAA;IAFX;EApBF;EA6BxB;IACS,6BAAc;EADc;EAOrC;IACS,iCAAW;EADY;EAOhC;IACS,iCAAW;IAAC,wCAAgB;IAAhB,wRAAgB;IAAhB,gRAAgB;EADP;EAO9B;IACS,aAAI;IAAC,sBAAQ;IAAC,mBAAY;IAC1B,qCAA4B;IAAC,WAAM;IAAC,mCAAO;IAAC,OAAM;IAClD,iCAAG;IACH;MAAA,kBAAQ;IAAA;IAAC;MAAA,kCAAO;IAAA;IAChB,oBAAmB;IAG1B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,+CAAa;MAAb,gEAAa;MAAC,+BAAS;MAAT,qBAAS;MAAC,8BAAW;MAElE;QACS,8CAAsB;QACtB;UAAA,8CAAyB;UAAzB,oCAAyB;QAAA;MAFT;MAKzB;QACS,iDAAmB;MADJ;MAIxB;QACS,iDAAmB;QAAnB,qCAAmB;MADD;MAI3B;QACS,8CAAsB;MADJ;IAhBL;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,+CAAa;MAAb,gEAAa;MAAC,8BAAU;MAAV,oBAAU;MAAC,4BAAW;MAAX,oBAAW;IAD/C;IAQvB;MAES,8BAA+B;MAC/B;QAAA,eAA0B;QAA1B;UAAA,eAA0B;QAAA;MAAA;MAA1B;QAAA;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;MAAA;IAFX;EAvCD;EAgDzB;IACS,kBAAQ;IACR,aAAI;IAAC,WAAM;IAAC,sBAAQ;IACpB,gCAAU;IAAC,kCAAc;IAAd,sIAAc;IAAC,wBAAY;IAAZ,mBAAY;IAC7C,2CAA2C;IACpC,iCAAG;IACH,gBAAe;IACf,oBAAmB;IAE1B;MACS,gBAAO;MACP;QAAA,kBAAU;MAAA;IAFM;IAKzB;MACS,kBAAO;IADW;IAI3B;MACS,gBAAO;IADW;IAI3B;MACS,oCAAI;IADW;EAtBJ;EA8BtB;IACS,8BAAQ;EADS;EAO1B;IACS,8BAAQ;EADS;EAO1B;IACS,8BAAQ;EADS;EAO1B;IACS,8BAAQ;EADS;EAO1B;IACS,YAAM;IAAC,gBAAU;IAAC,WAAM;EADJ;EAO7B;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IACnB,uCAAI;IAGX;MACS,uCAAI;IADI;EALG;EAatB;IACS,sBAAY;IACZ,2BAAS;IAAT,6DAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAFvB;EAQvB;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAChC,gCAAO;IAAP,iCAAO;IAAC,cAAQ;IAChB,sCAAW;IAAC,yBAAW;IAAX,iBAAW;IAE9B;MACS,uBAAW;MAAC,+BAAM;MAAN,gCAAM;IADa;EALtB;EAapB;IACS,gCAAU;IAAC,wBAAe;EADN;EAO7B;IACS,mDAAc;IAAd;MAAA,yFAAc;IAAA;IAAC,mDAA2B;EADvB;EAO5B;IACS,qDAAe;IAAf;MAAA,2FAAe;IAAA;IAAC,qDAA4B;EADxB;EAO7B;IACS,qDAAe;IAAf;MAAA,2FAAe;IAAA;IAAC,qDAA4B;EADxB;EAO7B;IACS,mDAAc;IAAd;MAAA,yFAAc;IAAA;IAAC,mDAA2B;EADvB;EAO5B;IACS,oCAAO;IAAC,OAAM;IACd,yBAAO;IAAP,2DAAO;IAAC,kBAAc;IAAd,iBAAc;IAAC,mBAAU;IACjC,sCAAI;IACJ,gBAAe;IACtB,iCAAiC;EALf;EAWpB;IACS,aAAI;IAAC,mBAAQ;IAAC,mBAAY;IAAC,yBAAW;IAAC,6BAAK;IAC5C,oCAAI;EAFS;EAQtB;IACS,kBAAQ;IAAC,6BAAK;IAAC,+BAAO;EADF;EAO7B;IACS,oCAAI;EAD+B;EAI5C;IACS,oCAAI;EADiC;EAI9C;IACS,oCAAI;EAD+B;EC9S5C;IACS,qBAAY;IAAC,iCAA6B;IAMjD,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAEE,sBAAsB;IADD;EA3BR;EAmCjB;IACS,eAAK;IAAC,+BAAO;IAAC,WAAI;IAClB,qCAA4B;IAAC,WAAM;IAC1C,UAAU;IACV,wDAAwD;IAExD;MACE,UAAU;IADY;IAIxB;MACE,UAAU;MACV,0BAA0B;MAC1B,0DAA0D;IAHrC;IAMvB;MAEE,oBAAoB;IADE;IAIxB;MACE,gBAAgB;IADsB;EArBxB;EA6BlB;IACS,6BAAc;EADQ;EAO/B;IACS,iCAAW;EADM;EAO1B;IACS,iCAAW;IAAC,wCAAgB;IAAhB,wRAAgB;IAAhB,gRAAgB;EADb;EAOxB;IACS,oBAAmB;IACnB,eAAK;IAAC,+BAAO;IAAC,WAAI;IAAC,aAAI;IACvB,qCAA4B;IAAC,WAAM;IAAC,mCAAO;EAHnC;EAUjB;IACS,qBAAS;EADO;EAQzB;IACS,uBAAW;EADE;EAQtB;IACS,2BAAa;EADC;EAQvB;IACS,yBAAW;EADI;EAOxB;IACS,kBAAQ;IACR,aAAI;IAAC,sBAAQ;IACb,gCAAU;IAAC,kCAAc;IAAd,sIAAc;IAAC,wBAAY;IAAZ,mBAAY;IACtC,iCAAG;IACH,oBAAmB;IAE1B,8BAA8B;IAC9B,6BAA6B;IAC7B,mDAAmD;IACnD,kDAAkD;IAElD,sBAAsB;IACtB,2EAA2E;IAE3E;MACE,gBAAgB;IADsB;IAKxC;MACS,WAAM;MACN,gBAAY;MACnB,oDAAoD;MACpD,qDAAqD;IAJ5B;IAO3B;MACS,WAAM;MACN,gBAAY;MACnB,uDAAuD;MACvD,wDAAwD;IAJlC;IAQxB;MACS,YAAM;MAAC,gBAAY;MACnB,gCAAI;MAAC,eAAY;MAAC;QAAA,gCAAO;MAAA;IAFT;IAKzB;MACS,YAAM;MAAC,gBAAY;MACnB,gCAAI;MAAC,eAAY;MAAC;QAAA,gCAAO;MAAA;IAFR;EAxCZ;EA8ChB;IACE,gDAAgD;IAChD,mDAAmD;EAFf;EAKtC;IAIE,cAAc;EADyB;EAIzC;IAEE,kBAAkB;EADwC;EAI5D;IAEE,iBAAiB;EAD0C;EAI7D;IAEE,kBAAkB;EADuC;EAI3D;IAEE,iBAAiB;EAD2C;EAI9D;IACS,wCAAI;IACX;MACS,wCAAI;IADG;EAFG;EAUrB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IACnB,uCAAI;EAFG;EAQhB;IACS,sBAAY;IACZ,2BAAS;IAAT,6DAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAF7B;EASjB;IACS,oCAAO;IAAC,OAAM;IACd,yBAAO;IAAP,2DAAO;IAAC,kBAAc;IAAd,iBAAc;IAAC,mBAAU;IACjC,sBAAQ;IAAC,sCAAI;IAAC,YAAO;IACrB,gBAAe;IAAC,4BAAkB;IACzC,iCAAiC;EALrB;EAWd;IACS,aAAI;IAAC,mBAAQ;IAAC,mBAAY;IAAC,yBAAW;IAAC,6BAAK;IAC5C,oCAAI;EAFG;EAQhB;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAChC,wCAAI;IAGX;MACS,gCAAG;MAAC,+BAAG;MAAC,yCAAU;MAClB,kCAAY;IAFe;EALtB;EAchB;IACS,kBAAQ;IAAC,6BAAK;IAAC,+BAAO;EADR;EAOvB;IACS,oCAAI;EADmB;EAIhC;IACS,oCAAI;EADqB;EAIlC;IACS,oCAAI;EADmB;EAIhC;IACS,oCAAI;EADqB;EAIlC;IACS,oCAAI;EADmB;EC/RhC;IACS,qBAAY;IAAC,iCAA6B;IAMjD,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;IAKxB;MAEE,sBAAsB;IADD;EA3BT;EAmChB;IACS,eAAK;IAAC,+BAAO;IAAC,WAAI;IAClB,aAAI;IAAC,mBAAQ;IAAC,mBAAY;IAAC,uBAAc;IACzC,qCAA4B;IAAC,WAAM;IAG1C;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,0BAAQ;MAAR,2CAAQ;MAAC,+BAAS;MAAT,qBAAS;IAD3B;IAKxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,0BAAQ;MAAR,2CAAQ;MAAC,8BAAU;MAAV,oBAAU;IAD9B;IAQvB;MAES,oBAAqB;MACrB;QAAA,eAA0B;QAA1B;UAAA,eAA0B;QAAA;MAAA;MAA1B;QAAA;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;MAAA;IAFX;EApBT;EA6BjB;IACS,6BAAc;EADO;EAO9B;IACS,iCAAW;EADK;EAOzB;IACS,iCAAW;IAAC,wCAAgB;IAAhB,wRAAgB;IAAhB,gRAAgB;EADd;EAOvB;IACS,aAAI;IAAC,sBAAQ;IAAC,mBAAY;IAC1B,qCAA4B;IAAC,WAAM;IAAC,mCAAO;IAAC,OAAM;IAClD,iCAAG;IACH;MAAA,kBAAQ;IAAA;IAAC;MAAA,kCAAO;IAAA;IAChB,oBAAmB;IAG1B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,+CAAa;MAAb,gEAAa;MAAC,+BAAS;MAAT,qBAAS;MAAC,8BAAW;MAElE;QACS,8CAAsB;QACtB;UAAA,8CAAyB;UAAzB,oCAAyB;QAAA;MAFT;MAKzB;QACS,iDAAmB;MADJ;MAIxB;QACS,iDAAmB;QAAnB,qCAAmB;MADD;MAI3B;QACS,8CAAsB;MADJ;IAhBL;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,+CAAa;MAAb,gEAAa;MAAC,8BAAU;MAAV,oBAAU;MAAC,4BAAW;MAAX,oBAAW;IAD/C;IAQvB;MAES,8BAA+B;MAC/B;QAAA,eAA0B;QAA1B;UAAA,eAA0B;QAAA;MAAA;MAA1B;QAAA;UAAA,eAA0B;UAA1B;YAAA,eAA0B;UAAA;QAAA;MAAA;IAFX;EAvCR;EAgDlB;IACS,gBAAe;IACf,oBAAmB;IAC1B,iCAAiC;EAHD;EASlC;IACS,iCAAG;IAAC;MAAA,iCAAM;IAAA;IAGjB;MACS,8CAAsB;MAAtB,oCAAsB;MAAC,8BAAW;MAAX,mBAAW;MAClC;QAAA,8CAAyB;QAAzB,oCAAyB;MAAA;IAFV;IAMxB;MACS,6BAAY;MAAZ,kBAAY;IADE;EAVD;EAkBxB;IACS,kBAAQ;IACR,aAAI;IAAC,WAAM;IAAC,sBAAQ;IACpB,gCAAU;IAAC,kCAAc;IAAd,sIAAc;IAAC,wBAAY;IAAZ,mBAAY;IAC7C,2CAA2C;IACpC,iCAAG;IACH,oBAAmB;IAE1B;MACS,gBAAO;MACP;QAAA,kBAAU;MAAA;IAFM;IAKzB;MACS,kBAAO;IADW;IAI3B;MACS,gBAAO;IADW;IAI3B;MACS,oCAAI;IADW;EArBX;EA6Bf;IACS,gBAAe;EADM;EAO9B;IACS,YAAM;IACN,oCAAO;IAAC,cAAQ;EAFM;EAQ/B;IACS,8BAAQ;EADE;EAOnB;IACS,8BAAQ;EADE;EAOnB;IACS,8BAAQ;EADE;EAOnB;IACS,8BAAQ;EADE;EAOnB;IACS,YAAM;IAAC,gBAAU;IAAC,WAAM;EADX;EAOtB;IACS,YAAM;IAAC,gBAAU;IAAC,WAAM;IACxB,gBAAY;IAAC,sBAAW;IAAX,sIAAW;EAFZ;EAQrB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IACnB,uCAAI;IAGX;MACS,uCAAI;IADI;EALJ;EAaf;IACS,sBAAY;IACZ,2BAAS;IAAT,6DAAS;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAe;EAF9B;EAQhB;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAChC,gCAAO;IAAP,iCAAO;IAAC,cAAQ;IAChB,sCAAW;IAAC,yBAAW;IAAX,iBAAW;EAHnB;EASb;IACS,oCAAO;IAAC,OAAM;IACd,yBAAO;IAAP,2DAAO;IAAC,kBAAc;IAAd,iBAAc;IAAC,mBAAU;IACjC,sCAAI;EAHA;EASb;IACS,gBAAe;IACtB,iCAAiC;EAFP;EAQ5B;IACS,mBAAkB;EADE;EAO7B;IACS,aAAI;IAAC,mBAAQ;IAAC,mBAAY;IAAC,yBAAW;IAAC,6BAAK;IAC5C,oCAAI;EAFE;EAQf;IACS,kBAAQ;IAAC,6BAAK;IAAC,+BAAO;EADT;EAOtB;IACS,oCAAI;EADiB;EAI9B;IACS,oCAAI;EADmB;EAIhC;IACS,oCAAI;EADiB;ECzU9B;IACS,6CAA+B;IAAC,gCAAU;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAC7D,2CAA2C;IAC3C,iCAAiC;IAGjC;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,oBAAU;MAG/D;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACE,oBAAoB;IADgB;IAKtC;MACE,cAAc;IAD+C;IAI/D;MACE,cAAc;IAD6C;IAI7D;MACE,aAAa;IAD+C;EAnDvD;EAyDT;IACS,iCAAG;IAAC,wBAAY;IAAZ,mBAAY;EADR;EAKjB;IACS,2CAAW;IAAX,sCAAW;EADF;EAKlB;IACS,qBAAY;IAMnB,uHAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC,iCAAiC;IAGjC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;IAK7B;MAES,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAvBR;ECnElB;IACS,8BAAQ;IAAC,6CAA+B;IAAC,gCAAU;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC,qBAAS;IAChF,0CAA0C;IAC1C,iCAAiC;IAGjC;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,oBAAU;MAG/D;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACS,qBAAgB;MAAhB;QAAA,2DAAgB;MAAA;MACvB,oBAAoB;IAFQ;IAM9B;MACE,cAAc;IADuC;IAIvD;MACE,cAAc;IADqC;IAIrD;MACE,aAAa;IADuC;EApD/C;EA0DT;IACS,qBAAY;IAMnB,uHAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAEpC;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;IADM;EAdb;EC5DlB;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;IAIpB;MACS,mCAAO;MAAC,OAAM;MAGrB;QACS,uCAAI;MADgB;MAK7B;QAES,wHAAoB;QAApB,sIAAoB;QAApB,6BAAoB;QAApB,4GAAoB;QAApB,wBAAoB;QAApB,mBAAoB;QAApB,2BAAoB;QAC3B,6CAA6C;QAC7C,0CAA0C;MAH9B;MAOd;QAGS,gCAAe;QAAf,8BAAe;QAAf,oBAAe;MADA;IAnBN;EAdX;EAuCX;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,mBAAY;EAD1B;EAIxB;IACS,kBAAQ;IAAC,uBAAO;IAAC,+BAAO;IAAC,aAAI;IAAC,YAAM;IAAC,cAAQ;IAAC,+CAAgB;IAAhB,sDAAgB;IAAC,eAAc;IAAC,mBAAY;IAAC,uBAAc;IAAC,uCAAI;IAAC,6CAAsB;IAAC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAAC,wCAAY;IAG1K,uBAAW;IAAX,kBAAW;IAAC,6BAAc;IAAC,wBAAY;IAAZ,mBAAY;IAG9C;MACE;QAES,iDAAqB;MADP;IAFH;IAQtB;MAES,sBAAO;MAAC,wHAAM;MAAN,sIAAM;MAAC,6BAAU;MAAC,2BAAa;MAAb,4GAAa;MAAC,yCAAsB;MAAC,wBAAY;MAAZ,mBAAY;IADvD;IAK7B;MACS,YAAU;IADI;IAKvB;MAGS,mBAAkB;MAAC,YAAU;IADd;IAIxB;MACS,+BAAM;MAAN,gCAAM;MAAC,wDAAoB;MAApB,qFAAoB;MAApB,2EAAoB;MAAC,oBAAY;MAAZ,0BAAY;MAAC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IADlC;IAK7C;MACS,cAAU;IAD8C;EArC/C;EA2CpB;IACS,+BAAuB;IAAC,6CAA+B;IAAC,8CAAW;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IACpI,2CAA2C;IAC3C,iCAAiC;IAGjC;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAG/D;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACE,oBAAoB;IADgB;IAKtC;MACE,cAAc;IAD+C;IAI/D;MACE,cAAc;IAD6C;IAI7D;MACE,aAAa;IAD+C;IAK9D;MACS,mCAAK;MAAC,wBAAY;MAAZ,mBAAY;IADJ;IAIvB;MACS,0CAAM;MAGb;QACS,yBAAe;MADyB;IAJvB;EAlEV;EA6EpB;IACS,WAAM;EADQ;EAIvB;IACS,WAAM;EADqB;ECvKpC;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAE1B;MAEE;QACS,aAAM;MADW;IADL;IAMvB;MACS,kBAAK;IADM;EAVd;EAeR;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,oCAAO;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAMpK,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAEjC,uCAAuC;IACvC,uCAAuC;IAGvC;MACS,uCAAI;IADa;IAK1B;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFxB;IAFH;IAStB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;MACrB,6CAA6C;MAC7C,0CAA0C;IAHf;IAY7B;MAES,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFb;IAM/B;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAxDT;EAkEjB;IACS,sBAAW;IAAX,sIAAW;IAClB,0CAA0C;IAE1C,yCAAyC;IACzC,qDAAqD;IACrD,+CAA+C;IAE/C;MACE;QAEE,gDAAgD;MAD3B;IAFH;IAOtB;MAEE,gDAAgD;IADrB;EAhBK;EAyBpC;IACS,OAAM;IAAC,gBAAS;IAAC,2BAAS;IAAT,6DAAS;IAAC,yBAAe;IAAC,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAEzE;MACS,6CAAsB;IADJ;IAK3B;MACS,aAAM;IADuB;EARzB;EAaf;IACS,kBAAQ;IAAC,qCAAS;IAAC,+BAAO;IAAC,kBAAO;IAAC,aAAI;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,6CAAsB;IAAC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAElI;MACS,cAAU;IADC;IAIpB;MACS,+BAAM;MAAN,gCAAM;IADyB;EAPvB;EAanB;IACS,+BAAuB;IAAC,6CAA+B;IAAC,8CAAW;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IACpI,2CAA2C;IAC3C,iCAAiC;IAGjC;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAG/D;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,eAAW;MAAX,gCAAW;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD3C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACE,oBAAoB;IADgB;IAKtC;MACE,cAAc;IAD+C;IAI/D;MACE,cAAc;IAD6C;IAI7D;MACE,aAAa;IAD+C;IAK9D;MACS,mCAAK;MAAC,wBAAY;MAAZ,mBAAY;IADJ;IAIvB;MACS,0CAAM;IADa;IAK5B;MAIS,yBAAe;IAD2B;EA1EpC;EAgFjB;IACS,WAAM;EADK;EAIpB;IACS,WAAM;EADc;ECxN7B;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;EADd;EAId;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,oCAAO;IAAC,6DAAa;IAAC,oCAAM;IAAN,iBAAM;IAAC,yDAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,iDAAqB;IAAC,gCAAY;IAAZ,sIAAY;IAAC,wBAAY;IAAZ,mBAAY;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAMpK,8HAGkC;IAC3B;MAAA,yBAA6B;MAA7B;QAAA,yBAA6B;MAAA;IAAA;IAA7B;MAAA;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;IAAA;IAGpC,iCAAiC;IAEjC,uCAAuC;IACvC,uCAAuC;IAGvC;MACS,uCAAI;IADmB;IAKhC;MACE;QAES,yDAAc;QAAd;UAAA;;;;GAAc;QAAA;QACrB,6CAA6C;MAFqB;IAFhD;IAStB;MAES,wHAAc;MAAd,sIAAc;MAAd,6BAAc;MAAd,2BAAc;MAAd,4GAAc;MAAd,yCAAc;MAAd,wBAAc;MAAd,mBAAc;MAAd,gDAAc;MACrB,6CAA6C;MAC7C,0CAA0C;IAHf;IAY7B;MAES,sCAAoB;MAApB,kBAAoB;MAApB,4BAAoB;MAApB,yBAAoB;MAApB,oBAAoB;MAApB,2BAAoB;MAApB;QAAA,wHAAoB;QAApB,sIAAoB;QAApB,8BAAoB;QAApB,4GAAoB;QAApB,2BAAoB;MAAA;MAC3B,0CAA0C;IAFP;IAMrC;MAGS,gCAAe;MAAf,8BAAe;MAAf,oBAAe;IADA;EAxDH;EAkEvB;IACS,sBAAW;IAAX,sIAAW;IAClB,gDAAgD;IAEhD,+CAA+C;IAC/C,2DAA2D;IAC3D,qDAAqD;IAGrD;MACE;QAEE,sDAAsD;MADY;IAFhD;IAOtB;MAEE,sDAAsD;IAD3B;EAjBiB;EA0BhD;IACS,OAAM;IAAC,gBAAS;IAAC,2BAAS;IAAT,6DAAS;IAAC,yBAAe;IAAC,mBAAY;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAEzE;MACS,6CAAsB;IADJ;IAK3B;MACS,aAAM;IADuB;EARnB;EAarB;IACS,kBAAQ;IAAC,qCAAS;IAAC,+BAAO;IAAC,kBAAO;IAAC,aAAI;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,6CAAsB;IAAC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC,oBAAY;IAAZ,0BAAY;IAGlI,iCAAiC;IAEjC;MACS,cAAU;IADC;IAIpB;MACS,+BAAM;MAAN,gCAAM;IAD+B;EAVvB;EAgBzB;IACS,+BAAuB;IAAC,6CAA+B;IAAC,8CAAW;IAAC,gBAAe;IAAC,4BAAkB;IAAC,gCAAU;IAAC,iCAAG;IAAC,qCAAI;IAAC,yBAAO;IAAP,2DAAO;IACzI,2CAA2C;IAC3C,iCAAiC;IAGjC;MAES,wBAAY;MAAZ,mBAAY;IADQ;IAK7B;MACS,+NAAU;MAAC,oBAAY;MAAZ,0BAAY;MAAC,yCAAc;MAAd,0DAAc;MAAC,+BAAS;MAAT,qBAAS;MAAC,6BAAU;MAAV,qBAAU;MAGlE;QACS,8CAAsB;MADP;MAIxB;QACS,iDAAmB;MADD;MAI3B;QACS,8CAAqB;MADL;MAIzB;QACS,iDAAoB;MADH;IAhBJ;IAsBxB;MACS,8NAAW;MAAC,oBAAY;MAAZ,0BAAY;MAAC,+CAAa;MAAb,gEAAa;MAAC,4BAAW;MAAX,oBAAW;MAAC,oBAAQ;IAD7C;IAIvB;MAES,8BAA+B;IADhB;IAKxB;MACE,oBAAoB;IADgB;IAKtC;MACE,cAAc;IAD+C;IAI/D;MACE,cAAc;IAD6C;IAI7D;MACE,aAAa;IAD+C;IAK9D;MACS,mCAAK;MAAC,wBAAY;MAAZ,mBAAY;IADJ;IAIvB;MACS,0CAAM;IADa;IAK5B;MAIS,yBAAe;IAD2B;IAKnD;MACS,wCAAI;MAAC,uCAAI;MAAC,wBAAY;MAAZ,mBAAY;IADJ;IAK3B;MACS,kBAAW;MAAC,yBAAO;MAAP,2DAAO;MAAC,gCAA0B;MAA1B;QAAA,sEAA0B;MAAA;IAD7B;EApFL;EA0FvB;IACS,WAAM;EADW;EAI1B;IACS,WAAM;EADoB;EAKnC;IACS,kBAAQ;IAAC,kBAAO;IAAC,oBAAW;IAAC,gCAAG;IAAC,+BAAG;IAAU,wBAAa;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAU;IAAC,iCAAG;IAAC,mBAAU;IAAC,yBAAW;IAAX,iBAAW;IAAC,wCAAY;IAC1I,sCAAI;IAAC,+BAAM;IAAN,gCAAM;IAAC,cAAQ;IAAC,kBAAW;IAAC,6BAAc;IAGtD,iCAAiC;IAE1B,wHAAa;IAGpB;MACE,4CAA4C;MACrC;QAAA,yBAA6B;QAA7B;UAAA,yBAA6B;QAAA;MAAA;MAA7B;QAAA;UAAA,yBAA6B;UAA7B;YAAA,yBAA6B;UAAA;QAAA;MAAA;IAFX;IAK3B;MACS,oBAAmB;MAAC,WAAS;IADjB;IAIrB;MACS,iCAAQ;MAAR,kCAAQ;IAD4B;IAQ7C;MACE;QAES,gCAAgB;QAAhB;UAAA,uFAAgB;QAAA;MADF;IAFH;IAOtB;MAEE,sBAAsB;IADD;EAnCG;EChO5B;IACS,oBAAW;IAAC,gCAAG;IAAC,mBAAY;IAAC;MAAA,uBAAW;MAAX,iFAAW;MAAX,yFAAW;IAAA;IAAC,sCAAU;IAAC,gCAAU;IAAC,wCAAI;IAAC,kBAAW;IAAC,6BAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,mBAAiB;IAAC,mBAAU;IAAC;MAAA;QAAA,uBAAmB;MAAA;IAAA;IACrK,sBAAsB;EAFnB;EAML;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qBAAqB;EANZ;EAUX;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EAHP;EAOd;IACS,6BAAc;EADX;ECxBZ;IACS,wBAAe;EADlB;EAIN;IACS,wBAAe;EADZ;EAIZ;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EAD/B;EAIf;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EAD/B;EAIf;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EAD/B;EAIf;IACS,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EAD9B;EAIf;IACS,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EAD9B;EAIf;IACS,2BAAS;IAAT,6DAAS;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADhC;EAIf;IACS,2BAAS;IAAT,6DAAS;IAAC,sCAAS;IAAT,qCAAS;EADd;EAId;IACS,yCAAU;IAAC,gCAAU;IAAC,0CAAM;IAAC,yCAAM;IAAC,6BAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,wBAAe;EAD7D;EAIjB;IACS,2CAAW;IAAX,sCAAW;IAAC,kBAAS;IAAC,+BAAS;IAAC,0BAAkB;EAD7C;EAId;IACS,oCAAI;IAAC,yCAAU;IAAV,sBAAU;IAAC,2BAAa;IAAC,sCAAI;IAAQ,mBAAU;IAAjB,kBAAM;EAD3B;EAIvB;IACS,sCAAI;IAAC,qBAAS;IAAC;MAAA,uBAAS;MAAT,8EAAS;MAAT,sFAAS;IAAA;IAAC,sCAAI;EADvB;EAIf;IACS,sCAAI;IAAC,wBAAY;IAAC;MAAA,uBAAS;MAAT,8EAAS;MAAT,sFAAS;IAAA;IAAC,sCAAI;EAD1B;EAIf;IACS,2BAAS;IAAT,6DAAS;IAAC,sCAAS;IAAT,qCAAS;EADb;EAIf;IACS,sCAAI;IAAC,8BAAgB;EADf;EAIf;IACS,sCAAI;IAAC,gBAAe;IAAC,wCAAU;IAAC,gCAAU;IAAC,iCAAG;IAAC,6BAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,oCAAe;IAAf,mCAAe;EADzE;EAIhB;IACS,6CAAa;IAAb,wCAAa;IAAC,wBAAe;EADnB;EAInB;IACS,kBAAM;EADA;EAIf;IACS,sCAAI;IAAC,wCAAU;EADR;EAIhB;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADpC;EAIV;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADpC;EAIV;IACS,0BAAQ;IAAR,4DAAQ;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADpC;EAIV;IACS,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADnC;EAIV;IACS,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADnC;EAIV;IACS,2BAAS;IAAT,6DAAS;IAAC,6CAAa;IAAb,wCAAa;IAAC,oCAAc;IAAd,qCAAc;EADrC;EAIV;IACS,2BAAS;IAAT,6DAAS;IAAC,sCAAS;IAAT,qCAAS;EADhB;EAIZ;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;EADX;EAIf;IACS,yBAAO;IAAP,2DAAO;IAAC,sCAAS;IAAT,qCAAS;EADX;EAIf;IACS,yCAAU;IAAC,gCAAU;IAAC,0CAAM;IAAC,yCAAM;IAAC,6BAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,wBAAe;EADlE;EAIZ;IACS,gBAAS;IAAC;MAAA,iBAAc;IAAA;EADd;EAInB;IACS,kBAAW;EADA;EAIpB;IACS,iBAAU;IAAC;MAAA,gBAAa;IAAA;EADhB;EAIjB;IACS,mBAAY;EADA;EAIrB;IACS,wBAAe;EADH;EAIrB;IACS,mBAAU;EADA;EAInB;IACS,cAAK;IAAC,gBAAQ;IAAR,uBAAQ;IAAR,mBAAQ;EADP;EAIhB;IACS,2CAAW;IAAX,sCAAW;EADC;EAIrB;IACS,2CAAW;IAAX,sCAAW;EADC;EAIrB;IACS,6CAAa;IAAb,wCAAa;EADC;EAIvB;IACS,yCAAS;IAAT,oCAAS;EADC;EC/JnB;IACS,kBAAQ;IACf,0BAA0B;EAFb;EAMf;IACS,gBAAe;EADC;EAKzB;IACS,gBAAe;EADG;EAK3B;IACE;MACE,wFAAwF;MAExF,0DAA0D;MAC1D,kEAAkE;IAJ1C;IAO1B;MACE,0FAA0F;MAE1F,0DAA0D;MAC1D,kEAAkE;IAJvC;IAO7B;MACE;8DAE0D;MAE1D,0DAA0D;MAC1D,kEAAkE;IANnC;EAfU;EA0B7C;IACE;MACE,0FAA0F;MAE1F,0DAA0D;MAC1D,kEAAkE;IAJzC;IAO3B;MACE,yFAAyF;MAEzF,0DAA0D;MAC1D,kEAAkE;IAJxC;IAO5B;MACE;8DAE0D;MAE1D,0DAA0D;MAC1D,kEAAkE;IANnC;EAfY;EA0B/C;IACE,qBAAqB;IACrB,wBAAwB;IAExB;MACS,aAAM;IADM;EAJQ;ArFzDmB;AAGlD;EsFXA;ICJA;MAEE;QAKE,mBAAmB;QAKnB,wBAAwB;QACxB,sBAAsB;QACtB,yBAAyB;QACzB,sCAAsC;QAGtC,kBAAkB;QAGlB,mBAAmB;QACnB,yBAAyB;QACzB,uBAAuB;QAGvB,wBAAwB;QAGxB,6BAA6B;QAC7B,8BAA8B;QAG9B,gBAAgB;QAChB,yCAAyC;QAKzC,+BAA+B;QAC/B,4BAA4B;QAG5B,uBAAuB;QACvB,uCAAuC;QAEvC,gDAAgD;QAChD,iDAAiD;QAEjD,+CAA+C;QAC/C,gDAAgD;QAGhD,uBAAuB;QACvB,uCAAuC;QAEvC,oCAAoC;QAEpC,uCAAuC;QAEvC,mCAAmC;QACnC,oCAAoC;QAEpC,oCAAoC;QACpC,gCAAgC;QAGhC,gCAAgC;QAChC,+CAA+C;QAC/C,iCAAiC;QACjC,2BAA2B;QAG3B,sCAAsC;QACtC,oCAAoC;QAEpC,qCAAqC;QACrC,oCAAoC;QAEpC,oCAAoC;QACpC,gCAAgC;QAGhC,uBAAuB;QACvB,oCAAoC;QAGpC,iCAAiC;QACjC,oCAAoC;QACpC,sBAAsB;QACtB,yBAAyB;QAGzB,8BAA8B;QAI9B;mCAE+B;QAE/B;uCAEmC;QACnC;mCAE+B;QAE/B,6BAA6B;MAtGR;MAyGvB;QAEE,kBAAkB;QAIlB,sCAAsC;QACtC,yBAAyB;QAGzB,sCAAsC;QACtC,uCAAuC;QAEvC,+CAA+C;QAC/C,+CAA+C;QAG/C,sCAAsC;QACtC,uCAAuC;QAEvC,mCAAmC;QAEnC,uCAAuC;QAEvC,qCAAqC;QACrC,iCAAiC;QAGjC,+CAA+C;QAC/C,qCAAqC;QAGrC,qCAAqC;QACrC,oCAAoC;QAEpC,mCAAmC;QACnC,gCAAgC;QAGhC,oCAAoC;QACpC,uCAAuC;QAGvC,kCAAkC;QAClC,qCAAqC;QACrC,sBAAsB;QACtB,yBAAyB;QAGzB,8BAA8B;QAG9B,2CAA2C;QAC3C,0DAA0D;QAC1D,yCAAyC;MArDvB;IAhHV;EDI0B;EAGtC,iBAAkD;AtFQD;AFNjD;EACE;IACE,yBAA0B;IAC1B,2BAA4B;IAC5B,yBAA0B;IAC1B,4BAA6B;IAC7B,0BAA2B;IAC3B,mBAAoB;IACpB,wBAAyB;IACzB,wBAAyB;IACzB,+BAAgC;IAChC,8BAA+B;IAC/B,qBAAsB;IACtB,2BAA4B;IAC5B,uBAAwB;IACxB,8BAA+B;IAC/B,0CAA2C;IAC3C,uBAAwB;IACxB,gDAAiD;IACjD,wCAAyC;IACzC,8CAA+C;IAC/C,4CAA0F;IAA1F;MAAA,yFAA0F;IAAA;IAC1F,4CAA0F;IAA1F;MAAA,yFAA0F;IAAA;IAC1F,yCAA+E;IAA/E;MAAA,8EAA+E;IAAA;IAC/E,kDAAmD;IACnD,yDAA0D;IAC1D,wBAAyB;IACzB,0BAA2B;IAC3B,4BAA6B;IAC7B,uBAAwB;IACxB,wBAAyB;IACzB,wBAAyB;IAQzB,+BAAgC;IAChC,yBAA0B;IAC1B,6BAA8B;IAC9B,yBAA0B;IAC1B,qCAAsC;IACtC,uCAAwC;EACzC;EAED;;IAEE,kBAAmB;IACnB,wBAAyB;IACzB,wBAAyB;IACzB,+BAAgC;IAChC,8BAA+B;IAC/B,qBAAsB;IACtB,2BAA4B;IAC5B,uBAAwB;IACxB,8BAA+B;IAC/B,0BAA2B;IAC3B,uBAAwB;IACxB,gDAAiD;IACjD,wCAA8E;IAA9E;MAAA,6EAA8E;IAAA;IAC9E,8CAAoF;IAApF;MAAA,mFAAoF;IAAA;IACpF,4CAA2F;IAA3F;MAAA,0FAA2F;IAAA;IAC3F,4CAA0F;IAA1F;MAAA,yFAA0F;IAAA;IAC1F,yCAA+E;IAA/E;MAAA,8EAA+E;IAAA;IAC/E,+CAAgD;IAChD,sDAAuD;IACvD,wBAAyB;IACzB,0BAA2B;IAC3B,4BAA6B;IAC7B,uBAAwB;IACxB,wBAAyB;IACzB,wBAAyB;EAC1B;EAED;IACE;MACE,kBAAmB;MACnB,wBAAyB;MACzB,wBAAyB;MACzB,+BAAgC;MAChC,8BAA+B;MAC/B,qBAAsB;MACtB,2BAA4B;MAC5B,uBAAwB;MACxB,8BAA+B;MAC/B,0BAA2B;MAC3B,uBAAwB;MACxB,gDAAiD;MACjD,wCAA8E;MAA9E;QAAA,6EAA8E;MAAA;MAC9E,8CAAoF;MAApF;QAAA,mFAAoF;MAAA;MACpF,4CAA2F;MAA3F;QAAA,0FAA2F;MAAA;MAC3F,4CAA0F;MAA1F;QAAA,yFAA0F;MAAA;MAC1F,yCAA+E;MAA/E;QAAA,8EAA+E;MAAA;MAC/E,+CAAgD;MAChD,sDAAuD;MACvD,wBAAyB;MACzB,0BAA2B;MAC3B,4BAA6B;MAC7B,uBAAwB;MACxB,wBAAyB;MACzB,wBAAyB;IAC1B;EACF;EAED;IACE,6BAA8B;IAC9B,eAAgB;IAChB,gBAAiB;EAClB;EAED;IACS,mCAAW;IAAX,kCAAW;IAClB,gCAAiC;IACjC,wBAAyB;IACzB,6BAA8B;EAC/B;EAED;;;;IAIE,aAAc;EACf;EAED;IACE,4BAA6B;EAC9B;AACF;AAED;EACE;IACS,mBAAO;IAAC,WAAM;IAAC,wCAAI;IAAC,uCAAI;IAAC;MAAA,wCAAO;IAAA;IACvC,kCAAmC;EACpC;EAED;IACS,sCAAW;IAAC,oCAAM;IAAN,iBAAM;IAAC,0HAAS;IAAT,sIAAS;IACnC,gCAAiC;IACjC,iCAAkC;EACnC;AACF;ADuxBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AU/5BZ;EAAA,WAAY;EAAZ,iBAAY;EAAZ,eAAY;AAAA;ACYD;EAAA,WAAY;EAAZ,eAAY;AAAA;AYoCG;EAAA,WAAW;EAAX,eAAW;AAAA;AIqBjC;EAAA,WAAS;EAAT,eAAS;EAAT,gBAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;EAAT,gBAAS;AAAA;AAAT;EAAA,WAAS;EAAT,eAAS;EAAT,gBAAS;AAAA;AOnCS;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AUwEX;EAAA,kBAAgB;EAAhB,eAAgB;EAAhB,gBAAgB;AAAA;AAAhB;EAAA,kBAAgB;EAAhB,eAAgB;EAAhB,gBAAgB;AAAA;AGhH8B;EAAA,WAAgB;EAAhB,eAAgB;AAAA;AAAhB;EAAA,iBAAgB;EAAhB,eAAgB;EAAhB,oBAAgB;AAAA;AAAhB;EAAA,iBAAgB;EAAhB,eAAgB;EAAhB,oBAAgB;AAAA;AAAhB;EAAA,iBAAgB;EAAhB,eAAgB;EAAhB,oBAAgB;AAAA;AAAhB;EAAA,WAAgB;EAAhB,eAAgB;AAAA;AAAhB;EAAA,WAAgB;EAAhB,eAAgB;AAAA;AAAhB;EAAA,6BAAgB;EAAhB,eAAgB;EAAhB,iBAAgB;AAAA;AAAhB;EAAA,6BAAgB;EAAhB,eAAgB;EAAhB,kBAAgB;AAAA;AAAhB;EAAA,6BAAgB;EAAhB,eAAgB;EAAhB,mBAAgB;AAAA;AuCPxD;EAAA,WAAW;EAAX,eAAW;EAAX,gBAAW;AAAA;AtFic7C;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AAdjB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AIjdixF;EAAmB;IAAO,kCAAkC;IAAE,qMAAqM;IAAE,oCAAoC;EAAjR;AAAP;AAA4R;EAAkB;IAAK,iCAAiC;IAAE,+LAA+L;IAAE,mCAAmC;EAAzQ;AAAL;AAAkvE;EAAyB;IAAc,UAAU;EAAZ;EAAe;IAAU,UAAU;EAAZ;AAArC;AF2L12K;EACE;IACE,2BAA2B;EADxB;AADa;AAMpB;EACE;IAGE,UAAU;EADP;EAGL;IAEE,UAAU;EADR;AAPiB;AF6uBvB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MI96BrB,wBAA8B;MAA4C,gCAAkC;MAAgD,gCAAiC;MAA2B,8BAAkC;MAA8C,iCAAwC;MAA2C,kBAAyB;MAA2C,qBAA4B;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,yBAAgC;MAA2C,yBAAgC;MAA2C,iBAAwB;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,kBAAyB;MAA2C,wBAA+B;MAA2C,wBAA+B;MMezpC,gBAAY;MCYD,sBAAY;MYoCG,kBAAW;MIqBjC,eAAS;MAAT,eAAS;MAAT,eAAS;MOnCS,qBAAY;MAAZ,0BAAY;MAAZ,4BAAY;MAAZ,6BAAY;MAAZ,8BAAY;MUwEX,wBAAgB;MAAhB,wBAAgB;MGhH8B,+BAAgB;MAAhB,yBAAgB;MAAhB,wBAAgB;MAAhB,uBAAgB;MAAhB,4BAAgB;MAAhB,gCAAgB;MAAhB,+BAAgB;MAAhB,+BAAgB;MAAhB,+BAAgB;MuCPxD,uBAAW;ItF46B5B;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n@import \"@heroui/styles/css\";\n\n@source \"../**/*.{js,jsx}\";\n\n@theme {\n  --font-sans: \"Aptos\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\n@layer base {\n  :root {\n    --tenant-primary: #463634;\n    --tenant-secondary: #ece9e2;\n    --tenant-surface: #ffffff;\n    --tenant-foreground: #18181b;\n    --tenant-max-width: 1200px;\n    color-scheme: light;\n    --owner-page-bg: #fafafa;\n    --owner-surface: #ffffff;\n    --owner-surface-raised: #ffffff;\n    --owner-surface-muted: #f4f4f5;\n    --owner-text: #18181b;\n    --owner-text-muted: #52525b;\n    --owner-border: #e4e4e7;\n    --owner-border-strong: #d4d4d8;\n    --owner-header-bg: var(--tenant-secondary);\n    --owner-nav-bg: #17191b;\n    --owner-nav-active-bg: rgba(255, 255, 255, 0.09);\n    --owner-subnav-bg: var(--tenant-primary);\n    --owner-accent-readable: var(--tenant-primary);\n    --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 9%, var(--owner-surface));\n    --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 34%, var(--owner-border));\n    --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 22%, transparent);\n    --owner-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);\n    --owner-shadow-strong: 0 24px 60px rgba(15, 23, 42, 0.16);\n    --owner-info-bg: #eff6ff;\n    --owner-info-text: #1e40af;\n    --owner-info-border: #bfdbfe;\n    --owner-danger: #dc2626;\n    --owner-success: #16a34a;\n    --owner-warning: #ea580c;\n\n    /* Bridge HeroUI's own generic color tokens onto the tenant/owner design\n       tokens - without this, vendor/heroui's Button variants (primary/\n       secondary/danger) fall back to HeroUI's stock palette instead of\n       following the tenant brand color or the app's own danger/surface\n       tones. References (not literals), so they track the light/dark\n       overrides of --owner-danger/--owner-surface-muted/--owner-text below. */\n    --accent: var(--tenant-primary);\n    --accent-foreground: #fff;\n    --danger: var(--owner-danger);\n    --danger-foreground: #fff;\n    --default: var(--owner-surface-muted);\n    --default-foreground: var(--owner-text);\n  }\n\n  :root.dark,\n  :root[data-theme=\"dark\"] {\n    color-scheme: dark;\n    --owner-page-bg: #111113;\n    --owner-surface: #18181b;\n    --owner-surface-raised: #202024;\n    --owner-surface-muted: #27272a;\n    --owner-text: #f4f4f5;\n    --owner-text-muted: #a1a1aa;\n    --owner-border: #3f3f46;\n    --owner-border-strong: #52525b;\n    --owner-header-bg: #1b1817;\n    --owner-nav-bg: #09090b;\n    --owner-nav-active-bg: rgba(255, 255, 255, 0.13);\n    --owner-subnav-bg: color-mix(in srgb, var(--tenant-primary) 70%, #09090b 30%);\n    --owner-accent-readable: color-mix(in srgb, var(--tenant-primary) 42%, #ffffff 58%);\n    --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 14%, var(--owner-surface));\n    --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 44%, var(--owner-border));\n    --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 42%, transparent);\n    --owner-shadow: 0 16px 40px rgba(0, 0, 0, 0.34);\n    --owner-shadow-strong: 0 28px 70px rgba(0, 0, 0, 0.48);\n    --owner-info-bg: #172033;\n    --owner-info-text: #bfdbfe;\n    --owner-info-border: #31527e;\n    --owner-danger: #f87171;\n    --owner-success: #4ade80;\n    --owner-warning: #fb923c;\n  }\n\n  @media (prefers-color-scheme: dark) {\n    :root:not(.light):not([data-theme=\"light\"]) {\n      color-scheme: dark;\n      --owner-page-bg: #111113;\n      --owner-surface: #18181b;\n      --owner-surface-raised: #202024;\n      --owner-surface-muted: #27272a;\n      --owner-text: #f4f4f5;\n      --owner-text-muted: #a1a1aa;\n      --owner-border: #3f3f46;\n      --owner-border-strong: #52525b;\n      --owner-header-bg: #1b1817;\n      --owner-nav-bg: #09090b;\n      --owner-nav-active-bg: rgba(255, 255, 255, 0.13);\n      --owner-subnav-bg: color-mix(in srgb, var(--tenant-primary) 70%, #09090b 30%);\n      --owner-accent-readable: color-mix(in srgb, var(--tenant-primary) 42%, #ffffff 58%);\n      --owner-accent-subtle: color-mix(in srgb, var(--tenant-primary) 14%, var(--owner-surface));\n      --owner-accent-border: color-mix(in srgb, var(--tenant-primary) 44%, var(--owner-border));\n      --owner-focus-ring: color-mix(in srgb, var(--tenant-primary) 42%, transparent);\n      --owner-shadow: 0 16px 40px rgba(0, 0, 0, 0.34);\n      --owner-shadow-strong: 0 28px 70px rgba(0, 0, 0, 0.48);\n      --owner-info-bg: #172033;\n      --owner-info-text: #bfdbfe;\n      --owner-info-border: #31527e;\n      --owner-danger: #f87171;\n      --owner-success: #4ade80;\n      --owner-warning: #fb923c;\n    }\n  }\n\n  html {\n    font-family: var(--font-sans);\n    font-size: 16px;\n    line-height: 1.5;\n  }\n\n  body {\n    @apply antialiased;\n    background: var(--owner-page-bg);\n    color: var(--owner-text);\n    font-family: var(--font-sans);\n  }\n\n  button,\n  input,\n  select,\n  textarea {\n    font: inherit;\n  }\n\n  a {\n    color: var(--tenant-primary);\n  }\n}\n\n@layer components {\n  .owner-page {\n    @apply mx-auto w-full px-4 py-8 sm:px-6;\n    max-width: var(--tenant-max-width);\n  }\n\n  .owner-card {\n    @apply rounded-2xl border shadow-sm;\n    background: var(--owner-surface);\n    border-color: var(--owner-border);\n  }\n}\n","@theme inline {\n  --color-background: var(--background);\n  --color-foreground: var(--foreground);\n\n  --color-surface: var(--surface);\n  --color-surface-foreground: var(--surface-foreground);\n  --color-surface-hover: color-mix(in oklab, var(--surface) 92%, var(--surface-foreground) 8%);\n\n  --color-surface-secondary: var(--surface-secondary);\n  --color-surface-secondary-foreground: var(--surface-secondary-foreground);\n\n  --color-surface-tertiary: var(--surface-tertiary);\n  --color-surface-tertiary-foreground: var(--surface-tertiary-foreground);\n\n  --color-overlay: var(--overlay);\n  --color-overlay-foreground: var(--overlay-foreground);\n\n  --color-muted: var(--muted);\n\n  --color-accent: var(--accent);\n  --color-accent-foreground: var(--accent-foreground);\n\n  --color-segment: var(--segment);\n  --color-segment-foreground: var(--segment-foreground);\n\n  --color-border: var(--border);\n  --color-separator: var(--separator);\n  --color-focus: var(--focus);\n  --color-link: var(--link);\n\n  --color-default: var(--default);\n  --color-default-foreground: var(--default-foreground);\n\n  --color-success: var(--success);\n  --color-success-foreground: var(--success-foreground);\n\n  --color-warning: var(--warning);\n  --color-warning-foreground: var(--warning-foreground);\n\n  --color-danger: var(--danger);\n  --color-danger-foreground: var(--danger-foreground);\n\n  --color-backdrop: var(--backdrop);\n\n  --shadow-surface: var(--surface-shadow);\n  --shadow-overlay: var(--overlay-shadow);\n  --shadow-field: var(--field-shadow);\n\n  /* Form Field Tokens */\n  --color-field: var(--field-background, var(--default));\n  --color-field-hover: color-mix(\n    in oklab,\n    var(--field-background, var(--default)) 90%,\n    var(--field-foreground, var(--default-foreground)) 10%\n  );\n  --color-field-foreground: var(--field-foreground, var(--foreground));\n  --color-field-placeholder: var(--field-placeholder, var(--muted));\n  --color-field-border: var(--field-border, var(--border));\n  --radius-field: var(--field-radius, calc(var(--radius) * 1.5));\n  --border-width-field: var(--field-border-width, var(--border-width));\n\n  /* Calculated Variables */\n\n  /* Colors */\n\n  /* --- background shades --- */\n  --color-background-secondary: color-mix(in oklab, var(--background) 96%, var(--foreground) 4%);\n  --color-background-tertiary: color-mix(in oklab, var(--background) 92%, var(--foreground) 8%);\n  --color-background-inverse: var(--foreground);\n\n  /* ------------------------- */\n  --color-default-hover: color-mix(in oklab, var(--default) 96%, var(--default-foreground) 4%);\n  --color-accent-hover: color-mix(in oklab, var(--accent) 90%, var(--accent-foreground) 10%);\n  --color-success-hover: color-mix(in oklab, var(--success) 90%, var(--success-foreground) 10%);\n  --color-warning-hover: color-mix(in oklab, var(--warning) 90%, var(--warning-foreground) 10%);\n  --color-danger-hover: color-mix(in oklab, var(--danger) 90%, var(--danger-foreground) 10%);\n\n  /* Form Field Colors */\n  --color-field-hover: color-mix(\n    in oklab,\n    var(--field-background, var(--default)) 90%,\n    var(--field-foreground, var(--foreground)) 2%\n  );\n  --color-field-focus: var(--field-background, var(--default));\n  --color-field-border-hover: color-mix(\n    in oklab,\n    var(--field-border, var(--border)) 88%,\n    var(--field-foreground, var(--foreground)) 10%\n  );\n  --color-field-border-focus: color-mix(\n    in oklab,\n    var(--field-border, var(--border)) 74%,\n    var(--field-foreground, var(--foreground)) 22%\n  );\n\n  /* Soft Colors */\n  --color-accent-soft: var(--accent-soft, color-mix(in oklab, var(--accent) 15%, transparent));\n  --color-accent-soft-foreground: var(--accent-soft-foreground, var(--accent));\n  --color-accent-soft-hover: var(\n    --accent-soft-hover,\n    color-mix(in oklab, var(--accent) 20%, transparent)\n  );\n\n  --color-danger-soft: var(--danger-soft, color-mix(in oklab, var(--danger) 15%, transparent));\n  --color-danger-soft-foreground: var(--danger-soft-foreground, var(--danger));\n  --color-danger-soft-hover: var(\n    --danger-soft-hover,\n    color-mix(in oklab, var(--danger) 20%, transparent)\n  );\n\n  --color-warning-soft: var(--warning-soft, color-mix(in oklab, var(--warning) 15%, transparent));\n  --color-warning-soft-foreground: var(--warning-soft-foreground, var(--warning));\n  --color-warning-soft-hover: var(\n    --warning-soft-hover,\n    color-mix(in oklab, var(--warning) 20%, transparent)\n  );\n\n  --color-success-soft: var(--success-soft, color-mix(in oklab, var(--success) 15%, transparent));\n  --color-success-soft-foreground: var(--success-soft-foreground, var(--success));\n  --color-success-soft-hover: var(\n    --success-soft-hover,\n    color-mix(in oklab, var(--success) 20%, transparent)\n  );\n\n  /* Separator Colors - Levels */\n  --color-separator-secondary: color-mix(\n    in oklab,\n    var(--surface) 85%,\n    var(--surface-foreground) 15%\n  );\n  --color-separator-tertiary: color-mix(\n    in oklab,\n    var(--surface) 81%,\n    var(--surface-foreground) 19%\n  );\n\n  /* Border Colors - Levels (progressive contrast: default → secondary → tertiary) */\n  /* Light mode: lighter → darker | Dark mode: darker → lighter */\n  --color-border-secondary: color-mix(in oklab, var(--surface) 78%, var(--surface-foreground) 22%);\n  --color-border-tertiary: color-mix(in oklab, var(--surface) 66%, var(--surface-foreground) 34%);\n\n  /* Radius and default sizes - defaults can change by just changing the --radius */\n  --radius-xs: calc(var(--radius) * 0.25); /* 0.125rem (2px) */\n  --radius-sm: calc(var(--radius) * 0.5); /* 0.25rem (4px) */\n  --radius-md: calc(var(--radius) * 0.75); /* 0.375rem (6px) */\n  --radius-lg: calc(var(--radius) * 1); /* 0.5rem (8px) */\n  --radius-xl: calc(var(--radius) * 1.5); /* 0.75rem (12px) */\n  --radius-2xl: calc(var(--radius) * 2); /* 1rem (16px) */\n  --radius-3xl: calc(var(--radius) * 3); /* 1.5rem (24px) */\n  --radius-4xl: calc(var(--radius) * 4); /* 2rem (32px) */\n\n  /* Transition Timing Functions  */\n  --ease-smooth: ease; /* same as transition: ease; */\n  /* These custom curves are made by https://twitter.com/bdc */\n\n  /* From smoother to faster */\n  --ease-in-quad: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  --ease-in-cubic: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  --ease-in-quart: cubic-bezier(0.895, 0.03, 0.685, 0.22);\n  --ease-in-quint: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n  --ease-in-expo: cubic-bezier(0.95, 0.05, 0.795, 0.035);\n  --ease-in-circ: cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  /* From slower to faster */\n  --ease-out-quad: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  --ease-out-cubic: cubic-bezier(0.215, 0.61, 0.355, 1);\n  --ease-out-quart: cubic-bezier(0.165, 0.84, 0.44, 1);\n  --ease-out-quint: cubic-bezier(0.23, 1, 0.32, 1);\n  --ease-out-expo: cubic-bezier(0.19, 1, 0.22, 1);\n  --ease-out-circ: cubic-bezier(0.075, 0.82, 0.165, 1);\n  /* Custom smooth-out curve: fast start, smooth stop - Apple style */\n  --ease-out-fluid: cubic-bezier(0.32, 0.72, 0, 1);\n  /* From slower to faster */\n  --ease-in-out-quad: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  --ease-in-out-cubic: cubic-bezier(0.645, 0.045, 0.355, 1);\n  --ease-in-out-quart: cubic-bezier(0.77, 0, 0.175, 1);\n  --ease-in-out-quint: cubic-bezier(0.86, 0, 0.07, 1);\n  --ease-in-out-expo: cubic-bezier(1, 0, 0, 1);\n  --ease-in-out-circ: cubic-bezier(0.785, 0.135, 0.15, 0.86);\n\n  /* Linear */\n  --ease-linear: linear;\n\n  /* Animations */\n  --animate-spin-fast: spin 0.75s linear infinite;\n  --animate-skeleton: skeleton 2s linear infinite;\n  --animate-caret-blink: caret-blink 1.2s ease-out infinite;\n\n  @keyframes skeleton {\n    100% {\n      transform: translateX(200%);\n    }\n  }\n\n  @keyframes caret-blink {\n    0%,\n    70%,\n    100% {\n      opacity: 1;\n    }\n    20%,\n    50% {\n      opacity: 0;\n    }\n  }\n}\n","@layer theme, base, components, utilities;\n\n/* HeroUI v3 Styles - Layered Theme Architecture */\n\n/* Base layer - Tailwind CSS v4 */\n@import \"tailwindcss\";\n@import \"tw-animate-css\";\n\n/* Base styles */\n@import \"./base/base.css\" layer(base);\n\n/* Base component structures (unstyled) */\n@import \"./components/index.css\" layer(components);\n\n/* Default theme (variables + component customizations) */\n@import \"./themes/default/index.css\" layer(theme);\n\n/* Utilities */\n@import \"./utilities/index.css\";\n\n/* Variants */\n@import \"./variants/index.css\";\n","@property --tw-animation-delay{syntax:\"*\";inherits:false;initial-value:0s}@property --tw-animation-direction{syntax:\"*\";inherits:false;initial-value:normal}@property --tw-animation-duration{syntax:\"*\";inherits:false}@property --tw-animation-fill-mode{syntax:\"*\";inherits:false;initial-value:none}@property --tw-animation-iteration-count{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-blur{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-blur{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-translate-y{syntax:\"*\";inherits:false;initial-value:0}@theme inline{--animation-delay-0: 0s; --animation-delay-75: 75ms; --animation-delay-100: .1s; --animation-delay-150: .15s; --animation-delay-200: .2s; --animation-delay-300: .3s; --animation-delay-500: .5s; --animation-delay-700: .7s; --animation-delay-1000: 1s; --animation-repeat-0: 0; --animation-repeat-1: 1; --animation-repeat-infinite: infinite; --animation-direction-normal: normal; --animation-direction-reverse: reverse; --animation-direction-alternate: alternate; --animation-direction-alternate-reverse: alternate-reverse; --animation-fill-mode-none: none; --animation-fill-mode-forwards: forwards; --animation-fill-mode-backwards: backwards; --animation-fill-mode-both: both; --percentage-0: 0; --percentage-5: .05; --percentage-10: .1; --percentage-15: .15; --percentage-20: .2; --percentage-25: .25; --percentage-30: .3; --percentage-35: .35; --percentage-40: .4; --percentage-45: .45; --percentage-50: .5; --percentage-55: .55; --percentage-60: .6; --percentage-65: .65; --percentage-70: .7; --percentage-75: .75; --percentage-80: .8; --percentage-85: .85; --percentage-90: .9; --percentage-95: .95; --percentage-100: 1; --percentage-translate-full: 1; --animate-in: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-out: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); @keyframes enter { from { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); filter: blur(var(--tw-enter-blur,0)); }}@keyframes exit { to { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); filter: blur(var(--tw-exit-blur,0)); }}--animate-accordion-down: accordion-down var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-accordion-up: accordion-up var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-collapsible-down: collapsible-down var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-collapsible-up: collapsible-up var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); @keyframes accordion-down { from { height: 0; }to { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,var(--ngp-accordion-content-height,auto))))); }}@keyframes accordion-up { from { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,var(--ngp-accordion-content-height,auto))))); }to { height: 0; }}@keyframes collapsible-down { from { height: 0; }to { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }}@keyframes collapsible-up { from { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }to { height: 0; }}--animate-caret-blink: caret-blink 1.25s ease-out infinite; @keyframes caret-blink { 0%,70%,100% { opacity: 1; }20%,50% { opacity: 0; }}}@utility animation-duration-*{--tw-animation-duration: calc(--value(number)*1ms); --tw-animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]); animation-duration: calc(--value(number)*1ms); animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]);}@utility delay-*{animation-delay: calc(--value(number)*1ms); animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]); --tw-animation-delay: calc(--value(number)*1ms); --tw-animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]);}@utility repeat-*{animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]); --tw-animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]);}@utility direction-*{animation-direction: --value(--animation-direction-*,\"initial\",[*]); --tw-animation-direction: --value(--animation-direction-*,\"initial\",[*]);}@utility fill-mode-*{animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]); --tw-animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]);}@utility running{animation-play-state: running;}@utility paused{animation-play-state: paused;}@utility play-state-*{animation-play-state: --value(\"initial\",[*]);}@utility blur-in{--tw-enter-blur: 20px;}@utility blur-in-*{--tw-enter-blur: calc(--value(number)*1px); --tw-enter-blur: --value(--blur-*,[*]);}@utility blur-out{--tw-exit-blur: 20px;}@utility blur-out-*{--tw-exit-blur: calc(--value(number)*1px); --tw-exit-blur: --value(--blur-*,[*]);}@utility fade-in{--tw-enter-opacity: 0;}@utility fade-in-*{--tw-enter-opacity: calc(--value(number)/100); --tw-enter-opacity: --value(--percentage-*,[*]);}@utility fade-out{--tw-exit-opacity: 0;}@utility fade-out-*{--tw-exit-opacity: calc(--value(number)/100); --tw-exit-opacity: --value(--percentage-*,[*]);}@utility zoom-in{--tw-enter-scale: 0;}@utility zoom-in-*{--tw-enter-scale: calc(--value(number)*1%); --tw-enter-scale: calc(--value(ratio)); --tw-enter-scale: --value(--percentage-*,[*]);}@utility -zoom-in-*{--tw-enter-scale: calc(--value(number)*-1%); --tw-enter-scale: calc(--value(ratio)*-1); --tw-enter-scale: --value(--percentage-*,[*]);}@utility zoom-out{--tw-exit-scale: 0;}@utility zoom-out-*{--tw-exit-scale: calc(--value(number)*1%); --tw-exit-scale: calc(--value(ratio)); --tw-exit-scale: --value(--percentage-*,[*]);}@utility -zoom-out-*{--tw-exit-scale: calc(--value(number)*-1%); --tw-exit-scale: calc(--value(ratio)*-1); --tw-exit-scale: --value(--percentage-*,[*]);}@utility spin-in{--tw-enter-rotate: 30deg;}@utility spin-in-*{--tw-enter-rotate: calc(--value(number)*1deg); --tw-enter-rotate: calc(--value(ratio)*360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility -spin-in{--tw-enter-rotate: -30deg;}@utility -spin-in-*{--tw-enter-rotate: calc(--value(number)*-1deg); --tw-enter-rotate: calc(--value(ratio)*-360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility spin-out{--tw-exit-rotate: 30deg;}@utility spin-out-*{--tw-exit-rotate: calc(--value(number)*1deg); --tw-exit-rotate: calc(--value(ratio)*360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility -spin-out{--tw-exit-rotate: -30deg;}@utility -spin-out-*{--tw-exit-rotate: calc(--value(number)*-1deg); --tw-exit-rotate: calc(--value(ratio)*-360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility slide-in-from-top{--tw-enter-translate-y: -100%;}@utility slide-in-from-top-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-y: calc(--value(ratio)*-100%); --tw-enter-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-bottom{--tw-enter-translate-y: 100%;}@utility slide-in-from-bottom-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-y: calc(--value(ratio)*100%); --tw-enter-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-in-from-left{--tw-enter-translate-x: -100%;}@utility slide-in-from-left-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-right{--tw-enter-translate-x: 100%;}@utility slide-in-from-right-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]);}@utility slide-in-from-start{&:dir(ltr){ --tw-enter-translate-x: -100%; }&:dir(rtl){ --tw-enter-translate-x: 100%; }}@utility slide-in-from-start-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]); }}@utility slide-in-from-end{&:dir(ltr){ --tw-enter-translate-x: 100%; }&:dir(rtl){ --tw-enter-translate-x: -100%; }}@utility slide-in-from-end-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }}@utility slide-out-to-top{--tw-exit-translate-y: -100%;}@utility slide-out-to-top-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-y: calc(--value(ratio)*-100%); --tw-exit-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-bottom{--tw-exit-translate-y: 100%;}@utility slide-out-to-bottom-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-y: calc(--value(ratio)*100%); --tw-exit-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-left{--tw-exit-translate-x: -100%;}@utility slide-out-to-left-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-right{--tw-exit-translate-x: 100%;}@utility slide-out-to-right-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-start{&:dir(ltr){ --tw-exit-translate-x: -100%; }&:dir(rtl){ --tw-exit-translate-x: 100%; }}@utility slide-out-to-start-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]); }}@utility slide-out-to-end{&:dir(ltr){ --tw-exit-translate-x: 100%; }&:dir(rtl){ --tw-exit-translate-x: -100%; }}@utility slide-out-to-end-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }}","/*\n * Scrollbar styles\n *\n * TODO: This is a temporary workaround by removing the scrollbar styles.\n * Global scrollbar styling causes modal/overlay interaction/closure issues\n * (e.g. backdrop clicks not closing the overlay) and should be removed.\n */\n/*\n*:not(.alert-dialog__backdrop):not(.modal__backdrop) {\n  scrollbar-color: var(--scrollbar) transparent;\n  scrollbar-width: thin;\n}\n*/\n\n/* Border color inheritance */\n*,\n::after,\n::before,\n::backdrop,\n::file-selector-button {\n  border-color: var(--border, currentColor);\n}\n\n/* Keeps main page content interactive during view transitions */\n:root {\n  view-transition-name: none;\n}\n\n::view-transition {\n  pointer-events: none;\n}\n","/* Close Button component styles */\n\n/* Base close button styles */\n.close-button {\n  @apply relative isolate inline-flex h-6 w-6 shrink-0 origin-center items-center justify-center rounded-xl p-1 select-none no-highlight;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    color 150ms var(--ease-out),\n    background-color 100ms var(--ease-out),\n    box-shadow 150ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Pending state */\n  &[data-pending=\"true\"] {\n    @apply status-pending;\n  }\n\n  /* SVG icon styling*/\n  & svg {\n    @apply pointer-events-none;\n    @apply size-4 shrink-0 self-center;\n    @apply -mx-0.5 my-0.5;\n  }\n}\n\n/* Variants */\n.close-button--default {\n  @apply bg-default text-muted;\n\n  &:active,\n  &[data-pressed=\"true\"] {\n  }\n\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default-hover;\n    }\n  }\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.93);\n  }\n}\n","/* Base description styles */\n.description {\n  @apply text-xs text-wrap wrap-break-word text-muted;\n}\n","/* Base error message styles */\n.error-message {\n  @apply h-auto text-xs wrap-break-word text-danger;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    opacity 150ms var(--ease-out),\n    height 350ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n}\n","/* Field error styles */\n.field-error {\n  @apply h-0 px-1 text-xs wrap-break-word text-danger opacity-0 data-[visible=true]:h-auto data-[visible=true]:opacity-100;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    opacity 150ms var(--ease-out),\n    height 350ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n}\n","/* Base label styles */\n.label {\n  /* Base styling */\n  @apply text-sm font-medium text-foreground;\n}\n\n/*\n * Exclude group-level components (RadioGroup, CheckboxGroup) and radio/checkbox items\n * to ensure asterisks only appear on atomic form field labels and group labels,\n * not on individual options within those groups\n */\n.label--required,\n[data-required=\"true\"]:not([role=\"group\"]):not([role=\"radiogroup\"]):not([role=\"checkboxgroup\"])\n  > .label,\n[data-required=\"true\"]:not([data-slot=\"radio\"]):not([data-slot=\"checkbox\"]) > .label {\n  @apply after:ml-0.5 after:text-danger after:content-['*'];\n}\n\n.label--disabled,\n[data-disabled=\"true\"] .label {\n  @apply status-disabled;\n}\n\n.label--invalid,\n[data-invalid=\"true\"] .label,\n[aria-invalid=\"true\"] .label {\n  @apply text-danger;\n}\n","/* Base accordion styles */\n.accordion {\n  @apply w-full;\n\n  /* Performance optimization - contain layout changes */\n  contain: layout style;\n}\n\n/* Accordion elements */\n.accordion__body {\n  @apply text-sm;\n}\n\n.accordion__body-inner {\n  @apply px-4 pt-0 pb-4 text-muted;\n}\n\n.accordion__heading {\n  @apply flex;\n}\n\n.accordion__indicator {\n  @apply ml-auto size-4 shrink-0 text-muted;\n\n  /**\n   * Transitions\n   */\n  @apply transition duration-250 motion-reduce:transition-none;\n\n  /* Expanded state for indicator rotation */\n  &[data-expanded=\"true\"] {\n    @apply -rotate-180;\n  }\n}\n\n/* Accordion Item - Separator styles */\n.accordion__item {\n  @apply relative border-none;\n}\n\n.accordion__item::after {\n  content: \"\";\n  @apply absolute bottom-0 left-0 h-px w-full rounded-xs bg-separator;\n}\n\n.accordion__item:last-child::after {\n  content: none;\n}\n\n/* Hide separator when hideSeparator prop is set */\n.accordion__item[data-hide-separator=\"true\"]::after {\n  display: none;\n}\n/* ------------------------------------ */\n\n.accordion__trigger {\n  cursor: var(--cursor-interactive);\n\n  /* Base Styles */\n  @apply flex flex-1 items-center justify-between px-4 py-4 text-left text-sm font-medium no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    opacity 150ms var(--ease-out),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not([aria-expanded=\"true\"]),\n    &[data-hovered=\"true\"]:not([aria-expanded=\"true\"]) {\n      background-color: color-mix(in oklab, var(--color-foreground) 3%, transparent 90%);\n    }\n  }\n\n  /* Pressed state */\n  &[data-pressed=\"true\"]:not([aria-expanded=\"true\"]) {\n  }\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled State */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.accordion__panel {\n  opacity: 0;\n  height: var(--disclosure-panel-height);\n  overflow: clip;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    height 200ms var(--ease-out-quad),\n    opacity 200ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  &[data-expanded=\"true\"] {\n    will-change: height, opacity;\n    opacity: 1;\n  }\n}\n\n/* Surface variant */\n.accordion--surface {\n  @apply bg-surface;\n  border-radius: min(32px, var(--radius-3xl));\n\n  .accordion__trigger {\n    @media (hover: hover) {\n      &:hover:not([aria-expanded=\"true\"]),\n      &[data-hovered=\"true\"]:not([aria-expanded=\"true\"]) {\n        @apply bg-default;\n      }\n    }\n  }\n\n  .accordion__item::after {\n    @apply bg-surface-foreground/6;\n  }\n}\n\n.accordion--surface .accordion__item {\n  /* Surface variant separator styling */\n  &::after {\n    @apply left-[3%] w-[94%];\n  }\n\n  /* Special rounding for first and last items in surface variant */\n  &:first-child [data-slot=\"accordion-trigger\"] {\n    border-top-left-radius: min(32px, var(--radius-3xl));\n    border-top-right-radius: min(32px, var(--radius-3xl));\n  }\n\n  &:last-child:not(:has([data-slot=\"accordion-trigger\"][aria-expanded=\"true\"]))\n    [data-slot=\"accordion-trigger\"] {\n    border-bottom-left-radius: min(32px, var(--radius-3xl));\n    border-bottom-right-radius: min(32px, var(--radius-3xl));\n  }\n}\n","/* Base breadcrumbs container */\n.breadcrumbs {\n  @apply flex items-center;\n\n  /* Breadcrumb link */\n  .breadcrumbs__link {\n    @apply relative px-0.5 text-sm leading-5 font-medium text-muted no-underline opacity-100;\n\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply underline;\n    }\n\n    &[data-current=\"true\"] {\n      @apply text-link opacity-100;\n    }\n  }\n\n  /* Breadcrumb item wrapper */\n  .breadcrumbs__item {\n    @apply flex shrink-0 items-center justify-center gap-0.5 px-0.5;\n  }\n\n  /* Separator icon */\n  .breadcrumbs__separator {\n    @apply size-3 text-muted rtl:rotate-180;\n  }\n}\n","/* Base disclosure-group styles */\n.disclosure-group {\n  @apply w-full;\n\n  /* Performance optimization - contain layout changes */\n  contain: layout style;\n}\n","/* Base disclosure styles */\n.disclosure {\n  @apply relative;\n}\n\n.accordion__heading {\n  @apply flex;\n}\n\n.disclosure__trigger {\n  cursor: var(--cursor-interactive);\n  @apply inline-block no-highlight;\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.disclosure__indicator {\n  @apply ml-auto size-4 shrink-0 text-inherit;\n\n  /**\n   * Transitions\n   */\n  @apply transition duration-250 motion-reduce:transition-none;\n\n  /* Expanded state for indicator rotation */\n  &[data-expanded=\"true\"] {\n    @apply -rotate-180;\n  }\n}\n\n.disclosure__content {\n  opacity: 0;\n  height: var(--disclosure-panel-height);\n  overflow: clip;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    height 200ms var(--ease-out-quad),\n    opacity 200ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  &[data-expanded=\"true\"] {\n    will-change: height, opacity;\n    opacity: 1;\n  }\n}\n\n.disclosure__body {\n  @apply p-2;\n}\n","/* Base link styles */\n.link {\n  @apply relative inline-flex h-fit w-fit items-center rounded-xl text-sm font-medium text-link underline decoration-separator-tertiary decoration-[1.5px] underline-offset-4 no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 100ms var(--ease-smooth),\n    text-decoration-color 100ms var(--ease-out),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out),\n    opacity 100ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply decoration-muted;\n\n      .link__icon {\n        @apply opacity-100;\n      }\n    }\n  }\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n\n    .link__icon {\n      @apply opacity-100;\n    }\n  }\n\n  /* Disabled state */\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  .link__icon {\n    @apply pointer-events-none inline-flex size-2 shrink-0 items-center justify-center text-current opacity-60;\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition: opacity 150ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n\n    & svg {\n      @apply transform-gpu;\n    }\n  }\n\n  .link__icon[data-default-icon=\"true\"] {\n    @apply ml-1 pb-1.5;\n  }\n\n  /* Handle Link with Button Variants */\n  &.button {\n    @apply gap-0 no-underline;\n  }\n}\n","/* ==========================================================================\n   Pagination - Page navigation component\n   ========================================================================== */\n\n/* Base styles */\n.pagination {\n  @apply flex w-full flex-col items-center justify-between gap-4 sm:flex-row;\n}\n\n/* Summary - left side info container */\n.pagination__summary {\n  @apply flex items-center gap-2 self-start text-sm text-muted sm:self-center;\n}\n\n/* Content - container for pagination items */\n.pagination__content {\n  @apply flex items-center gap-1 self-start sm:self-center;\n}\n\n/* Item - list item wrapper */\n.pagination__item {\n  @apply inline-flex;\n}\n\n/* Link - page number button (ghost button style) */\n.pagination__link {\n  @apply relative isolate inline-flex size-9 origin-center items-center justify-center rounded-3xl text-sm font-medium whitespace-nowrap outline-none select-none no-highlight md:size-8;\n\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-smooth),\n    background-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Ghost button tokens */\n  --pagination-link-bg: transparent;\n  --pagination-link-bg-hover: var(--color-default-hover);\n  --pagination-link-bg-pressed: var(--color-default-hover);\n  --pagination-link-fg: var(--color-default-foreground);\n\n  background-color: var(--pagination-link-bg);\n  color: var(--pagination-link-fg);\n\n  /* Focus state */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      background-color: var(--pagination-link-bg-hover);\n    }\n  }\n\n  /* Active / pressed */\n  &:active,\n  &[data-pressed=\"true\"] {\n    background-color: var(--pagination-link-bg-pressed);\n    transform: scale(0.97);\n  }\n\n  /* Active page - tertiary button style */\n  &[data-active=\"true\"] {\n    --pagination-link-bg: var(--color-default);\n    --pagination-link-bg-hover: var(--color-default-hover);\n    --pagination-link-bg-pressed: var(--color-default-hover);\n  }\n}\n\n/* Ellipsis */\n.pagination__ellipsis {\n  @apply inline-flex size-9 items-center justify-center text-sm text-muted select-none md:size-8;\n}\n\n/* Navigation buttons (Previous / Next) */\n.pagination__link--nav {\n  @apply w-auto gap-1.5 px-2.5;\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.pagination--sm {\n  .pagination__link {\n    @apply size-8 text-xs md:size-7;\n\n    &:active,\n    &[data-pressed=\"true\"] {\n      transform: scale(0.98);\n    }\n  }\n\n  .pagination__link--nav {\n    @apply w-auto px-2;\n  }\n\n  .pagination__ellipsis {\n    @apply size-8 text-xs md:size-7;\n  }\n\n  .pagination__summary {\n    @apply text-xs;\n  }\n}\n\n.pagination--md {\n  /* No styles as this is the default size */\n}\n\n.pagination--lg {\n  .pagination__link {\n    @apply size-10 text-base md:size-9;\n\n    &:active,\n    &[data-pressed=\"true\"] {\n      transform: scale(0.96);\n    }\n  }\n\n  .pagination__link--nav {\n    @apply w-auto px-3;\n  }\n\n  .pagination__ellipsis {\n    @apply size-10 text-base md:size-9;\n  }\n\n  .pagination__summary {\n    @apply text-base;\n  }\n}\n","/* Base tabs component */\n.tabs {\n  @apply flex gap-2;\n\n  /* Orientation styles */\n  &[data-orientation=\"horizontal\"] {\n    @apply flex-col;\n  }\n\n  &[data-orientation=\"vertical\"] {\n    @apply flex-row;\n  }\n}\n\n/* Tab list container */\n.tabs__list-container {\n  @apply relative;\n}\n\n/* Tab list */\n.tabs__list {\n  @apply inline-flex bg-default p-1;\n\n  border-radius: calc(var(--radius) * 2.5);\n\n  /* Horizontal orientation */\n  &[data-orientation=\"horizontal\"] {\n    @apply w-full flex-row;\n  }\n\n  /* Vertical orientation */\n  &[data-orientation=\"vertical\"] {\n    @apply flex-col gap-1;\n\n    .tabs__tab {\n      @apply min-w-20;\n    }\n  }\n}\n\n/* Individual tab */\n.tabs__tab {\n  position: relative;\n  z-index: 1;\n  cursor: var(--cursor-interactive);\n\n  @apply flex h-8 w-full items-center justify-center rounded-3xl px-4 text-center text-sm font-medium text-muted outline-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 150ms var(--ease-smooth),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out),\n    opacity 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n\n  /* Selected state */\n  &[data-selected=\"true\"] {\n    @apply text-segment-foreground;\n  }\n\n  /* Hide separator when this tab is selected */\n  &[data-selected=\"true\"] .tabs__separator {\n    opacity: 0;\n  }\n\n  /* Hide separator when previous sibling is selected */\n  &[data-selected=\"true\"] + .tabs__tab .tabs__separator {\n    opacity: 0;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Hover states - both approaches for compatibility */\n  @media (hover: hover) {\n    &:not([data-selected=\"true\"]):not([data-disabled=\"true\"]):hover,\n    &[data-hovered=\"true\"]:not([data-selected=\"true\"]):not([data-disabled=\"true\"]) {\n      @apply opacity-70;\n    }\n  }\n\n  /* Focus states - comprehensive fallback */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n}\n\n/* Tab separator */\n.tabs__separator {\n  @apply rounded-sm bg-muted/25;\n  position: absolute;\n  pointer-events: none;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition: opacity 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n\n  /* Horizontal tabs - vertical separator */\n  .tabs__list[data-orientation=\"horizontal\"] & {\n    left: 0;\n    top: 25%;\n    width: 1px;\n    height: 50%;\n  }\n\n  /* Vertical tabs - horizontal separator */\n  .tabs__list[data-orientation=\"vertical\"] & {\n    top: 0;\n    left: 5%;\n    width: 90%;\n    height: 1px;\n  }\n}\n\n/* Tab panel */\n.tabs__panel {\n  @apply w-full p-2 outline-none;\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply absolute top-0 left-0 w-full;\n  }\n\n  /* Orientation spacing */\n  &[data-orientation=\"horizontal\"] {\n    @apply mt-4;\n  }\n\n  &[data-orientation=\"vertical\"] {\n    @apply ml-4;\n  }\n}\n\n/* Tab indicator - React Aria's SelectionIndicator */\n.tabs__indicator {\n  box-shadow: var(--shadow-surface);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  border-radius: var(--radius-3xl);\n  width: 100%;\n  height: 100%;\n\n  @apply bg-segment;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition-duration: 250ms;\n  transition-property: translate, width, height;\n  transition-timing-function: var(--ease-out-fluid);\n  @apply motion-reduce:transition-none;\n}\n\n/* ==========================================================================\n   Secondary Variant\n   ========================================================================== */\n\n.tabs--secondary {\n  /* Tab list - remove background, add bottom/left border */\n  > .tabs__list-container > .tabs__list {\n    @apply bg-transparent p-0;\n\n    border-radius: 0;\n\n    /* Horizontal orientation - bottom border, scrollable */\n    &[data-orientation=\"horizontal\"] {\n      @apply border-b border-border;\n\n      max-width: 100%;\n      overflow-x: auto;\n      overflow-y: clip;\n      scrollbar-width: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    /* Vertical orientation - left border */\n    &[data-orientation=\"vertical\"] {\n      @apply border-l border-border;\n    }\n  }\n\n  /* Tab - adjust for secondary variant */\n  > .tabs__list-container .tabs__tab {\n    @apply rounded-none;\n\n    /* Selected state - use text-foreground */\n    &[data-selected=\"true\"] {\n      @apply text-foreground;\n    }\n  }\n\n  /* Hide separators in secondary variant */\n  > .tabs__list-container .tabs__separator {\n    display: none;\n  }\n\n  /* Tab indicator - line style */\n  > .tabs__list-container .tabs__indicator {\n    @apply bg-accent;\n\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  /* Horizontal orientation - bottom line indicator */\n  &[data-orientation=\"horizontal\"] > .tabs__list-container .tabs__indicator {\n    top: auto;\n    bottom: 0;\n    height: 2px;\n  }\n\n  /* Vertical orientation - left line indicator */\n  &[data-orientation=\"vertical\"] > .tabs__list-container .tabs__indicator {\n    left: 0;\n    top: 0;\n    width: 2px;\n    height: 100%;\n  }\n}\n","/* Button component styles */\n\n/* Base button styles */\n.button {\n  @apply relative isolate inline-flex h-10 w-fit origin-center items-center justify-center gap-2 rounded-3xl px-4 text-sm font-medium whitespace-nowrap outline-none select-none no-highlight md:h-9;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-smooth),\n    background-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Default tokens (fallback behavior) */\n  --button-bg: transparent;\n  --button-bg-hover: var(--button-bg);\n  --button-bg-pressed: var(--button-bg-hover);\n  --button-fg: currentColor;\n\n  background-color: var(--button-bg);\n  color: var(--button-fg);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Pending state */\n  &[data-pending=\"true\"] {\n    @apply status-pending;\n  }\n\n  /* Active / pressed */\n  &:active,\n  &[data-pressed=\"true\"] {\n    background-color: var(--button-bg-pressed);\n    transform: scale(0.97);\n  }\n\n  /* Hover */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      background-color: var(--button-bg-hover);\n    }\n  }\n\n  /* SVG icon styling - exclude spinner and link-icon svgs */\n  & svg:not([data-slot=\"spinner\"] svg, [data-slot=\"link-icon\"] svg) {\n    @apply pointer-events-none -mx-0.5 my-0.5 size-5 shrink-0 self-center sm:my-1 sm:size-4;\n  }\n}\n\n/* Size variants */\n.button--sm {\n  @apply h-9 px-3 md:h-8;\n\n  & svg:not([data-slot=\"spinner\"] svg, [data-slot=\"link-icon\"] svg) {\n    @apply size-4;\n  }\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.98);\n  }\n}\n\n.button--md {\n  /* No styles as this is the default size */\n}\n\n.button--lg {\n  @apply h-11 text-base md:h-10;\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.96);\n  }\n}\n\n/* Color variants - only set custom property values */\n.button--primary {\n  --button-bg: var(--color-accent);\n  --button-bg-hover: var(--color-accent-hover);\n  --button-bg-pressed: var(--color-accent-hover);\n  --button-fg: var(--color-accent-foreground);\n}\n\n.button--secondary {\n  --button-bg: var(--color-default);\n  --button-bg-hover: var(--color-default-hover);\n  --button-bg-pressed: var(--color-default-hover);\n  --button-fg: var(--color-accent-soft-foreground);\n}\n\n.button--tertiary {\n  --button-bg: var(--color-default);\n  --button-bg-hover: var(--color-default-hover);\n  --button-bg-pressed: var(--color-default-hover);\n}\n\n.button--ghost,\n.button--outline {\n  --button-bg: transparent;\n  --button-bg-hover: var(--color-default);\n  --button-bg-pressed: var(--color-default);\n  --button-fg: var(--color-default-foreground);\n}\n\n.button--outline {\n  @apply border border-border;\n  --button-bg-hover: color-mix(in srgb, var(--color-default) 60%, transparent);\n}\n\n.button--danger {\n  --button-bg: var(--color-danger);\n  --button-bg-hover: var(--color-danger-hover);\n  --button-bg-pressed: var(--color-danger-hover);\n  --button-fg: var(--color-danger-foreground);\n}\n\n.button--danger-soft {\n  --button-bg: var(--color-danger-soft);\n  --button-bg-hover: var(--color-danger-soft-hover);\n  --button-bg-pressed: var(--color-danger-soft-hover);\n  --button-fg: var(--color-danger-soft-foreground);\n}\n\n/* Icon-only modifier */\n.button--icon-only {\n  @apply w-10 p-0 md:w-9;\n}\n\n.button--icon-only.button--sm {\n  @apply w-9 md:w-8;\n}\n\n.button--icon-only.button--lg {\n  @apply w-11 md:w-10;\n}\n\n/* Full width modifier */\n.button--full-width {\n  @apply w-full;\n}\n","/* ==========================================================================\n   ButtonGroup - Groups related buttons together\n   ========================================================================== */\n\n/* Base button group styles */\n.button-group {\n  @apply inline-flex h-auto items-center justify-center gap-0;\n}\n\n/* ==========================================================================\n   Orientation variants\n   ========================================================================== */\n\n.button-group--horizontal {\n  @apply flex-row;\n}\n\n.button-group--vertical {\n  @apply flex-col;\n}\n\n/* Remove border radius from all buttons in group */\n.button-group .button {\n  @apply rounded-none;\n}\n\n/* Apply border radius to first button (start edge) */\n.button-group--horizontal .button:first-child {\n  @apply rounded-s-3xl;\n}\n\n/* Apply border radius to last button (end edge) */\n.button-group--horizontal .button:last-child {\n  @apply rounded-e-3xl;\n}\n\n/* If only one button, apply both rounded edges */\n.button-group--horizontal .button:first-child:last-child {\n  @apply rounded-3xl;\n}\n\n/* Apply border radius to first button (top edge) in vertical */\n.button-group--vertical .button:first-child {\n  @apply rounded-t-3xl;\n}\n\n/* Apply border radius to last button (bottom edge) in vertical */\n.button-group--vertical .button:last-child {\n  @apply rounded-b-3xl;\n}\n\n/* If only one button in vertical, apply all rounded edges */\n.button-group--vertical .button:first-child:last-child {\n  @apply rounded-3xl;\n}\n\n/* Remove scale transform on active/pressed state for buttons in group */\n.button-group .button:active,\n.button-group .button[data-pressed=\"true\"] {\n  transform: none;\n}\n\n/* Override focus ring to use inset style so it stays within button bounds */\n.button-group .button:focus-visible:not(:focus),\n.button-group .button[data-focus-visible=\"true\"] {\n  --tw-ring-offset-width: 0px;\n  @apply ring-inset;\n}\n\n/* ==========================================================================\n   Separator (compound component)\n   ========================================================================== */\n\n.button-group__separator {\n  @apply rounded-sm bg-current opacity-15;\n  position: absolute;\n  pointer-events: none;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition: opacity 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n\n  /* Horizontal orientation - vertical divider */\n  .button-group--horizontal & {\n    left: -1px;\n    top: 25%;\n    width: 1px;\n    height: 50%;\n  }\n\n  /* Vertical orientation - horizontal divider */\n  .button-group--vertical & {\n    left: 25%;\n    top: -1px;\n    width: 50%;\n    height: 1px;\n  }\n}\n\n/* ==========================================================================\n   Outline button border handling\n   ========================================================================== */\n\n/* Remove adjacent borders from outline buttons in horizontal group */\n/* First button: remove end border (right in LTR, left in RTL) */\n.button-group--horizontal .button--outline:first-child {\n  @apply border-e-0;\n}\n\n/* Last button: remove start border (left in LTR, right in RTL) */\n.button-group--horizontal .button--outline:last-child {\n  @apply border-s-0;\n}\n\n/* Middle buttons: remove both inline borders */\n.button-group--horizontal .button--outline:not(:first-child):not(:last-child) {\n  @apply border-x-0;\n}\n\n/* Remove adjacent borders from outline buttons in vertical group */\n/* First button: remove bottom border */\n.button-group--vertical .button--outline:first-child {\n  @apply border-b-0;\n}\n\n/* Last button: remove top border */\n.button-group--vertical .button--outline:last-child {\n  @apply border-t-0;\n}\n\n/* Middle buttons: remove both block borders */\n.button-group--vertical .button--outline:not(:first-child):not(:last-child) {\n  @apply border-y-0;\n}\n\n/* ==========================================================================\n   Full width modifier\n   ========================================================================== */\n\n.button-group--full-width {\n  @apply w-full;\n}\n","/* ==========================================================================\n   ToggleButton - Interactive toggle control for on/off states\n   ========================================================================== */\n\n/* Base styles */\n.toggle-button {\n  @apply relative isolate inline-flex h-10 w-fit origin-center items-center justify-center gap-2 rounded-3xl px-4 text-sm font-medium whitespace-nowrap outline-none select-none no-highlight md:h-9;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-smooth),\n    background-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Default tokens (unselected state) */\n  --toggle-button-bg: var(--color-default);\n  --toggle-button-bg-hover: var(--color-default-hover);\n  --toggle-button-bg-pressed: var(--color-default-hover);\n  --toggle-button-fg: currentColor;\n\n  /* Selected state tokens */\n  --toggle-button-bg-selected: var(--color-accent-soft);\n  --toggle-button-bg-selected-hover: var(--color-accent-soft-hover);\n  --toggle-button-bg-selected-pressed: var(--color-accent-soft-hover);\n  --toggle-button-fg-selected: var(--color-accent-soft-foreground);\n\n  background-color: var(--toggle-button-bg);\n  color: var(--toggle-button-fg);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Hover */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      background-color: var(--toggle-button-bg-hover);\n    }\n  }\n\n  /* Active / pressed */\n  &:active,\n  &[data-pressed=\"true\"] {\n    background-color: var(--toggle-button-bg-pressed);\n    transform: scale(0.97);\n  }\n\n  /* Selected state */\n  &[data-selected=\"true\"] {\n    background-color: var(--toggle-button-bg-selected);\n    color: var(--toggle-button-fg-selected);\n\n    @media (hover: hover) {\n      &:hover,\n      &[data-hovered=\"true\"] {\n        background-color: var(--toggle-button-bg-selected-hover);\n      }\n    }\n\n    &:active,\n    &[data-pressed=\"true\"] {\n      background-color: var(--toggle-button-bg-selected-pressed);\n    }\n  }\n\n  /* SVG icon styling */\n  & svg {\n    @apply pointer-events-none -mx-0.5 my-0.5 size-5 shrink-0 self-center sm:my-1 sm:size-4;\n  }\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.toggle-button--sm {\n  @apply h-9 px-3 md:h-8;\n\n  & svg {\n    @apply size-4;\n  }\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.98);\n  }\n}\n\n.toggle-button--md {\n  /* No styles as this is the default size */\n}\n\n.toggle-button--lg {\n  @apply h-11 text-base md:h-10;\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.96);\n  }\n}\n\n/* ==========================================================================\n   Variant styles\n   ========================================================================== */\n\n.toggle-button--default {\n  --toggle-button-bg: var(--color-default);\n  --toggle-button-bg-hover: var(--color-default-hover);\n  --toggle-button-bg-pressed: var(--color-default-hover);\n}\n\n.toggle-button--ghost {\n  --toggle-button-bg: transparent;\n  --toggle-button-bg-hover: var(--color-default);\n  --toggle-button-bg-pressed: var(--color-default);\n  --toggle-button-fg: var(--color-default-foreground);\n}\n\n/* ==========================================================================\n   Icon-only modifier\n   ========================================================================== */\n\n.toggle-button--icon-only {\n  @apply w-10 p-0 md:w-9;\n}\n\n.toggle-button--icon-only.toggle-button--sm {\n  @apply w-9 md:w-8;\n}\n\n.toggle-button--icon-only.toggle-button--lg {\n  @apply w-11 md:w-10;\n}\n","/* ==========================================================================\n   ToggleButtonGroup - Groups multiple ToggleButtons into a unified control\n   ========================================================================== */\n\n/* Base styles */\n.toggle-button-group {\n  @apply inline-flex h-auto w-fit items-center justify-center gap-0;\n}\n\n/* ==========================================================================\n   Orientation variants\n   ========================================================================== */\n\n.toggle-button-group--horizontal {\n  @apply flex-row;\n}\n\n.toggle-button-group--vertical {\n  @apply flex-col;\n}\n\n/* ==========================================================================\n   Full width modifier\n   ========================================================================== */\n\n.toggle-button-group--full-width {\n  @apply w-full;\n}\n\n/* ==========================================================================\n   Attached mode (default) - buttons connected with dividers\n   ========================================================================== */\n\n/* Remove border radius from all toggle buttons in attached group */\n.toggle-button-group .toggle-button {\n  @apply rounded-none;\n}\n\n/* Apply border radius to first button (start edge) */\n.toggle-button-group--horizontal .toggle-button:first-child {\n  @apply rounded-s-3xl;\n}\n\n/* Apply border radius to last button (end edge) */\n.toggle-button-group--horizontal .toggle-button:last-child {\n  @apply rounded-e-3xl;\n}\n\n/* If only one button, apply both rounded edges */\n.toggle-button-group--horizontal .toggle-button:first-child:last-child {\n  @apply rounded-3xl;\n}\n\n/* Apply border radius to first button (top edge) in vertical */\n.toggle-button-group--vertical .toggle-button:first-child {\n  @apply rounded-t-3xl;\n}\n\n/* Apply border radius to last button (bottom edge) in vertical */\n.toggle-button-group--vertical .toggle-button:last-child {\n  @apply rounded-b-3xl;\n}\n\n/* If only one button in vertical, apply all rounded edges */\n.toggle-button-group--vertical .toggle-button:first-child:last-child {\n  @apply rounded-3xl;\n}\n\n/* Remove scale transform on active/pressed state for buttons in group */\n.toggle-button-group .toggle-button:active,\n.toggle-button-group .toggle-button[data-pressed=\"true\"] {\n  transform: none;\n}\n\n/* Override focus ring to use inset style so it stays within button bounds */\n.toggle-button-group .toggle-button:focus-visible:not(:focus),\n.toggle-button-group .toggle-button[data-focus-visible=\"true\"] {\n  --tw-ring-offset-width: 0px;\n  @apply ring-inset;\n}\n\n/* Full width: stretch each toggle button */\n.toggle-button-group--full-width .toggle-button {\n  @apply flex-1;\n}\n\n/* ==========================================================================\n   Separator (compound component)\n   ========================================================================== */\n\n.toggle-button-group__separator {\n  @apply rounded-sm bg-current opacity-15;\n  position: absolute;\n  pointer-events: none;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition: opacity 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n\n  /* Horizontal orientation - vertical divider */\n  .toggle-button-group--horizontal & {\n    left: -1px;\n    top: 25%;\n    width: 1px;\n    height: 50%;\n  }\n\n  /* Vertical orientation - horizontal divider */\n  .toggle-button-group--vertical & {\n    left: 25%;\n    top: -1px;\n    width: 50%;\n    height: 1px;\n  }\n}\n\n/* ==========================================================================\n   Detached mode - buttons separated with gaps\n   ========================================================================== */\n\n.toggle-button-group--detached {\n  @apply gap-1;\n}\n\n/* Restore border radius in detached mode */\n.toggle-button-group--detached .toggle-button {\n  @apply rounded-3xl;\n}\n\n/* Hide separators in detached mode */\n.toggle-button-group--detached .toggle-button-group__separator {\n  display: none;\n}\n","/* ==========================================================================\n   Toolbar - Container for interactive controls with arrow key navigation\n   ========================================================================== */\n\n/* Base styles */\n.toolbar {\n  @apply grid w-fit grid-flow-col items-center gap-2;\n\n  .separator--vertical {\n    @apply h-1/2 self-center;\n  }\n\n  .separator--horizontal {\n    @apply w-1/2 justify-center justify-self-center;\n  }\n}\n\n/* Orientation variants */\n.toolbar--horizontal {\n}\n\n.toolbar--vertical {\n  @apply grid-flow-row items-start justify-start;\n  .button-group {\n    @apply justify-start;\n  }\n}\n\n/* Attached variant */\n.toolbar--attached {\n  @apply rounded-3xl bg-surface p-1 shadow-overlay;\n}\n","/* ==========================================================================\n   Base dropdown styles\n   ========================================================================== */\n\n.dropdown {\n  @apply flex flex-col gap-1;\n}\n\n.dropdown__trigger {\n  @apply inline-block;\n  /* Only visible when using a custom trigger  - not passing \"Button\" as a child - hence we use some button styles (custom trigger) */\n  @apply outline-none;\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Pending state */\n  &[data-pending=\"true\"] {\n    @apply status-pending;\n  }\n\n  /* Default active/pressed state - scale transform */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.97);\n  }\n}\n\n/* Similar to select popover styles */\n.dropdown__popover {\n  @apply max-w-[48svw] origin-(--trigger-anchor-point) scroll-py-1 overflow-y-auto overscroll-contain bg-overlay p-0 text-sm md:min-w-55;\n  border-radius: min(32px, var(--radius-3xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-90;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"popover-overlay-arrow\"] {\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 90deg;\n  }\n\n  /* Menu styles */\n  [data-slot=\"dropdown-menu\"] {\n    @apply p-1.5 outline-none;\n  }\n\n  [data-slot=\"menu-item\"] {\n    @apply px-2.5;\n  }\n}\n\n.dropdown__menu {\n  @apply relative flex w-full flex-col gap-0.5 overflow-clip p-1;\n\n  /* This makes the separator take up 94% of the width and be centered */\n  [data-slot=\"separator\"] {\n    @apply ml-[3%] w-[94%];\n  }\n}\n","/* ==========================================================================\n   Base list-box item styles\n   ========================================================================== */\n\n.list-box-item {\n  @apply relative flex min-h-9 w-full items-center justify-start gap-3 rounded-2xl px-2 py-1.5 outline-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    box-shadow 150ms var(--ease-out);\n\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  [data-slot=\"label\"] {\n    @apply pointer-events-none w-fit select-none;\n  }\n\n  [data-slot=\"description\"] {\n    @apply pointer-events-none text-wrap select-none;\n  }\n\n  /* Add padding-right when indicator is present */\n  &:has(.list-box-item__indicator) {\n    @apply pr-7;\n  }\n\n  /* Focus visible state (keyboard focus only) */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.98);\n  }\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default;\n    }\n  }\n\n  /* Selected state */\n  &[aria-selected=\"true\"],\n  &[data-selected=\"true\"] {\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   List-box item indicator\n   ========================================================================== */\n\n.list-box-item__indicator {\n  @apply absolute top-1/2 right-2 flex size-4 shrink-0 -translate-y-1/2 items-center justify-center text-default-foreground;\n\n  /**\n   * Transitions\n   */\n  @apply transition duration-250 motion-reduce:transition-none;\n\n  /* Checkmark SVG indicator */\n  [data-slot=\"list-box-item-indicator--checkmark\"] {\n    @apply size-2.5;\n\n    /**\n     * Transitions\n     */\n    @apply transition-all duration-300 motion-reduce:transition-none;\n  }\n\n  .list-box-item[aria-selected=\"true\"] [data-slot=\"list-box-item-indicator--checkmark\"],\n  .list-box-item[data-selected=\"true\"] [data-slot=\"list-box-item-indicator--checkmark\"] {\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition: stroke-dashoffset 250ms linear;\n    @apply motion-reduce:transition-none;\n  }\n}\n\n/* Default variant */\n.list-box-item--default {\n}\n\n/* Danger variant */\n.list-box-item--danger {\n  .list-box-item__indicator {\n    @apply text-danger;\n  }\n\n  [data-slot=\"label\"] {\n    @apply text-danger;\n  }\n}\n","/* ==========================================================================\n   Base list-box section styles\n   ========================================================================== */\n\n.list-box-section {\n  @apply flex flex-col items-start gap-0;\n}\n","/* ==========================================================================\n   Base list-box styles\n   ========================================================================== */\n\n.list-box {\n  @apply relative flex w-full flex-col gap-1 overflow-clip p-1;\n\n  /* This makes the horizontal separator take up 94% of the width and be centered */\n  [data-slot=\"separator\"][data-orientation=\"horizontal\"] {\n    @apply ml-[3%] w-[94%];\n  }\n}\n","/* ==========================================================================\n   Base menu item styles\n   ========================================================================== */\n\n.menu-item {\n  @apply relative flex min-h-9 w-full items-center justify-start gap-3 rounded-2xl px-2 py-1.5 outline-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    box-shadow 150ms var(--ease-out);\n\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  [data-slot=\"label\"] {\n    @apply pointer-events-none w-fit select-none;\n  }\n\n  [data-slot=\"description\"] {\n    @apply pointer-events-none text-wrap select-none;\n  }\n\n  [data-slot=\"submenu-indicator\"] svg {\n    @apply size-3.5;\n  }\n\n  /* Add padding-left when indicator is present */\n  &:has(.menu-item__indicator) {\n    @apply pl-7;\n  }\n\n  /* Add padding-right when indicator is present and has submenu */\n  &[data-has-submenu=\"true\"]:has(.menu-item__indicator) {\n    @apply pr-7 pl-2;\n  }\n\n  /* Focus visible state (keyboard focus only) */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.98);\n  }\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default;\n    }\n  }\n\n  /* Selected state */\n  &[aria-checked=\"true\"],\n  &[aria-selected=\"true\"],\n  &[data-selected=\"true\"] {\n    [data-slot=\"menu-item-indicator--checkmark\"] {\n      /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n      transition: stroke-dashoffset 100ms linear;\n      @apply motion-reduce:transition-none;\n    }\n\n    [data-slot=\"menu-item-indicator--dot\"] {\n      /**\n       * Selected state: visible and scaled up\n       */\n      @apply scale-100 opacity-100;\n    }\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Menu item indicator\n   ========================================================================== */\n\n.menu-item__indicator {\n  @apply absolute top-1/2 left-2 flex size-4 shrink-0 -translate-y-1/2 items-center justify-center text-muted;\n\n  /**\n   * Transitions\n   */\n  @apply transition duration-250 motion-reduce:transition-none;\n\n  /* Position on the right when menu item has submenu */\n  .menu-item[data-has-submenu=\"true\"] & {\n    @apply right-2 left-auto;\n  }\n\n  /* Checkmark SVG indicator */\n  [data-slot=\"menu-item-indicator--checkmark\"] {\n    @apply size-2.5;\n\n    .menu-item[data-selection-mode=\"multiple\"] & {\n      /**\n       * Transitions\n       */\n      @apply transition-all duration-300 motion-reduce:transition-none;\n    }\n  }\n\n  /* Dot SVG indicator */\n  [data-slot=\"menu-item-indicator--dot\"] {\n    @apply size-2;\n\n    .menu-item[data-selection-mode=\"multiple\"] & {\n      /**\n     * Transitions\n     */\n      @apply transition-all duration-250 motion-reduce:transition-none;\n    }\n    /**\n     * Default state: hidden and scaled down\n     */\n    @apply scale-70 opacity-0;\n  }\n}\n\n/* Submenu indicator (chevron-right) */\n.menu-item__indicator--submenu {\n  @apply text-muted;\n\n  svg {\n    @apply size-3;\n  }\n}\n\n/* Default variant */\n.menu-item--default {\n}\n\n/* Danger variant */\n.menu-item--danger {\n  .menu-item__indicator {\n    @apply text-danger;\n  }\n\n  [data-slot=\"label\"] {\n    @apply text-danger;\n  }\n}\n","/* ==========================================================================\n   Base menu section styles\n   ========================================================================== */\n\n.menu-section {\n  @apply flex flex-col items-start gap-0;\n}\n","/* ==========================================================================\n   Base menu styles\n   ========================================================================== */\n\n.menu {\n  @apply relative flex w-full flex-col gap-1 overflow-clip p-1;\n\n  /* This makes the separator take up 94% of the width and be centered */\n  [data-slot=\"separator\"] {\n    @apply ml-[3%] w-[94%];\n  }\n}\n","/* Base styles */\n.tag-group {\n  @apply relative flex flex-col gap-1;\n}\n\n.tag-group__list {\n  @apply relative flex flex-wrap gap-1.5;\n}\n\n.tag-group [slot=\"description\"],\n.tag-group [data-slot=\"description\"],\n.tag-group [slot=\"errorMessage\"],\n.tag-group [data-slot=\"error-message\"] {\n  @apply p-1;\n}\n","/* Tag component styles */\n.tag {\n  --optical-offset: 0.031em;\n\n  @apply relative inline-flex items-center gap-1 rounded-xl font-medium select-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 100ms var(--ease-smooth),\n    scale 100ms var(--ease-smooth),\n    opacity 100ms var(--ease-smooth),\n    background-color 100ms var(--ease-smooth),\n    box-shadow 100ms var(--ease-out);\n  @apply origin-center transform-gpu motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* SVG icon styling */\n  & svg {\n    @apply pointer-events-none size-3 shrink-0 self-center text-current;\n  }\n}\n\n/* Disabled state */\n.tag:is([data-disabled=\"true\"], [aria-disabled=\"true\"]) {\n  @apply status-disabled;\n}\n\n/* Focus visible state (keyboard focus only) */\n.tag:is(:focus-visible, [data-focus-visible]) {\n  @apply status-focused;\n}\n\n/* Pressed/Active state */\n.tag:is(:active, [data-pressed=\"true\"]) {\n}\n\n/* Selected state */\n.tag:is([data-selected=\"true\"], [aria-selected=\"true\"]) {\n  @apply bg-accent-soft text-accent-soft-foreground;\n\n  /* Selected + Hover state */\n  @media (hover: hover) {\n    &:is(:hover, [data-hovered=\"true\"]) {\n      @apply bg-accent-soft-hover;\n    }\n  }\n}\n\n/* Size */\n.tag--sm {\n  @apply px-2 py-0.5 text-xs;\n}\n\n.tag--md {\n  @apply px-2 py-1 text-xs;\n}\n\n.tag--lg {\n  @apply rounded-2xl px-2.5 py-1.5 text-sm;\n}\n\n/* Variant */\n.tag--default {\n  @apply bg-default text-default-foreground;\n\n  /* Hover state (when not selected or disabled) */\n  @media (hover: hover) {\n    &:is(:hover, [data-hovered=\"true\"]):not([data-selected=\"true\"]):not([data-disabled=\"true\"]) {\n      @apply bg-default-hover;\n    }\n  }\n}\n\n.tag--surface {\n  @apply bg-surface text-surface-foreground;\n\n  /* Hover state (when not selected or disabled) */\n  @media (hover: hover) {\n    &:is(:hover, [data-hovered=\"true\"]):not([data-selected=\"true\"]):not([data-disabled=\"true\"]) {\n      @apply bg-surface-hover;\n    }\n  }\n}\n\n/* Remove Button  */\n.tag__remove-button {\n  @apply size-3 text-inherit;\n\n  /* SVG icon styling */\n  & svg {\n    @apply size-[inherit] shrink-0 self-center text-current;\n  }\n}\n","/* ==========================================================================\n   ColorArea - 2D color picker for selecting colors from a gradient area\n   ========================================================================== */\n\n/* Base styles */\n.color-area {\n  @apply relative w-full max-w-56 shrink-0 rounded-2xl no-highlight;\n\n  /* Square aspect ratio */\n  aspect-ratio: 1 / 1;\n\n  /* Color gradient background from React Aria */\n  background: var(--color-area-background);\n\n  /* Inner shadow for depth */\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n\n  /* Disabled state */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Dots overlay variant\n   ========================================================================== */\n\n.color-area--show-dots {\n  /* Dot pattern overlay using radial gradient */\n  &::after {\n    content: \"\";\n    @apply pointer-events-none absolute inset-0 rounded-[inherit];\n\n    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px);\n    background-size: 8px 8px;\n  }\n}\n\n/* ==========================================================================\n   Thumb element\n   ========================================================================== */\n\n.color-area__thumb {\n  @apply size-4 rounded-xl will-change-[width,height];\n\n  /* Current color from React Aria */\n  background-color: var(--color-area-thumb-color);\n\n  /* White border for visibility */\n  border: 3px solid white;\n\n  /* Inner shadow for depth */\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.1),\n    inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    width 150ms var(--ease-out),\n    height 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Focus state */\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Dragging state */\n  &[data-dragging=\"true\"] {\n    @apply size-5;\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n","/* ==========================================================================\n   ColorPicker - Color selection component with popover\n   ========================================================================== */\n\n/* Base color-picker styles */\n.color-picker {\n  @apply inline-flex;\n}\n\n/* ==========================================================================\n   Trigger\n   ========================================================================== */\n\n.color-picker__trigger {\n  @apply inline-flex items-center gap-3 rounded-sm text-sm no-highlight;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  [data-slot=\"label\"] {\n    cursor: var(--cursor-interactive);\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Popover\n   ========================================================================== */\n\n.color-picker__popover {\n  @apply min-w-62 origin-(--trigger-anchor-point) overflow-x-hidden overflow-y-auto overscroll-contain bg-overlay px-2 pt-2 pb-3;\n  box-shadow: var(--shadow-overlay);\n  border-radius: min(32px, calc(var(--radius) * 2.5));\n  /* Content layout */\n  @apply flex flex-col gap-3;\n\n  /* Hide scrollbar */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  /* For IE and Edge */\n  -ms-overflow-style: none;\n  /* For Firefox */\n  scrollbar-width: none;\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-95;\n\n    /* Placement-specific translations */\n    &[data-placement^=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement^=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement^=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement^=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n}\n","/* ==========================================================================\n   ColorSlider - A slider for adjusting individual color channel values\n   ========================================================================== */\n\n/* Base styles */\n.color-slider {\n  @apply grid w-full gap-1;\n\n  grid-template-areas:\n    \"label output\"\n    \"track track\";\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto;\n\n  /* When neither label nor output exist, collapse to single row */\n  &:not(:has([data-slot=\"label\"])):not(:has(.color-slider__output)) {\n    grid-template-areas: \"track\";\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    gap: 0;\n  }\n\n  /* When only label exists (no output) */\n  &:has([data-slot=\"label\"]):not(:has(.color-slider__output)) {\n    grid-template-areas:\n      \"label\"\n      \"track\";\n    grid-template-columns: 1fr;\n  }\n\n  /* When only output exists (no label) */\n  &:not(:has([data-slot=\"label\"])):has(.color-slider__output) {\n    grid-template-areas:\n      \"output\"\n      \"track\";\n    grid-template-columns: 1fr;\n\n    .color-slider__output {\n      justify-self: end;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit text-sm font-medium;\n\n    grid-area: label;\n  }\n\n  .color-slider__output {\n    @apply text-sm font-medium tabular-nums;\n\n    grid-area: output;\n  }\n\n  .color-slider__track {\n    @apply relative rounded-2xl;\n\n    grid-area: track;\n    /* Edge cap pseudo-elements */\n    &::before,\n    &::after {\n      content: \"\";\n      position: absolute;\n      z-index: 0;\n      pointer-events: none;\n    }\n  }\n\n  .color-slider__thumb {\n    /* Flex container for centering */\n    @apply absolute flex cursor-grab items-center justify-center rounded-2xl no-highlight;\n\n    /* Border to create white ring around the thumb */\n    @apply border-3 border-white shadow-overlay;\n\n    /* Ensure thumb is above edge caps */\n    z-index: 1;\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition:\n      transform 250ms var(--ease-out),\n      box-shadow 150ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n\n    /* Dragging state - cursor changes and thumb scales down */\n    &[data-dragging=\"true\"] {\n      @apply cursor-grabbing;\n    }\n\n    /* Focus state - show focus ring */\n    &[data-focus-visible=\"true\"] {\n      @apply z-10 status-focused;\n    }\n\n    /* Disabled state */\n    &[data-disabled=\"true\"] {\n      @apply cursor-default bg-default;\n    }\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n\n    [data-slot=\"label\"] {\n      @apply opacity-100;\n    }\n  }\n\n  /* Horizontal orientation */\n  &[data-orientation=\"horizontal\"] {\n    flex-direction: column;\n\n    .color-slider__track {\n      @apply h-5 justify-self-center rounded-none;\n      width: calc(100% - 1.25rem);\n\n      /* Default border for visibility against similar backgrounds */\n      box-shadow:\n        inset 0 1px 0 0 rgba(0, 0, 0, 0.1),\n        inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n\n      /* Edge caps for horizontal orientation */\n      &::before,\n      &::after {\n        @apply top-0 h-full;\n        width: 0.625rem; /* Half thumb width + 2px gap */\n      }\n\n      &::before {\n        @apply rounded-tl-2xl rounded-bl-2xl;\n        left: -0.625rem;\n        box-shadow:\n          inset 1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 1px 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n        background:\n          linear-gradient(var(--track-start-color, transparent)),\n          repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;\n      }\n\n      &::after {\n        @apply rounded-tr-2xl rounded-br-2xl;\n        right: -0.625rem;\n        box-shadow:\n          inset -1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 1px 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n        background-color: var(--track-end-color, transparent);\n      }\n    }\n\n    .color-slider__thumb {\n      @apply top-1/2 size-4;\n    }\n  }\n\n  /* Vertical orientation */\n  &[data-orientation=\"vertical\"] {\n    @apply h-full gap-2;\n\n    flex-direction: row;\n    grid-template-areas:\n      \"output\"\n      \"track\"\n      \"label\";\n    grid-template-rows: auto 1fr auto;\n    grid-template-columns: 1fr;\n    align-items: center;\n    justify-items: center;\n\n    /* When neither label nor output exist in vertical, just show track */\n    &:not(:has([data-slot=\"label\"])):not(:has(.color-slider__output)) {\n      grid-template-areas: \"track\";\n      grid-template-rows: 1fr;\n      gap: 0;\n    }\n\n    /* When only label exists in vertical (no output) */\n    &:has([data-slot=\"label\"]):not(:has(.color-slider__output)) {\n      grid-template-areas:\n        \"track\"\n        \"label\";\n      grid-template-rows: 1fr auto;\n    }\n\n    /* When only output exists in vertical (no label) */\n    &:not(:has([data-slot=\"label\"])):has(.color-slider__output) {\n      grid-template-areas:\n        \"output\"\n        \"track\";\n      grid-template-rows: auto 1fr;\n    }\n\n    .color-slider__output {\n      text-align: center;\n    }\n\n    [data-slot=\"label\"] {\n      text-align: center;\n    }\n\n    .color-slider__track {\n      @apply w-5 justify-self-center rounded-none;\n      height: calc(100% - 1.25rem);\n\n      /* Left and right borders for vertical track */\n      box-shadow:\n        inset 1px 0 0 0 rgba(0, 0, 0, 0.1),\n        inset -1px 0 0 0 rgba(0, 0, 0, 0.1);\n\n      /* Edge caps for vertical orientation */\n      &::before,\n      &::after {\n        @apply left-0 w-full;\n        height: 0.625rem; /* Half thumb height + 2px gap */\n      }\n\n      &::before {\n        bottom: -0.625rem;\n        border-bottom-left-radius: 999px;\n        border-bottom-right-radius: 999px;\n        /* Left, right, and bottom borders for bottom cap */\n        box-shadow:\n          inset 1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset -1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n        background:\n          linear-gradient(var(--track-start-color, transparent)),\n          repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;\n      }\n\n      &::after {\n        top: -0.625rem;\n        border-top-left-radius: 999px;\n        border-top-right-radius: 999px;\n        /* Left, right, and top borders for top cap */\n        box-shadow:\n          inset 1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset -1px 0 0 0 rgba(0, 0, 0, 0.1),\n          inset 0 1px 0 0 rgba(0, 0, 0, 0.1);\n        background-color: var(--track-end-color, transparent);\n      }\n    }\n\n    .color-slider__thumb {\n      @apply left-1/2 size-4;\n    }\n  }\n}\n","/* Base color-swatch styles */\n.color-swatch {\n  @apply relative box-border size-8 shrink-0;\n\n  /* Checkered background pattern for transparency */\n  background:\n    linear-gradient(var(--color-swatch-current), var(--color-swatch-current)),\n    repeating-conic-gradient(#efefef 0% 25%, #f7f7f7 0% 50%) 50% / 16px 16px;\n\n  /* Default border for visibility against similar backgrounds */\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n\n/* Shape variants */\n.color-swatch--circle {\n  @apply rounded-2xl;\n}\n\n.color-swatch--square {\n  @apply rounded-md;\n}\n\n/* Size variants */\n.color-swatch--xs {\n  @apply size-4;\n\n  &.color-swatch--circle {\n    @apply rounded-lg;\n  }\n}\n\n.color-swatch--sm {\n  @apply size-6;\n\n  &.color-swatch--circle {\n    @apply rounded-xl;\n  }\n}\n\n.color-swatch--md {\n  /* No additional styles — default size (32px) uses circle's base rounded-2xl */\n}\n\n.color-swatch--lg {\n  @apply size-9;\n\n  &.color-swatch--circle {\n    @apply rounded-3xl;\n  }\n}\n\n.color-swatch--xl {\n  @apply size-10;\n\n  &.color-swatch--circle {\n    @apply rounded-3xl;\n  }\n}\n","/* ==========================================================================\n   ColorSwatchPicker - A list of color swatches for selection\n   ========================================================================== */\n\n/* Base styles */\n.color-swatch-picker {\n  @apply flex flex-wrap items-center gap-2;\n}\n\n/* ==========================================================================\n   Item - Individual swatch picker item\n   ========================================================================== */\n\n.color-swatch-picker__item {\n  @apply relative flex size-8 items-center justify-center rounded-2xl border-2 border-transparent outline-none no-highlight;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    border-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Focus state */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Selected state */\n  &[data-selected=\"true\"] {\n    border-color: var(--color-swatch-current);\n    box-shadow: var(--field-shadow);\n    /* Shrink the swatch to reveal the white gap */\n    .color-swatch-picker__swatch {\n      transform: scale(0.77);\n    }\n  }\n}\n\n/* ==========================================================================\n   Swatch - The color swatch visual\n   ========================================================================== */\n\n.color-swatch-picker__swatch {\n  @apply block size-full;\n\n  /* Inherit border-radius from item */\n  border-radius: inherit;\n  /**\n  * Transitions\n  * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n  */\n  transition: transform 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  @media (hover: hover) {\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\n/* ==========================================================================\n   Indicator - Checkmark indicator for selected state\n   ========================================================================== */\n\n.color-swatch-picker__indicator {\n  @apply pointer-events-none absolute inset-0 z-10 flex items-center justify-center;\n\n  /* Checkmark SVG styles - default to white for dark backgrounds */\n  & > * {\n    @apply size-1/3 text-white;\n\n    /* Start scaled down - use translateZ(0) for GPU acceleration */\n    transform: scale(0) translateZ(0);\n\n    /**\n     * Transitions\n     */\n    transition: transform 150ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n  }\n\n  /* Use black checkmark on light backgrounds */\n  &[data-light-color=\"true\"] & > * {\n    @apply text-black;\n  }\n\n  /* Scale up when parent item is selected */\n  .color-swatch-picker__item[data-selected=\"true\"] & > * {\n    transform: scale(1) translateZ(0);\n  }\n}\n\n/* ==========================================================================\n   Layout variants\n   ========================================================================== */\n\n.color-swatch-picker--grid {\n  /* Default is already grid (flex-wrap) - no additional styles needed */\n}\n\n.color-swatch-picker--stack {\n  @apply flex-col;\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.color-swatch-picker--xs {\n  .color-swatch-picker__item {\n    @apply size-4 rounded-lg border;\n  }\n}\n\n.color-swatch-picker--sm {\n  .color-swatch-picker__item {\n    @apply size-6 rounded-xl border-2;\n  }\n}\n\n.color-swatch-picker--md {\n  .color-swatch-picker__item {\n    /* No styles as this is the default size */\n  }\n}\n\n.color-swatch-picker--lg {\n  .color-swatch-picker__item {\n    @apply size-9 rounded-3xl border-3;\n  }\n}\n\n.color-swatch-picker--xl {\n  .color-swatch-picker__item {\n    @apply size-10 rounded-3xl border-3;\n  }\n}\n\n/* ==========================================================================\n   Shape variants\n   ========================================================================== */\n\n/* Circle variant (default) - no additional styles needed */\n.color-swatch-picker--circle .color-swatch-picker__item {\n  /* Default is already circle - radius set per size */\n}\n\n/* Square variant */\n.color-swatch-picker--square {\n  .color-swatch-picker__item {\n    @apply rounded-xl;\n    .color-swatch-picker__swatch {\n      @apply rounded-lg;\n    }\n    &[data-selected=\"true\"] {\n      .color-swatch-picker__swatch {\n        @apply rounded-lg;\n      }\n    }\n  }\n}\n\n/* Square variant - item radius for xs */\n.color-swatch-picker--square.color-swatch-picker--xs {\n  .color-swatch-picker__item {\n    @apply rounded-md;\n    .color-swatch-picker__swatch {\n      @apply rounded-md;\n    }\n    &[data-selected=\"true\"] {\n      .color-swatch-picker__swatch {\n        @apply rounded-md;\n      }\n    }\n  }\n}\n\n/* Square variant - item radius for sm */\n.color-swatch-picker--square.color-swatch-picker--sm {\n  .color-swatch-picker__item {\n    @apply rounded-lg;\n    .color-swatch-picker__swatch {\n      @apply rounded-lg;\n    }\n    &[data-selected=\"true\"] {\n      .color-swatch-picker__swatch {\n        @apply rounded-md;\n      }\n    }\n  }\n}\n\n/* Square variant - item radius for md (default) */\n.color-swatch-picker--square.color-swatch-picker--md {\n  /* No styles as this is the default size */\n}\n\n/* Square variant - item radius for lg */\n.color-swatch-picker--square.color-swatch-picker--lg {\n  .color-swatch-picker__item {\n    @apply rounded-xl;\n    .color-swatch-picker__swatch {\n      @apply rounded-lg;\n    }\n    &[data-selected=\"true\"] {\n      .color-swatch-picker__swatch {\n        @apply rounded-lg;\n      }\n    }\n  }\n}\n\n/* Square variant - item radius for xl */\n.color-swatch-picker--square.color-swatch-picker--xl {\n  .color-swatch-picker__item {\n    @apply rounded-xl;\n    .color-swatch-picker__swatch {\n      @apply rounded-lg;\n    }\n    &[data-selected=\"true\"] {\n      .color-swatch-picker__swatch {\n        @apply rounded-lg;\n      }\n    }\n  }\n}\n","/* ==========================================================================\n   ColorInputGroup - Input group for color field with prefix/suffix support\n   ========================================================================== */\n\n/* Base styles */\n.color-input-group {\n  @apply inline-flex h-9 items-center overflow-hidden rounded-field border bg-field text-sm text-field-foreground shadow-field outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus within state */\n  &[data-focus-within=\"true\"],\n  &:focus-within {\n    @apply status-focused-field;\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n    border-color: var(--color-field-border-invalid);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Elements\n   ========================================================================== */\n\n.color-input-group__input {\n  @apply flex h-full flex-1 cursor-text items-center rounded-none border-0 bg-transparent px-3 py-2 text-base shadow-none outline-none sm:text-sm;\n\n  /* Placeholder styling */\n  &::placeholder {\n    @apply text-field-placeholder;\n  }\n\n  /* Remove border radius on left side when prefix is present */\n  .color-input-group:has([data-slot=\"color-input-group-prefix\"]) & {\n    @apply rounded-l-none pl-2;\n  }\n\n  /* Remove border radius on right side when suffix is present */\n  .color-input-group:has([data-slot=\"color-input-group-suffix\"]) & {\n    @apply rounded-r-none pr-2;\n  }\n\n  /* Focus state - handled by group */\n  &:focus,\n  &:focus-visible {\n    @apply outline-none;\n  }\n}\n\n.color-input-group__prefix {\n  @apply shrink-0 text-field-placeholder;\n  @apply mr-0 ml-3 flex items-center;\n}\n\n.color-input-group__suffix {\n  @apply shrink-0 text-field-placeholder;\n  @apply mr-3 flex items-center;\n}\n\n/* ==========================================================================\n   Variant modifiers\n   ========================================================================== */\n\n.color-input-group--primary {\n  /* Default styles - primary variant uses the base field styling */\n}\n\n.color-input-group--secondary {\n  @apply shadow-none;\n  background-color: var(--color-input-group-bg);\n\n  --color-input-group-bg: var(--color-default);\n  --color-input-group-bg-hover: var(--color-default-hover);\n  --color-input-group-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      background-color: var(--color-input-group-bg-hover);\n    }\n  }\n\n  &:focus-within,\n  &[data-focus-within=\"true\"] {\n    background-color: var(--color-input-group-bg-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    border-color: var(--color-field-border-invalid);\n    background-color: var(--color-input-group-bg-focus);\n  }\n\n  [data-slot=\"color-input-group-input\"] {\n    @apply bg-transparent;\n  }\n}\n\n/* ==========================================================================\n   Full width modifier\n   ========================================================================== */\n\n.color-input-group--full-width {\n  @apply w-full;\n}\n","/* ==========================================================================\n   ColorField - Form field for editing hex colors or individual color channels\n   ========================================================================== */\n\n/* Base styles */\n.color-field {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n}\n\n/* Full width modifier */\n.color-field--full-width {\n  @apply w-full;\n}\n","/* Slider styles */\n\n.slider {\n  @apply grid w-full gap-1;\n\n  grid-template-areas:\n    \"label output\"\n    \"track track\";\n  grid-template-columns: 1fr auto;\n\n  [data-slot=\"label\"] {\n    @apply w-fit text-sm font-medium;\n\n    grid-area: label;\n  }\n\n  .slider__output {\n    @apply text-sm font-medium tabular-nums;\n\n    grid-area: output;\n  }\n\n  .slider__track {\n    @apply relative rounded-xl bg-default;\n\n    grid-area: track;\n  }\n\n  .slider__fill {\n    @apply pointer-events-none absolute bg-accent;\n  }\n\n  .slider__thumb {\n    /* Flex container for centering pseudo-elements */\n    @apply absolute flex cursor-grab items-center justify-center rounded-xl bg-accent no-highlight;\n\n    /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n    transition:\n      background-color 250ms var(--ease-smooth),\n      transform 250ms var(--ease-out),\n      box-shadow 150ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n\n    /* after: Visible thumb element */\n    &::after {\n      @apply relative z-10 rounded-lg bg-accent-foreground text-black shadow-field;\n      content: \"\";\n\n      /**\n       * Transitions\n       */\n      @apply origin-center transition-all motion-reduce:transition-none;\n    }\n\n    /* Dragging state - cursor changes and thumb scales down */\n    &[data-dragging=\"true\"] {\n      @apply cursor-grabbing;\n\n      &::after {\n        @apply scale-[0.9] motion-reduce:scale-100;\n      }\n    }\n\n    /* Focus state - increase z-index */\n    &[data-focus-visible=\"true\"] {\n      @apply z-10 status-focused;\n    }\n\n    /* Disabled state */\n    &[data-disabled=\"true\"] {\n      @apply cursor-default;\n    }\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n\n    [data-slot=\"label\"] {\n      @apply opacity-100;\n    }\n  }\n\n  /* Horizontal orientation */\n  &[data-orientation=\"horizontal\"] {\n    flex-direction: column;\n\n    .slider__track {\n      @apply h-5 w-full;\n      /* Add transparent borders to provide space for thumb at edges */\n      /* Thumb width is 1.5rem (24px), so half is 0.75rem (12px) */\n      @apply border-x-[0.75rem] border-x-transparent;\n\n      &[data-fill-start=\"true\"] {\n        @apply border-s-accent;\n      }\n\n      &[data-fill-end=\"true\"] {\n        @apply border-e-accent;\n      }\n    }\n\n    .slider__fill,\n    .slider__thumb {\n      @apply h-full;\n    }\n\n    .slider__thumb {\n      @apply top-1/2;\n\n      /* Thumb width + border width */\n      width: calc(1.5rem + 0.25rem);\n\n      &::after {\n        width: 1.5rem;\n        height: 1rem;\n      }\n    }\n  }\n\n  /* Vertical orientation */\n  &[data-orientation=\"vertical\"] {\n    @apply h-full gap-2;\n\n    flex-direction: row;\n    grid-template-areas:\n      \"output\"\n      \"track\"\n      \"label\";\n    grid-template-rows: auto 1fr auto;\n    grid-template-columns: 1fr;\n\n    .slider__output {\n      text-align: center;\n    }\n\n    [data-slot=\"label\"] {\n      text-align: center;\n    }\n\n    .slider__track {\n      @apply h-full w-5;\n      /* Add transparent borders to provide space for thumb at edges */\n      /* Thumb height is 1.5rem (24px), so half is 0.75rem (12px) */\n      @apply border-y-[0.75rem] border-y-transparent;\n      justify-self: center;\n\n      &[data-fill-start=\"true\"] {\n        @apply border-b-accent;\n      }\n\n      &[data-fill-end=\"true\"] {\n        @apply border-t-accent;\n      }\n    }\n\n    .slider__fill,\n    .slider__thumb {\n      @apply w-full;\n    }\n\n    .slider__thumb {\n      @apply left-1/2;\n\n      /* Thumb height + border height */\n      height: calc(1.5rem + 0.25rem);\n\n      &::after {\n        width: 1rem;\n        height: 1.5rem;\n      }\n    }\n  }\n}\n","/* Switch base styles */\n.switch {\n  @apply inline-flex items-center gap-3 no-highlight;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Default tokens for switch control states */\n  --switch-control-bg: var(--color-default);\n  --switch-control-bg-hover: color-mix(in oklab, var(--switch-control-bg), transparent 20%);\n  --switch-control-bg-pressed: var(--switch-control-bg-hover);\n  --switch-control-bg-checked: var(--color-accent);\n  --switch-control-bg-checked-hover: var(--color-accent-hover);\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n\n    .switch__thumb {\n      @apply bg-default-foreground/20;\n    }\n  }\n\n  /* Disabled + Selected state */\n  &:disabled[aria-checked=\"true\"],\n  &:disabled[data-selected=\"true\"],\n  &[data-disabled=\"true\"][aria-checked=\"true\"],\n  &[data-disabled=\"true\"][data-selected=\"true\"],\n  &[aria-disabled=\"true\"][aria-checked=\"true\"],\n  &[aria-disabled=\"true\"][data-selected=\"true\"] {\n    .switch__thumb {\n      opacity: 0.4;\n    }\n  }\n}\n\n/* Size variants - default is medium */\n.switch--sm {\n  /* Small size modifier */\n}\n\n.switch--md {\n  /* Medium size - no styles as this is the default */\n}\n\n.switch--lg {\n  /* Large size modifier */\n}\n\n/* Switch control (track) */\n.switch__control {\n  /* Default size (medium) */\n  @apply relative flex shrink-0 items-center overflow-hidden rounded-xl;\n  height: 1.25rem; /* 20px on desktop (14px base), 20px on mobile (16px base) - scales with font-size */\n  width: 2.5rem; /* 35px on desktop, 40px on mobile - scales with font-size */\n\n  background-color: var(--switch-control-bg);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 250ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Focus states */\n  .switch:focus-visible &,\n  .switch[data-focus-visible=\"true\"] & {\n    @apply status-focused;\n  }\n\n  /* Hover states */\n  .switch:hover &,\n  .switch[data-hovered=\"true\"] & {\n    background-color: var(--switch-control-bg-hover);\n  }\n\n  /* Pressed states */\n  .switch:active &,\n  .switch[data-pressed=\"true\"] & {\n    background-color: var(--switch-control-bg-pressed);\n    @apply motion-reduce:transform-none;\n  }\n\n  /* Checked states */\n  .switch[aria-checked=\"true\"] &,\n  .switch[data-selected=\"true\"] & {\n    background-color: var(--switch-control-bg-checked);\n  }\n\n  /* Checked + Hover states */\n  .switch[aria-checked=\"true\"]:hover &,\n  .switch[data-selected=\"true\"]:hover &,\n  .switch[aria-checked=\"true\"][data-hovered=\"true\"] &,\n  .switch[data-selected=\"true\"][data-hovered=\"true\"] & {\n    background-color: var(--switch-control-bg-checked-hover);\n  }\n\n  /* Checked + Pressed states */\n  .switch[aria-checked=\"true\"]:active &,\n  .switch[data-selected=\"true\"]:active &,\n  .switch[aria-checked=\"true\"][data-pressed=\"true\"] &,\n  .switch[data-selected=\"true\"][data-pressed=\"true\"] & {\n    background-color: var(--switch-control-bg-checked-hover);\n  }\n}\n\n/* Size-specific control dimensions */\n.switch--sm .switch__control {\n  @apply rounded-lg;\n  height: 1rem; /* ~14px on desktop, ~16px on mobile */\n  width: 2rem; /* ~32px on desktop, ~36px on mobile */\n}\n\n.switch--md .switch__control {\n  /* No styles as this is the default size */\n}\n\n.switch--lg .switch__control {\n  height: 1.5rem; /* ~21px on desktop, ~24px on mobile */\n  width: 3rem; /* ~48px on desktop, ~56px on mobile */\n}\n\n/* Switch thumb */\n.switch__thumb {\n  /* Default size (medium) with margin-based positioning */\n  @apply ms-0.5 flex origin-center rounded-lg bg-white text-black shadow-field;\n  height: 1rem; /* ~14px on desktop, ~16px on mobile */\n  width: 1.375rem; /* ~19px on desktop, ~22px on mobile */\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    margin 300ms var(--ease-out-fluid),\n    background-color 200ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Selected/checked state - use margin instead of translate */\n  .switch[aria-checked=\"true\"] &,\n  .switch[data-selected=\"true\"] & {\n    @apply ms-[calc(100%-1.5rem)] bg-accent-foreground text-accent;\n    box-shadow:\n      0px 0px 5px 0px rgb(0 0 0 / 0.02),\n      0px 2px 10px 0px rgb(0 0 0 / 0.06),\n      0px 0px 1px 0px rgb(0 0 0 / 0.3);\n  }\n\n  .switch:active &,\n  .switch[data-pressed=\"true\"] & {\n  }\n}\n\n/* Size-specific thumb dimensions */\n.switch--sm .switch__thumb {\n  @apply rounded-md;\n  height: 0.75rem; /* ~10.5px on desktop, ~12px on mobile */\n  width: 1.03125rem; /* ~14.4px on desktop, ~16.5px on mobile - maintains 1.375:1 ratio */\n\n  /* Small selected state positioning */\n  .switch[aria-checked=\"true\"] &,\n  .switch[data-selected=\"true\"] & {\n    @apply ms-[calc(100%-1.15625rem)];\n  }\n}\n\n.switch--lg .switch__thumb {\n  @apply rounded-xl;\n  height: 1.25rem; /* ~17.5px on desktop, ~20px on mobile */\n  width: 1.71875rem; /* ~24px on desktop, ~27.5px on mobile - maintains 1.375:1 ratio */\n\n  /* Large selected state positioning */\n  .switch[aria-checked=\"true\"] &,\n  .switch[data-selected=\"true\"] & {\n    @apply ms-[calc(100%-1.84375rem)];\n  }\n}\n\n/* Switch thumb content container */\n.switch__thumb > * {\n  @apply flex size-full items-center justify-center;\n}\n\n/* Switch label */\n.switch__label {\n  @apply text-base font-medium text-foreground;\n}\n\n/* Switch content */\n.switch__content {\n  @apply flex flex-col gap-0;\n}\n","/* Switch Group styles */\n.switch-group {\n  @apply flex flex-col gap-6;\n}\n\n.switch-group__items {\n  @apply flex gap-4;\n}\n\n/* Orientation modifiers */\n.switch-group--horizontal .switch-group__items {\n  @apply flex-row;\n}\n\n.switch-group--vertical .switch-group__items {\n  @apply flex-col;\n}\n","/* ==========================================================================\n   Badge - Small informational badges for displaying labels, statuses, and categories.\n   ========================================================================== */\n\n/* Base styles */\n.badge {\n  @apply inline-flex shrink-0 items-center justify-center gap-0.5 font-medium;\n\n  /* Default size (matches --md) */\n  @apply min-h-7 min-w-7 rounded-3xl text-xs leading-[1.34];\n\n  /* Default tokens */\n  --badge-bg: var(--color-default);\n  --badge-fg: var(--color-default-foreground);\n  --badge-border: var(--color-background);\n\n  background-color: var(--badge-bg);\n  color: var(--badge-fg);\n  border: 1px solid var(--badge-border);\n}\n\n.badge__label {\n  @apply px-0.5;\n}\n\n.badge-anchor {\n  @apply relative inline-flex shrink-0;\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.badge--lg {\n  @apply min-h-8 min-w-8 rounded-2xl text-sm leading-[1.43];\n}\n\n.badge--md {\n  /* No styles as this is the default size */\n}\n\n.badge--sm {\n  @apply min-h-4 min-w-4 rounded-xl text-[10px] leading-[1.34];\n}\n\n/* ==========================================================================\n   Color variants - set foreground color\n   ========================================================================== */\n\n.badge--accent {\n  --badge-fg: var(--color-accent-soft-foreground);\n}\n\n.badge--default {\n  --badge-fg: var(--color-default-foreground);\n}\n\n.badge--success {\n  --badge-fg: var(--color-success);\n}\n\n.badge--warning {\n  --badge-fg: var(--color-warning);\n}\n\n.badge--danger {\n  --badge-fg: var(--color-danger);\n}\n\n/* ==========================================================================\n   Variant styles\n   ========================================================================== */\n\n.badge--primary {\n  /* Solid background - compound variants below handle bg/fg per color */\n}\n\n.badge--secondary {\n  /* Default background with colored text - base behavior */\n}\n\n.badge--soft {\n  /* Soft/muted background - compound variants below handle bg/fg per color */\n}\n\n/* ==========================================================================\n   Placement variants\n   ========================================================================== */\n\n.badge--top-right {\n  @apply absolute top-0 right-0;\n  transform: translate(25%, -25%);\n}\n\n.badge--top-left {\n  @apply absolute top-0 left-0;\n  transform: translate(-25%, -25%);\n}\n\n.badge--bottom-right {\n  @apply absolute right-0 bottom-0;\n  transform: translate(25%, 25%);\n}\n\n.badge--bottom-left {\n  @apply absolute bottom-0 left-0;\n  transform: translate(-25%, 25%);\n}\n\n/* ==========================================================================\n   Compound variants - Primary (solid background)\n   ========================================================================== */\n\n.badge--primary.badge--accent {\n  --badge-bg: var(--color-accent);\n  --badge-fg: var(--color-accent-foreground);\n}\n\n.badge--primary.badge--default {\n  --badge-bg: var(--color-default);\n  --badge-fg: var(--color-default-foreground);\n}\n\n.badge--primary.badge--success {\n  --badge-bg: var(--color-success);\n  --badge-fg: var(--color-success-foreground);\n}\n\n.badge--primary.badge--warning {\n  --badge-bg: var(--color-warning);\n  --badge-fg: var(--color-warning-foreground);\n}\n\n.badge--primary.badge--danger {\n  --badge-bg: var(--color-danger);\n  --badge-fg: var(--color-danger-foreground);\n}\n\n/* ==========================================================================\n   Compound variants - Soft (muted background)\n   ========================================================================== */\n\n.badge--soft.badge--accent {\n  --badge-bg: var(--color-accent-soft);\n  --badge-fg: var(--color-accent-soft-foreground);\n}\n\n.badge--soft.badge--default {\n  --badge-bg: var(--color-default);\n  --badge-fg: var(--color-default-foreground);\n}\n\n.badge--soft.badge--success {\n  --badge-bg: var(--color-success-soft);\n  --badge-fg: var(--color-success-soft-foreground);\n}\n\n.badge--soft.badge--warning {\n  --badge-bg: var(--color-warning-soft);\n  --badge-fg: var(--color-warning-soft-foreground);\n}\n\n.badge--soft.badge--danger {\n  --badge-bg: var(--color-danger-soft);\n  --badge-fg: var(--color-danger-soft-foreground);\n}\n","/* Base styles */\n.chip {\n  @apply inline-flex shrink-0 items-center gap-0.5 rounded-2xl px-2 py-0.5 text-xs leading-5 font-medium;\n\n  /* Default tokens */\n  --chip-bg: var(--color-default);\n  --chip-fg: currentColor;\n\n  background-color: var(--chip-bg);\n  color: var(--chip-fg);\n}\n\n.chip__label {\n  @apply px-0.5;\n}\n\n/* Color variants - set foreground color */\n.chip--accent {\n  --chip-fg: var(--color-accent-soft-foreground);\n}\n\n.chip--danger {\n  --chip-fg: var(--color-danger);\n}\n\n.chip--default {\n  --chip-fg: var(--color-default-foreground);\n}\n\n.chip--success {\n  --chip-fg: var(--color-success);\n}\n\n.chip--warning {\n  --chip-fg: var(--color-warning);\n}\n\n/* Variant styles */\n.chip--primary {\n}\n\n.chip--secondary {\n  /* No additional styles for secondary variant */\n}\n\n.chip--tertiary {\n  --chip-bg: transparent;\n}\n\n/* Size variants */\n.chip--sm {\n  @apply px-1 py-0 text-xs;\n}\n\n.chip--md {\n  @apply text-xs;\n}\n\n.chip--lg {\n  @apply px-3 py-1 text-sm font-medium;\n}\n\n/* ====================== */\n/* = Compound variants = */\n/* ====================== */\n\n/* Primary variants - solid backgrounds */\n.chip--primary.chip--accent {\n  --chip-bg: var(--color-accent);\n  --chip-fg: var(--color-accent-foreground);\n}\n\n.chip--primary.chip--success {\n  --chip-bg: var(--color-success);\n  --chip-fg: var(--color-success-foreground);\n}\n\n.chip--primary.chip--warning {\n  --chip-bg: var(--color-warning);\n  --chip-fg: var(--color-warning-foreground);\n}\n\n.chip--primary.chip--danger {\n  --chip-bg: var(--color-danger);\n  --chip-fg: var(--color-danger-foreground);\n}\n\n/* Soft variants - muted backgrounds */\n.chip--accent.chip--soft {\n  --chip-bg: var(--color-accent-soft);\n  --chip-fg: var(--color-accent-soft-foreground);\n}\n\n.chip--success.chip--soft {\n  --chip-bg: var(--color-success-soft);\n  --chip-fg: var(--color-success-soft-foreground);\n}\n\n.chip--warning.chip--soft {\n  --chip-bg: var(--color-warning-soft);\n  --chip-fg: var(--color-warning-soft-foreground);\n}\n\n.chip--danger.chip--soft {\n  --chip-bg: var(--color-danger-soft);\n  --chip-fg: var(--color-danger-soft-foreground);\n}\n","/* ==========================================================================\n   Table — Data display component for structured tabular data.\n   ========================================================================== */\n\n/* --------------------------------------------------------------------------\n   Table Root — Outer container for table + optional footer.\n   Primary variant: gray background with the table body as a white card inside.\n   -------------------------------------------------------------------------- */\n.table-root {\n  @apply relative grid w-full overflow-clip;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n/* --------------------------------------------------------------------------\n   Scroll Container — Allows the table to scroll horizontally while the\n   wrapper and footer remain at full width. The parent grid with\n   minmax(0, 1fr) creates a hard width boundary that table layout\n   cannot push beyond.\n   -------------------------------------------------------------------------- */\n.table__scroll-container {\n  @apply overflow-x-auto;\n  /* Custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: oklch(0% 0 0 / 0.15) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: oklch(0% 0 0 / 0.15);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: oklch(0% 0 0 / 0.25);\n  }\n\n  /* Dark mode scrollbar */\n  :is([data-theme=\"dark\"], .dark) & {\n    scrollbar-color: oklch(100% 0 0 / 0.15) transparent;\n\n    &::-webkit-scrollbar-thumb {\n      background: oklch(100% 0 0 / 0.15);\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: oklch(100% 0 0 / 0.25);\n    }\n  }\n}\n\n.table-root--primary {\n  @apply bg-surface-secondary px-1 pb-1;\n  border-radius: min(32px, calc(var(--radius) * 2.5));\n}\n\n.table-root--secondary {\n  /* No background, padding, or rounding on the root */\n}\n\n/* Secondary: header is a standalone rounded card.\n   Background is on cells (not <thead>) because Firefox does not support */\n.table-root--secondary .table__header {\n  @apply border-b-0 bg-transparent;\n}\n\n.table-root--secondary .table__column {\n  @apply bg-surface-secondary;\n}\n\n.table-root--secondary .table__column:first-child {\n  border-top-left-radius: min(32px, var(--radius-2xl));\n  border-bottom-left-radius: min(32px, var(--radius-2xl));\n}\n\n.table-root--secondary .table__column:last-child {\n  border-top-right-radius: min(32px, var(--radius-2xl));\n  border-bottom-right-radius: min(32px, var(--radius-2xl));\n}\n\n/* Secondary: body has no shadow or rounded corners */\n.table-root--secondary .table__body {\n  @apply shadow-none;\n\n  /* Non-virtualized */\n  & tr:first-child td:first-child,\n  & tr:first-child td:last-child,\n  & tr:last-child td:first-child,\n  & tr:last-child td:last-child {\n    @apply rounded-none;\n  }\n\n  /* Virtualized: undo the rounding applied by .table__body:not(tbody) */\n  &:not(tbody) {\n    @apply overflow-visible rounded-none;\n  }\n}\n\n/* Secondary: rows are transparent and keep bottom border on every row */\n.table-root--secondary .table__row {\n  .table__cell {\n    @apply border-b border-separator-tertiary/50 bg-transparent;\n  }\n\n  @media (hover: hover) {\n    &:hover .table__cell,\n    &[data-hovered=\"true\"] .table__cell {\n      @apply bg-default/50;\n    }\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table Content (<table> element) — the white card inside the root\n   -------------------------------------------------------------------------- */\n.table__content {\n  @apply w-full border-separate border-spacing-0 text-sm;\n}\n\n/* Primary variant: table gets the white surface card look */\n.table-root--primary .table__content {\n  @apply overflow-clip;\n}\n\n/* --------------------------------------------------------------------------\n   Table Header (<thead>)\n   -------------------------------------------------------------------------- */\n.table__header {\n  @apply border-b border-separator/50 bg-surface-secondary;\n}\n\n/* --------------------------------------------------------------------------\n   Table Column (<th>)\n   -------------------------------------------------------------------------- */\n.table__column {\n  @apply relative px-4 py-2.5 text-left text-xs font-medium text-muted;\n\n  /* Separator between columns — a short vertical line on the right edge */\n  &::after {\n    content: \"\";\n    @apply pointer-events-none absolute top-1/2 right-0 h-4 w-px -translate-y-1/2 rounded-sm bg-separator;\n  }\n\n  &:last-child:not(:only-child)::after {\n    content: none;\n  }\n\n  /* Sortable columns */\n  &[data-allows-sorting=\"true\"] {\n    cursor: var(--cursor-interactive);\n  }\n\n  @media (hover: hover) {\n    &[data-allows-sorting=\"true\"]:hover,\n    &[data-allows-sorting=\"true\"][data-hovered=\"true\"] {\n      @apply text-foreground;\n    }\n  }\n\n  /* Focus visible — inset shadow for consistent table focus styling */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply rounded-lg outline-none;\n    box-shadow: inset 0 0 0 2px var(--color-focus);\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table Body (<tbody>)\n   -------------------------------------------------------------------------- */\n.table__body {\n  /* Non-virtualized: round corners via first/last cells\n     (border-radius on <tbody> itself has no effect) */\n  & tr:first-child td:first-child {\n    border-top-left-radius: min(32px, var(--radius-2xl));\n  }\n  & tr:first-child td:last-child {\n    border-top-right-radius: min(32px, var(--radius-2xl));\n  }\n  & tr:last-child td:first-child {\n    border-bottom-left-radius: min(32px, var(--radius-2xl));\n  }\n  & tr:last-child td:last-child {\n    border-bottom-right-radius: min(32px, var(--radius-2xl));\n  }\n\n  /* Virtualized: elements are divs, not tr/td. VirtualizerItem wrappers\n     break :first-child/:last-child on rows and cells, so round the body\n     itself and clip overflow instead. */\n  &:not(tbody) {\n    @apply relative h-full overflow-clip;\n    border-radius: min(32px, var(--radius-2xl));\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table Row (<tr>)\n   -------------------------------------------------------------------------- */\n.table__row {\n  @apply relative h-full;\n\n  /* Bottom separator */\n  @apply border-b border-separator/50;\n\n  /* Last row in body has no bottom border */\n  &:last-child {\n    @apply border-b-0;\n  }\n\n  /* Hover state — applied to cells so Firefox clips bg to border-radius */\n  @media (hover: hover) {\n    &:hover .table__cell,\n    &[data-hovered=\"true\"] .table__cell {\n      @apply bg-surface/40;\n    }\n  }\n\n  /* Selected state */\n  &[data-selected=\"true\"] .table__cell {\n    @apply bg-surface/10;\n  }\n\n  /* Disabled state */\n  &[aria-disabled=\"true\"],\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Row focus ring: see “Table row focus ring” block below (after `.table__cell`). */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Dragging state */\n  &[data-dragging=\"true\"] {\n    @apply opacity-50;\n  }\n\n  /* Drop target state */\n  &[data-drop-target=\"true\"] .table__cell {\n    @apply bg-accent-soft;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table Cell (<td>)\n   -------------------------------------------------------------------------- */\n.table__cell {\n  @apply h-full bg-surface px-4 py-3 align-middle text-sm text-foreground;\n\n  @apply border-b border-separator-tertiary/50;\n\n  /* Focus visible — inset shadow so focus stays within the cell boundaries */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply rounded-lg outline-none;\n    box-shadow: inset 0 0 0 2px var(--color-focus);\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table row focus ring — must follow `.table__cell` (cascade). One continuous\n   inset ring split across cells; `:is(.table__cell, .table__column)` + direct vs\n   `> *:…` covers virtualized wrappers. `:is(:focus-visible, [data-focus-visible])`\n   matches row keyboard focus from RAC.\n   -------------------------------------------------------------------------- */\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"]) :is(.table__cell, .table__column) {\n  @apply shadow-none;\n}\n\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > :is(.table__cell, .table__column):only-child,\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > *:only-child\n  :is(.table__cell, .table__column) {\n  @apply rounded-lg shadow-[inset_0_0_0_2px_var(--color-focus)] outline-none;\n}\n\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > :is(.table__cell, .table__column):first-child:not(:only-child),\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > *:first-child:not(:only-child)\n  :is(.table__cell, .table__column) {\n  @apply rounded-l-lg shadow-[inset_2px_0_0_0_var(--color-focus),inset_0_2px_0_0_var(--color-focus),inset_0_-2px_0_0_var(--color-focus)] outline-none;\n}\n\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > :is(.table__cell, .table__column):last-child:not(:only-child),\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > *:last-child:not(:only-child)\n  :is(.table__cell, .table__column) {\n  @apply rounded-r-lg shadow-[inset_-2px_0_0_0_var(--color-focus),inset_0_2px_0_0_var(--color-focus),inset_0_-2px_0_0_var(--color-focus)] outline-none;\n}\n\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > :is(.table__cell, .table__column):not(:first-child):not(:last-child):not(:only-child),\n.table__row:is(:focus-visible, [data-focus-visible=\"true\"])\n  > *:not(:first-child):not(:last-child):not(:only-child)\n  :is(.table__cell, .table__column) {\n  @apply shadow-[inset_0_2px_0_0_var(--color-focus),inset_0_-2px_0_0_var(--color-focus)] outline-none;\n}\n\n/* --------------------------------------------------------------------------\n   Tree / expandable rows — indent the tree column by depth (any level).\n   React Aria sets `--table-row-level` (1-based) on each body row and\n   `data-level` on cells; tree column cells expose `[data-tree-column]`.\n   The row custom property inherits onto cells (1rem per level).\n   -------------------------------------------------------------------------- */\n.table__cell[data-tree-column] {\n  padding-inline-start: calc(1rem * var(--table-row-level, 1));\n}\n\n/* --------------------------------------------------------------------------\n   Table Footer (div outside <table>, sits on gray bg)\n   -------------------------------------------------------------------------- */\n.table__footer {\n  @apply flex items-center px-4 py-2.5;\n}\n\n/* --------------------------------------------------------------------------\n   Resizable Container — wraps table to enable column resizing via React Aria.\n   -------------------------------------------------------------------------- */\n.table__resizable-container {\n  @apply relative overflow-auto;\n}\n\n/* --------------------------------------------------------------------------\n   Column Resizer — drag handle between resizable columns.\n   Replaces the ::after separator when present.\n   -------------------------------------------------------------------------- */\n.table__column-resizer {\n  /* Match the ::after separator: absolute, right edge, short vertical line */\n  @apply absolute top-1/2 right-0 h-4 w-px -translate-y-1/2 rounded-sm bg-separator;\n  /* Make it interactive — wider hit area with transparent padding */\n  @apply box-content translate-x-1/2 cursor-col-resize touch-none px-2;\n  /* Reset appearance */\n  @apply border-none bg-clip-content outline-none;\n\n  &[data-hovered=\"true\"],\n  &:hover {\n    @apply h-full w-0.5 bg-accent;\n  }\n\n  &[data-resizing=\"true\"] {\n    @apply h-full w-0.5 bg-accent;\n  }\n\n  &[data-focus-visible=\"true\"],\n  &:focus-visible {\n    @apply h-full w-0.5 bg-focus;\n  }\n}\n\n/* Hide the ::after separator when a resizer is present in the column */\n.table__column:has(.table__column-resizer)::after {\n  content: none;\n}\n\n/* --------------------------------------------------------------------------\n   Load More Item — sentinel row for infinite scrolling.\n   Non-virtualized: <tr> with <td colSpan=N> inside.\n   Virtualized: <div> with <div role=\"rowheader\"> inside.\n   -------------------------------------------------------------------------- */\n.table__load-more {\n  & td,\n  & [role=\"rowheader\"] {\n    @apply py-3 text-center;\n    & > * {\n      @apply mx-auto;\n    }\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Load More Content — styled container for the loading indicator inside\n   the load-more sentinel row.\n   -------------------------------------------------------------------------- */\n.table__load-more-content {\n  @apply flex items-center justify-center gap-2 py-2;\n}\n","/* Alert component styles */\n\n/* Base alert styles */\n.alert {\n  @apply flex w-full flex-row items-start justify-start gap-4 bg-surface px-4 py-3 shadow-surface;\n  border-radius: min(32px, var(--radius-3xl));\n}\n\n/* Alert elements */\n.alert__content {\n  @apply flex h-full grow flex-col items-start;\n}\n\n.alert__indicator {\n  @apply flex items-center justify-center p-1 select-none;\n\n  [data-slot=\"alert-default-icon\"] {\n    @apply box-content size-4;\n  }\n}\n\n.alert__title {\n  @apply text-sm leading-6 font-medium;\n}\n\n.alert__description {\n  @apply text-sm text-muted;\n}\n\n/* Variant modifiers */\n.alert--default .alert__indicator {\n  @apply text-foreground;\n}\n\n.alert--default .alert__title {\n  @apply text-foreground;\n}\n\n.alert--accent .alert__indicator {\n  @apply text-accent;\n}\n\n.alert--accent .alert__title {\n  @apply text-accent;\n}\n\n.alert--success .alert__indicator {\n  @apply text-success;\n}\n\n.alert--success .alert__title {\n  @apply text-success;\n}\n\n.alert--warning .alert__indicator {\n  @apply text-warning;\n}\n\n.alert--warning .alert__title {\n  @apply text-warning;\n}\n\n.alert--danger .alert__indicator {\n  @apply text-danger;\n}\n\n.alert--danger .alert__title {\n  @apply text-danger;\n}\n","/* Base empty-state styles */\n.empty-state {\n  @apply p-2 text-sm text-muted;\n}\n",".skeleton {\n  @apply pointer-events-none relative overflow-hidden rounded-sm bg-surface-tertiary/70;\n}\n\n/* TODO: Skeleton with parent are not visible */\n\n/* Animation types */\n.skeleton--shimmer {\n  &::after {\n    @apply absolute inset-0 -translate-x-full animate-skeleton bg-linear-to-r from-transparent via-surface-tertiary to-transparent content-[''];\n  }\n\n  /* When applied to a parent container with multiple skeletons */\n  &:has(.skeleton) {\n    &::after {\n      content: none;\n    }\n\n    /* Single synchronized shimmer that passes over all children */\n    &::before {\n      @apply absolute inset-0 -translate-x-full animate-skeleton content-[''];\n      background: linear-gradient(\n        90deg,\n        transparent 0%,\n        rgba(255, 255, 255, 0.5) 50%,\n        transparent 100%\n      );\n      z-index: 10;\n      pointer-events: none;\n      /* Use mix-blend-mode to only show over skeleton elements */\n      mix-blend-mode: overlay;\n    }\n\n    /* Ensure children don't have their own shimmer */\n    & .skeleton {\n      &::after {\n        content: none;\n      }\n    }\n  }\n}\n\n.skeleton--pulse {\n  @apply animate-pulse;\n}\n\n.skeleton--none {\n}\n","/* ==========================================================================\n   Meter - A quantity indicator within a known range\n   ========================================================================== */\n\n/* Base styles */\n.meter {\n  @apply grid w-full gap-1;\n  grid-template-areas:\n    \"label output\"\n    \"track track\";\n  grid-template-columns: 1fr auto;\n\n  /* Default color tokens (accent) */\n  --meter-fill: var(--color-accent);\n\n  [data-slot=\"label\"] {\n    @apply w-fit text-sm font-medium;\n\n    grid-area: label;\n  }\n\n  .meter__output {\n    @apply text-sm font-medium tabular-nums;\n\n    grid-area: output;\n  }\n\n  .meter__track {\n    @apply relative overflow-hidden rounded-sm bg-default;\n\n    grid-area: track;\n\n    /* Default height (matches --md) */\n    @apply h-2;\n  }\n\n  .meter__fill {\n    @apply absolute top-0 left-0 h-full rounded-sm;\n\n    background-color: var(--meter-fill);\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition: width 300ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n\n    [data-slot=\"label\"] {\n      @apply opacity-100;\n    }\n  }\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.meter--sm {\n  .meter__track {\n    @apply h-1 rounded-xs;\n  }\n\n  .meter__fill {\n    @apply rounded-xs;\n  }\n}\n\n.meter--md {\n  /* No styles as this is the default size */\n}\n\n.meter--lg {\n  .meter__track {\n    @apply h-3 rounded-md;\n  }\n\n  .meter__fill {\n    @apply rounded-md;\n  }\n}\n\n/* ==========================================================================\n   Color variants\n   ========================================================================== */\n\n.meter--default {\n  --meter-fill: var(--color-default-foreground);\n}\n\n.meter--accent {\n  --meter-fill: var(--color-accent);\n}\n\n.meter--success {\n  --meter-fill: var(--color-success);\n}\n\n.meter--warning {\n  --meter-fill: var(--color-warning);\n}\n\n.meter--danger {\n  --meter-fill: var(--color-danger);\n}\n","/* ==========================================================================\n   ProgressBar - Shows determinate or indeterminate progress\n   ========================================================================== */\n\n/* Base styles */\n.progress-bar {\n  @apply grid w-full gap-1;\n  grid-template-areas:\n    \"label output\"\n    \"track track\";\n  grid-template-columns: 1fr auto;\n\n  /* Default color token (accent) */\n  --progress-bar-fill: var(--color-accent);\n\n  [data-slot=\"label\"] {\n    @apply w-fit text-sm font-medium;\n\n    grid-area: label;\n  }\n\n  .progress-bar__output {\n    @apply text-sm font-medium tabular-nums;\n\n    grid-area: output;\n  }\n\n  .progress-bar__track {\n    @apply relative overflow-hidden rounded-sm bg-default;\n\n    grid-area: track;\n\n    /* Default height (matches --md) */\n    @apply h-2;\n  }\n\n  .progress-bar__fill {\n    @apply absolute top-0 left-0 h-full rounded-sm;\n\n    background-color: var(--progress-bar-fill);\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition: width 300ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n  }\n\n  /* Indeterminate state - when no aria-valuenow is set */\n  &:not([aria-valuenow]) {\n    .progress-bar__fill {\n      @apply w-2/5;\n\n      animation: progress-bar-indeterminate 1.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;\n\n      @apply motion-reduce:animate-none;\n    }\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n\n    [data-slot=\"label\"] {\n      @apply opacity-100;\n    }\n  }\n}\n\n/* ==========================================================================\n   Indeterminate animation\n   ========================================================================== */\n\n@keyframes progress-bar-indeterminate {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(350%);\n  }\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.progress-bar--sm {\n  .progress-bar__track {\n    @apply h-1 rounded-xs;\n  }\n\n  .progress-bar__fill {\n    @apply rounded-xs;\n  }\n}\n\n.progress-bar--md {\n  /* No styles as this is the default size */\n}\n\n.progress-bar--lg {\n  .progress-bar__track {\n    @apply h-3 rounded-md;\n  }\n\n  .progress-bar__fill {\n    @apply rounded-md;\n  }\n}\n\n/* ==========================================================================\n   Color variants\n   ========================================================================== */\n\n.progress-bar--default {\n  --progress-bar-fill: var(--color-default-foreground);\n}\n\n.progress-bar--accent {\n  --progress-bar-fill: var(--color-accent);\n}\n\n.progress-bar--success {\n  --progress-bar-fill: var(--color-success);\n}\n\n.progress-bar--warning {\n  --progress-bar-fill: var(--color-warning);\n}\n\n.progress-bar--danger {\n  --progress-bar-fill: var(--color-danger);\n}\n","/* ==========================================================================\n   ProgressCircle - Circular progress indicator\n   ========================================================================== */\n\n/* Base styles */\n.progress-circle {\n  @apply inline-flex items-center justify-center;\n\n  /* Default color token (accent) */\n  --progress-circle-stroke: var(--color-accent);\n  --progress-circle-track-stroke: var(--color-default);\n\n  .progress-circle__track {\n    /* Default size (matches --md) */\n    @apply size-7;\n  }\n\n  .progress-circle__track-circle {\n    stroke: var(--progress-circle-track-stroke);\n  }\n\n  .progress-circle__fill-circle {\n    stroke: var(--progress-circle-stroke);\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition: stroke-dashoffset 300ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n  }\n\n  /* Indeterminate state - when no aria-valuenow is set */\n  &:not([aria-valuenow]) {\n    .progress-circle__track {\n      animation: progress-circle-spin 1s linear infinite;\n\n      @apply motion-reduce:animate-none;\n    }\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Indeterminate animation\n   ========================================================================== */\n\n@keyframes progress-circle-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ==========================================================================\n   Size variants\n   ========================================================================== */\n\n.progress-circle--sm {\n  .progress-circle__track {\n    @apply size-5;\n  }\n}\n\n.progress-circle--md {\n  /* No styles as this is the default size */\n}\n\n.progress-circle--lg {\n  .progress-circle__track {\n    @apply size-9;\n  }\n}\n\n/* ==========================================================================\n   Color variants\n   ========================================================================== */\n\n.progress-circle--default {\n  --progress-circle-stroke: var(--color-default-foreground);\n}\n\n.progress-circle--accent {\n  --progress-circle-stroke: var(--color-accent);\n}\n\n.progress-circle--success {\n  --progress-circle-stroke: var(--color-success);\n}\n\n.progress-circle--warning {\n  --progress-circle-stroke: var(--color-warning);\n}\n\n.progress-circle--danger {\n  --progress-circle-stroke: var(--color-danger);\n}\n","/* Base spinner styles */\n.spinner {\n  @apply pointer-events-none relative size-6 origin-center animate-spin-fast;\n}\n\n/* Size variants */\n.spinner--sm {\n  @apply size-4;\n}\n\n.spinner--md {\n  /* No styles as this is the default size */\n}\n\n.spinner--lg {\n  @apply size-8;\n}\n\n.spinner--xl {\n  @apply size-10;\n}\n\n/* Color variants */\n.spinner--current {\n  color: inherit;\n}\n\n.spinner--accent {\n  color: var(--accent);\n}\n\n.spinner--danger {\n  color: var(--danger);\n}\n\n.spinner--success {\n  color: var(--success);\n}\n\n.spinner--warning {\n  color: var(--warning);\n}\n","/* Toast component styles */\n\n/* Toast Region - Container for all toasts */\n.toast-region {\n  @apply pointer-events-none fixed z-50 outline-none;\n  @apply w-[calc(100vw-2rem)] sm:w-auto sm:min-w-(--toast-width);\n\n  display: block;\n}\n\n/* Placement variants - Bottom */\n.toast-region--bottom {\n  @apply bottom-4 left-1/2 -translate-x-1/2;\n}\n\n.toast-region--bottom-start {\n  @apply bottom-4 left-4;\n}\n\n.toast-region--bottom-end {\n  @apply right-4 bottom-4;\n}\n\n/* Placement variants - Top */\n.toast-region--top {\n  @apply top-4 left-1/2 -translate-x-1/2;\n}\n\n.toast-region--top-start {\n  @apply top-4 left-4;\n}\n\n.toast-region--top-end {\n  @apply top-4 right-4;\n}\n\n.toast-region:focus-visible {\n  @apply outline-2 outline-offset-2 outline-focus;\n}\n\n/* Base toast styles */\n.toast {\n  position: absolute;\n  left: 0;\n  right: 0;\n\n  @apply pointer-events-auto flex flex-row items-start justify-start gap-1.5 bg-surface px-4 py-3 shadow-overlay;\n  border-radius: min(32px, var(--radius-3xl));\n}\n\n.toast--bottom,\n.toast--bottom-start,\n.toast--bottom-end {\n  bottom: 0;\n}\n\n.toast--top,\n.toast--top-start,\n.toast--top-end {\n  top: 0;\n}\n\n.toast:not([data-frontmost=\"true\"]) {\n  @apply pointer-events-none;\n\n  height: var(--front-height);\n  overflow: hidden;\n\n  .toast__close-button {\n    @apply pointer-events-none opacity-0;\n    outline: none;\n  }\n}\n\n.toast[data-hidden=\"true\"] {\n  @apply pointer-events-none flex opacity-0;\n}\n\n.toast:focus-visible {\n  @apply outline-2 outline-offset-2 outline-focus;\n}\n\n/* Toast placements + view transitions */\n.toast--bottom,\n.toast--bottom-start,\n.toast--bottom-end {\n  view-transition-class: toast-bottom;\n}\n\n.toast--top,\n.toast--top-start,\n.toast--top-end {\n  view-transition-class: toast-top;\n}\n\n/* Toast content */\n.toast__content {\n  @apply flex h-full grow flex-col items-start self-center;\n}\n\n/* Toast indicator */\n.toast__indicator {\n  @apply flex shrink-0 items-center justify-center p-1 text-overlay-foreground select-none;\n\n  [data-slot=\"toast-default-icon\"] {\n    @apply box-content size-4;\n  }\n\n  /* Spinner styles override for toast */\n  [data-slot=\"spinner\"] {\n    @apply size-4;\n  }\n\n  [data-slot=\"spinner-icon\"] {\n    @apply size-4;\n  }\n}\n\n/* Toast title */\n.toast__title {\n  @apply text-sm leading-5 font-medium text-overlay-foreground;\n}\n\n/* Toast description */\n.toast__description {\n  @apply text-sm text-muted;\n}\n\n/* Toast close button */\n.toast__close-button {\n  @apply absolute top-2.5 right-2.5 size-5 border-border bg-default opacity-100 sm:pointer-events-none sm:-top-1 sm:-right-1 sm:border sm:bg-overlay sm:opacity-0;\n\n  transition: opacity 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n  /* Overrides close button default icon size from 16px to 12px */\n  [data-slot=\"close-button-icon\"] {\n    @apply size-3.5 sm:size-3;\n  }\n\n  /* Overrides close button hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default;\n    }\n  }\n}\n\n/* Only show close button on hover for frontmost toast */\n.toast[data-frontmost=\"true\"]:hover .toast__close-button {\n  @apply pointer-events-auto opacity-100;\n}\n\n/* Toast action button */\n.toast__action {\n  @apply mt-2 sm:mt-0;\n}\n\n/* Variant modifiers */\n.toast--accent .toast__title {\n  @apply text-accent;\n}\n\n.toast--success .toast__title {\n  @apply text-success;\n}\n\n.toast--success .toast__indicator {\n  @apply text-success;\n}\n\n.toast--warning .toast__title {\n  @apply text-warning;\n}\n\n.toast--warning .toast__indicator {\n  @apply text-warning;\n}\n\n.toast--danger .toast__title {\n  @apply text-danger;\n}\n\n.toast--danger .toast__indicator {\n  @apply text-danger;\n}\n\n/* View transition animations */\n::view-transition-group(.toast-bottom),\n::view-transition-group(.toast-top) {\n}\n\n::view-transition-old(*),\n::view-transition-new(*) {\n  will-change: translate, opacity;\n}\n\n/* Bottom */\n::view-transition-new(.toast-bottom):only-child {\n  animation: toast-slide-bottom-in 350ms;\n}\n\n::view-transition-old(.toast-bottom):only-child {\n  animation: toast-slide-bottom-out 350ms;\n  animation-fill-mode: forwards;\n}\n\n/* Top */\n::view-transition-new(.toast-top):only-child {\n  animation: toast-slide-top-in 350ms;\n}\n\n::view-transition-old(.toast-top):only-child {\n  animation: toast-slide-top-out 350ms;\n  animation-fill-mode: forwards;\n}\n\n/* Keyframes */\n\n/* Bottom */\n@keyframes toast-slide-bottom-in {\n  from {\n    translate: 0 100%;\n    opacity: 0;\n  }\n}\n\n@keyframes toast-slide-bottom-out {\n  to {\n    translate: 0 100%;\n    opacity: 0;\n  }\n}\n\n/* Top */\n@keyframes toast-slide-top-in {\n  from {\n    translate: 0 -100%;\n    opacity: 0;\n  }\n}\n\n@keyframes toast-slide-top-out {\n  to {\n    translate: 0 -100%;\n    opacity: 0;\n  }\n}\n",".checkbox-group {\n  @apply flex flex-col;\n\n  [data-slot=\"checkbox\"] {\n    @apply mt-4;\n  }\n}\n","/* ==========================================================================\n   Base checkbox styles\n   ========================================================================== */\n\n.checkbox {\n  @apply flex gap-3 outline-none no-highlight;\n\n  cursor: var(--cursor-interactive);\n\n  /* Align center when there's no description */\n  &:not(:has([data-slot=\"description\"])) {\n    @apply items-center;\n  }\n\n  /* Align start when there's a description */\n  &:has([data-slot=\"description\"]) {\n    @apply items-start;\n  }\n\n  [data-slot=\"label\"] {\n    @apply select-none;\n  }\n\n  [data-slot=\"description\"] {\n    @apply text-wrap select-none;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Indicator styles */\n  &[data-selected=\"true\"],\n  &[data-indeterminate=\"true\"] {\n    .checkbox__indicator {\n      border-color: var(--accent-foreground);\n    }\n  }\n\n  /* Checkmark SVG indicator */\n  [data-slot=\"checkbox-default-indicator--checkmark\"] {\n    @apply size-2.5 stroke-[2.5px] text-accent-foreground;\n\n    /**\n     * Transitions\n     */\n    @apply transition-all duration-200 motion-reduce:transition-none;\n  }\n\n  &[data-selected=\"true\"] [data-slot=\"checkbox-default-indicator--checkmark\"] {\n    transition: stroke-dashoffset 150ms linear 15ms;\n  }\n\n  /* Invalid + Selected: checkmark icon color */\n  &[data-invalid=\"true\"][data-selected=\"true\"] [data-slot=\"checkbox-default-indicator--checkmark\"],\n  &[data-invalid=\"true\"][aria-checked=\"true\"] [data-slot=\"checkbox-default-indicator--checkmark\"],\n  &[aria-invalid=\"true\"][data-selected=\"true\"] [data-slot=\"checkbox-default-indicator--checkmark\"],\n  &[aria-invalid=\"true\"][aria-checked=\"true\"] [data-slot=\"checkbox-default-indicator--checkmark\"] {\n    @apply text-danger-foreground;\n  }\n\n  /* Indeterminate line indicator */\n  &[data-indeterminate=\"true\"] {\n    [data-slot=\"checkbox-default-indicator--indeterminate\"] {\n      @apply size-3;\n    }\n  }\n\n  /* Invalid + Indeterminate: indeterminate icon color */\n  &[data-indeterminate=\"true\"][data-invalid=\"true\"]\n    [data-slot=\"checkbox-default-indicator--indeterminate\"],\n  &[data-indeterminate=\"true\"][aria-invalid=\"true\"]\n    [data-slot=\"checkbox-default-indicator--indeterminate\"] {\n    @apply text-danger-foreground;\n  }\n}\n\n/* ==========================================================================\n   Checkbox control (the square button)\n   ========================================================================== */\n\n.checkbox__control {\n  @apply relative inline-flex size-4 shrink-0 items-center justify-center overflow-hidden rounded-md bg-field shadow-field outline-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 200ms var(--ease-out),\n    transform 100ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Add top margin when there's a description */\n  .checkbox:has([data-slot=\"description\"]) & {\n    @apply mt-0.5;\n  }\n\n  /* Background indicator pseudo-element */\n  &::before {\n    @apply pointer-events-none absolute inset-0 z-0 origin-center scale-70 rounded-md bg-accent opacity-0 content-[''];\n\n    /**\n     * Transitions\n     * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n     */\n    transition:\n      scale 100ms var(--ease-linear),\n      opacity 200ms var(--ease-linear),\n      background-color 200ms var(--ease-out);\n    @apply motion-reduce:transition-none;\n  }\n\n  /* Interactive states */\n  /* Focus */\n  .checkbox:focus-visible &,\n  .checkbox[data-focus-visible=\"true\"] & {\n    @apply status-focused;\n  }\n\n  /* Hover */\n  .checkbox:hover &,\n  .checkbox[data-hovered=\"true\"] & {\n    @apply border-field-border-hover;\n\n    &::before {\n      @apply bg-accent-hover;\n    }\n  }\n\n  /* Pressed */\n  .checkbox:active &,\n  .checkbox[data-pressed=\"true\"] & {\n  }\n\n  /* Selection states */\n  /* Selected */\n  .checkbox[aria-checked=\"true\"] &,\n  .checkbox[data-selected=\"true\"] & {\n    @apply border-transparent text-accent-foreground;\n\n    &::before {\n      @apply scale-100 opacity-100;\n    }\n  }\n\n  /* Indeterminate */\n  .checkbox[data-indeterminate=\"true\"] & {\n    @apply bg-accent text-accent-foreground;\n  }\n\n  /* Indeterminate + Pressed */\n  .checkbox:active[data-indeterminate=\"true\"] &,\n  .checkbox[data-pressed=\"true\"][data-indeterminate=\"true\"] & {\n    @apply bg-accent-hover;\n  }\n\n  /* Validation states */\n  /* Invalid (only when not selected/indeterminate) */\n  .checkbox[data-invalid=\"true\"]:not([aria-checked=\"true\"]):not([data-selected=\"true\"]):not(\n      [data-indeterminate=\"true\"]\n    )\n    &,\n  .checkbox[aria-invalid=\"true\"]:not([aria-checked=\"true\"]):not([data-selected=\"true\"]):not(\n      [data-indeterminate=\"true\"]\n    )\n    & {\n    @apply status-invalid-field;\n  }\n\n  /* Invalid + Selected */\n  .checkbox[data-invalid=\"true\"][aria-checked=\"true\"] &,\n  .checkbox[data-invalid=\"true\"][data-selected=\"true\"] &,\n  .checkbox[aria-invalid=\"true\"][aria-checked=\"true\"] &,\n  .checkbox[aria-invalid=\"true\"][data-selected=\"true\"] & {\n    @apply border-transparent bg-danger text-danger-foreground;\n\n    &::before {\n      @apply scale-100 bg-danger opacity-100;\n    }\n  }\n\n  /* Invalid + Indeterminate */\n  .checkbox[data-indeterminate=\"true\"][aria-invalid=\"true\"] &,\n  .checkbox[data-indeterminate=\"true\"][data-invalid=\"true\"] & {\n    @apply bg-danger text-danger-foreground;\n  }\n}\n\n/* ==========================================================================\n   Checkbox indicator\n   ========================================================================== */\n\n.checkbox__indicator {\n  @apply relative z-10 flex size-3 items-center justify-center;\n\n  & svg {\n    @apply transform-gpu;\n  }\n}\n\n/* ==========================================================================\n   Checkbox content wrapper\n   ========================================================================== */\n\n.checkbox__content {\n  @apply flex flex-col gap-0;\n}\n\n/* ==========================================================================\n   Disabled modifier\n   ========================================================================== */\n\n.checkbox--disabled {\n  @apply status-disabled;\n}\n\n/* ==========================================================================\n   Variant property definitions\n   ========================================================================== */\n\n.checkbox--primary {\n  /* Default styles */\n}\n\n.checkbox--secondary .checkbox__control {\n  @apply shadow-none;\n  background-color: var(--checkbox-control-bg);\n\n  --checkbox-control-bg: var(--color-default);\n\n  /* Hover state */\n  .checkbox:hover &,\n  .checkbox[data-hovered=\"true\"] & {\n    @apply border-field-border-hover;\n  }\n}\n\n/* Unselected state background for secondary variant */\n.checkbox--secondary:not([aria-checked=\"true\"]):not([data-selected=\"true\"]):not(\n    [data-indeterminate=\"true\"]\n  )\n  .checkbox__control {\n  background-color: var(--checkbox-control-bg);\n}\n\n/* Selected state on secondary variant */\n.checkbox--secondary[aria-checked=\"true\"] .checkbox__control,\n.checkbox--secondary[data-selected=\"true\"] .checkbox__control {\n  &::before {\n    @apply bg-accent;\n  }\n}\n\n/* Indeterminate state on secondary variant */\n.checkbox--secondary[data-indeterminate=\"true\"] .checkbox__control {\n  @apply bg-accent;\n\n  &::before {\n    @apply bg-accent;\n  }\n}\n","/* Base component styles */\n.fieldset {\n  @apply flex flex-col gap-6;\n  /* fix flexbox issue in Safari when fieldset with legend is inside a flexbox */\n  @apply shrink grow basis-0;\n}\n\n.fieldset__legend {\n  @apply text-base font-medium text-foreground;\n}\n\n.fieldset__field_group {\n  @apply w-full space-y-4;\n}\n\n.fieldset__actions {\n  @apply flex items-center gap-2 pt-1;\n}\n","/* Base container */\n.input-otp {\n  @apply relative flex items-center gap-2;\n\n  &[data-disabled=\"true\"] {\n    @apply cursor-not-allowed opacity-50;\n  }\n}\n\n/* Group - slots separated with gap */\n.input-otp__group {\n  @apply flex items-center gap-2;\n}\n\n/* Individual slot box - fully rounded, standalone */\n.input-otp__slot {\n  @apply relative flex h-10 w-9.5 flex-1 items-center justify-center;\n  @apply border bg-field text-field-foreground shadow-field;\n  @apply rounded-field text-sm font-semibold outline-none;\n\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Active/Focus */\n  &[data-active=\"true\"] {\n    @apply z-10 bg-field-focus status-focused-field;\n  }\n\n  /* Filled */\n  &[data-filled=\"true\"] {\n    @apply bg-field-focus;\n  }\n\n  /* Disabled */\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Invalid */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n  }\n}\n\n/* Slot value */\n.input-otp__slot-value {\n  @apply text-lg leading-6 tracking-[-0.27px];\n\n  /**\n   * Animations\n   * CRITICAL: motion-reduce must be AFTER animation for correct override specificity\n   */\n  animation: slot-value-in 250ms var(--ease-smooth) both;\n  transform-origin: bottom center;\n  @apply motion-reduce:animate-none;\n}\n\n/* Caret */\n.input-otp__caret {\n  @apply absolute h-4 w-[2px] animate-caret-blink rounded-sm bg-field-placeholder;\n}\n\n/* Separator */\n.input-otp__separator {\n  @apply h-[2px] w-[6px] shrink-0 rounded-sm bg-separator;\n}\n\n/* Variant property definitions */\n.input-otp--primary {\n  /* Default styles */\n}\n\n.input-otp--secondary .input-otp__slot {\n  @apply shadow-none;\n  background-color: var(--input-otp-slot-bg);\n\n  --input-otp-slot-bg: var(--color-default);\n  --input-otp-slot-bg-hover: var(--color-default-hover);\n  --input-otp-slot-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      background-color: var(--input-otp-slot-bg-hover);\n    }\n  }\n\n  &[data-active=\"true\"],\n  &[data-filled=\"true\"] {\n    background-color: var(--input-otp-slot-bg-focus);\n  }\n}\n\n/* Animations */\n@keyframes slot-value-in {\n  0% {\n    opacity: 0;\n    transform: translateY(8px) scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n",".input {\n  @apply rounded-field border bg-field px-3 py-2 text-base text-field-foreground shadow-field outline-none placeholder:text-field-placeholder sm:text-sm;\n\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  @media (hover: hover) {\n    &:hover:not(:focus):not(:focus-visible),\n    &[data-hovered=\"true\"]:not([data-focused=\"true\"]):not([data-focus-visible=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focused=\"true\"] {\n    @apply status-focused-field;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* Variant property definitions */\n.input--primary {\n  /* Default styles */\n}\n\n.input--secondary {\n  @apply shadow-none;\n  background-color: var(--input-bg);\n\n  --input-bg: var(--color-default);\n  --input-bg-hover: var(--color-default-hover);\n  --input-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus):not(:focus-visible),\n    &[data-hovered=\"true\"]:not([data-focus-visible=\"true\"]):not([data-focused=\"true\"]) {\n      background-color: var(--input-bg-hover);\n    }\n  }\n\n  &:focus,\n  &[data-focused=\"true\"] {\n    background-color: var(--input-bg-focus);\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--input-bg-focus);\n  }\n}\n\n/* Full width modifier */\n.input--full-width {\n  @apply w-full;\n}\n","/* Input group styles */\n.input-group {\n  @apply inline-flex min-h-9 items-center rounded-field border bg-field text-sm text-field-foreground shadow-field outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /* When textarea is present, align items to start and allow height to grow */\n  &:has([data-slot=\"input-group-textarea\"]) {\n    @apply items-start;\n    height: auto;\n  }\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus within state - only when input/textarea is focused */\n  &:has([data-slot=\"input-group-input\"]:focus),\n  &:has([data-slot=\"input-group-textarea\"]:focus) {\n    @apply status-focused-field;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n    border-color: var(--color-field-border-invalid);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.input-group__input {\n  @apply flex-1 rounded-none border-0 bg-transparent px-3 py-2 text-base shadow-none outline-none placeholder:text-field-placeholder sm:text-sm;\n\n  /* Remove border radius on left side when prefix is present */\n  .input-group:has([data-slot=\"input-group-prefix\"]) & {\n    @apply rounded-l-none pl-0;\n  }\n\n  /* Remove border radius on right side when suffix is present */\n  .input-group:has([data-slot=\"input-group-suffix\"]) & {\n    @apply rounded-r-none pr-0;\n  }\n\n  /* Focus state - handled by group */\n  &:focus,\n  &:focus-visible {\n    @apply outline-none;\n  }\n}\n\n/* TextArea within InputGroup - uses same base class as input but with textarea-specific styles */\n.input-group__input[data-slot=\"input-group-textarea\"] {\n  min-height: 38px;\n  resize: vertical;\n}\n\n.input-group__prefix {\n  @apply flex h-full items-center justify-center rounded-l-field rounded-r-none bg-transparent px-3 text-field-placeholder;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n  border-style: solid;\n  border-right-color: var(--color-field-border);\n  border-left: none;\n  border-top: none;\n  border-bottom: none;\n\n  /* Align to top when textarea is present */\n  .input-group:has([data-slot=\"input-group-textarea\"]) & {\n    @apply items-start;\n    padding-top: 0.5rem;\n  }\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n}\n\n.input-group__suffix {\n  @apply flex h-full items-center justify-center rounded-l-none rounded-r-field bg-transparent px-3 text-field-placeholder;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n  border-style: solid;\n  border-left-color: var(--color-field-border);\n  border-right: none;\n  border-top: none;\n  border-bottom: none;\n\n  /* Align to top when textarea is present */\n  .input-group:has([data-slot=\"input-group-textarea\"]) & {\n    @apply items-start;\n    padding-top: 0.5rem;\n  }\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n}\n\n/* Variant property definitions */\n.input-group--primary {\n  /* Default styles */\n}\n\n.input-group--secondary {\n  @apply shadow-none;\n  background-color: var(--input-group-bg);\n\n  --input-group-bg: var(--color-default);\n  --input-group-bg-hover: var(--color-default-hover);\n  --input-group-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      background-color: var(--input-group-bg-hover);\n    }\n  }\n\n  &:has([data-slot=\"input-group-input\"]:focus),\n  &:has([data-slot=\"input-group-textarea\"]:focus) {\n    background-color: var(--input-group-bg-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    border-color: var(--color-field-border-invalid);\n    background-color: var(--input-group-bg-focus);\n  }\n\n  [data-slot=\"input-group-input\"],\n  [data-slot=\"input-group-textarea\"] {\n    @apply bg-transparent;\n  }\n}\n\n/* Full width modifier */\n.input-group--full-width {\n  @apply w-full;\n}\n","/* Number field styles */\n.number-field {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n}\n\n.number-field__group {\n  @apply grid h-9 items-center overflow-hidden rounded-field border bg-field text-sm text-field-foreground shadow-field outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n  grid-template-columns: 40px 1fr 40px;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus within state */\n  &[data-focus-within=\"true\"],\n  &:focus-within {\n    @apply status-focused-field;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n    border-color: var(--color-field-border-invalid);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.number-field__input {\n  @apply min-w-0 rounded-none border-0 bg-transparent px-3 py-2 text-base tabular-nums shadow-none outline-none sm:text-sm;\n\n  /* Remove border radius on left side when decrement button is present */\n  .number-field__group:has([slot=\"decrement\"]) & {\n    @apply rounded-l-none;\n  }\n\n  /* Remove border radius on right side when increment button is present */\n  .number-field__group:has([slot=\"increment\"]) & {\n    @apply rounded-r-none;\n  }\n\n  /* Focus state - handled by group */\n  &:focus,\n  &:focus-visible {\n    @apply outline-none;\n  }\n}\n\n.number-field__increment-button,\n.number-field__decrement-button {\n  @apply flex h-full w-10 items-center justify-center rounded-none bg-transparent text-field-foreground outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n  border-style: solid;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth);\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  /* Hover state */\n  &:hover,\n  &[data-hovered=\"true\"] {\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    @apply bg-field-foreground/10;\n    transform: scale(0.97);\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Icon styling */\n  [data-slot=\"number-field-increment-button-icon\"],\n  [data-slot=\"number-field-decrement-button-icon\"] {\n    @apply size-4;\n  }\n}\n\n.number-field__increment-button {\n  @apply rounded-l-none rounded-r-field border-l border-field-placeholder/15;\n}\n\n.number-field__decrement-button {\n  @apply rounded-l-field rounded-r-none border-r border-field-placeholder/15;\n}\n\n/* Variant property definitions */\n.number-field--primary {\n  /* Default styles */\n}\n\n.number-field--secondary .number-field__group {\n  @apply shadow-none;\n  background-color: var(--number-field-group-bg);\n\n  --number-field-group-bg: var(--color-default);\n  --number-field-group-bg-hover: var(--color-default-hover);\n  --number-field-group-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      background-color: var(--number-field-group-bg-hover);\n    }\n  }\n\n  &:focus-within,\n  &[data-focus-within=\"true\"] {\n    background-color: var(--number-field-group-bg-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    border-color: var(--color-field-border-invalid);\n    background-color: var(--number-field-group-bg-focus);\n  }\n\n  [data-slot=\"number-field-input\"] {\n    @apply bg-transparent;\n  }\n}\n\n/* Full width modifier */\n.number-field--full-width {\n  @apply w-full;\n}\n\n.number-field__group--full-width {\n  @apply w-full;\n}\n","/* Radio Group base styles */\n.radio-group {\n  @apply flex flex-col;\n\n  /* Default orientation */\n  &[data-orientation=\"vertical\"] {\n    [data-slot=\"radio\"] {\n      @apply mt-4;\n    }\n  }\n\n  &[data-orientation=\"horizontal\"] {\n    @apply flex-row flex-wrap gap-4;\n  }\n}\n\n/* Variant property definitions */\n.radio-group--primary {\n  /* Default styles */\n}\n\n.radio-group--secondary .radio__control {\n  @apply shadow-none;\n  background-color: var(--radio-control-bg);\n\n  --radio-control-bg: var(--color-default);\n  --radio-control-bg-hover: var(--color-default-hover);\n\n  /* Hover state */\n  .radio:hover &,\n  .radio[data-hovered=\"true\"] & {\n    @apply border-field-border-hover;\n  }\n\n  /* Default indicator color (unselected) */\n  .radio:not([aria-checked=\"true\"]):not([data-selected=\"true\"]) & .radio__indicator:empty::before {\n    background-color: var(--radio-control-bg);\n  }\n\n  /* Hover indicator color (unselected) */\n  .radio:hover:not([aria-checked=\"true\"]):not([data-selected=\"true\"]) &,\n  .radio[data-hovered=\"true\"]:not([aria-checked=\"true\"]):not([data-selected=\"true\"]) & {\n    .radio__indicator:empty::before {\n      background-color: var(--radio-control-bg-hover);\n    }\n  }\n}\n","/* ==========================================================================\n   Base radio styles\n   ========================================================================== */\n\n.radio {\n  @apply relative flex items-start gap-3 outline-none no-highlight;\n\n  cursor: var(--cursor-interactive);\n\n  [data-slot=\"label\"] {\n    @apply select-none;\n  }\n\n  [data-slot=\"description\"] {\n    @apply text-wrap select-none;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* ==========================================================================\n   Radio control (the circular button)\n   ========================================================================== */\n\n.radio__control {\n  @apply relative mt-[3px] inline-flex size-4 shrink-0 items-center justify-center rounded-lg border [border-width:var(--border-width-field)] bg-field shadow-field outline-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 200ms var(--ease-out),\n    border-color 200ms var(--ease-out),\n    transform 100ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Interactive states */\n  /* Focus */\n  .radio:focus-visible &,\n  .radio[data-focus-visible=\"true\"] & {\n    @apply status-focused;\n  }\n\n  /* Hover */\n  .radio:hover &,\n  .radio[data-hovered=\"true\"] & {\n    @apply border-field-border-hover;\n  }\n\n  /* Hover - only when not selected */\n  .radio:hover:not([aria-checked=\"true\"]):not([data-selected=\"true\"]) &,\n  .radio[data-hovered=\"true\"]:not([aria-checked=\"true\"]):not([data-selected=\"true\"]) & {\n    .radio__indicator:empty::before {\n      @apply bg-field-hover;\n    }\n  }\n\n  /* Pressed */\n  .radio:active &,\n  .radio[data-pressed=\"true\"] & {\n    @apply scale-95;\n  }\n\n  /* Selection states */\n  /* Selected */\n  .radio[aria-checked=\"true\"] &,\n  .radio[data-selected=\"true\"] & {\n    @apply border-transparent bg-accent;\n  }\n\n  /* Selected + Pressed */\n  .radio:active[data-selected=\"true\"] &,\n  .radio[data-pressed=\"true\"][data-selected=\"true\"] & {\n    @apply bg-accent-hover;\n  }\n\n  /* Validation states */\n  /* Invalid */\n  .radio[data-invalid=\"true\"] &,\n  .radio[aria-invalid=\"true\"] & {\n    @apply status-invalid-field;\n  }\n\n  /* Invalid + Selected */\n  .radio[data-invalid=\"true\"][aria-checked=\"true\"] &,\n  .radio[data-invalid=\"true\"][data-selected=\"true\"] &,\n  .radio[aria-invalid=\"true\"][aria-checked=\"true\"] &,\n  .radio[aria-invalid=\"true\"][data-selected=\"true\"] & {\n    @apply status-invalid-field;\n  }\n}\n\n/* ==========================================================================\n   Radio indicator (the inner dot)\n   ========================================================================== */\n\n.radio__indicator {\n  @apply absolute inset-0 flex items-center justify-center;\n\n  pointer-events: none;\n}\n\n/* :empty pseudo-class ensures these styles only apply when the indicator has no custom children\n   (e.g., custom icon). When custom content is present, these default dot styles are not applied. */\n.radio__indicator:empty::before {\n  content: \"\";\n  @apply rounded-lg bg-field;\n\n  width: 100%;\n  height: 100%;\n  scale: 1;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    scale 200ms var(--ease-out),\n    background-color 200ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n}\n\n/* Selected state */\n.radio[aria-checked=\"true\"] .radio__indicator:empty::before,\n.radio[data-selected=\"true\"] .radio__indicator:empty::before {\n  @apply bg-accent-foreground;\n  scale: 0.4286; /* 6px */\n}\n\n/* Selected + Pressed state */\n.radio[data-selected=\"true\"][data-pressed=\"true\"] .radio__indicator:empty::before {\n  scale: 0.5714; /* 8px */\n}\n\n/* ==========================================================================\n   Radio content wrapper\n   ========================================================================== */\n\n.radio__content {\n  @apply flex flex-col gap-0;\n}\n\n/* ==========================================================================\n   Disabled modifier\n   ========================================================================== */\n\n.radio--disabled {\n  @apply status-disabled;\n}\n","/* Text field styles */\n/* use textfield instead of text-field to avoid conflict with Tailwind `text-` prefix */\n.textfield {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n}\n\n/* Full width modifier */\n.textfield--full-width {\n  @apply w-full;\n\n  /* Automatically make Input full width when TextField is full width */\n  [data-slot=\"input\"],\n  [data-slot=\"textarea\"] {\n    @apply w-full;\n  }\n}\n","/* Search field styles */\n.search-field {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n\n  &[data-empty=\"true\"] {\n    [data-slot=\"search-field-clear-button\"] {\n      @apply pointer-events-none opacity-0;\n    }\n  }\n}\n\n.search-field__group {\n  @apply relative inline-flex h-9 items-center overflow-hidden rounded-field border bg-field text-sm text-field-foreground shadow-field outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus within state */\n  &[data-focus-within=\"true\"],\n  &:focus-within {\n    @apply status-focused-field;\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n    border-color: var(--color-field-border-invalid);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.search-field__input {\n  @apply flex-1 rounded-none border-0 bg-transparent px-3 py-2 text-base shadow-none outline-none sm:text-sm;\n\n  /* Hide browser default search clear button */\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-decoration {\n    -webkit-appearance: none;\n    appearance: none;\n  }\n\n  /* Remove border radius on left side when search icon is present */\n  .search-field__group:has([data-slot=\"search-field-search-icon\"]) & {\n    @apply rounded-l-none pl-2;\n  }\n\n  /* Remove border radius on right side when clear button is present */\n  .search-field__group:has([slot=\"clear\"]) & {\n    @apply rounded-r-none pr-2;\n  }\n\n  /* Focus state - handled by group */\n  &:focus,\n  &:focus-visible {\n    @apply outline-none;\n  }\n}\n\n.search-field__search-icon {\n  @apply pointer-events-none shrink-0 text-field-placeholder;\n  @apply mr-0 ml-3 size-4;\n}\n\n.search-field__clear-button {\n  @apply mr-2 size-5 shrink-0;\n\n  /* Overrides close button default icon size from 16px to 12px */\n  [data-slot=\"close-button-icon\"] {\n    @apply size-3;\n  }\n}\n\n/* Variant property definitions */\n.search-field--primary {\n  /* Default styles */\n}\n\n.search-field--secondary .search-field__group {\n  @apply shadow-none;\n  background-color: var(--search-field-group-bg);\n\n  --search-field-group-bg: var(--color-default);\n  --search-field-group-bg-hover: var(--color-default-hover);\n  --search-field-group-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      background-color: var(--search-field-group-bg-hover);\n    }\n  }\n\n  &:focus-within,\n  &[data-focus-within=\"true\"] {\n    background-color: var(--search-field-group-bg-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    border-color: var(--color-field-border-invalid);\n    background-color: var(--search-field-group-bg-focus);\n  }\n\n  [data-slot=\"search-field-input\"] {\n    @apply bg-transparent;\n  }\n}\n\n/* Full width modifier */\n.search-field--full-width {\n  @apply w-full;\n}\n\n.search-field__group--full-width {\n  @apply w-full;\n}\n","/* use textarea instead of text-area to avoid conflict with Tailwind `text-` prefix */\n.textarea {\n  @apply rounded-field border bg-field px-3 py-2 text-base text-field-foreground shadow-field outline-none placeholder:text-field-placeholder sm:text-sm;\n\n  min-height: 38px;\n\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  @media (hover: hover) {\n    &:hover:not(:focus):not(:focus-visible),\n    &[data-hovered=\"true\"]:not([data-focused=\"true\"]):not([data-focus-visible=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focused=\"true\"] {\n    @apply status-focused-field;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n  }\n\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* Variant property definitions */\n.textarea--primary {\n  /* Default styles */\n}\n\n.textarea--secondary {\n  @apply shadow-none;\n  background-color: var(--textarea-bg);\n\n  --textarea-bg: var(--color-default);\n  --textarea-bg-hover: var(--color-default-hover);\n  --textarea-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus):not(:focus-visible),\n    &[data-hovered=\"true\"]:not([data-focused=\"true\"]):not([data-focus-visible=\"true\"]) {\n      background-color: var(--textarea-bg-hover);\n    }\n  }\n\n  &:focus,\n  &[data-focused=\"true\"] {\n    background-color: var(--textarea-bg-focus);\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--textarea-bg-focus);\n  }\n}\n\n/* Full width modifier */\n.textarea--full-width {\n  @apply w-full;\n}\n","/* =============================================================================\n * Calendar Component Styles\n *\n * A compound component for date selection.\n * Uses BEM naming convention: calendar, calendar__element, calendar--modifier\n * ============================================================================= */\n\n/* -----------------------------------------------------------------------------\n * Base Calendar Styles\n * -------------------------------------------------------------------------- */\n.calendar {\n  @apply w-63 max-w-full;\n\n  container-type: inline-size;\n}\n\n/* -----------------------------------------------------------------------------\n * Calendar Header\n * -------------------------------------------------------------------------- */\n.calendar__header {\n  @apply flex items-center justify-between px-0.5 pb-4;\n\n  &:has(.calendar-year-picker__trigger[data-open=\"true\"]) {\n    .calendar__nav-button {\n      @apply pointer-events-none opacity-0;\n    }\n  }\n}\n\n.calendar__heading {\n  @apply flex-1 text-sm font-medium;\n}\n\n.calendar__nav-button {\n  @apply flex size-6 items-center justify-center rounded-2xl text-accent;\n\n  will-change: scale;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out),\n    background-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out),\n    opacity 150ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Hover state – only on devices that support hover (avoids false triggers on touch) */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default text-accent;\n    }\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.95);\n  }\n\n  /* Focus state */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.calendar__nav-button-icon {\n  @apply size-4;\n}\n\n/* -----------------------------------------------------------------------------\n * Calendar Grid\n * -------------------------------------------------------------------------- */\n.calendar__grid {\n  /* Override table display with CSS Grid for easier customization */\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  @apply w-full;\n\n  &[aria-readonly=\"true\"] {\n    .calendar__cell {\n      @apply pointer-events-none;\n    }\n  }\n}\n\n.calendar__grid-header {\n  /* Grid header (thead) styles */\n  display: contents;\n\n  & > tr {\n    display: contents;\n  }\n}\n\n.calendar__grid-body {\n  /* Grid body (tbody) styles */\n  display: contents;\n\n  & > tr {\n    display: contents;\n  }\n\n  /* Add top spacing between header and first body row */\n  & > tr:first-child > td {\n    @apply mt-1;\n  }\n}\n\n.calendar__grid-row {\n  /* Use 'contents' so cells participate directly in grid */\n  /* Note: This class can be used for custom row styling if needed */\n  display: contents;\n}\n\n.calendar__header-cell {\n  /* Header cell (th - weekday names) styles */\n  @apply flex items-center justify-center pb-2 text-xs font-medium text-muted;\n}\n\n/* -----------------------------------------------------------------------------\n * Calendar Cells\n * -------------------------------------------------------------------------- */\n.calendar__cell {\n  /* Cell (td) wrapper styles - margins now work with grid layout */\n  @apply relative flex aspect-square size-full items-center justify-center rounded-3xl text-center text-sm font-medium outline-none no-highlight;\n\n  will-change: scale;\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out),\n    box-shadow 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Today indicator */\n  &[data-today=\"true\"] {\n    @apply text-accent;\n  }\n\n  /* Selected state */\n  &[data-selected=\"true\"] {\n    @apply bg-accent text-accent-foreground;\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    @apply bg-default;\n    transform: scale(0.95);\n\n    &[data-selected=\"true\"] {\n      @apply bg-accent-hover;\n    }\n  }\n\n  /* Hover state – only on devices that support hover (avoids false triggers on touch) */\n  @media (hover: hover) {\n    &:hover:not([data-selected=\"true\"]),\n    &[data-hovered=\"true\"]:not([data-selected=\"true\"]) {\n      @apply bg-default;\n    }\n  }\n\n  /* Outside month (previous/next month days) */\n  &[data-outside-month=\"true\"] {\n    @apply text-muted opacity-50;\n  }\n\n  &[data-selected=\"true\"][data-outside-month=\"true\"] {\n    @apply bg-default;\n  }\n\n  /* Unavailable dates */\n  &[data-unavailable=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Disabled state */\n  &:disabled:not([data-outside-month=\"true\"]),\n  &[data-disabled=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply status-disabled;\n\n    text-decoration: line-through;\n  }\n}\n\n/* Cell indicator - small dot at bottom center of cell */\n.calendar__cell-indicator {\n  @apply absolute bottom-1 left-1/2 size-[3px] -translate-x-1/2 rounded-xs bg-muted;\n\n  /* Indicator color changes when cell is selected */\n  [data-selected=\"true\"] > & {\n    @apply bg-accent-foreground;\n  }\n}\n","/* =============================================================================\n * RangeCalendar Component Styles\n *\n * A compound component for contiguous date range selection.\n * Uses BEM naming convention: range-calendar, range-calendar__element, range-calendar--modifier\n * ============================================================================= */\n\n/* -----------------------------------------------------------------------------\n * Base RangeCalendar Styles\n * -------------------------------------------------------------------------- */\n.range-calendar {\n  @apply w-63 max-w-full;\n\n  container-type: inline-size;\n}\n\n/* -----------------------------------------------------------------------------\n * RangeCalendar Header\n * -------------------------------------------------------------------------- */\n.range-calendar__header {\n  @apply flex items-center justify-between px-0.5 pb-4;\n\n  &:has(.calendar-year-picker__trigger[data-open=\"true\"]) {\n    .range-calendar__nav-button {\n      @apply pointer-events-none opacity-0;\n    }\n  }\n}\n\n.range-calendar__heading {\n  @apply flex-1 text-sm font-medium;\n}\n\n.range-calendar__nav-button {\n  @apply flex size-6 items-center justify-center rounded-xl text-accent;\n\n  will-change: scale;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out),\n    background-color 100ms var(--ease-out),\n    box-shadow 100ms var(--ease-out),\n    opacity 150ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Hover state – only on devices that support hover (avoids false triggers on touch) */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default text-accent;\n    }\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.95);\n  }\n\n  /* Focus state */\n  &:focus-visible,\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.range-calendar__nav-button-icon {\n  @apply size-4;\n}\n\n/* -----------------------------------------------------------------------------\n * RangeCalendar Grid\n * -------------------------------------------------------------------------- */\n.range-calendar__grid {\n  /* Override table display with CSS Grid for easier customization */\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  @apply w-full;\n\n  &[aria-readonly=\"true\"] {\n    .range-calendar__cell {\n      @apply pointer-events-none;\n    }\n  }\n}\n\n.range-calendar__grid-header {\n  /* Grid header (thead) styles */\n  display: contents;\n\n  & > tr {\n    display: contents;\n  }\n}\n\n.range-calendar__grid-body {\n  /* Grid body (tbody) styles */\n  display: contents;\n\n  & > tr {\n    display: contents;\n  }\n\n  /* Add top spacing between header and first body row */\n  & > tr:first-child > td {\n    @apply mt-1;\n  }\n}\n\n.range-calendar__grid-row {\n  /* Use 'contents' so cells participate directly in grid */\n  /* Note: This class can be used for custom row styling if needed */\n  display: contents;\n}\n\n.range-calendar__header-cell {\n  /* Header cell (th - weekday names) styles */\n  @apply flex items-center justify-center pb-2 text-xs font-medium text-muted;\n}\n\n/* -----------------------------------------------------------------------------\n * RangeCalendar Cells\n * -------------------------------------------------------------------------- */\n.range-calendar__cell {\n  @apply relative z-1 mx-0 my-[2px] rounded-3xl p-0 outline-none;\n  cursor: var(--cursor-interactive);\n\n  will-change: background-color, border-color;\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    box-shadow 100ms var(--ease-out),\n    border-color 100ms var(--ease-out);\n  @apply transform-gpu motion-reduce:transition-none;\n\n  /* Inner interactive circle/capsule (equivalent to React Aria \"button-base\") */\n  .range-calendar__cell-button {\n    @apply flex aspect-square w-full items-center justify-center rounded-3xl text-sm font-medium text-foreground no-highlight;\n\n    will-change: scale;\n    transition: scale 200ms var(--ease-out);\n    @apply transform-gpu motion-reduce:transition-none;\n  }\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply z-2;\n\n    .range-calendar__cell-button {\n      @apply status-focused;\n    }\n  }\n\n  /* Today indicator */\n  &[data-today=\"true\"] {\n    .range-calendar__cell-button {\n      @apply text-accent;\n    }\n  }\n\n  /* Range selected track (middle segment) */\n  &[data-selected=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply rounded-none bg-accent-soft;\n  }\n\n  /* Round row boundaries so the range track looks continuous across weeks */\n  &[data-selected=\"true\"]:is(td:first-child > *, [aria-disabled] + td > *) {\n    @apply rounded-ss-lg rounded-es-lg;\n    &[data-selection-start=\"true\"] {\n      @apply rounded-ss-3xl rounded-es-3xl;\n    }\n  }\n\n  &[data-selected=\"true\"]:is(td:last-child > *, td:has(+ [aria-disabled]) > *) {\n    @apply rounded-se-lg rounded-ee-lg;\n    &[data-selection-end=\"true\"] {\n      @apply rounded-se-3xl rounded-ee-3xl;\n    }\n  }\n\n  /* Range caps (start/end) */\n  &[data-selection-start=\"true\"]:not([data-outside-month=\"true\"]),\n  &[data-selection-end=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply z-2;\n\n    .range-calendar__cell-button {\n      @apply bg-accent text-accent-foreground;\n    }\n  }\n\n  /* &[data-selection-start=\"true\"]:has(+ [data-selection-end=\"true\"]) {\n    @apply rounded-full;\n  } */\n\n  &[data-selection-start=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply rounded-tl-3xl rounded-bl-3xl;\n  }\n\n  &[data-selection-end=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply rounded-tr-3xl rounded-br-3xl;\n  }\n\n  /* Pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    .range-calendar__cell-button {\n      scale: 0.9;\n    }\n\n    &[data-selection-start=\"true\"],\n    &[data-selection-end=\"true\"] {\n      .range-calendar__cell-button {\n        @apply bg-accent-hover;\n      }\n    }\n  }\n\n  /* Hover state for non-selected days */\n  @media (hover: hover) {\n    &:hover:not([data-selected=\"true\"]),\n    &[data-hovered=\"true\"]:not([data-selected=\"true\"]) {\n      .range-calendar__cell-button {\n        @apply bg-default;\n      }\n    }\n  }\n\n  /* Outside month (previous/next month days) */\n  &[data-outside-month=\"true\"] {\n    @apply text-muted opacity-50;\n  }\n\n  &[data-selected=\"true\"][data-outside-month=\"true\"]:not(\n      [data-selection-start=\"true\"],\n      [data-selection-end=\"true\"]\n    ) {\n    @apply bg-default/20;\n  }\n\n  /* Unavailable dates */\n  &[data-unavailable=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Disabled state */\n  &:disabled:not([data-outside-month=\"true\"]),\n  &[data-disabled=\"true\"]:not([data-outside-month=\"true\"]) {\n    @apply status-disabled;\n\n    text-decoration: line-through;\n  }\n}\n\n/* Outside-month cell followed by selected cell across adjacent table cells */\n.range-calendar__grid-body\n  td:has(> .range-calendar__cell[data-outside-month=\"true\"])\n  + td\n  > .range-calendar__cell[data-selected=\"true\"] {\n  @apply rounded-ss-lg rounded-es-lg;\n\n  &[data-outside-month=\"true\"],\n  &[data-selection-start=\"true\"] {\n    @apply rounded-ss-3xl rounded-es-3xl;\n  }\n}\n\n/* Selected cell followed by outside-month cell across adjacent table cells */\n.range-calendar__grid-body\n  td:has(> .range-calendar__cell[data-selected=\"true\"]):has(\n    + td > .range-calendar__cell[data-outside-month=\"true\"]\n  )\n  > .range-calendar__cell[data-selected=\"true\"] {\n  @apply rounded-se-lg rounded-ee-lg;\n\n  &[data-outside-month=\"true\"],\n  &[data-selection-end=\"true\"] {\n    @apply rounded-se-3xl rounded-ee-3xl;\n  }\n}\n\n/* Cell indicator - small dot at bottom center of cell */\n.range-calendar__cell-indicator {\n  @apply absolute bottom-1 left-1/2 size-[3px] -translate-x-1/2 rounded-xs bg-muted;\n\n  /* Indicator color changes when cell is selected */\n  [data-selected=\"true\"] > & {\n    @apply bg-accent-foreground;\n  }\n}\n","/* =============================================================================\n * Calendar Year Picker Component Styles\n *\n * Internal component used inside Calendar / RangeCalendar to provide a\n * toggleable year selector. Uses CSS :has() on the parent .calendar to\n * drive crossfade transitions.\n *\n * The year grid is absolutely positioned and sized via JS to match the\n * day grid's exact area. This keeps the calendar's original block layout\n * completely untouched.\n *\n * BEM naming: calendar-year-picker__element, calendar-year-picker--modifier\n * ============================================================================= */\n\n/* -----------------------------------------------------------------------------\n * Positioning Context\n * -------------------------------------------------------------------------- */\n.calendar:has(.calendar-year-picker__year-grid),\n.range-calendar:has(.calendar-year-picker__year-grid) {\n  position: relative;\n}\n\n/* -----------------------------------------------------------------------------\n * Crossfade + Blur Transitions\n *\n * The crossfade is staggered to avoid both grids being semi-transparent at\n * the same time (ghosting). When opening, the day grid fades out first,\n * then the year grid fades in. When closing, the year grid fades out first,\n * then the day grid fades in (via transition-delay).\n *\n * -------------------------------------------------------------------------- */\n\n/* Day grid – default visible */\n.calendar:has(.calendar-year-picker__year-grid) > [data-slot=\"calendar-grid\"],\n.range-calendar:has(.calendar-year-picker__year-grid) > [data-slot=\"range-calendar-grid\"] {\n  will-change: opacity;\n  transition:\n    opacity 150ms var(--ease-out),\n    visibility 0ms linear;\n  @apply motion-reduce:transition-none;\n}\n\n/* Day grid – hidden when year picker is open (fade + blur out) */\n.calendar:has(.calendar-year-picker__year-grid[data-open=\"true\"]) > [data-slot=\"calendar-grid\"],\n.range-calendar:has(.calendar-year-picker__year-grid[data-open=\"true\"])\n  > [data-slot=\"range-calendar-grid\"] {\n  @apply pointer-events-none opacity-0;\n  visibility: hidden;\n  transition:\n    opacity 150ms var(--ease-out),\n    visibility 0ms linear 150ms;\n  @apply motion-reduce:transition-none;\n}\n\n/* -----------------------------------------------------------------------------\n * Trigger Button\n * -------------------------------------------------------------------------- */\n.calendar-year-picker__trigger {\n  @apply flex flex-1 items-center justify-start gap-1 rounded-lg outline-none;\n\n  cursor: var(--cursor-interactive);\n  touch-action: manipulation;\n\n  /* Focus state */\n  &:focus-visible {\n    @apply status-focused;\n  }\n}\n\n.calendar-year-picker__trigger-heading {\n  @apply text-sm font-medium;\n\n  transition: color 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n}\n\n.calendar-year-picker__trigger-indicator {\n  @apply text-xs text-accent;\n\n  transition: transform 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n}\n\n/* Rotate chevron when open */\n.calendar-year-picker__trigger[data-open=\"true\"] .calendar-year-picker__trigger-indicator {\n  transform: rotate(90deg);\n}\n\n.calendar-year-picker__trigger[data-open=\"true\"] .calendar-year-picker__trigger-heading {\n  @apply text-accent;\n}\n\n/* -----------------------------------------------------------------------------\n * Year Grid Container\n *\n * Absolutely positioned over the day grid area. The exact `top` and `height`\n * are set via JS to match the sibling day grid element.\n * -------------------------------------------------------------------------- */\n.calendar-year-picker__year-grid {\n  @apply pointer-events-none absolute right-0 left-0 grid content-start gap-1 overflow-y-auto p-1 opacity-0;\n  grid-template-columns: repeat(3, 1fr);\n\n  /* When closing: instant (no transition) */\n  will-change: opacity;\n\n  /* Custom scrollbar – small contained element, per Emil's guidelines */\n  scrollbar-width: thin;\n  scrollbar-color: oklch(0% 0 0 / 0.15) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: oklch(0% 0 0 / 0.15);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: oklch(0% 0 0 / 0.25);\n  }\n\n  /* Dark mode scrollbar */\n  :is([data-theme=\"dark\"], .dark) & {\n    scrollbar-color: oklch(100% 0 0 / 0.15) transparent;\n\n    &::-webkit-scrollbar-thumb {\n      background: oklch(100% 0 0 / 0.15);\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: oklch(100% 0 0 / 0.25);\n    }\n  }\n}\n\n.calendar-year-picker__year-grid[data-open=\"true\"] {\n  @apply pointer-events-auto opacity-100;\n\n  /* When opening: slight delay so the day grid starts fading out first */\n  transition: opacity 200ms var(--ease-out) 50ms;\n  @apply motion-reduce:transition-none;\n}\n\n/* -----------------------------------------------------------------------------\n * Year Cell\n * -------------------------------------------------------------------------- */\n.calendar-year-picker__year-cell {\n  @apply relative inline-flex h-8 items-center justify-center rounded-3xl px-2.5 text-sm font-medium outline-none select-none no-highlight;\n  touch-action: manipulation;\n\n  /**\n   * Transitions – same as .tag\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 100ms var(--ease-smooth),\n    scale 100ms var(--ease-smooth),\n    opacity 100ms var(--ease-smooth),\n    background-color 100ms var(--ease-smooth),\n    box-shadow 100ms var(--ease-out);\n  @apply origin-center transform-gpu motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Hover state (when not selected) – only on devices that support hover */\n  @media (hover: hover) and (pointer: fine) {\n    &:is(:hover, [data-hovered=\"true\"]):not([data-selected=\"true\"]) {\n      @apply bg-default text-default-foreground;\n    }\n  }\n\n  /* Selected state (current year) – same as .tag[data-selected] */\n  &[data-selected=\"true\"],\n  &[aria-selected=\"true\"] {\n    @apply bg-accent text-accent-foreground;\n\n    @media (hover: hover) and (pointer: fine) {\n      &:is(:hover, [data-hovered=\"true\"]) {\n        @apply bg-accent-hover;\n      }\n    }\n  }\n\n  /* Focus state */\n  &:focus-visible {\n    @apply status-focused;\n  }\n}\n","/* Date field styles */\n.date-field {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n}\n\n/* Full width modifier */\n.date-field--full-width {\n  @apply w-full;\n}\n","/* Time field styles */\n.time-field {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n}\n\n/* Full width modifier */\n.time-field--full-width {\n  @apply w-full;\n}\n","/* Date input group styles */\n.date-input-group {\n  @apply inline-flex h-9 items-center overflow-hidden rounded-field border bg-field text-sm text-field-foreground shadow-field outline-none;\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus within state */\n  &[data-focus-within=\"true\"]:not(\n      :has(\n        [data-slot=\"date-picker-trigger\"]:focus,\n        [data-slot=\"date-picker-trigger\"][data-focused=\"true\"],\n        [data-slot=\"date-range-picker-trigger\"]:focus,\n        [data-slot=\"date-range-picker-trigger\"][data-focused=\"true\"]\n      )\n    ),\n  &:focus-within:not(\n      :has(\n        [data-slot=\"date-picker-trigger\"]:focus,\n        [data-slot=\"date-picker-trigger\"][data-focused=\"true\"],\n        [data-slot=\"date-range-picker-trigger\"]:focus,\n        [data-slot=\"date-range-picker-trigger\"][data-focused=\"true\"]\n      )\n    ) {\n    @apply status-focused-field;\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n    border-color: var(--color-field-border-invalid);\n  }\n\n  /* Disabled state */\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.date-input-group__input {\n  @apply flex flex-1 cursor-text items-center gap-px rounded-none border-0 bg-transparent px-3 py-2 text-base shadow-none outline-none sm:text-sm;\n\n  /* Remove border radius on left side when prefix is present */\n  .date-input-group:has([data-slot=\"date-input-group-prefix\"]) & {\n    @apply rounded-l-none pl-2;\n  }\n\n  /* Remove border radius on right side when suffix is present */\n  .date-input-group:has([data-slot=\"date-input-group-suffix\"]) & {\n    @apply rounded-r-none pr-2;\n  }\n\n  .date-input-group:has(.date-range-picker__range-separator) & {\n    &[slot=\"start\"] {\n      @apply flex-none pr-0;\n    }\n    &[slot=\"end\"] {\n      @apply pl-0;\n    }\n  }\n\n  /* Focus state - handled by group */\n  &:focus,\n  &:focus-visible {\n    @apply outline-none;\n  }\n}\n\n.date-input-group__input-container {\n  @apply flex flex-1 items-center;\n  width: fit-content;\n  overflow-x: auto;\n  overflow-y: clip;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.date-input-group__segment {\n  @apply inline-block rounded-md px-0.5 text-end text-nowrap outline-none;\n\n  /* Segment separators styling \"/\" */\n  &[data-type=\"literal\"] {\n    @apply p-0 text-muted;\n  }\n\n  /* Placeholder styling */\n  &[data-placeholder=\"true\"] {\n    @apply text-field-placeholder;\n  }\n\n  /* Focused segment */\n  &:focus,\n  &[data-focused=\"true\"] {\n    @apply bg-accent-soft text-accent-soft-foreground;\n  }\n\n  /* Disabled segment */\n  &[data-disabled=\"true\"] {\n    @apply opacity-50;\n  }\n\n  /* Invalid segment */\n  &[data-invalid=\"true\"] {\n    @apply text-danger;\n\n    /* Focused segment */\n    &:focus,\n    &[data-focused=\"true\"] {\n      @apply bg-danger-soft text-danger-soft-foreground;\n    }\n  }\n}\n\n.date-input-group__prefix {\n  @apply pointer-events-none shrink-0 text-field-placeholder;\n  @apply mr-0 ml-3 flex items-center;\n}\n\n.date-input-group__suffix {\n  @apply pointer-events-none shrink-0 text-field-placeholder;\n  @apply mr-3 flex items-center;\n}\n\n/* Variant property definitions */\n.date-input-group--primary {\n  /* Default styles */\n}\n\n.date-input-group--secondary {\n  @apply shadow-none;\n  background-color: var(--date-input-group-bg);\n\n  --date-input-group-bg: var(--color-default);\n  --date-input-group-bg-hover: var(--color-default-hover);\n  --date-input-group-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover:not(:focus-within),\n    &[data-hovered=\"true\"]:not([data-focus-within=\"true\"]) {\n      background-color: var(--date-input-group-bg-hover);\n    }\n  }\n\n  &:focus-within,\n  &[data-focus-within=\"true\"] {\n    background-color: var(--date-input-group-bg-focus);\n  }\n\n  /* Invalid state */\n  &[data-invalid=\"true\"] {\n    @apply status-invalid-field;\n    border-color: var(--color-field-border-invalid);\n    background-color: var(--date-input-group-bg-focus);\n  }\n\n  [data-slot=\"date-input-group-input\"] {\n    @apply bg-transparent;\n  }\n}\n\n/* Full width modifier */\n.date-input-group--full-width {\n  @apply w-full;\n}\n","/* ==========================================================================\n   DatePicker - Date selection trigger and popover container\n   ========================================================================== */\n\n.date-picker {\n  @apply inline-flex flex-col gap-1;\n\n  .date-input-group__suffix,\n  .date-input-group__prefix {\n    @apply pointer-events-auto;\n  }\n}\n\n.date-picker__trigger {\n  @apply inline-flex w-full items-center rounded-field p-1 text-sm no-highlight;\n\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition: box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.date-picker__trigger-indicator {\n  @apply inline-flex size-4 items-center justify-center text-field-placeholder;\n}\n\n.date-picker__popover {\n  @apply max-w-(--trigger-width) origin-(--trigger-anchor-point) overflow-x-hidden overflow-y-auto overscroll-contain bg-overlay p-3;\n  @apply motion-reduce:transition-none;\n\n  box-shadow: var(--shadow-overlay);\n  border-radius: min(32px, calc(var(--radius) * 2.5));\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-95;\n\n    &[data-placement^=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement^=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement^=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement^=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n}\n","/* ==========================================================================\n   DateRangePicker - Date range selection trigger and popover container\n   ========================================================================== */\n\n.date-range-picker {\n  @apply inline-flex flex-col gap-1;\n\n  .date-input-group__suffix,\n  .date-input-group__prefix {\n    @apply pointer-events-auto;\n  }\n}\n\n.date-range-picker__trigger {\n  @apply inline-flex w-full items-center rounded-field p-1 text-sm no-highlight;\n\n  cursor: var(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition: box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n.date-range-picker__trigger-indicator {\n  @apply inline-flex size-4 items-center justify-center text-field-placeholder;\n}\n\n.date-range-picker__range-separator {\n  @apply px-1 text-field-placeholder select-none;\n}\n\n.date-range-picker__popover {\n  @apply max-w-(--trigger-width) origin-(--trigger-anchor-point) overflow-x-hidden overflow-y-auto overscroll-contain bg-overlay p-3;\n  @apply motion-reduce:transition-none;\n\n  box-shadow: var(--shadow-overlay);\n  border-radius: min(32px, calc(var(--radius) * 2.5));\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-95;\n\n    &[data-placement^=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement^=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement^=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement^=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n}\n","/* Card component styles */\n\n/* Block */\n.card {\n  @apply relative flex flex-col gap-3 overflow-hidden p-4;\n  @apply shadow-surface;\n  border-radius: min(32px, var(--radius-3xl));\n}\n\n/* Element - header */\n.card__header {\n  @apply flex flex-col;\n}\n\n/* Element - title */\n.card__title {\n  @apply text-sm leading-6 font-medium text-foreground;\n}\n\n/* Element - description */\n.card__description {\n  @apply text-sm leading-5 text-muted;\n}\n\n/* Element - content */\n.card__content {\n  @apply flex flex-1 flex-col gap-1;\n}\n\n/* Element - footer */\n.card__footer {\n  @apply flex flex-row items-center;\n}\n\n/* Modifier - variant */\n\n.card--transparent {\n  @apply border-none bg-transparent shadow-none;\n}\n\n.card--default {\n  @apply bg-surface;\n}\n\n.card--secondary {\n  @apply bg-surface-secondary;\n}\n\n.card--tertiary {\n  @apply bg-surface-tertiary;\n}\n","/* ==========================================================================\n   Base header styles\n   ========================================================================== */\n\n.header {\n  @apply w-full px-2 pt-1.5 pb-1 text-left text-xs font-medium text-muted;\n}\n","/* Separator Component Styles */\n\n/* Base separator with default horizontal orientation */\n.separator {\n  @apply shrink-0 rounded-sm border-t-0 border-b-0 bg-separator;\n\n  /* Default size - horizontal orientation */\n  @apply h-px w-full;\n}\n\n/* Orientation variants */\n.separator--horizontal {\n  @apply h-px w-full;\n}\n\n.separator--vertical {\n  @apply h-auto min-h-2 w-px self-stretch;\n}\n\n/* Color variants */\n.separator--default {\n  @apply bg-separator;\n}\n\n.separator--secondary {\n  @apply bg-separator-secondary;\n}\n\n.separator--tertiary {\n  @apply bg-separator-tertiary;\n}\n\n.separator__container {\n  @apply flex items-center gap-3;\n}\n\n.separator__container--horizontal {\n  @apply w-full flex-row;\n}\n\n.separator__container--vertical {\n  @apply h-full flex-col justify-center;\n}\n\n.separator__line {\n  @apply shrink-0 grow;\n}\n\n.separator__content {\n  @apply inline-flex items-center justify-center text-center whitespace-nowrap text-muted;\n}\n\n.separator__content--horizontal {\n  @apply text-center;\n}\n\n.separator__content--vertical {\n  @apply text-center;\n}\n","/* Surface component styles */\n\n/* Block */\n.surface {\n  @apply relative text-foreground;\n}\n\n/* Modifier - variant */\n.surface--transparent {\n  @apply bg-transparent;\n}\n\n.surface--default {\n  @apply bg-surface text-surface-foreground;\n}\n\n.surface--secondary {\n  @apply bg-surface-secondary text-surface-secondary-foreground;\n}\n\n.surface--tertiary {\n  @apply bg-surface-tertiary text-surface-tertiary-foreground;\n}\n","/* Base avatar styles */\n.avatar {\n  @apply relative flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-3xl bg-default;\n}\n\n/* Avatar fallback element */\n.avatar__fallback {\n  @apply flex size-full items-center justify-center bg-default text-sm font-medium;\n}\n\n/* Avatar image element */\n.avatar__image {\n  @apply absolute inset-0 aspect-square size-full;\n\n  /**\n   * Transitions\n   */\n  @apply transition-opacity duration-250 motion-reduce:transition-none;\n}\n\n/* Size modifiers */\n.avatar--sm {\n  @apply size-8 rounded-2xl;\n}\n\n.avatar--md {\n  /* No styles as this is the default size */\n}\n\n.avatar--lg {\n  @apply size-12 rounded-3xl;\n\n  .avatar__fallback {\n    @apply text-base;\n  }\n}\n\n/* Color modifiers for fallback */\n.avatar__fallback--accent {\n  @apply text-accent;\n}\n\n.avatar__fallback--default {\n  @apply text-default-foreground;\n}\n\n.avatar__fallback--success {\n  @apply text-success;\n}\n\n.avatar__fallback--warning {\n  @apply text-warning;\n}\n\n.avatar__fallback--danger {\n  @apply text-danger;\n}\n\n/* Variant modifiers */\n.avatar--soft {\n  @apply bg-transparent;\n}\n\n.avatar--soft .avatar__fallback--accent {\n  @apply bg-accent-soft text-accent-soft-foreground;\n}\n\n.avatar--soft .avatar__fallback--success {\n  @apply bg-success-soft text-success-soft-foreground;\n}\n\n.avatar--soft .avatar__fallback--warning {\n  @apply bg-warning-soft text-warning-soft-foreground;\n}\n\n.avatar--soft .avatar__fallback--danger {\n  @apply bg-danger-soft text-danger-soft-foreground;\n}\n","/* -------------------------------------------------------------------------------------------------\n * AlertDialog Component Styles\n * Block: alert-dialog\n * -----------------------------------------------------------------------------------------------*/\n\n/**\n * Element: trigger - the element that opens the modal\n */\n.alert-dialog__trigger {\n  @apply inline-block;\n  @apply cursor-(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Active/pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.97);\n  }\n}\n\n/**\n * Element: backdrop - the overlay behind the dialog\n */\n.alert-dialog__backdrop {\n  @apply fixed inset-0 z-50;\n  @apply flex flex-row items-center justify-center;\n  @apply h-(--visual-viewport-height) w-full;\n\n  /* Entering animation */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-out fade-in-0;\n  }\n\n  /* Exiting animation */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-out fade-out-0;\n  }\n\n  /**\n   * Reduce Animation\n   * CRITICAL: motion-reduce must be AFTER animate for correct override specificity\n   */\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity];\n    @apply motion-reduce:animate-none;\n  }\n}\n\n/**\n * Modifier: backdrop--transparent\n */\n.alert-dialog__backdrop--transparent {\n  @apply bg-transparent;\n}\n\n/**\n * Modifier: backdrop--opaque\n */\n.alert-dialog__backdrop--opaque {\n  @apply bg-backdrop;\n}\n\n/**\n * Modifier: backdrop--blur\n */\n.alert-dialog__backdrop--blur {\n  @apply bg-backdrop backdrop-blur-md;\n}\n\n/**\n * Element: container - the positioning wrapper for the modal\n */\n.alert-dialog__container {\n  @apply flex flex-col items-center;\n  @apply h-(--visual-viewport-height) w-full min-w-0 flex-1;\n  @apply p-4;\n  @apply sm:w-fit sm:p-10;\n  @apply pointer-events-none;\n\n  /* Entering animation */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-250 ease-out-quad fade-in-0 zoom-in-105;\n\n    &[data-placement=\"auto\"] {\n      @apply slide-in-from-bottom-1;\n      @apply sm:slide-in-from-bottom-0;\n    }\n\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"center\"] {\n      @apply slide-in-from-top-0;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-bottom-1;\n    }\n  }\n\n  /* Exiting animation */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-out-quad fade-out-0 zoom-out-95;\n  }\n\n  /**\n   * Reduce Animation\n   * CRITICAL: motion-reduce must be AFTER animate for correct override specificity\n   */\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n    @apply motion-reduce:animate-none;\n  }\n}\n\n/**\n * Element: dialog - the content container for the modal\n */\n.alert-dialog__dialog {\n  @apply relative;\n  @apply flex w-full flex-col;\n  @apply bg-overlay shadow-overlay outline-none;\n  border-radius: min(32px, var(--radius-3xl));\n  @apply p-6;\n  @apply overflow-hidden;\n  @apply pointer-events-auto;\n\n  &[data-placement=\"auto\"] {\n    @apply mt-auto;\n    @apply sm:my-auto;\n  }\n\n  &[data-placement=\"center\"] {\n    @apply my-auto;\n  }\n\n  &[data-placement=\"bottom\"] {\n    @apply mt-auto;\n  }\n\n  &[data-placement=\"top\"] {\n    @apply mt-0;\n  }\n}\n\n/**\n * Modifier: dialog--xs\n */\n.alert-dialog__dialog--xs {\n  @apply max-w-xs;\n}\n\n/**\n * Modifier: dialog--sm\n */\n.alert-dialog__dialog--sm {\n  @apply max-w-sm;\n}\n\n/**\n * Modifier: dialog--md\n */\n.alert-dialog__dialog--md {\n  @apply max-w-md;\n}\n\n/**\n * Modifier: dialog--lg\n */\n.alert-dialog__dialog--lg {\n  @apply max-w-lg;\n}\n\n/**\n * Modifier: dialog--cover\n */\n.alert-dialog__dialog--cover {\n  @apply h-full min-h-full w-full;\n}\n\n/**\n * Element: header - the top section with the title\n */\n.alert-dialog__header {\n  @apply flex flex-col gap-3;\n  @apply mb-0;\n\n  /* When header contains icon, use flex-col layout with gap */\n  & > .modal__icon {\n    @apply mb-0;\n  }\n}\n\n/**\n * Element: heading - the main title text\n */\n.alert-dialog__heading {\n  @apply align-middle;\n  @apply text-base font-medium text-foreground;\n}\n\n/**\n * Element: icon - the optional icon indicator\n */\n.alert-dialog__icon {\n  @apply flex items-center justify-center;\n  @apply size-10 shrink-0;\n  @apply rounded-3xl select-none;\n\n  [data-slot=\"alert-dialog-default-icon\"] {\n    @apply box-content size-5;\n  }\n}\n\n/**\n * Modifier: icon--default\n */\n.alert-dialog__icon--default {\n  @apply bg-default text-foreground;\n}\n\n/**\n * Modifier: icon--accent\n */\n.alert-dialog__icon--accent {\n  @apply bg-accent-soft text-accent-soft-foreground;\n}\n\n/**\n * Modifier: icon--success\n */\n.alert-dialog__icon--success {\n  @apply bg-success-soft text-success-soft-foreground;\n}\n\n/**\n * Modifier: icon--warning\n */\n.alert-dialog__icon--warning {\n  @apply bg-warning-soft text-warning-soft-foreground;\n}\n\n/**\n * Modifier: icon--danger\n */\n.alert-dialog__icon--danger {\n  @apply bg-danger-soft text-danger-soft-foreground;\n}\n\n/**\n * Element: body - the main content area\n */\n.alert-dialog__body {\n  @apply min-h-0 flex-1;\n  @apply text-sm leading-[1.43] text-muted;\n  @apply my-0;\n  @apply overflow-y-auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/**\n * Element: footer - the bottom action section\n */\n.alert-dialog__footer {\n  @apply flex flex-row items-center justify-end gap-2;\n  @apply mt-0;\n}\n\n/**\n * Element: close-trigger - the optional x icon button to close the modal\n */\n.alert-dialog__close-trigger {\n  @apply absolute top-4 right-4;\n}\n\n/**\n * Elements Spacing\n */\n.alert-dialog__header + .alert-dialog__body {\n  @apply mt-2;\n}\n\n.alert-dialog__header + .alert-dialog__footer {\n  @apply mt-5;\n}\n\n.alert-dialog__body + .alert-dialog__footer {\n  @apply mt-5;\n}\n","/* -------------------------------------------------------------------------------------------------\n * Drawer Component Styles\n * Block: drawer\n * -----------------------------------------------------------------------------------------------*/\n\n/**\n * Element: trigger - the element that opens the drawer\n */\n.drawer__trigger {\n  @apply inline-block cursor-(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Active/pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.97);\n  }\n}\n\n/**\n * Element: backdrop - the overlay behind the drawer\n */\n.drawer__backdrop {\n  @apply fixed inset-0 z-50;\n  @apply h-(--visual-viewport-height) w-full;\n  opacity: 1;\n  transition: opacity 250ms cubic-bezier(0.32, 0.72, 0, 1);\n\n  &[data-entering=\"true\"] {\n    opacity: 0;\n  }\n\n  &[data-exiting=\"true\"] {\n    opacity: 0;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.32, 0.72, 0, 1);\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    will-change: opacity;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n}\n\n/**\n * Modifier: backdrop--transparent\n */\n.drawer__backdrop--transparent {\n  @apply bg-transparent;\n}\n\n/**\n * Modifier: backdrop--opaque\n */\n.drawer__backdrop--opaque {\n  @apply bg-backdrop;\n}\n\n/**\n * Modifier: backdrop--blur\n */\n.drawer__backdrop--blur {\n  @apply bg-backdrop backdrop-blur-md;\n}\n\n/**\n * Element: content - the positioning wrapper for the drawer panel\n */\n.drawer__content {\n  @apply pointer-events-none;\n  @apply fixed inset-0 z-50 flex;\n  @apply h-(--visual-viewport-height) w-full min-w-0;\n}\n\n/**\n * Modifier: content--bottom (default)\n * Slides up from the bottom edge\n */\n.drawer__content--bottom {\n  @apply items-end;\n}\n\n/**\n * Modifier: content--top\n * Slides down from the top edge\n */\n.drawer__content--top {\n  @apply items-start;\n}\n\n/**\n * Modifier: content--left\n * Slides in from the left edge\n */\n.drawer__content--left {\n  @apply justify-start;\n}\n\n/**\n * Modifier: content--right\n * Slides in from the right edge\n */\n.drawer__content--right {\n  @apply justify-end;\n}\n\n/**\n * Element: dialog - the drawer panel itself\n */\n.drawer__dialog {\n  @apply relative;\n  @apply flex flex-col;\n  @apply bg-overlay shadow-overlay outline-none;\n  @apply p-6;\n  @apply pointer-events-auto;\n\n  --drawer-enter-duration: 250ms;\n  --drawer-exit-duration: 200ms;\n  --drawer-enter-ease: cubic-bezier(0.32, 0.72, 0, 1);\n  --drawer-exit-ease: cubic-bezier(0.32, 0.72, 0, 1);\n\n  will-change: translate;\n  transition: translate var(--drawer-enter-duration) var(--drawer-enter-ease);\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n\n  /* Bottom/top placement: full width, auto height */\n  &[data-placement=\"bottom\"] {\n    @apply w-full;\n    @apply max-h-[85vh];\n    border-top-left-radius: min(32px, var(--radius-2xl));\n    border-top-right-radius: min(32px, var(--radius-2xl));\n  }\n\n  &[data-placement=\"top\"] {\n    @apply w-full;\n    @apply max-h-[85vh];\n    border-bottom-left-radius: min(32px, var(--radius-2xl));\n    border-bottom-right-radius: min(32px, var(--radius-2xl));\n  }\n\n  /* Left/right placement: auto width, full height */\n  &[data-placement=\"left\"] {\n    @apply h-full rounded-none;\n    @apply w-80 max-w-[85vw] sm:w-96;\n  }\n\n  &[data-placement=\"right\"] {\n    @apply h-full rounded-none;\n    @apply w-80 max-w-[85vw] sm:w-96;\n  }\n}\n\n[data-exiting=\"true\"] .drawer__dialog {\n  transition-duration: var(--drawer-exit-duration);\n  transition-timing-function: var(--drawer-exit-ease);\n}\n\n.drawer__content--left .drawer__dialog,\n.drawer__content--right .drawer__dialog,\n.drawer__content--top .drawer__dialog,\n.drawer__content--bottom .drawer__dialog {\n  translate: 0 0;\n}\n\n.drawer__content--left[data-entering=\"true\"] .drawer__dialog,\n.drawer__content--left[data-exiting=\"true\"] .drawer__dialog {\n  translate: -100% 0;\n}\n\n.drawer__content--right[data-entering=\"true\"] .drawer__dialog,\n.drawer__content--right[data-exiting=\"true\"] .drawer__dialog {\n  translate: 100% 0;\n}\n\n.drawer__content--top[data-entering=\"true\"] .drawer__dialog,\n.drawer__content--top[data-exiting=\"true\"] .drawer__dialog {\n  translate: 0 -100%;\n}\n\n.drawer__content--bottom[data-entering=\"true\"] .drawer__dialog,\n.drawer__content--bottom[data-exiting=\"true\"] .drawer__dialog {\n  translate: 0 100%;\n}\n\n.drawer__dialog--top {\n  @apply pb-2;\n  .drawer__handle {\n    @apply pb-0;\n  }\n}\n\n/**\n * Element: header - the top section with the title\n */\n.drawer__header {\n  @apply flex flex-col gap-3;\n  @apply mb-0;\n}\n\n/**\n * Element: heading - the main title text\n */\n.drawer__heading {\n  @apply align-middle;\n  @apply text-base font-medium text-foreground;\n}\n\n/**\n * Element: body - the main content area\n * touch-action: pan-y allows vertical scrolling while the dialog captures drag gestures\n */\n.drawer__body {\n  @apply min-h-0 flex-1;\n  @apply text-sm leading-[1.43] text-muted;\n  @apply -m-[3px] my-0 p-[3px];\n  @apply overflow-y-auto overscroll-contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n/**\n * Element: footer - the bottom action section\n */\n.drawer__footer {\n  @apply flex flex-row items-center justify-end gap-2;\n  @apply mt-0;\n}\n\n/**\n * Element: handle - visual drag handle indicator\n */\n.drawer__handle {\n  @apply flex items-center justify-center;\n  @apply pb-2;\n\n  /* The handle bar */\n  & > [data-slot=\"drawer-handle-bar\"] {\n    @apply h-1 w-9 rounded-xs;\n    @apply bg-separator;\n  }\n}\n\n/**\n * Element: close-trigger - the close button\n */\n.drawer__close-trigger {\n  @apply absolute top-4 right-4;\n}\n\n/**\n * Elements Spacing\n */\n.drawer__header + .drawer__body {\n  @apply mt-2;\n}\n\n.drawer__header + .drawer__footer {\n  @apply mt-5;\n}\n\n.drawer__body + .drawer__footer {\n  @apply mt-5;\n}\n\n.drawer__handle + .drawer__header {\n  @apply mt-0;\n}\n\n.drawer__handle + .drawer__body {\n  @apply mt-0;\n}\n","/* -------------------------------------------------------------------------------------------------\n * Modal Component Styles\n * Block: modal\n * -----------------------------------------------------------------------------------------------*/\n\n/**\n * Element: trigger - the element that opens the modal\n */\n.modal__trigger {\n  @apply inline-block cursor-(--cursor-interactive);\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    transform 250ms var(--ease-out-quart),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n\n  /* Active/pressed state */\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.97);\n  }\n}\n\n/**\n * Element: backdrop - the overlay behind the dialog\n */\n.modal__backdrop {\n  @apply fixed inset-0 z-50;\n  @apply flex flex-row items-center justify-center;\n  @apply h-(--visual-viewport-height) w-full;\n\n  /* Entering animation */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-out fade-in-0;\n  }\n\n  /* Exiting animation */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-out fade-out-0;\n  }\n\n  /**\n   * Reduce Animation\n   * CRITICAL: motion-reduce must be AFTER animate for correct override specificity\n   */\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity];\n    @apply motion-reduce:animate-none;\n  }\n}\n\n/**\n * Modifier: backdrop--transparent\n */\n.modal__backdrop--transparent {\n  @apply bg-transparent;\n}\n\n/**\n * Modifier: backdrop--opaque\n */\n.modal__backdrop--opaque {\n  @apply bg-backdrop;\n}\n\n/**\n * Modifier: backdrop--blur\n */\n.modal__backdrop--blur {\n  @apply bg-backdrop backdrop-blur-md;\n}\n\n/**\n * Element: container - the positioning wrapper for the modal\n */\n.modal__container {\n  @apply flex flex-col items-center;\n  @apply h-(--visual-viewport-height) w-full min-w-0 flex-1;\n  @apply p-4;\n  @apply sm:w-fit sm:p-10;\n  @apply pointer-events-none;\n\n  /* Entering animation */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-250 ease-out-quad fade-in-0 zoom-in-105;\n\n    &[data-placement=\"auto\"] {\n      @apply slide-in-from-bottom-1;\n      @apply sm:slide-in-from-bottom-0;\n    }\n\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"center\"] {\n      @apply slide-in-from-top-0;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-bottom-1;\n    }\n  }\n\n  /* Exiting animation */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-out-quad fade-out-0 zoom-out-95;\n  }\n\n  /**\n   * Reduce Animation\n   * CRITICAL: motion-reduce must be AFTER animate for correct override specificity\n   */\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n    @apply motion-reduce:animate-none;\n  }\n}\n\n/**\n * Modifier: container--scroll-outside\n */\n.modal__container--scroll-outside {\n  @apply overflow-y-auto;\n  @apply pointer-events-auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/**\n * Modifier: container--full\n */\n.modal__container--full {\n  @apply p-0 sm:p-0;\n\n  /* Entering animation */\n  &[data-entering=\"true\"] {\n    @apply slide-in-from-bottom-0 zoom-in-100;\n    @apply sm:slide-in-from-bottom-0;\n  }\n\n  /* Exiting animation */\n  &[data-exiting=\"true\"] {\n    @apply zoom-out-100;\n  }\n}\n\n/**\n * Element: dialog - the content container for the modal\n */\n.modal__dialog {\n  @apply relative;\n  @apply flex w-full flex-col;\n  @apply bg-overlay shadow-overlay outline-none;\n  border-radius: min(32px, var(--radius-3xl));\n  @apply p-6;\n  @apply pointer-events-auto;\n\n  &[data-placement=\"auto\"] {\n    @apply mt-auto;\n    @apply sm:my-auto;\n  }\n\n  &[data-placement=\"center\"] {\n    @apply my-auto;\n  }\n\n  &[data-placement=\"bottom\"] {\n    @apply mt-auto;\n  }\n\n  &[data-placement=\"top\"] {\n    @apply mt-0;\n  }\n}\n\n/**\n * Modifier: dialog--scroll-inside\n */\n.modal__dialog--scroll-inside {\n  @apply overflow-hidden;\n}\n\n/**\n * Modifier: dialog--scroll-outside\n */\n.modal__dialog--scroll-outside {\n  @apply h-auto;\n  @apply min-h-0 shrink-0;\n}\n\n/**\n * Modifier: dialog--xs\n */\n.modal__dialog--xs {\n  @apply max-w-xs;\n}\n\n/**\n * Modifier: dialog--sm\n */\n.modal__dialog--sm {\n  @apply max-w-sm;\n}\n\n/**\n * Modifier: dialog--md\n */\n.modal__dialog--md {\n  @apply max-w-md;\n}\n\n/**\n * Modifier: dialog--lg\n */\n.modal__dialog--lg {\n  @apply max-w-lg;\n}\n\n/**\n * Modifier: dialog--cover\n */\n.modal__dialog--cover {\n  @apply h-full min-h-full w-full;\n}\n\n/**\n * Modifier: dialog--full\n */\n.modal__dialog--full {\n  @apply h-full min-h-full w-full;\n  @apply rounded-none shadow-none;\n}\n\n/**\n * Element: header - the top section with the title\n */\n.modal__header {\n  @apply flex flex-col gap-3;\n  @apply mb-0;\n\n  /* When header contains icon, use flex-col layout with gap */\n  & > .modal__icon {\n    @apply mb-0;\n  }\n}\n\n/**\n * Element: heading - the main title text\n */\n.modal__heading {\n  @apply align-middle;\n  @apply text-base font-medium text-foreground;\n}\n\n/**\n * Element: icon - the optional icon indicator\n */\n.modal__icon {\n  @apply flex items-center justify-center;\n  @apply size-10 shrink-0;\n  @apply rounded-3xl select-none;\n}\n\n/**\n * Element: body - the main content area\n */\n.modal__body {\n  @apply min-h-0 flex-1;\n  @apply text-sm leading-[1.43] text-muted;\n  @apply my-0;\n}\n\n/**\n * Modifier: body--scroll-inside\n */\n.modal__body--scroll-inside {\n  @apply overflow-y-auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/**\n * Modifier: body--scroll-outside\n */\n.modal__body--scroll-outside {\n  @apply overflow-y-visible;\n}\n\n/**\n * Element: footer - the bottom action section\n */\n.modal__footer {\n  @apply flex flex-row items-center justify-end gap-2;\n  @apply mt-0;\n}\n\n/**\n * Element: close-trigger - the optional x icon button to close the modal\n */\n.modal__close-trigger {\n  @apply absolute top-4 right-4;\n}\n\n/**\n * Elements Spacing\n */\n.modal__header + .modal__body {\n  @apply mt-2;\n}\n\n.modal__header + .modal__footer {\n  @apply mt-5;\n}\n\n.modal__body + .modal__footer {\n  @apply mt-5;\n}\n","/* Popover component styles */\n\n/* Base popover styles */\n.popover {\n  @apply origin-(--trigger-anchor-point) bg-overlay p-0 text-sm;\n  border-radius: min(32px, var(--radius-3xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-90;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"popover-overlay-arrow\"] {\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 90deg;\n  }\n}\n\n/* Popover dialog */\n.popover__dialog {\n  @apply p-4 outline-none;\n}\n\n/* Popover heading */\n.popover__heading {\n  @apply font-medium;\n}\n\n/* Popover trigger */\n.popover__trigger {\n  @apply inline-block;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 150ms var(--ease-smooth),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  cursor: var(--cursor-interactive);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n","/* Tooltip component styles */\n\n/* Base tooltip styles */\n.tooltip {\n  @apply max-w-xs origin-(--trigger-anchor-point) bg-overlay p-2 text-xs break-all;\n  border-radius: min(32px, var(--radius-xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-90;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"overlay-arrow\"] {\n    @apply stroke-border/40;\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"overlay-arrow\"] {\n    rotate: 90deg;\n  }\n}\n\n/* Tooltip trigger */\n.tooltip__trigger {\n  @apply inline-block;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    color 150ms var(--ease-smooth),\n    background-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n  }\n}\n","/* ComboBox styles */\n.combo-box {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n\n  [data-slot=\"input\"] {\n    @apply min-w-0 flex-1;\n\n    /* Add padding-right when trigger is present */\n    &:has(+ .combo-box__trigger) {\n      @apply pr-7;\n    }\n\n    /* Focus state (input.css only has focus-visible, but combo-box also needs focus) */\n    &:focus,\n    &[data-focus] {\n      @apply status-focused-field;\n      border-color: var(--color-field-border-focus);\n      background-color: var(--color-field-focus);\n    }\n\n    /* Disabled state */\n    &:disabled,\n    &[data-disabled],\n    &[aria-disabled=\"true\"] {\n      @apply status-disabled;\n    }\n  }\n}\n\n.combo-box__input-group {\n  @apply relative isolate inline-flex items-center;\n}\n\n.combo-box__trigger {\n  @apply absolute top-1/2 right-0 flex h-full shrink-0 -translate-y-1/2 cursor-pointer items-center justify-center pr-2 text-field-placeholder transition duration-150 no-highlight;\n\n  /* Remove default button styles */\n  @apply border-none bg-transparent outline-none;\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply text-field-foreground;\n    }\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply rounded ring-2 ring-focus ring-offset-2 ring-offset-background outline-none;\n  }\n\n  /* Pressed state */\n  &[data-pressed=\"true\"] {\n    @apply opacity-70;\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled],\n  &[aria-disabled=\"true\"] {\n    @apply cursor-not-allowed opacity-50;\n  }\n\n  [data-slot=\"combo-box-trigger-default-icon\"] {\n    @apply size-4 transition-transform duration-150 motion-reduce:transition-none;\n  }\n\n  /* Rotate icon when trigger is open */\n  &[data-open=\"true\"] [data-slot=\"combo-box-trigger-default-icon\"] {\n    @apply rotate-180;\n  }\n}\n\n/* Similar to popover content styles */\n.combo-box__popover {\n  @apply min-w-(--trigger-width) origin-(--trigger-anchor-point) scroll-py-1 overflow-y-auto overscroll-contain bg-overlay p-0 text-sm;\n  border-radius: min(32px, var(--radius-3xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-95;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"popover-overlay-arrow\"] {\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 90deg;\n  }\n\n  /* Listbox styles */\n  [data-slot=\"list-box\"] {\n    @apply p-1.5 outline-none;\n  }\n\n  [data-slot=\"list-box-item\"] {\n    @apply px-2.5;\n\n    /* As the combo-box is single-select, we don't need to animate the checkmark */\n    [data-slot=\"list-box-item-indicator--checkmark\"] {\n      @apply transition-none;\n    }\n  }\n}\n\n/* Full width modifier */\n.combo-box--full-width {\n  @apply w-full;\n}\n\n.combo-box__input-group--full-width {\n  @apply w-full;\n}\n","/* Select styles */\n.select {\n  @apply flex flex-col gap-1;\n\n  &[data-invalid=\"true\"],\n  &[aria-invalid=\"true\"] {\n    [data-slot=\"description\"] {\n      @apply hidden;\n    }\n  }\n\n  [data-slot=\"label\"] {\n    @apply w-fit;\n  }\n}\n\n.select__trigger {\n  @apply relative isolate inline-flex min-h-9 rounded-field border bg-field px-3 py-2 text-sm text-field-foreground shadow-field outline-none select-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /* Add padding-right when indicator is present */\n  &:has(.select__indicator) {\n    @apply pr-7;\n  }\n\n  /* Hover state */\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n\n  /* Invalid state */\n  .select[data-invalid=\"true\"] &,\n  .select[aria-invalid=\"true\"] & {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* Variant property definitions */\n.select--primary {\n  /* Default styles */\n}\n\n.select--secondary .select__trigger {\n  @apply shadow-none;\n  background-color: var(--select-trigger-bg);\n\n  --select-trigger-bg: var(--color-default);\n  --select-trigger-bg-hover: var(--color-default-hover);\n  --select-trigger-bg-focus: var(--color-default);\n\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      background-color: var(--select-trigger-bg-hover);\n    }\n  }\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    background-color: var(--select-trigger-bg-focus);\n  }\n\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n}\n\n.select__value {\n  @apply flex-1 text-left text-base wrap-break-word text-current sm:text-sm;\n\n  &[data-placeholder=\"true\"] {\n    @apply text-field-placeholder;\n  }\n\n  /* Removes the list-box-item indicator element from the select value*/\n  [data-slot=\"list-box-item-indicator\"] {\n    @apply hidden;\n  }\n}\n\n.select__indicator {\n  @apply absolute inset-y-0 right-2 my-auto flex shrink-0 items-center justify-center text-field-placeholder transition duration-150;\n\n  &[data-open=\"true\"] {\n    @apply rotate-180;\n  }\n\n  &[data-slot=\"select-default-indicator\"] {\n    @apply size-4;\n  }\n}\n\n/* Similar to popover content styles */\n.select__popover {\n  @apply min-w-(--trigger-width) origin-(--trigger-anchor-point) scroll-py-1 overflow-y-auto overscroll-contain bg-overlay p-0 text-sm;\n  border-radius: min(32px, var(--radius-3xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-150 ease-smooth fade-in-0 zoom-in-95;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-smooth zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"popover-overlay-arrow\"] {\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 90deg;\n  }\n\n  /* Listbox styles */\n  [data-slot=\"list-box\"] {\n    @apply p-1.5 outline-none;\n  }\n\n  [data-slot=\"list-box-item\"] {\n    @apply px-2.5;\n  }\n\n  /* As the popover closes fast in single-select mode, the default item indicator transition is not even visible - so we disable it only for single-select */\n  [data-slot=\"list-box\"]:not([aria-multiselectable=\"true\"]) [data-slot=\"list-box-item-indicator\"],\n  [data-slot=\"list-box\"]:not([aria-multiselectable=\"true\"])\n    [data-slot=\"list-box-item-indicator\"]\n    [data-slot=\"list-box-item-indicator--checkmark\"] {\n    @apply transition-none;\n  }\n}\n\n/* Full width modifier */\n.select--full-width {\n  @apply w-full;\n}\n\n.select__trigger--full-width {\n  @apply w-full;\n}\n","/* Autocomplete styles */\n.autocomplete {\n  @apply flex flex-col gap-1;\n}\n\n.autocomplete__trigger {\n  @apply relative isolate inline-flex min-h-9 rounded-field border bg-field px-3 py-2 text-sm text-field-foreground shadow-field outline-none select-none no-highlight;\n\n  /**\n   * Transitions\n   * CRITICAL: motion-reduce must be AFTER transition for correct override specificity\n   */\n  transition:\n    background-color 150ms var(--ease-smooth),\n    border-color 150ms var(--ease-smooth),\n    box-shadow 150ms var(--ease-out);\n  @apply motion-reduce:transition-none;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  border-width: var(--border-width-field);\n  border-color: var(--color-field-border);\n\n  /* Add padding-right when indicator is present */\n  &:has(.autocomplete__indicator) {\n    @apply pr-7;\n  }\n\n  /* Hover state - exclude when clear button is hovered to prevent double hover effect */\n  @media (hover: hover) {\n    &:hover:not(:has(.autocomplete__clear-button:hover)),\n    &[data-hovered=\"true\"]:not(:has(.autocomplete__clear-button:hover)) {\n      @apply bg-field-hover;\n      border-color: var(--color-field-border-hover);\n    }\n  }\n\n  /* Focus visible state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply status-focused;\n    border-color: var(--color-field-border-focus);\n    background-color: var(--color-field-focus);\n  }\n\n  /* Focus state */\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n\n  /* Invalid state */\n  .autocomplete[data-invalid=\"true\"] &,\n  .autocomplete[aria-invalid=\"true\"] & {\n    @apply status-invalid-field;\n    background-color: var(--color-field-focus);\n  }\n\n  /* Disabled state */\n  &:disabled,\n  &[data-disabled=\"true\"],\n  &[aria-disabled=\"true\"] {\n    @apply status-disabled;\n  }\n}\n\n/* Variant property definitions */\n.autocomplete--primary {\n  /* Default styles */\n}\n\n.autocomplete--secondary .autocomplete__trigger {\n  @apply shadow-none;\n  background-color: var(--autocomplete-trigger-bg);\n\n  --autocomplete-trigger-bg: var(--color-default);\n  --autocomplete-trigger-bg-hover: var(--color-default-hover);\n  --autocomplete-trigger-bg-focus: var(--color-default);\n\n  /* Exclude when clear button is hovered to prevent double hover effect */\n  @media (hover: hover) {\n    &:hover:not(:has(.autocomplete__clear-button:hover)),\n    &[data-hovered=\"true\"]:not(:has(.autocomplete__clear-button:hover)) {\n      background-color: var(--autocomplete-trigger-bg-hover);\n    }\n  }\n\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    background-color: var(--autocomplete-trigger-bg-focus);\n  }\n\n  &:focus,\n  &[data-focus=\"true\"] {\n  }\n}\n\n.autocomplete__value {\n  @apply flex-1 text-left text-base wrap-break-word text-current sm:text-sm;\n\n  &[data-placeholder=\"true\"] {\n    @apply text-field-placeholder;\n  }\n\n  /* Removes the list-box-item indicator element from the autocomplete value*/\n  [data-slot=\"list-box-item-indicator\"] {\n    @apply hidden;\n  }\n}\n\n.autocomplete__indicator {\n  @apply absolute inset-y-0 right-2 my-auto flex shrink-0 items-center justify-center text-field-placeholder transition duration-150;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  &[data-open=\"true\"] {\n    @apply rotate-180;\n  }\n\n  &[data-slot=\"autocomplete-default-indicator\"] {\n    @apply size-4;\n  }\n}\n\n/* Similar to popover content styles */\n.autocomplete__popover {\n  @apply min-w-(--trigger-width) origin-(--trigger-anchor-point) scroll-py-1 overflow-y-auto overscroll-contain bg-overlay p-0 pt-2 text-sm;\n  border-radius: min(32px, var(--radius-3xl));\n  box-shadow: var(--shadow-overlay);\n\n  /* Focus state */\n  &:focus-visible:not(:focus),\n  &[data-focus-visible=\"true\"] {\n    @apply outline-none;\n  }\n\n  /* Entering animations */\n  &[data-entering=\"true\"] {\n    @apply animate-in duration-250 ease-out-fluid fade-in-0 zoom-in-95;\n\n    /* Placement-specific translations */\n    &[data-placement=\"top\"] {\n      @apply slide-in-from-bottom-1;\n    }\n\n    &[data-placement=\"bottom\"] {\n      @apply slide-in-from-top-1;\n    }\n\n    &[data-placement=\"left\"] {\n      @apply slide-in-from-right-1;\n    }\n\n    &[data-placement=\"right\"] {\n      @apply slide-in-from-left-1;\n    }\n  }\n\n  /* Exiting animations */\n  &[data-exiting=\"true\"] {\n    @apply animate-out duration-100 ease-out-quad zoom-out-95 fade-out;\n  }\n\n  &[data-exiting=\"true\"],\n  &[data-entering=\"true\"] {\n    @apply will-change-[opacity,transform];\n  }\n\n  /* Arrow styling */\n  & [data-slot=\"popover-overlay-arrow\"] {\n    fill: var(--overlay);\n  }\n\n  /* Arrow rotation based on placement */\n  &[data-placement=\"bottom\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 180deg;\n  }\n\n  &[data-placement=\"left\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: -90deg;\n  }\n\n  &[data-placement=\"right\"] [data-slot=\"popover-overlay-arrow\"] {\n    rotate: 90deg;\n  }\n\n  /* Listbox styles */\n  [data-slot=\"list-box\"] {\n    @apply p-1.5 outline-none;\n  }\n\n  [data-slot=\"list-box-item\"] {\n    @apply px-2.5;\n  }\n\n  /* As the popover closes fast in single-select mode, the default item indicator transition is not even visible - so we disable it only for single-select */\n  [data-slot=\"list-box\"]:not([aria-multiselectable=\"true\"]) [data-slot=\"list-box-item-indicator\"],\n  [data-slot=\"list-box\"]:not([aria-multiselectable=\"true\"])\n    [data-slot=\"list-box-item-indicator\"]\n    [data-slot=\"list-box-item-indicator--checkmark\"] {\n    @apply transition-none;\n  }\n\n  /* Search Field styles */\n  [data-slot=\"search-field\"] {\n    @apply px-3 py-1 outline-none;\n  }\n\n  /* Empty State */\n  [data-slot=\"empty-state\"] {\n    @apply text-center text-sm text-overlay-foreground/60;\n  }\n}\n\n/* Full width modifier */\n.autocomplete--full-width {\n  @apply w-full;\n}\n\n.autocomplete__trigger--full-width {\n  @apply w-full;\n}\n\n/* Clear Button styles */\n.autocomplete__clear-button {\n  @apply relative isolate inline-flex h-6 w-6 shrink-0 origin-center items-center justify-center rounded-xl p-1 text-muted select-none no-highlight;\n  @apply mr-0 size-5 shrink-0 self-center bg-transparent;\n\n  /* Cursor */\n  cursor: var(--cursor-interactive);\n\n  @apply transform-gpu;\n\n  /* Transition only when visible - disappears immediately when cleared */\n  &:not([data-empty=\"true\"]) {\n    transition: opacity 150ms var(--ease-smooth);\n    @apply motion-reduce:transition-none;\n  }\n\n  &[data-empty=\"true\"] {\n    @apply pointer-events-none opacity-0;\n  }\n\n  [data-slot=\"autocomplete-clear-button-icon\"] {\n    @apply size-3.5;\n  }\n\n  &:active,\n  &[data-pressed=\"true\"] {\n  }\n\n  @media (hover: hover) {\n    &:hover,\n    &[data-hovered=\"true\"] {\n      @apply bg-default-hover;\n    }\n  }\n\n  &:active,\n  &[data-pressed=\"true\"] {\n    transform: scale(0.93);\n  }\n}\n","/* Base styles */\n.kbd {\n  @apply inline-flex h-6 items-center space-x-0.5 rounded-lg bg-default px-2 text-center font-sans text-sm font-medium whitespace-nowrap text-muted rtl:space-x-reverse;\n  word-spacing: -0.25rem;\n}\n\n/* Key abbreviation styles */\n.kbd__abbr {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n}\n\n/* Content wrapper */\n.kbd__content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Variant styles */\n.kbd--light {\n  @apply bg-transparent;\n}\n",".text {\n  @apply text-foreground;\n}\n\n.text-prose {\n  @apply text-foreground;\n}\n\n.text-prose h1 {\n  @apply text-4xl font-semibold tracking-tight;\n}\n\n.text-prose h2 {\n  @apply text-3xl font-semibold tracking-tight;\n}\n\n.text-prose h3 {\n  @apply text-2xl font-semibold tracking-tight;\n}\n\n.text-prose h4 {\n  @apply text-xl font-semibold tracking-tight;\n}\n\n.text-prose h5 {\n  @apply text-lg font-semibold tracking-tight;\n}\n\n.text-prose h6 {\n  @apply text-base font-semibold tracking-tight;\n}\n\n.text-prose p {\n  @apply text-base leading-7;\n}\n\n.text-prose code {\n  @apply rounded-md bg-default px-1.5 py-0.5 font-mono text-sm text-foreground;\n}\n\n.text-prose a {\n  @apply font-medium text-link underline underline-offset-4;\n}\n\n.text-prose blockquote {\n  @apply mt-4 border-l-4 border-border pl-4 italic text-muted;\n}\n\n.text-prose ul {\n  @apply my-4 list-disc space-y-2 pl-6;\n}\n\n.text-prose ol {\n  @apply my-4 list-decimal space-y-2 pl-6;\n}\n\n.text-prose li {\n  @apply text-base leading-7;\n}\n\n.text-prose hr {\n  @apply my-8 border-separator;\n}\n\n.text-prose pre {\n  @apply my-4 overflow-x-auto rounded-xl bg-default p-4 font-mono text-sm leading-relaxed;\n}\n\n.text-prose strong {\n  @apply font-semibold text-foreground;\n}\n\n.text-prose em {\n  @apply italic;\n}\n\n.text-prose img {\n  @apply my-4 rounded-xl;\n}\n\n.text--h1 {\n  @apply text-4xl font-semibold tracking-tight;\n}\n\n.text--h2 {\n  @apply text-3xl font-semibold tracking-tight;\n}\n\n.text--h3 {\n  @apply text-2xl font-semibold tracking-tight;\n}\n\n.text--h4 {\n  @apply text-xl font-semibold tracking-tight;\n}\n\n.text--h5 {\n  @apply text-lg font-semibold tracking-tight;\n}\n\n.text--h6 {\n  @apply text-base font-semibold tracking-tight;\n}\n\n.text--body {\n  @apply text-base leading-7;\n}\n\n.text--body-sm {\n  @apply text-sm leading-6;\n}\n\n.text--body-xs {\n  @apply text-xs leading-5;\n}\n\n.text--code {\n  @apply rounded-md bg-default px-1.5 py-0.5 font-mono text-sm text-foreground;\n}\n\n.text--align-start {\n  @apply text-left rtl:text-right;\n}\n\n.text--align-center {\n  @apply text-center;\n}\n\n.text--align-end {\n  @apply text-right rtl:text-left;\n}\n\n.text--align-justify {\n  @apply text-justify;\n}\n\n.text--color-default {\n  @apply text-foreground;\n}\n\n.text--color-muted {\n  @apply text-muted;\n}\n\n.text--truncate {\n  @apply block truncate;\n}\n\n.text--weight-normal {\n  @apply font-normal;\n}\n\n.text--weight-medium {\n  @apply font-medium;\n}\n\n.text--weight-semibold {\n  @apply font-semibold;\n}\n\n.text--weight-bold {\n  @apply font-bold;\n}\n","/* Base scroll-shadow component */\n.scroll-shadow {\n  @apply relative;\n  --scroll-shadow-size: 40px;\n}\n\n/* Orientation: Vertical */\n.scroll-shadow--vertical {\n  @apply overflow-y-auto;\n}\n\n/* Orientation: Horizontal */\n.scroll-shadow--horizontal {\n  @apply overflow-x-auto;\n}\n\n/* Variant: Fade - Vertical */\n.scroll-shadow--fade.scroll-shadow--vertical {\n  &[data-top-scroll=\"true\"] {\n    --scroll-linear-gradient: 0deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n\n  &[data-bottom-scroll=\"true\"] {\n    --scroll-linear-gradient: 180deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n\n  &[data-top-bottom-scroll=\"true\"] {\n    --scroll-linear-gradient:\n      #000, #000, transparent 0, #000 var(--scroll-shadow-size),\n      #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n}\n\n/* Variant: Fade - Horizontal */\n.scroll-shadow--fade.scroll-shadow--horizontal {\n  &[data-left-scroll=\"true\"] {\n    --scroll-linear-gradient: 270deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n\n  &[data-right-scroll=\"true\"] {\n    --scroll-linear-gradient: 90deg, #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n\n  &[data-left-right-scroll=\"true\"] {\n    --scroll-linear-gradient:\n      to right, #000, #000, transparent 0, #000 var(--scroll-shadow-size),\n      #000 calc(100% - var(--scroll-shadow-size)), transparent;\n\n    mask-image: linear-gradient(var(--scroll-linear-gradient));\n    -webkit-mask-image: linear-gradient(var(--scroll-linear-gradient));\n  }\n}\n\n/* Hide scrollbar modifier */\n.scroll-shadow--hide-scrollbar {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar {\n    @apply hidden;\n  }\n}\n","/* Declares the theme variables - @see https://tailwindcss.com/docs/theme */\n@import \"../shared/theme.css\";\n\n/* Default Theme */\n@import \"./variables.css\" layer(theme);\n\n/* Component customizations for default theme */\n@import \"./components/index.css\" layer(components);\n","@layer base {\n  /* HeroUI Default Theme */\n  :root,\n  .light,\n  .default,\n  [data-theme=\"light\"],\n  [data-theme=\"default\"] {\n    color-scheme: light;\n\n    /* == Common Variables == */\n\n    /* Primitive Colors (Do not change between light and dark) */\n    --white: oklch(100% 0 0);\n    --black: oklch(0% 0 0);\n    --snow: oklch(0.9911 0 0);\n    --eclipse: oklch(0.2103 0.0059 285.89);\n\n    /* Spacing scale */\n    --spacing: 0.25rem;\n\n    /* Border */\n    --border-width: 1px;\n    --field-border-width: 0px;\n    --disabled-opacity: 0.5;\n\n    /* Ring offset - Used for focus ring */\n    --ring-offset-width: 2px;\n\n    /* Cursor */\n    --cursor-interactive: pointer;\n    --cursor-disabled: not-allowed;\n\n    /* Radius */\n    --radius: 0.5rem;\n    --field-radius: calc(var(--radius) * 1.5);\n\n    /* == Light Theme Variables == */\n\n    /* Base Colors */\n    --background: oklch(0.9702 0 0);\n    --foreground: var(--eclipse);\n\n    /* Surface: Used for non-overlay components (cards, accordions, disclosure groups) */\n    --surface: var(--white);\n    --surface-foreground: var(--foreground);\n\n    --surface-secondary: oklch(0.9524 0.0013 286.37);\n    --surface-secondary-foreground: var(--foreground);\n\n    --surface-tertiary: oklch(0.9373 0.0013 286.37);\n    --surface-tertiary-foreground: var(--foreground);\n\n    /* Overlay: Used for floating/overlay components (tooltips, popovers, modals, menus) */\n    --overlay: var(--white);\n    --overlay-foreground: var(--foreground);\n\n    --muted: oklch(0.5517 0.0138 285.94);\n\n    --scrollbar: oklch(87.1% 0.006 286.286);\n\n    --default: oklch(94% 0.001 286.375);\n    --default-foreground: var(--eclipse);\n\n    --accent: oklch(0.6204 0.195 253.83);\n    --accent-foreground: var(--snow);\n\n    /* Form Fields */\n    --field-background: var(--white);\n    --field-foreground: oklch(0.2103 0.0059 285.89);\n    --field-placeholder: var(--muted);\n    --field-border: transparent; /* no border by default on form fields */\n\n    /* Status Colors */\n    --success: oklch(0.7329 0.1935 150.81);\n    --success-foreground: var(--eclipse);\n\n    --warning: oklch(0.7819 0.1585 72.33);\n    --warning-foreground: var(--eclipse);\n\n    --danger: oklch(0.6532 0.2328 25.74);\n    --danger-foreground: var(--snow);\n\n    /* Component Colors */\n    --segment: var(--white);\n    --segment-foreground: var(--eclipse);\n\n    /* Misc Colors */\n    --border: oklch(90% 0.004 286.32);\n    --separator: oklch(92% 0.004 286.32);\n    --focus: var(--accent);\n    --link: var(--foreground);\n\n    /* Backdrop */\n    --backdrop: rgba(0, 0, 0, 0.5);\n\n    /* Shadows */\n    /* --surface-shadow: 0 0px 0px 0 rgba(24, 24, 27, 0.03), 0 2px 10px 0 rgba(24, 24, 27, 0.08); */\n    --surface-shadow:\n      0 2px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.06),\n      0 0 1px 0 rgba(0, 0, 0, 0.06);\n    /* Overlay shadow */\n    --overlay-shadow:\n      0 2px 8px 0 rgba(0, 0, 0, 0.06), 0 -6px 12px 0 rgba(0, 0, 0, 0.03),\n      0 14px 28px 0 rgba(0, 0, 0, 0.08);\n    --field-shadow:\n      0 2px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.06),\n      0 0 1px 0 rgba(0, 0, 0, 0.06);\n    /* Skeleton Default Global Animation */\n    --skeleton-animation: shimmer; /* shimmer, pulse, none */\n  }\n\n  .dark,\n  [data-theme=\"dark\"] {\n    color-scheme: dark;\n    /* == Dark Theme Variables == */\n\n    /* Base Colors */\n    --background: oklch(12% 0.005 285.823);\n    --foreground: var(--snow);\n\n    /* Surface: Used for non-overlay components (cards, accordions, disclosure groups) */\n    --surface: oklch(0.2103 0.0059 285.89);\n    --surface-foreground: var(--foreground);\n\n    --surface-secondary: oklch(0.257 0.0037 286.14);\n    --surface-tertiary: oklch(0.2721 0.0024 247.91);\n\n    /* Overlay: Used for floating/overlay components (tooltips, popovers, modals, menus) - lighter for contrast */\n    --overlay: oklch(0.2103 0.0059 285.89);\n    --overlay-foreground: var(--foreground);\n\n    --muted: oklch(70.5% 0.015 286.067);\n\n    --scrollbar: oklch(70.5% 0.015 286.067);\n\n    --default: oklch(27.4% 0.006 286.033);\n    --default-foreground: var(--snow);\n\n    /* Form Fields */\n    --field-background: oklch(0.2103 0.0059 285.89);\n    --field-foreground: var(--foreground);\n\n    /* Status Colors */\n    --warning: oklch(0.8203 0.1388 76.34);\n    --warning-foreground: var(--eclipse);\n\n    --danger: oklch(0.594 0.1967 24.63);\n    --danger-foreground: var(--snow);\n\n    /* Component Colors */\n    --segment: oklch(0.3964 0.01 285.93);\n    --segment-foreground: var(--foreground);\n\n    /* Misc Colors */\n    --border: oklch(28% 0.006 286.033);\n    --separator: oklch(25% 0.006 286.033);\n    --focus: var(--accent);\n    --link: var(--foreground);\n\n    /* Backdrop */\n    --backdrop: rgba(0, 0, 0, 0.6);\n\n    /* Shadows */\n    --surface-shadow: 0 0 0 0 transparent inset; /* No shadow on dark mode */\n    --overlay-shadow: 0 0 1px 0 rgba(255, 255, 255, 0.3) inset;\n    --field-shadow: 0 0 0 0 transparent inset; /* Transparent shadow to allow ring utilities to work */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
